// Auto-generated from 6_ZONES.kml — all 6 Hyderabad zones
const ZONES_DATA = [
  {
    name: "L.B.NAGAR ZONE",
    color: "#e74c3c",
    polygons: [
      [
        { lat: 17.31336372772201, lng: 78.50599311569506 },
        { lat: 17.31359506402992, lng: 78.50590640702929 },
        { lat: 17.31366843470684, lng: 78.50579648303088 },
        { lat: 17.31368954014513, lng: 78.50557228527013 },
        { lat: 17.31367122677331, lng: 78.50500114081862 },
        { lat: 17.31332995487447, lng: 78.50500836207628 },
        { lat: 17.31331958116275, lng: 78.50551852165465 },
        { lat: 17.31336372772201, lng: 78.50599311569506 },
      ],
      [
        { lat: 17.31274026424066, lng: 78.510529251404 },
        { lat: 17.31323945693992, lng: 78.51055549088545 },
        { lat: 17.31381262751869, lng: 78.51052537952391 },
        { lat: 17.31450700886689, lng: 78.5104413881118 },
        { lat: 17.31422388165993, lng: 78.50900469671554 },
        { lat: 17.31385895678229, lng: 78.50906186296481 },
        { lat: 17.31350734810256, lng: 78.50903674531536 },
        { lat: 17.31302504225251, lng: 78.50887904561483 },
        { lat: 17.31274353778533, lng: 78.50872610219339 },
        { lat: 17.3125330636475, lng: 78.50851995650403 },
        { lat: 17.3124535841695, lng: 78.5078940783147 },
        { lat: 17.31260654884926, lng: 78.5075113673653 },
        { lat: 17.31263067009578, lng: 78.50714532195526 },
        { lat: 17.31259754064399, lng: 78.5067875139039 },
        { lat: 17.31258693437375, lng: 78.50651150010113 },
        { lat: 17.31256629596909, lng: 78.5063892504011 },
        { lat: 17.31229787721368, lng: 78.50642396855861 },
        { lat: 17.31160465203444, lng: 78.50640844250375 },
        { lat: 17.30946512238077, lng: 78.5063533416624 },
        { lat: 17.30937450714599, lng: 78.50771354948542 },
        { lat: 17.30935101256371, lng: 78.50846644276761 },
        { lat: 17.30945343875605, lng: 78.509736977435 },
        { lat: 17.31068745544044, lng: 78.50976077932565 },
        { lat: 17.31128281683781, lng: 78.50983361476948 },
        { lat: 17.31133482869305, lng: 78.50993243063688 },
        { lat: 17.31139674322403, lng: 78.5105877753923 },
        { lat: 17.31187954813819, lng: 78.51049730663028 },
        { lat: 17.31274026424066, lng: 78.510529251404 },
      ],
      [
        { lat: 17.31650659494216, lng: 78.50784368150917 },
        { lat: 17.3166608903579, lng: 78.50800020985842 },
        { lat: 17.31680809076793, lng: 78.50806664276243 },
        { lat: 17.31805179288209, lng: 78.50803275043596 },
        { lat: 17.31831995330383, lng: 78.50762271477666 },
        { lat: 17.31841087973034, lng: 78.50728785298591 },
        { lat: 17.31854640664423, lng: 78.50669067808225 },
        { lat: 17.31857797178547, lng: 78.50650333903067 },
        { lat: 17.31862099570561, lng: 78.50612023222726 },
        { lat: 17.31863050354197, lng: 78.5059241758425 },
        { lat: 17.31851643022269, lng: 78.50562615840501 },
        { lat: 17.31836810740606, lng: 78.50549454149755 },
        { lat: 17.31742640070769, lng: 78.50566364427804 },
        { lat: 17.3170743005114, lng: 78.50573507884462 },
        { lat: 17.31647306014671, lng: 78.50599491845493 },
        { lat: 17.31634534066235, lng: 78.5068880006511 },
        { lat: 17.31637299545778, lng: 78.50694982520751 },
        { lat: 17.31633687653354, lng: 78.50716800673632 },
        { lat: 17.31650659494216, lng: 78.50784368150917 },
      ],
      [
        { lat: 17.31969020415492, lng: 78.49668038946383 },
        { lat: 17.31967372605585, lng: 78.49660005903435 },
        { lat: 17.31958609509157, lng: 78.49630809472177 },
        { lat: 17.31948906880289, lng: 78.4957154080613 },
        { lat: 17.31921918392983, lng: 78.49467722969871 },
        { lat: 17.31904775201049, lng: 78.49412633509486 },
        { lat: 17.31895754096015, lng: 78.49389384936404 },
        { lat: 17.31877806750339, lng: 78.49406546484666 },
        { lat: 17.31875833080333, lng: 78.49401597322434 },
        { lat: 17.31878425354103, lng: 78.49381856086022 },
        { lat: 17.3184654027502, lng: 78.49363414286059 },
        { lat: 17.31829833077879, lng: 78.49392269323585 },
        { lat: 17.31845212069171, lng: 78.4939902703227 },
        { lat: 17.31841488681455, lng: 78.4940703908836 },
        { lat: 17.31819549081469, lng: 78.49401460948145 },
        { lat: 17.31810830518688, lng: 78.49398944977554 },
        { lat: 17.31801890888788, lng: 78.49424567631588 },
        { lat: 17.31776045887951, lng: 78.49412167365391 },
        { lat: 17.31744986169169, lng: 78.49460481433029 },
        { lat: 17.31723330487442, lng: 78.4944864644861 },
        { lat: 17.31706101822069, lng: 78.49480290221572 },
        { lat: 17.31679236544026, lng: 78.49457952083527 },
        { lat: 17.31637036497742, lng: 78.49499264036672 },
        { lat: 17.31656449896452, lng: 78.49499000852738 },
        { lat: 17.31720275538908, lng: 78.49490982726778 },
        { lat: 17.31722742111539, lng: 78.49490173520859 },
        { lat: 17.31753491815011, lng: 78.49480084837691 },
        { lat: 17.3177322823594, lng: 78.49473471183099 },
        { lat: 17.31779744606559, lng: 78.49469029034842 },
        { lat: 17.31746535120666, lng: 78.49555707036879 },
        { lat: 17.31728296414684, lng: 78.49604623686147 },
        { lat: 17.3169862074026, lng: 78.49677673659748 },
        { lat: 17.31704355166003, lng: 78.4967759597203 },
        { lat: 17.3183907720748, lng: 78.4967278518575 },
        { lat: 17.31969020415492, lng: 78.49668038946383 },
      ],
      [
        { lat: 17.33143546302858, lng: 78.51624163962721 },
        { lat: 17.33155991934693, lng: 78.51587171621749 },
        { lat: 17.33119457230873, lng: 78.51570246194441 },
        { lat: 17.33131828725895, lng: 78.51527283309257 },
        { lat: 17.33125231041403, lng: 78.5149634479261 },
        { lat: 17.33081786542195, lng: 78.51461846581965 },
        { lat: 17.3307525195458, lng: 78.51455216702475 },
        { lat: 17.33078418757925, lng: 78.51421583876537 },
        { lat: 17.33079574454201, lng: 78.51399175201436 },
        { lat: 17.33079175782995, lng: 78.51367083274253 },
        { lat: 17.33081746221448, lng: 78.51343162473296 },
        { lat: 17.33077800457135, lng: 78.5131410429551 },
        { lat: 17.33075557328202, lng: 78.5130667008334 },
        { lat: 17.33066034699024, lng: 78.51290376533903 },
        { lat: 17.33055134179367, lng: 78.51278580310453 },
        { lat: 17.33035650291809, lng: 78.51268392528783 },
        { lat: 17.33017553736616, lng: 78.51254454015347 },
        { lat: 17.33000974370448, lng: 78.51247212899904 },
        { lat: 17.32996380972979, lng: 78.51242970501873 },
        { lat: 17.32972685098172, lng: 78.51259213752009 },
        { lat: 17.32949349627541, lng: 78.5126599729061 },
        { lat: 17.32894493011216, lng: 78.5127469821093 },
        { lat: 17.3284105136847, lng: 78.5128188731925 },
        { lat: 17.32795268002537, lng: 78.51289968141259 },
        { lat: 17.32759415166814, lng: 78.51289456027048 },
        { lat: 17.32729247179143, lng: 78.51284886039721 },
        { lat: 17.32714365045574, lng: 78.51279612712334 },
        { lat: 17.32696628031783, lng: 78.51275373144304 },
        { lat: 17.326827880754, lng: 78.51277052316733 },
        { lat: 17.32665815532976, lng: 78.51372823571838 },
        { lat: 17.32665288138514, lng: 78.51484297404558 },
        { lat: 17.32662986623171, lng: 78.51568425952249 },
        { lat: 17.32661566578694, lng: 78.51646571248102 },
        { lat: 17.32630244052926, lng: 78.5181867101328 },
        { lat: 17.32649880397546, lng: 78.51821890475375 },
        { lat: 17.3264642741611, lng: 78.51851793994594 },
        { lat: 17.327421200153, lng: 78.51859963004041 },
        { lat: 17.32746019868153, lng: 78.51827564964248 },
        { lat: 17.32766097017772, lng: 78.51827792878237 },
        { lat: 17.32774895561976, lng: 78.51766467037362 },
        { lat: 17.32815384657109, lng: 78.51678340865237 },
        { lat: 17.32821393365764, lng: 78.51661838600177 },
        { lat: 17.3282678833188, lng: 78.51634396753275 },
        { lat: 17.32840260132251, lng: 78.5156454806566 },
        { lat: 17.32887209475189, lng: 78.51573371255164 },
        { lat: 17.32892256096286, lng: 78.5155638409484 },
        { lat: 17.32899525368631, lng: 78.51525931063132 },
        { lat: 17.32904646072622, lng: 78.51514914474383 },
        { lat: 17.32972421940023, lng: 78.51545850448866 },
        { lat: 17.32986440871328, lng: 78.5155860006417 },
        { lat: 17.33033513557561, lng: 78.5157737412944 },
        { lat: 17.3311902627798, lng: 78.51612550529569 },
        { lat: 17.33143546302858, lng: 78.51624163962721 },
      ],
      [
        { lat: 17.33168944451628, lng: 78.51944227692367 },
        { lat: 17.33213313034663, lng: 78.51937659897251 },
        { lat: 17.33239586330934, lng: 78.51936498183137 },
        { lat: 17.33274139769637, lng: 78.51928569314977 },
        { lat: 17.33279928191264, lng: 78.51913562448036 },
        { lat: 17.33283388936259, lng: 78.51903563154642 },
        { lat: 17.33309656733186, lng: 78.51901965941185 },
        { lat: 17.33373006364519, lng: 78.5190360273705 },
        { lat: 17.33400468925066, lng: 78.51901989533278 },
        { lat: 17.33386686142765, lng: 78.51754127022944 },
        { lat: 17.33365990597996, lng: 78.51723302920283 },
        { lat: 17.33310834066761, lng: 78.51707871536468 },
        { lat: 17.33264225728411, lng: 78.51707254284432 },
        { lat: 17.33247484504878, lng: 78.51706235579246 },
        { lat: 17.33176568207244, lng: 78.51691825029796 },
        { lat: 17.33139871870316, lng: 78.51681121670723 },
        { lat: 17.33127043227121, lng: 78.51687265894013 },
        { lat: 17.33122225349164, lng: 78.51761228957967 },
        { lat: 17.33124038601191, lng: 78.51791808947192 },
        { lat: 17.33145876141585, lng: 78.51818387658095 },
        { lat: 17.33165443214475, lng: 78.5183529297629 },
        { lat: 17.33165850404166, lng: 78.51868131163319 },
        { lat: 17.3316016699504, lng: 78.51930163053005 },
        { lat: 17.33153882049914, lng: 78.5194368368128 },
        { lat: 17.33168944451628, lng: 78.51944227692367 },
      ],
      [
        { lat: 17.3351323501067, lng: 78.52673414846042 },
        { lat: 17.33506476667087, lng: 78.52671863135244 },
        { lat: 17.33507929478235, lng: 78.52650196088214 },
        { lat: 17.33479493567513, lng: 78.52646546393184 },
        { lat: 17.33483267314289, lng: 78.52615442573638 },
        { lat: 17.33407821411248, lng: 78.52603838518266 },
        { lat: 17.33177500959816, lng: 78.52589010414002 },
        { lat: 17.33181475063134, lng: 78.52699944673716 },
        { lat: 17.33256860967189, lng: 78.52708638761662 },
        { lat: 17.3325179961025, lng: 78.52763197847864 },
        { lat: 17.33203800266449, lng: 78.52766080299517 },
        { lat: 17.33188214739783, lng: 78.5278121811281 },
        { lat: 17.33181010789539, lng: 78.52807440333805 },
        { lat: 17.3318171942688, lng: 78.52835796196428 },
        { lat: 17.33185078882062, lng: 78.52846574829698 },
        { lat: 17.33226926407744, lng: 78.5286803499636 },
        { lat: 17.33348433200599, lng: 78.52895893574104 },
        { lat: 17.3336817635422, lng: 78.52795080799021 },
        { lat: 17.33424682967092, lng: 78.52810061883807 },
        { lat: 17.33435328878379, lng: 78.52791631007389 },
        { lat: 17.33442150929022, lng: 78.52792534799329 },
        { lat: 17.33449466728145, lng: 78.52781013907254 },
        { lat: 17.33464821849806, lng: 78.52747217254655 },
        { lat: 17.33473010318804, lng: 78.52748451154564 },
        { lat: 17.33479226008982, lng: 78.5274090342003 },
        { lat: 17.33482827463876, lng: 78.52719058180948 },
        { lat: 17.33489767470785, lng: 78.52712097619826 },
        { lat: 17.33502978583407, lng: 78.52702067446604 },
        { lat: 17.3351323501067, lng: 78.52673414846042 },
      ],
      [
        { lat: 17.3375530214054, lng: 78.52644888630182 },
        { lat: 17.33768866267808, lng: 78.52640227862902 },
        { lat: 17.33804799537909, lng: 78.5264721117861 },
        { lat: 17.33816828605571, lng: 78.52634359655353 },
        { lat: 17.33824436687513, lng: 78.5261186329184 },
        { lat: 17.33817607124574, lng: 78.52581349074008 },
        { lat: 17.33811419987179, lng: 78.52544854630675 },
        { lat: 17.33742915986536, lng: 78.52512928297477 },
        { lat: 17.33751957659654, lng: 78.5249041257989 },
        { lat: 17.33704315220735, lng: 78.52464178499014 },
        { lat: 17.33663236345413, lng: 78.52524198418365 },
        { lat: 17.33646010219011, lng: 78.52561255409358 },
        { lat: 17.33626314669438, lng: 78.5259187618081 },
        { lat: 17.33603218512513, lng: 78.52618063366437 },
        { lat: 17.33601405580688, lng: 78.5262605014134 },
        { lat: 17.3360157167518, lng: 78.52639484380285 },
        { lat: 17.33602480068791, lng: 78.52674307617787 },
        { lat: 17.33603529752601, lng: 78.52720574826628 },
        { lat: 17.33658180321359, lng: 78.52733776591633 },
        { lat: 17.33651553228651, lng: 78.52777658583346 },
        { lat: 17.33682560924884, lng: 78.52792172696172 },
        { lat: 17.33707695829615, lng: 78.52795568431875 },
        { lat: 17.33710957002921, lng: 78.52769398155176 },
        { lat: 17.33688541982789, lng: 78.52754022428086 },
        { lat: 17.33669171781256, lng: 78.52749116289507 },
        { lat: 17.33675991244364, lng: 78.52682140695624 },
        { lat: 17.33691295900733, lng: 78.52686802842933 },
        { lat: 17.33705078653212, lng: 78.52641829474527 },
        { lat: 17.33731656330163, lng: 78.52645952092028 },
        { lat: 17.3375530214054, lng: 78.52644888630182 },
      ],
      [
        { lat: 17.50896584646953, lng: 78.5616934995043 },
        { lat: 17.50958367340993, lng: 78.55776146212177 },
        { lat: 17.50915615064568, lng: 78.55528982996985 },
        { lat: 17.50850225863809, lng: 78.55297756670429 },
        { lat: 17.50841296083471, lng: 78.55354302019418 },
        { lat: 17.50840175223519, lng: 78.55356063590717 },
        { lat: 17.50840197830723, lng: 78.5535606573535 },
        { lat: 17.50816595028559, lng: 78.55501149412407 },
        { lat: 17.50805677576603, lng: 78.55571925522787 },
        { lat: 17.50802140090346, lng: 78.55604849033726 },
        { lat: 17.5079894982484, lng: 78.55617469388494 },
        { lat: 17.50792820648224, lng: 78.55653416398741 },
        { lat: 17.50790028657845, lng: 78.55669269233138 },
        { lat: 17.50788026993175, lng: 78.55681375517335 },
        { lat: 17.50785990092101, lng: 78.55700331525786 },
        { lat: 17.50785271906781, lng: 78.55709929957503 },
        { lat: 17.50764096447657, lng: 78.55707847153492 },
        { lat: 17.50758431660535, lng: 78.55707870210564 },
        { lat: 17.50672070967262, lng: 78.55703251870209 },
        { lat: 17.50612747562047, lng: 78.55697066521999 },
        { lat: 17.50571193135803, lng: 78.55694509074176 },
        { lat: 17.50549910450201, lng: 78.55688567250553 },
        { lat: 17.50518594162289, lng: 78.55685225245819 },
        { lat: 17.50518126402713, lng: 78.55686620799436 },
        { lat: 17.50481695560094, lng: 78.55687730743661 },
        { lat: 17.50447416437578, lng: 78.55669509879941 },
        { lat: 17.50294048641955, lng: 78.55586882293072 },
        { lat: 17.5025397287801, lng: 78.55565808752893 },
        { lat: 17.50240095528116, lng: 78.55545073878304 },
        { lat: 17.50140219898154, lng: 78.55410800711411 },
        { lat: 17.50094222087481, lng: 78.55343425181805 },
        { lat: 17.50102769103861, lng: 78.5533114877858 },
        { lat: 17.50063345225906, lng: 78.55299808643942 },
        { lat: 17.50041375377367, lng: 78.55262371626259 },
        { lat: 17.50035975218809, lng: 78.55231437054819 },
        { lat: 17.50004700374408, lng: 78.55195245558163 },
        { lat: 17.4993899038034, lng: 78.55157274106372 },
        { lat: 17.49916929187366, lng: 78.55141505974066 },
        { lat: 17.49846745304252, lng: 78.55031495310395 },
        { lat: 17.4983252298868, lng: 78.55011886648332 },
        { lat: 17.49829117453874, lng: 78.54997362945335 },
        { lat: 17.49827880778045, lng: 78.5490301523718 },
        { lat: 17.49829260462828, lng: 78.54852190952928 },
        { lat: 17.49829781696617, lng: 78.54836344543756 },
        { lat: 17.49834205118054, lng: 78.54788169138362 },
        { lat: 17.50000407789205, lng: 78.54712749630524 },
        { lat: 17.4999339291715, lng: 78.54673595899057 },
        { lat: 17.4990840721838, lng: 78.54655257217155 },
        { lat: 17.49857006950123, lng: 78.54643993059136 },
        { lat: 17.49758167353409, lng: 78.54622905875007 },
        { lat: 17.49692393704989, lng: 78.54608846299749 },
        { lat: 17.49690682628797, lng: 78.54604207149586 },
        { lat: 17.49692912404913, lng: 78.54598997006156 },
        { lat: 17.49717800037716, lng: 78.54539887953935 },
        { lat: 17.49733142590507, lng: 78.54504155440944 },
        { lat: 17.49657001469642, lng: 78.54473051466478 },
        { lat: 17.49682402044399, lng: 78.54420659774053 },
        { lat: 17.49707973526303, lng: 78.5436278659713 },
        { lat: 17.49775610180636, lng: 78.54382548363002 },
        { lat: 17.4979120897201, lng: 78.54387817691106 },
        { lat: 17.49793635921184, lng: 78.54387699509928 },
        { lat: 17.49786093136547, lng: 78.54362320999196 },
        { lat: 17.49772649458853, lng: 78.54338095175545 },
        { lat: 17.49761437900039, lng: 78.5430113800452 },
        { lat: 17.49750385069894, lng: 78.54257703538964 },
        { lat: 17.49745117669174, lng: 78.54249455392247 },
        { lat: 17.49742816399773, lng: 78.542509480426 },
        { lat: 17.49737618365833, lng: 78.54255749818557 },
        { lat: 17.49727670737634, lng: 78.5424368035865 },
        { lat: 17.49706841415919, lng: 78.54221297370233 },
        { lat: 17.4967555118196, lng: 78.54203288868035 },
        { lat: 17.49637555276707, lng: 78.54184125411851 },
        { lat: 17.49621131655928, lng: 78.54170150782808 },
        { lat: 17.49625287590562, lng: 78.541583897544 },
        { lat: 17.49653019693851, lng: 78.54120660120653 },
        { lat: 17.49667112279707, lng: 78.54100795927762 },
        { lat: 17.49669384489187, lng: 78.5409130164819 },
        { lat: 17.49686629082604, lng: 78.54036528866766 },
        { lat: 17.49692043959861, lng: 78.53991378865773 },
        { lat: 17.4969205269551, lng: 78.53953523902722 },
        { lat: 17.49697024133103, lng: 78.53949721353837 },
        { lat: 17.49705117121371, lng: 78.53947121980745 },
        { lat: 17.4972587565261, lng: 78.53867397067829 },
        { lat: 17.49781736583419, lng: 78.53881836478205 },
        { lat: 17.49816117817659, lng: 78.53898557632176 },
        { lat: 17.4991704737033, lng: 78.53924344490603 },
        { lat: 17.49984656395356, lng: 78.53941863588398 },
        { lat: 17.49988927133937, lng: 78.53928142578341 },
        { lat: 17.49987897401264, lng: 78.53927810053227 },
        { lat: 17.49992341236449, lng: 78.53914049338267 },
        { lat: 17.50004001708341, lng: 78.53867668795989 },
        { lat: 17.49962383647727, lng: 78.53857072101407 },
        { lat: 17.49924913887234, lng: 78.53846728865685 },
        { lat: 17.49924478182953, lng: 78.5382105528105 },
        { lat: 17.49928098518434, lng: 78.53821946845495 },
        { lat: 17.49937716860386, lng: 78.53788195828253 },
        { lat: 17.49914088538403, lng: 78.537791001816 },
        { lat: 17.49927425613559, lng: 78.53733045945808 },
        { lat: 17.49898794467538, lng: 78.53725213227253 },
        { lat: 17.49896995692527, lng: 78.5373046749669 },
        { lat: 17.49870632389343, lng: 78.53720512235533 },
        { lat: 17.49878095451403, lng: 78.53701816148694 },
        { lat: 17.49893612994975, lng: 78.53663314572022 },
        { lat: 17.49831536711315, lng: 78.53614677434463 },
        { lat: 17.49593367804147, lng: 78.53545463765538 },
        { lat: 17.49470252007616, lng: 78.53510685078928 },
        { lat: 17.49391547760956, lng: 78.53462411138752 },
        { lat: 17.49348230507685, lng: 78.53498858846895 },
        { lat: 17.49308204692489, lng: 78.5355617236741 },
        { lat: 17.4931841052594, lng: 78.53571791354338 },
        { lat: 17.49319220113385, lng: 78.53579251689395 },
        { lat: 17.4929992601059, lng: 78.53622844448068 },
        { lat: 17.4927431648167, lng: 78.53677480027223 },
        { lat: 17.49261853538023, lng: 78.53693835506408 },
        { lat: 17.4924503727524, lng: 78.53706015896806 },
        { lat: 17.49229319822616, lng: 78.53710461282012 },
        { lat: 17.49213761095189, lng: 78.53708429613043 },
        { lat: 17.49204783522137, lng: 78.5370426546436 },
        { lat: 17.49196936553033, lng: 78.53700687069696 },
        { lat: 17.49180313890545, lng: 78.5368995337746 },
        { lat: 17.49178066650653, lng: 78.53701439409568 },
        { lat: 17.49173429966686, lng: 78.53712957536733 },
        { lat: 17.49170162034765, lng: 78.53719227495921 },
        { lat: 17.4916977153618, lng: 78.53764806617511 },
        { lat: 17.49150656492721, lng: 78.5376506408385 },
        { lat: 17.49150671477335, lng: 78.5382408558894 },
        { lat: 17.49120122510291, lng: 78.53825492411178 },
        { lat: 17.49105456757236, lng: 78.53932029245249 },
        { lat: 17.49034380940182, lng: 78.5392402061643 },
        { lat: 17.49024512189804, lng: 78.53937601336439 },
        { lat: 17.49018856384454, lng: 78.53970493411934 },
        { lat: 17.49016311034411, lng: 78.53998974410513 },
        { lat: 17.49011025375843, lng: 78.54035280237035 },
        { lat: 17.49007249396133, lng: 78.5404877892419 },
        { lat: 17.49004805341988, lng: 78.54054041583669 },
        { lat: 17.49005059797509, lng: 78.54074583521844 },
        { lat: 17.48994252015028, lng: 78.54070246270638 },
        { lat: 17.48963128784106, lng: 78.54050287231851 },
        { lat: 17.48949950770604, lng: 78.5409768816905 },
        { lat: 17.48941822970947, lng: 78.54107136286994 },
        { lat: 17.48925690778378, lng: 78.54135992166269 },
        { lat: 17.48922973864718, lng: 78.54181145470994 },
        { lat: 17.48902568482609, lng: 78.541814156692 },
        { lat: 17.48885244127274, lng: 78.54177362602736 },
        { lat: 17.48868128848768, lng: 78.54174438745913 },
        { lat: 17.48846513408025, lng: 78.54165764165553 },
        { lat: 17.48836427126912, lng: 78.54161790754998 },
        { lat: 17.48795674722211, lng: 78.54228830427682 },
        { lat: 17.48742701185637, lng: 78.54322182411427 },
        { lat: 17.48707953337414, lng: 78.54382043303949 },
        { lat: 17.48641678094441, lng: 78.54501347734973 },
        { lat: 17.48557799935565, lng: 78.54646662237492 },
        { lat: 17.48432154981885, lng: 78.54864255708766 },
        { lat: 17.48402492743234, lng: 78.54915256766975 },
        { lat: 17.48387856371137, lng: 78.54940422381755 },
        { lat: 17.48382772923025, lng: 78.54948585818607 },
        { lat: 17.48367217557371, lng: 78.54975061994638 },
        { lat: 17.48362808003575, lng: 78.54983489900698 },
        { lat: 17.4836157160311, lng: 78.54985615613556 },
        { lat: 17.48310586515639, lng: 78.55073277070294 },
        { lat: 17.48309724129683, lng: 78.55073000233195 },
        { lat: 17.48257591882573, lng: 78.55180242670508 },
        { lat: 17.48252391476188, lng: 78.55181535272904 },
        { lat: 17.48209634812553, lng: 78.55178372192965 },
        { lat: 17.48164211529009, lng: 78.55298201207304 },
        { lat: 17.48111929902268, lng: 78.55423947588959 },
        { lat: 17.48056081664972, lng: 78.55400787854502 },
        { lat: 17.47957695042284, lng: 78.55357369016238 },
        { lat: 17.47939147873748, lng: 78.55403005029906 },
        { lat: 17.47865482205045, lng: 78.553715641444 },
        { lat: 17.47818116166786, lng: 78.55350616554838 },
        { lat: 17.47795765048459, lng: 78.55403261578778 },
        { lat: 17.47768128678533, lng: 78.5546750703724 },
        { lat: 17.47716708972885, lng: 78.5544325419735 },
        { lat: 17.47555749870056, lng: 78.55576879905229 },
        { lat: 17.47513195529232, lng: 78.55622045090847 },
        { lat: 17.47474066617246, lng: 78.55660397355858 },
        { lat: 17.47433681374282, lng: 78.55703368982606 },
        { lat: 17.47429430745224, lng: 78.55709113359195 },
        { lat: 17.47418362277629, lng: 78.55725206279232 },
        { lat: 17.4739470766367, lng: 78.55776122039443 },
        { lat: 17.47368360464401, lng: 78.55763524872836 },
        { lat: 17.47358353602723, lng: 78.5578179295938 },
        { lat: 17.4734788574514, lng: 78.5580509108556 },
        { lat: 17.47334109274486, lng: 78.55833517373567 },
        { lat: 17.47318730676997, lng: 78.55865596451676 },
        { lat: 17.47286083832013, lng: 78.55933527438752 },
        { lat: 17.47269160398436, lng: 78.55968266526403 },
        { lat: 17.47261193029994, lng: 78.5598794841785 },
        { lat: 17.4728904006277, lng: 78.55998135432318 },
        { lat: 17.47319021456707, lng: 78.56010883711187 },
        { lat: 17.47336028528202, lng: 78.56017978076301 },
        { lat: 17.47346639836304, lng: 78.56025805137587 },
        { lat: 17.47350231785577, lng: 78.56030289318585 },
        { lat: 17.47349739024701, lng: 78.56036869893606 },
        { lat: 17.47341595588369, lng: 78.56074330837382 },
        { lat: 17.47327040303009, lng: 78.56135882234999 },
        { lat: 17.47306036852911, lng: 78.56242762958644 },
        { lat: 17.4729760094726, lng: 78.56238769788263 },
        { lat: 17.47291823914067, lng: 78.56249798712656 },
        { lat: 17.47258862400802, lng: 78.5630647362426 },
        { lat: 17.47221866432645, lng: 78.56368721831505 },
        { lat: 17.47193694585294, lng: 78.56420717455961 },
        { lat: 17.4716789130002, lng: 78.56468074752462 },
        { lat: 17.47158541927297, lng: 78.56461799398917 },
        { lat: 17.47134436951046, lng: 78.56507341064639 },
        { lat: 17.47125555927709, lng: 78.56501678275464 },
        { lat: 17.47123810587059, lng: 78.56500682132275 },
        { lat: 17.47112246489754, lng: 78.56523939720427 },
        { lat: 17.47092369326453, lng: 78.56559564069939 },
        { lat: 17.47073061281155, lng: 78.5659180092291 },
        { lat: 17.47047214312713, lng: 78.56635622189195 },
        { lat: 17.47034960938696, lng: 78.56653390207492 },
        { lat: 17.46998464610329, lng: 78.56619148413223 },
        { lat: 17.46989548033483, lng: 78.56609414677236 },
        { lat: 17.469513572946, lng: 78.56576783386964 },
        { lat: 17.46849739415015, lng: 78.56509489421482 },
        { lat: 17.46838797761921, lng: 78.56523454979221 },
        { lat: 17.46828977152649, lng: 78.56541140701087 },
        { lat: 17.4682239591412, lng: 78.56559903941309 },
        { lat: 17.467384783197, lng: 78.5654589645136 },
        { lat: 17.46713519104227, lng: 78.56540601978367 },
        { lat: 17.4669927884575, lng: 78.56539144829512 },
        { lat: 17.46625582604936, lng: 78.56522071716788 },
        { lat: 17.46610511387572, lng: 78.5651106690385 },
        { lat: 17.46597662388612, lng: 78.56481089039137 },
        { lat: 17.46563567607617, lng: 78.56477216239486 },
        { lat: 17.46558955933833, lng: 78.5647669238331 },
        { lat: 17.46562963697338, lng: 78.56413690419576 },
        { lat: 17.46561361273348, lng: 78.56407735611772 },
        { lat: 17.46559169983685, lng: 78.56403855907712 },
        { lat: 17.46558831447106, lng: 78.56403789356783 },
        { lat: 17.46539344863979, lng: 78.56398134688445 },
        { lat: 17.46523491959212, lng: 78.56396478126821 },
        { lat: 17.46484296322374, lng: 78.56391396906031 },
        { lat: 17.464322955935, lng: 78.56389598694727 },
        { lat: 17.46370664715319, lng: 78.5638201472971 },
        { lat: 17.46328046627152, lng: 78.56377502043165 },
        { lat: 17.4627959413297, lng: 78.56370776136603 },
        { lat: 17.46286359337847, lng: 78.56345586704202 },
        { lat: 17.46279451108032, lng: 78.56342366953459 },
        { lat: 17.46220726840559, lng: 78.563282081283 },
        { lat: 17.46166491143869, lng: 78.5631294540205 },
        { lat: 17.46165810463412, lng: 78.56312753816039 },
        { lat: 17.46160639183951, lng: 78.56319794579605 },
        { lat: 17.46148866887677, lng: 78.56314722268266 },
        { lat: 17.4613688614433, lng: 78.56312142603299 },
        { lat: 17.46113476983439, lng: 78.56309798097432 },
        { lat: 17.46089403647576, lng: 78.56305262898252 },
        { lat: 17.46074147084726, lng: 78.5630147846412 },
        { lat: 17.46070269063647, lng: 78.56296646902841 },
        { lat: 17.46038851508763, lng: 78.56287602974322 },
        { lat: 17.45993054656563, lng: 78.56275264501572 },
        { lat: 17.45944145425909, lng: 78.5626246946608 },
        { lat: 17.45873422184223, lng: 78.56244237775769 },
        { lat: 17.45816317404724, lng: 78.56229622141049 },
        { lat: 17.45770994097083, lng: 78.56216929015193 },
        { lat: 17.4576378705362, lng: 78.5621560906786 },
        { lat: 17.45751000093535, lng: 78.56214659156971 },
        { lat: 17.45733154991173, lng: 78.56209368922688 },
        { lat: 17.45723356681564, lng: 78.56205465666744 },
        { lat: 17.45706684050264, lng: 78.56202251386233 },
        { lat: 17.45695085288356, lng: 78.56199878478887 },
        { lat: 17.4567064160926, lng: 78.56194377290251 },
        { lat: 17.45646801018964, lng: 78.56187188646152 },
        { lat: 17.45611874147563, lng: 78.56176498643994 },
        { lat: 17.45576594608209, lng: 78.56167971241247 },
        { lat: 17.45559792245028, lng: 78.56161970060104 },
        { lat: 17.45549689496606, lng: 78.56156626649135 },
        { lat: 17.45543654866367, lng: 78.56151727207472 },
        { lat: 17.45532608585319, lng: 78.56147392389742 },
        { lat: 17.45500011574805, lng: 78.56139609501395 },
        { lat: 17.45468975058513, lng: 78.56130461365298 },
        { lat: 17.45466190158882, lng: 78.56137221110737 },
        { lat: 17.45386179498226, lng: 78.5611534161499 },
        { lat: 17.45377518464312, lng: 78.56111454378467 },
        { lat: 17.45372334701082, lng: 78.56125267636932 },
        { lat: 17.45355993676991, lng: 78.5611791581409 },
        { lat: 17.45329110016658, lng: 78.56108314132146 },
        { lat: 17.45315563507968, lng: 78.56141759264972 },
        { lat: 17.45294408008519, lng: 78.56131169916239 },
        { lat: 17.45272076401633, lng: 78.56122503570036 },
        { lat: 17.45250833748181, lng: 78.56114943166548 },
        { lat: 17.45214918980307, lng: 78.56109445470221 },
        { lat: 17.4517363717891, lng: 78.56104766219515 },
        { lat: 17.45113377854422, lng: 78.56098920256309 },
        { lat: 17.45077848992929, lng: 78.56095658274494 },
        { lat: 17.45045510131403, lng: 78.56094027109422 },
        { lat: 17.45017759541897, lng: 78.560292903415 },
        { lat: 17.44973815806745, lng: 78.56051620709887 },
        { lat: 17.44940916810278, lng: 78.56072652800678 },
        { lat: 17.44939600493985, lng: 78.56073652478882 },
        { lat: 17.44915000139454, lng: 78.56032052989188 },
        { lat: 17.44750975591775, lng: 78.55736262771943 },
        { lat: 17.44609290705763, lng: 78.55824401760526 },
        { lat: 17.44550631529573, lng: 78.55828673467812 },
        { lat: 17.44480751442291, lng: 78.55635347971072 },
        { lat: 17.44403650499522, lng: 78.55480557900339 },
        { lat: 17.44319207965864, lng: 78.55363007929422 },
        { lat: 17.44221026538972, lng: 78.5528336327881 },
        { lat: 17.44206742555132, lng: 78.55276880190345 },
        { lat: 17.44201476524916, lng: 78.55278981606658 },
        { lat: 17.44161510013363, lng: 78.55448967870844 },
        { lat: 17.44126513945778, lng: 78.55524875835926 },
        { lat: 17.43991213849113, lng: 78.55733851568935 },
        { lat: 17.4396186752985, lng: 78.55725537770994 },
        { lat: 17.44003108403946, lng: 78.5565912271283 },
        { lat: 17.44027111700436, lng: 78.5561789075795 },
        { lat: 17.43915296912811, lng: 78.55539297806409 },
        { lat: 17.43895798412814, lng: 78.55471081118888 },
        { lat: 17.43862648857729, lng: 78.55421346880513 },
        { lat: 17.43887708705457, lng: 78.55381385264894 },
        { lat: 17.43907338263924, lng: 78.55347431776897 },
        { lat: 17.43928123547053, lng: 78.55313053098044 },
        { lat: 17.43939438736705, lng: 78.55284818565354 },
        { lat: 17.43951045555892, lng: 78.55249210535248 },
        { lat: 17.43959896933044, lng: 78.552060258607 },
        { lat: 17.4397283232759, lng: 78.55150208720319 },
        { lat: 17.43974875559894, lng: 78.55143404491692 },
        { lat: 17.43997123033033, lng: 78.55102475825348 },
        { lat: 17.43946097305693, lng: 78.5505754622685 },
        { lat: 17.43928291816005, lng: 78.55039171195612 },
        { lat: 17.43877231751896, lng: 78.54997279862388 },
        { lat: 17.43847643257936, lng: 78.54966972549217 },
        { lat: 17.43848893106861, lng: 78.54959785629121 },
        { lat: 17.438691796768, lng: 78.54930435263509 },
        { lat: 17.43886360300692, lng: 78.54906972059744 },
        { lat: 17.43889248569361, lng: 78.54903744589087 },
        { lat: 17.43893600920979, lng: 78.54897534418048 },
        { lat: 17.43869143025918, lng: 78.54890890160114 },
        { lat: 17.43823125270746, lng: 78.54880052765957 },
        { lat: 17.43756975168044, lng: 78.54864505150947 },
        { lat: 17.43702992754931, lng: 78.54866720392891 },
        { lat: 17.43600272506545, lng: 78.54870084775106 },
        { lat: 17.43579901174797, lng: 78.54871713019459 },
        { lat: 17.43556849127865, lng: 78.5487256286769 },
        { lat: 17.43556562317618, lng: 78.54872384060259 },
        { lat: 17.43464185477909, lng: 78.54814790120932 },
        { lat: 17.4345911586927, lng: 78.5481050399339 },
        { lat: 17.4345888733361, lng: 78.54804935947143 },
        { lat: 17.43465921404504, lng: 78.54772768502897 },
        { lat: 17.43465996893929, lng: 78.54764275297161 },
        { lat: 17.43461911032234, lng: 78.5476157678278 },
        { lat: 17.43455176928071, lng: 78.54758719741552 },
        { lat: 17.43452225977979, lng: 78.5475602130129 },
        { lat: 17.43450986192936, lng: 78.54744149413227 },
        { lat: 17.4345055107548, lng: 78.54730223397758 },
        { lat: 17.4344584075865, lng: 78.54721237803584 },
        { lat: 17.43437463826035, lng: 78.54712652778842 },
        { lat: 17.43430427359209, lng: 78.54707167397336 },
        { lat: 17.43423816143615, lng: 78.54704146141029 },
        { lat: 17.43413065985307, lng: 78.54704147514767 },
        { lat: 17.43385949471554, lng: 78.5470359378726 },
        { lat: 17.43375462738515, lng: 78.54702975503288 },
        { lat: 17.43361805977185, lng: 78.54700835937832 },
        { lat: 17.43348902729226, lng: 78.54698977992744 },
        { lat: 17.43334817122102, lng: 78.54698078121295 },
        { lat: 17.43325673625919, lng: 78.54701686013463 },
        { lat: 17.43315617326634, lng: 78.54707603705414 },
        { lat: 17.43307545064822, lng: 78.54708843775052 },
        { lat: 17.43296572280731, lng: 78.5470557701502 },
        { lat: 17.43283935185208, lng: 78.54704508441523 },
        { lat: 17.4326898539915, lng: 78.54708398975767 },
        { lat: 17.43257960381541, lng: 78.54710768220548 },
        { lat: 17.43249519204612, lng: 78.54709417343496 },
        { lat: 17.43224803585539, lng: 78.54699846818752 },
        { lat: 17.4323077019867, lng: 78.54682350142151 },
        { lat: 17.43239841998964, lng: 78.54655952881507 },
        { lat: 17.43246548479365, lng: 78.54640477777917 },
        { lat: 17.4326871023591, lng: 78.5458616794051 },
        { lat: 17.43129351349127, lng: 78.54582353584183 },
        { lat: 17.43044380296591, lng: 78.54552995163563 },
        { lat: 17.4292751584861, lng: 78.54519971992899 },
        { lat: 17.42834413871472, lng: 78.54516127096507 },
        { lat: 17.42831892031667, lng: 78.54512945426775 },
        { lat: 17.4277702978252, lng: 78.54494217652655 },
        { lat: 17.42778421980829, lng: 78.54470270025385 },
        { lat: 17.42781528231196, lng: 78.54452089485908 },
        { lat: 17.42783942313589, lng: 78.54419609786275 },
        { lat: 17.42770891273515, lng: 78.54399731448538 },
        { lat: 17.42703397151439, lng: 78.54340355050918 },
        { lat: 17.42653892397648, lng: 78.54299835583552 },
        { lat: 17.42640866499341, lng: 78.54291843063604 },
        { lat: 17.42610815859674, lng: 78.54279191966474 },
        { lat: 17.42579542974523, lng: 78.54262932339128 },
        { lat: 17.4254723656978, lng: 78.54242087089492 },
        { lat: 17.42556042604555, lng: 78.54226260240061 },
        { lat: 17.42560457920953, lng: 78.54217971507116 },
        { lat: 17.4255929625973, lng: 78.54213827140345 },
        { lat: 17.42540786168664, lng: 78.54199720594653 },
        { lat: 17.42533541502839, lng: 78.5419454987616 },
        { lat: 17.42521621026782, lng: 78.54188217854175 },
        { lat: 17.4249975071199, lng: 78.54166264468633 },
        { lat: 17.42487566989227, lng: 78.54153050122929 },
        { lat: 17.42457786174237, lng: 78.54121877821534 },
        { lat: 17.42459028070742, lng: 78.54120579119397 },
        { lat: 17.4242313510791, lng: 78.54082167220675 },
        { lat: 17.42481333039645, lng: 78.54017508824604 },
        { lat: 17.42515570335162, lng: 78.53981121378149 },
        { lat: 17.42530911449316, lng: 78.53962756287177 },
        { lat: 17.4253740988624, lng: 78.5395702923402 },
        { lat: 17.42594432777437, lng: 78.5390351310311 },
        { lat: 17.42470336066491, lng: 78.5357568199154 },
        { lat: 17.42470835518487, lng: 78.53575095318809 },
        { lat: 17.42470353755779, lng: 78.5357296491963 },
        { lat: 17.42480994160584, lng: 78.53542430489993 },
        { lat: 17.42513371742454, lng: 78.53417007704516 },
        { lat: 17.42555498070515, lng: 78.53292737294265 },
        { lat: 17.4252976165581, lng: 78.53286668273066 },
        { lat: 17.42423157367782, lng: 78.53279905928407 },
        { lat: 17.42351628298117, lng: 78.53239807070803 },
        { lat: 17.42240794488634, lng: 78.53220765976444 },
        { lat: 17.42089735192485, lng: 78.53440445359328 },
        { lat: 17.41912866208777, lng: 78.535003244127 },
        { lat: 17.41727500362046, lng: 78.53515149733086 },
        { lat: 17.41545508753694, lng: 78.53484747479656 },
        { lat: 17.41292041656522, lng: 78.53418378428294 },
        { lat: 17.41188751353743, lng: 78.5337049138901 },
        { lat: 17.4104654143408, lng: 78.53355990445905 },
        { lat: 17.40943621787517, lng: 78.53336856772104 },
        { lat: 17.40844606226063, lng: 78.53313553931737 },
        { lat: 17.40678813391509, lng: 78.53311692093587 },
        { lat: 17.40544404233806, lng: 78.53297086002459 },
        { lat: 17.40465438268949, lng: 78.53294051230901 },
        { lat: 17.40386154552853, lng: 78.53266380194842 },
        { lat: 17.40223570027284, lng: 78.53215195190818 },
        { lat: 17.40143862408103, lng: 78.5315468756002 },
        { lat: 17.40083621367207, lng: 78.53069277391782 },
        { lat: 17.39936546339029, lng: 78.52993260282919 },
        { lat: 17.39880042494153, lng: 78.5289959768318 },
        { lat: 17.39823545446616, lng: 78.52797717732355 },
        { lat: 17.39690460049102, lng: 78.52777861277377 },
        { lat: 17.39686804856173, lng: 78.52785241479494 },
        { lat: 17.39662673246989, lng: 78.5283414061165 },
        { lat: 17.39652841025735, lng: 78.52878318229337 },
        { lat: 17.39648639075266, lng: 78.5288501354683 },
        { lat: 17.39632039294807, lng: 78.5290489980931 },
        { lat: 17.39626894622342, lng: 78.52903536658643 },
        { lat: 17.39618507805067, lng: 78.52900538599889 },
        { lat: 17.39608016376195, lng: 78.52875615810895 },
        { lat: 17.39595514187167, lng: 78.52844287277559 },
        { lat: 17.39569311277756, lng: 78.52849104979845 },
        { lat: 17.39559291236698, lng: 78.52811903892825 },
        { lat: 17.39513703292301, lng: 78.52811032021881 },
        { lat: 17.39509645309396, lng: 78.52794801445458 },
        { lat: 17.39495983528498, lng: 78.52796020663268 },
        { lat: 17.3946748640226, lng: 78.52796716722716 },
        { lat: 17.39452933628445, lng: 78.52795803408227 },
        { lat: 17.39436561155774, lng: 78.52793908250712 },
        { lat: 17.39427273387353, lng: 78.52794797070385 },
        { lat: 17.3942041238195, lng: 78.52795152232737 },
        { lat: 17.39410819302688, lng: 78.52792992568145 },
        { lat: 17.39388063840793, lng: 78.52787504386293 },
        { lat: 17.39273328949539, lng: 78.5276037865978 },
        { lat: 17.39213569060184, lng: 78.52747487883146 },
        { lat: 17.39165478292566, lng: 78.52738788773064 },
        { lat: 17.39149418067521, lng: 78.52737892365143 },
        { lat: 17.39148698174115, lng: 78.5277636111052 },
        { lat: 17.39058662293529, lng: 78.52777552617974 },
        { lat: 17.39051843813237, lng: 78.52772191405649 },
        { lat: 17.39022698196183, lng: 78.52774413570738 },
        { lat: 17.39008254201378, lng: 78.52775208719002 },
        { lat: 17.38998226579329, lng: 78.52776117882802 },
        { lat: 17.38993635224773, lng: 78.52775928795573 },
        { lat: 17.38984475299536, lng: 78.52775129628579 },
        { lat: 17.38969160784132, lng: 78.52771471198842 },
        { lat: 17.3895496606614, lng: 78.52767650784764 },
        { lat: 17.38946773601741, lng: 78.52765715787714 },
        { lat: 17.38933184280476, lng: 78.5276100326003 },
        { lat: 17.3892121266794, lng: 78.52759172961525 },
        { lat: 17.38899540615096, lng: 78.52752189463713 },
        { lat: 17.38843305935754, lng: 78.52740742538919 },
        { lat: 17.38831239591097, lng: 78.52739132241523 },
        { lat: 17.38812401976863, lng: 78.52729439755242 },
        { lat: 17.38810930888528, lng: 78.52730787705262 },
        { lat: 17.3878988443588, lng: 78.52726008010423 },
        { lat: 17.38651273425459, lng: 78.52690621833948 },
        { lat: 17.38648304456581, lng: 78.52721026583254 },
        { lat: 17.38620886652127, lng: 78.5270695939411 },
        { lat: 17.38494560459353, lng: 78.52695217054685 },
        { lat: 17.3847681732783, lng: 78.5269047779289 },
        { lat: 17.38466754164844, lng: 78.52726950930784 },
        { lat: 17.38435636625089, lng: 78.5272288908283 },
        { lat: 17.38406914603994, lng: 78.52719292765099 },
        { lat: 17.3839294823777, lng: 78.52749347154288 },
        { lat: 17.38377563640889, lng: 78.5274208721573 },
        { lat: 17.38358642661848, lng: 78.52796599167895 },
        { lat: 17.38354881224186, lng: 78.52801627489039 },
        { lat: 17.38343859263145, lng: 78.52799286605429 },
        { lat: 17.38341488309081, lng: 78.5280081178191 },
        { lat: 17.38324688678128, lng: 78.52795064146635 },
        { lat: 17.38294631644217, lng: 78.527994500683 },
        { lat: 17.38265126474897, lng: 78.52809801934607 },
        { lat: 17.38216083736508, lng: 78.52824896122341 },
        { lat: 17.38173906331478, lng: 78.52825680631906 },
        { lat: 17.38166390610478, lng: 78.528260612309 },
        { lat: 17.3815923477811, lng: 78.52827152939294 },
        { lat: 17.38094775649655, lng: 78.52814481579813 },
        { lat: 17.38072866526898, lng: 78.52811042605359 },
        { lat: 17.38060997319513, lng: 78.52808444547712 },
        { lat: 17.38056232112485, lng: 78.52807629871401 },
        { lat: 17.38034181943558, lng: 78.52802450598794 },
        { lat: 17.38025965530749, lng: 78.52795094440253 },
        { lat: 17.38025774477845, lng: 78.52779666193389 },
        { lat: 17.38039978476196, lng: 78.52730196341246 },
        { lat: 17.38060450260866, lng: 78.52685122114659 },
        { lat: 17.38072591479564, lng: 78.52662061516473 },
        { lat: 17.3807442689331, lng: 78.52658006011963 },
        { lat: 17.38050718241686, lng: 78.52652559955786 },
        { lat: 17.38005319429563, lng: 78.52642131677958 },
        { lat: 17.37945613931694, lng: 78.52641998646287 },
        { lat: 17.37942547573267, lng: 78.52644528079585 },
        { lat: 17.37918993903418, lng: 78.52635436155224 },
        { lat: 17.37901621488417, lng: 78.52626945320019 },
        { lat: 17.37712261430456, lng: 78.52545593708739 },
        { lat: 17.37685816920079, lng: 78.52534712238099 },
        { lat: 17.37633961085136, lng: 78.52515623463088 },
        { lat: 17.37605875645523, lng: 78.5250554805628 },
        { lat: 17.37591474586683, lng: 78.52500515273721 },
        { lat: 17.3757777650761, lng: 78.524943531241 },
        { lat: 17.3756226820644, lng: 78.52488688082451 },
        { lat: 17.37539231442142, lng: 78.52481033602523 },
        { lat: 17.37513376772199, lng: 78.52477399103073 },
        { lat: 17.37472168313185, lng: 78.52468993571603 },
        { lat: 17.37428080079265, lng: 78.52459631406792 },
        { lat: 17.37387839768992, lng: 78.52452208285035 },
        { lat: 17.37249191233208, lng: 78.524238575929 },
        { lat: 17.37146277282696, lng: 78.52398275243638 },
        { lat: 17.37140358985268, lng: 78.52396918872904 },
        { lat: 17.37129429569638, lng: 78.52394751061897 },
        { lat: 17.37117994955158, lng: 78.5239234802521 },
        { lat: 17.37112634668415, lng: 78.52390765744336 },
        { lat: 17.3710211490381, lng: 78.5238838982226 },
        { lat: 17.37093331145652, lng: 78.52384900109324 },
        { lat: 17.37087173764416, lng: 78.52382990022856 },
        { lat: 17.37082660108997, lng: 78.52381950100957 },
        { lat: 17.37078918849803, lng: 78.52381169185334 },
        { lat: 17.3706017845372, lng: 78.52375257241923 },
        { lat: 17.37018179090043, lng: 78.52360889784305 },
        { lat: 17.37012431746446, lng: 78.52359640617804 },
        { lat: 17.36997100607552, lng: 78.52355684479429 },
        { lat: 17.36985107398835, lng: 78.52352112662115 },
        { lat: 17.3698941479661, lng: 78.52391127267514 },
        { lat: 17.36991356884413, lng: 78.52434670174046 },
        { lat: 17.36991304592164, lng: 78.52434757977177 },
        { lat: 17.36991355470736, lng: 78.52436028147748 },
        { lat: 17.37005576994657, lng: 78.52432879525533 },
        { lat: 17.37034261602894, lng: 78.52428217932741 },
        { lat: 17.37034008921271, lng: 78.5248496360169 },
        { lat: 17.36969973406811, lng: 78.52485824182664 },
        { lat: 17.36918251556111, lng: 78.5247756000087 },
        { lat: 17.36873615319874, lng: 78.5246769246269 },
        { lat: 17.36857048421347, lng: 78.52462389452381 },
        { lat: 17.36861808511317, lng: 78.52317223013848 },
        { lat: 17.36725617648169, lng: 78.52305294369715 },
        { lat: 17.36716072409583, lng: 78.52306418243616 },
        { lat: 17.36716516653365, lng: 78.52342249033755 },
        { lat: 17.3670302948835, lng: 78.52339454611057 },
        { lat: 17.3670266706673, lng: 78.52342292076239 },
        { lat: 17.36689240286149, lng: 78.52339698317013 },
        { lat: 17.36678619632277, lng: 78.5236963591719 },
        { lat: 17.36652822832395, lng: 78.5242495395425 },
        { lat: 17.36604661926697, lng: 78.52427329627092 },
        { lat: 17.36601253565665, lng: 78.52441560804994 },
        { lat: 17.36562741378642, lng: 78.52445958435555 },
        { lat: 17.36578013872941, lng: 78.52378875853451 },
        { lat: 17.36585541265476, lng: 78.52341023501346 },
        { lat: 17.36525127911969, lng: 78.52336690289724 },
        { lat: 17.36521870378514, lng: 78.52341640254771 },
        { lat: 17.36506433995465, lng: 78.52386315001945 },
        { lat: 17.36473787406349, lng: 78.52374610323284 },
        { lat: 17.36481612529329, lng: 78.52345881394808 },
        { lat: 17.36418148627412, lng: 78.52332323711131 },
        { lat: 17.36411717377199, lng: 78.52353314488492 },
        { lat: 17.36405327764591, lng: 78.52390865150042 },
        { lat: 17.36352485500613, lng: 78.52382611441827 },
        { lat: 17.36358382658546, lng: 78.52333954623982 },
        { lat: 17.36334279928327, lng: 78.52326156105144 },
        { lat: 17.36333321057104, lng: 78.52329040845886 },
        { lat: 17.36312594786539, lng: 78.523287425019 },
        { lat: 17.36311359125016, lng: 78.52351925491168 },
        { lat: 17.36283098345984, lng: 78.52354681212842 },
        { lat: 17.36281970484681, lng: 78.52331777210594 },
        { lat: 17.36267142612316, lng: 78.52330253583631 },
        { lat: 17.36270046385301, lng: 78.52312131818717 },
        { lat: 17.36271589944563, lng: 78.52285607134735 },
        { lat: 17.36263058111227, lng: 78.52194774568216 },
        { lat: 17.3623421033584, lng: 78.52204497097334 },
        { lat: 17.36178471470373, lng: 78.52225542160315 },
        { lat: 17.36141058494833, lng: 78.52244086720445 },
        { lat: 17.36101253403633, lng: 78.52299003614586 },
        { lat: 17.36064084075729, lng: 78.52342592690438 },
        { lat: 17.3602998434998, lng: 78.52378792145451 },
        { lat: 17.36025916410721, lng: 78.52384215508175 },
        { lat: 17.36022353088394, lng: 78.52384076027938 },
        { lat: 17.3602193810434, lng: 78.52384947292859 },
        { lat: 17.36016639002401, lng: 78.52391240091093 },
        { lat: 17.36000641665109, lng: 78.52402031399629 },
        { lat: 17.35984613490746, lng: 78.52410334392408 },
        { lat: 17.35959648310557, lng: 78.52420624054808 },
        { lat: 17.35938267061752, lng: 78.52430865541203 },
        { lat: 17.35931160644807, lng: 78.52435938033825 },
        { lat: 17.35928465400037, lng: 78.5243670909291 },
        { lat: 17.35927482050299, lng: 78.5243988735643 },
        { lat: 17.35920225806812, lng: 78.52447951118742 },
        { lat: 17.35916264279473, lng: 78.52453319109794 },
        { lat: 17.35910986946298, lng: 78.52459986180118 },
        { lat: 17.3589968707513, lng: 78.5247758349247 },
        { lat: 17.35894000742325, lng: 78.52487188776294 },
        { lat: 17.35876109540139, lng: 78.52523835789458 },
        { lat: 17.35874103686178, lng: 78.52530570542329 },
        { lat: 17.35863765253004, lng: 78.52561840724421 },
        { lat: 17.35859411355154, lng: 78.52574936707114 },
        { lat: 17.35844259572544, lng: 78.52591695761001 },
        { lat: 17.35843026233255, lng: 78.52594177685177 },
        { lat: 17.3584239804881, lng: 78.5259491532564 },
        { lat: 17.35828748080471, lng: 78.52621601527677 },
        { lat: 17.35819129474264, lng: 78.52641890343138 },
        { lat: 17.3581379016806, lng: 78.5265247413237 },
        { lat: 17.35807421960203, lng: 78.52665193881852 },
        { lat: 17.35792318714511, lng: 78.52690400726765 },
        { lat: 17.35774781542932, lng: 78.52721618395803 },
        { lat: 17.35757588982932, lng: 78.52751711384174 },
        { lat: 17.35752002188013, lng: 78.52763731257981 },
        { lat: 17.35745319792676, lng: 78.52781718626869 },
        { lat: 17.35740416119123, lng: 78.52796209259137 },
        { lat: 17.35734031775907, lng: 78.5281677619422 },
        { lat: 17.3571623477169, lng: 78.52870519234426 },
        { lat: 17.35713553713687, lng: 78.52878678192864 },
        { lat: 17.3570900316284, lng: 78.5289785473033 },
        { lat: 17.35705653626496, lng: 78.52902719735121 },
        { lat: 17.35704704109848, lng: 78.52905609306488 },
        { lat: 17.35699471792075, lng: 78.52920534869807 },
        { lat: 17.356906443192, lng: 78.5294590735935 },
        { lat: 17.35689385405741, lng: 78.52949393334004 },
        { lat: 17.35682003458699, lng: 78.52970355030169 },
        { lat: 17.35667322799728, lng: 78.53001295297459 },
        { lat: 17.35659948463569, lng: 78.53013587494581 },
        { lat: 17.35658709995686, lng: 78.53015651838255 },
        { lat: 17.35647575537044, lng: 78.53028867227418 },
        { lat: 17.35643210839872, lng: 78.5303279039346 },
        { lat: 17.35639533979595, lng: 78.53035232018206 },
        { lat: 17.35639059487018, lng: 78.53035449150829 },
        { lat: 17.35626633240132, lng: 78.53040617904072 },
        { lat: 17.35616698529865, lng: 78.5304484959831 },
        { lat: 17.35607123041853, lng: 78.53048431452505 },
        { lat: 17.35599024499126, lng: 78.53052377820543 },
        { lat: 17.35589309916536, lng: 78.53056515695309 },
        { lat: 17.35582748491585, lng: 78.530603090357 },
        { lat: 17.35572097341379, lng: 78.53065499118823 },
        { lat: 17.35561608910551, lng: 78.53072170149608 },
        { lat: 17.35556984662673, lng: 78.53076258158235 },
        { lat: 17.35552909914348, lng: 78.5308152143602 },
        { lat: 17.35551062398175, lng: 78.53084266405175 },
        { lat: 17.35549815238365, lng: 78.53087177990118 },
        { lat: 17.3554519726747, lng: 78.53099210907297 },
        { lat: 17.35544412476828, lng: 78.53101040981657 },
        { lat: 17.3554155600862, lng: 78.5309426194639 },
        { lat: 17.35536790189324, lng: 78.53085215083483 },
        { lat: 17.35522802488861, lng: 78.53089446180478 },
        { lat: 17.35512843612319, lng: 78.5309017267207 },
        { lat: 17.35500125990487, lng: 78.53090218014107 },
        { lat: 17.35435557740847, lng: 78.5307893895602 },
        { lat: 17.35421189394255, lng: 78.53076543346172 },
        { lat: 17.35384245349125, lng: 78.53072857517851 },
        { lat: 17.35361856005585, lng: 78.53071166675184 },
        { lat: 17.35355132416483, lng: 78.53071462798852 },
        { lat: 17.35330818590879, lng: 78.53073042734255 },
        { lat: 17.35329513355046, lng: 78.53072590987448 },
        { lat: 17.35329372436641, lng: 78.53072597107199 },
        { lat: 17.35263517129735, lng: 78.5304998796917 },
        { lat: 17.35232616237291, lng: 78.53040248933348 },
        { lat: 17.3521767680428, lng: 78.53038060116369 },
        { lat: 17.35213125231436, lng: 78.53040163984903 },
        { lat: 17.3521013206561, lng: 78.53040650070497 },
        { lat: 17.35204085569105, lng: 78.53054168822878 },
        { lat: 17.35199423438764, lng: 78.53063687432771 },
        { lat: 17.35168876089444, lng: 78.53067082688663 },
        { lat: 17.35139161074763, lng: 78.53067480640878 },
        { lat: 17.35128941705965, lng: 78.53066920201546 },
        { lat: 17.35128939544079, lng: 78.53056163741581 },
        { lat: 17.3512772787806, lng: 78.53044019197942 },
        { lat: 17.35126256967158, lng: 78.53035303015629 },
        { lat: 17.35124735984784, lng: 78.53032784842691 },
        { lat: 17.35112318694491, lng: 78.53015582676258 },
        { lat: 17.3508654215814, lng: 78.52979596676417 },
        { lat: 17.35063235048383, lng: 78.5295004747368 },
        { lat: 17.35056961102193, lng: 78.5294515472191 },
        { lat: 17.3505160481159, lng: 78.52943870927591 },
        { lat: 17.3504462608529, lng: 78.52942831020088 },
        { lat: 17.3503369600689, lng: 78.52940190354974 },
        { lat: 17.35026760437724, lng: 78.52935903701665 },
        { lat: 17.3502325083838, lng: 78.52930376607198 },
        { lat: 17.35022382894725, lng: 78.52922027108211 },
        { lat: 17.35022323217112, lng: 78.52920852459269 },
        { lat: 17.35021146020177, lng: 78.52909054590248 },
        { lat: 17.35020427270576, lng: 78.5289247523939 },
        { lat: 17.35020273867359, lng: 78.5289060154384 },
        { lat: 17.35017949573762, lng: 78.52887384643624 },
        { lat: 17.35016075169082, lng: 78.52885482471748 },
        { lat: 17.34973999265938, lng: 78.52864894519138 },
        { lat: 17.3497039392861, lng: 78.5286231393378 },
        { lat: 17.34950640761769, lng: 78.52849480245166 },
        { lat: 17.34929231109501, lng: 78.52833281370562 },
        { lat: 17.34912947954592, lng: 78.52817598621776 },
        { lat: 17.34893095466526, lng: 78.5279562241091 },
        { lat: 17.34884017536331, lng: 78.5278709336649 },
        { lat: 17.34884216341256, lng: 78.52785793373711 },
        { lat: 17.34884163226804, lng: 78.52785734551988 },
        { lat: 17.34885026542535, lng: 78.52774375828524 },
        { lat: 17.34886820084087, lng: 78.52768678208862 },
        { lat: 17.34897430924743, lng: 78.52768685307863 },
        { lat: 17.3491608554646, lng: 78.52767698989288 },
        { lat: 17.34944288282281, lng: 78.52781308441656 },
        { lat: 17.34968894318132, lng: 78.52798099536139 },
        { lat: 17.34971224463376, lng: 78.52799348704484 },
        { lat: 17.34983030201319, lng: 78.52803221737462 },
        { lat: 17.34996263947171, lng: 78.52806627668203 },
        { lat: 17.35017998639944, lng: 78.52813353725033 },
        { lat: 17.35040573211634, lng: 78.52818426124075 },
        { lat: 17.35041244732472, lng: 78.52818445713915 },
        { lat: 17.35049714830465, lng: 78.52817911764932 },
        { lat: 17.3505280028552, lng: 78.52816862177409 },
        { lat: 17.35059267907635, lng: 78.52813229000989 },
        { lat: 17.35062667263733, lng: 78.52807827787113 },
        { lat: 17.35067144154556, lng: 78.52798809404823 },
        { lat: 17.3507041018311, lng: 78.52796227368607 },
        { lat: 17.3507712423094, lng: 78.52794196424328 },
        { lat: 17.35094570502239, lng: 78.52793150585441 },
        { lat: 17.35113476524966, lng: 78.5279666669376 },
        { lat: 17.35127769375467, lng: 78.52798135080731 },
        { lat: 17.35138482974465, lng: 78.52798512397291 },
        { lat: 17.35158578117607, lng: 78.52797917660358 },
        { lat: 17.35199394234886, lng: 78.52792015689711 },
        { lat: 17.35204147805822, lng: 78.52790874310183 },
        { lat: 17.35216334499518, lng: 78.52786461839396 },
        { lat: 17.35250042306028, lng: 78.52768092969548 },
        { lat: 17.35307925195543, lng: 78.52733473570513 },
        { lat: 17.35321311881138, lng: 78.52733791756714 },
        { lat: 17.35366192971849, lng: 78.52710669111252 },
        { lat: 17.353932445253, lng: 78.52696848723483 },
        { lat: 17.35401663245465, lng: 78.52692111876367 },
        { lat: 17.35406906136849, lng: 78.52687558143145 },
        { lat: 17.35415633126735, lng: 78.52679397580262 },
        { lat: 17.35433084431271, lng: 78.52670204922953 },
        { lat: 17.35443272921042, lng: 78.52664095494384 },
        { lat: 17.35444995176295, lng: 78.52659677857885 },
        { lat: 17.35445900447898, lng: 78.52636273899385 },
        { lat: 17.35445524793052, lng: 78.52605919409098 },
        { lat: 17.35442863975991, lng: 78.52577991216806 },
        { lat: 17.35437257760378, lng: 78.52543982648673 },
        { lat: 17.35435202337968, lng: 78.52522733610212 },
        { lat: 17.3543615047353, lng: 78.525124559582 },
        { lat: 17.35307086428856, lng: 78.52511202191805 },
        { lat: 17.35306389416978, lng: 78.52511946942047 },
        { lat: 17.35298695406666, lng: 78.52518114045525 },
        { lat: 17.35246996163206, lng: 78.52520860219684 },
        { lat: 17.3522437885284, lng: 78.52521283531351 },
        { lat: 17.35201784616836, lng: 78.52501478190084 },
        { lat: 17.35182370841829, lng: 78.52501738787504 },
        { lat: 17.35150067865624, lng: 78.52498439683798 },
        { lat: 17.35128467559335, lng: 78.52493410558752 },
        { lat: 17.35092281811332, lng: 78.52490163679497 },
        { lat: 17.35066326138548, lng: 78.52484250737831 },
        { lat: 17.35058414513497, lng: 78.52482587182074 },
        { lat: 17.35033949620481, lng: 78.52477820191314 },
        { lat: 17.35027165110616, lng: 78.5247719102147 },
        { lat: 17.3501876929919, lng: 78.52477631299017 },
        { lat: 17.35008184853458, lng: 78.52478485150591 },
        { lat: 17.3498570398553, lng: 78.52479365132889 },
        { lat: 17.34977662548654, lng: 78.52479786729701 },
        { lat: 17.34970388103612, lng: 78.52477046965716 },
        { lat: 17.34968009853612, lng: 78.52476349245579 },
        { lat: 17.34954749502043, lng: 78.5247658949783 },
        { lat: 17.34945529622125, lng: 78.52475033515407 },
        { lat: 17.34900633660208, lng: 78.52477626984523 },
        { lat: 17.34849990841582, lng: 78.52479301947304 },
        { lat: 17.34831195390968, lng: 78.52483887740897 },
        { lat: 17.34806067562174, lng: 78.52489010228796 },
        { lat: 17.34787153295213, lng: 78.52488550801105 },
        { lat: 17.347838293865, lng: 78.52488657200726 },
        { lat: 17.34783995397943, lng: 78.52490889964142 },
        { lat: 17.34762002773341, lng: 78.5249217592489 },
        { lat: 17.34762250588024, lng: 78.52499645854843 },
        { lat: 17.34752443574997, lng: 78.52500020674961 },
        { lat: 17.34737963475716, lng: 78.52500214993908 },
        { lat: 17.34724622798009, lng: 78.52499614070753 },
        { lat: 17.34725522168179, lng: 78.52513613353206 },
        { lat: 17.34711967162033, lng: 78.52514450766984 },
        { lat: 17.34701900794018, lng: 78.52514246044585 },
        { lat: 17.34683629970178, lng: 78.52515376682969 },
        { lat: 17.34681142133212, lng: 78.52505554300296 },
        { lat: 17.34660137690838, lng: 78.52507458027075 },
        { lat: 17.34660902831164, lng: 78.52518413949376 },
        { lat: 17.34640215480282, lng: 78.52521191252659 },
        { lat: 17.34641048250755, lng: 78.52540831848195 },
        { lat: 17.34596944528802, lng: 78.52549510797705 },
        { lat: 17.34572460974022, lng: 78.52550461298249 },
        { lat: 17.34567951614248, lng: 78.52572295126657 },
        { lat: 17.34554444036355, lng: 78.52572856652641 },
        { lat: 17.34524371080936, lng: 78.525722336115 },
        { lat: 17.3452225690441, lng: 78.52586638175151 },
        { lat: 17.34470117222777, lng: 78.52584182967406 },
        { lat: 17.34461203064442, lng: 78.52588035103486 },
        { lat: 17.34461259744391, lng: 78.52640911825728 },
        { lat: 17.3445412494472, lng: 78.52692018882456 },
        { lat: 17.3443263570337, lng: 78.52693551048806 },
        { lat: 17.3442978385622, lng: 78.5270246268981 },
        { lat: 17.34410341526298, lng: 78.5270456629304 },
        { lat: 17.34406734196883, lng: 78.52699086154908 },
        { lat: 17.34384728668024, lng: 78.52708595187997 },
        { lat: 17.3437733652603, lng: 78.52708694282663 },
        { lat: 17.34368811474329, lng: 78.52711051313797 },
        { lat: 17.34367463477898, lng: 78.52708332226624 },
        { lat: 17.34354942168669, lng: 78.52710366354506 },
        { lat: 17.34349447622705, lng: 78.52700859874346 },
        { lat: 17.34338825582316, lng: 78.5267288400632 },
        { lat: 17.34335772656816, lng: 78.5265822374932 },
        { lat: 17.34333578962005, lng: 78.52651232064021 },
        { lat: 17.3436169800295, lng: 78.52635191067341 },
        { lat: 17.34349037745557, lng: 78.52613247109299 },
        { lat: 17.34353465705871, lng: 78.5260647651134 },
        { lat: 17.34357855728481, lng: 78.52602955284686 },
        { lat: 17.34366833476089, lng: 78.52614970008075 },
        { lat: 17.34379382043124, lng: 78.52634032459325 },
        { lat: 17.34413003423336, lng: 78.52633581610299 },
        { lat: 17.34410493194406, lng: 78.52573723491255 },
        { lat: 17.34397992259373, lng: 78.52564677140215 },
        { lat: 17.34387443350918, lng: 78.52570346934958 },
        { lat: 17.3435994708484, lng: 78.52565187447352 },
        { lat: 17.34374144831364, lng: 78.52496812466063 },
        { lat: 17.34374317849552, lng: 78.52492276779358 },
        { lat: 17.34373200592211, lng: 78.52491637200059 },
        { lat: 17.34375921914686, lng: 78.52479805924601 },
        { lat: 17.34325815656105, lng: 78.52471495318582 },
        { lat: 17.34332717018663, lng: 78.52433430717335 },
        { lat: 17.34346473301587, lng: 78.52370938163119 },
        { lat: 17.34359903798914, lng: 78.5231302850601 },
        { lat: 17.34375383628292, lng: 78.5226623896267 },
        { lat: 17.34389623603181, lng: 78.52229534803038 },
        { lat: 17.34391527714205, lng: 78.52223944731386 },
        { lat: 17.34370786794839, lng: 78.52221058253176 },
        { lat: 17.34377139580273, lng: 78.52189102203944 },
        { lat: 17.34381222890729, lng: 78.52163765953523 },
        { lat: 17.3438466970717, lng: 78.52148789648811 },
        { lat: 17.34386815515628, lng: 78.52136816632212 },
        { lat: 17.3439067920812, lng: 78.52124621714331 },
        { lat: 17.34395730661267, lng: 78.52109922340824 },
        { lat: 17.34397112979357, lng: 78.52103832262303 },
        { lat: 17.34370024993435, lng: 78.52092600644247 },
        { lat: 17.34353218242883, lng: 78.5209004196044 },
        { lat: 17.34339493668312, lng: 78.52087375179289 },
        { lat: 17.34336703916614, lng: 78.5208686070865 },
        { lat: 17.34354404196655, lng: 78.5205225730424 },
        { lat: 17.34364616646064, lng: 78.52008574188352 },
        { lat: 17.3434243000669, lng: 78.52002029593282 },
        { lat: 17.34345784592054, lng: 78.51982240283951 },
        { lat: 17.3435551327905, lng: 78.51948976646908 },
        { lat: 17.34373367397849, lng: 78.51890396943651 },
        { lat: 17.34380655071953, lng: 78.51895269594607 },
        { lat: 17.34388951836385, lng: 78.5189704139361 },
        { lat: 17.34402094111039, lng: 78.51899205657426 },
        { lat: 17.34423652615414, lng: 78.51903270280738 },
        { lat: 17.34429376515121, lng: 78.51903590364877 },
        { lat: 17.34434569016058, lng: 78.51903004960741 },
        { lat: 17.34444070852407, lng: 78.51898398064287 },
        { lat: 17.34459315148928, lng: 78.51882298821972 },
        { lat: 17.34477050321733, lng: 78.51867130221021 },
        { lat: 17.34497659584846, lng: 78.51874940141876 },
        { lat: 17.34506729345665, lng: 78.5185957695999 },
        { lat: 17.34517835676981, lng: 78.51839831767403 },
        { lat: 17.3452563363572, lng: 78.51818264782646 },
        { lat: 17.34553468017314, lng: 78.51822555985311 },
        { lat: 17.34557644376003, lng: 78.51812879443955 },
        { lat: 17.34560823375277, lng: 78.51805996187507 },
        { lat: 17.34581699884632, lng: 78.5177582324035 },
        { lat: 17.34599594718896, lng: 78.51756666334651 },
        { lat: 17.34618745182424, lng: 78.51733718431569 },
        { lat: 17.34634518430675, lng: 78.51704889682642 },
        { lat: 17.34658638711624, lng: 78.51674704904308 },
        { lat: 17.34762765744098, lng: 78.51689475646819 },
        { lat: 17.34799323623555, lng: 78.51697694537056 },
        { lat: 17.34813626663379, lng: 78.51659554077975 },
        { lat: 17.34874818543986, lng: 78.51679881399484 },
        { lat: 17.34962968087615, lng: 78.5170606687537 },
        { lat: 17.34970528424136, lng: 78.5171129018646 },
        { lat: 17.34996424492508, lng: 78.51718257476648 },
        { lat: 17.35018312063679, lng: 78.51725726619489 },
        { lat: 17.35032854830413, lng: 78.51730607272633 },
        { lat: 17.35036614346212, lng: 78.51721598363422 },
        { lat: 17.35054201045578, lng: 78.51729125427697 },
        { lat: 17.35060541652653, lng: 78.51708585218452 },
        { lat: 17.35079865390195, lng: 78.51717432680822 },
        { lat: 17.35090715706161, lng: 78.51690560795379 },
        { lat: 17.35063600422368, lng: 78.51677787097535 },
        { lat: 17.35072798085643, lng: 78.5166023173265 },
        { lat: 17.35079489367307, lng: 78.51640980898053 },
        { lat: 17.35070589951463, lng: 78.51636372662047 },
        { lat: 17.35077237753008, lng: 78.5161363849906 },
        { lat: 17.35069247462486, lng: 78.51610174756766 },
        { lat: 17.35077403446341, lng: 78.51588503168179 },
        { lat: 17.3509439140245, lng: 78.51551694489328 },
        { lat: 17.35100253534654, lng: 78.51542657189752 },
        { lat: 17.35108520681035, lng: 78.5151973298349 },
        { lat: 17.35109346677354, lng: 78.51517284062038 },
        { lat: 17.35109883633729, lng: 78.51515953534644 },
        { lat: 17.35120813945545, lng: 78.51485643925069 },
        { lat: 17.35124063216623, lng: 78.51477886006757 },
        { lat: 17.35122873438588, lng: 78.5147680607137 },
        { lat: 17.35120811674407, lng: 78.51475157973223 },
        { lat: 17.35079898635983, lng: 78.51457322093023 },
        { lat: 17.35054853324478, lng: 78.51446967107282 },
        { lat: 17.35026997431185, lng: 78.5143614470068 },
        { lat: 17.3499506097614, lng: 78.51423884380033 },
        { lat: 17.3498113461858, lng: 78.51418597562346 },
        { lat: 17.34959996760134, lng: 78.5140992427031 },
        { lat: 17.34938861993698, lng: 78.51401499808907 },
        { lat: 17.34916982618412, lng: 78.51390845801566 },
        { lat: 17.34938871181672, lng: 78.51346359911213 },
        { lat: 17.34976866362948, lng: 78.51267848734203 },
        { lat: 17.34986743822062, lng: 78.51246594649703 },
        { lat: 17.35031717398866, lng: 78.51143195012183 },
        { lat: 17.35059181423209, lng: 78.51064937091621 },
        { lat: 17.35063038857735, lng: 78.51048461432143 },
        { lat: 17.35022361302941, lng: 78.51034456220292 },
        { lat: 17.35000913479812, lng: 78.51027121281913 },
        { lat: 17.34983137391488, lng: 78.51021953154786 },
        { lat: 17.34954385429275, lng: 78.51016583838252 },
        { lat: 17.34956784524396, lng: 78.50998137499502 },
        { lat: 17.34917735590807, lng: 78.50990452859658 },
        { lat: 17.34919995454793, lng: 78.50941649903221 },
        { lat: 17.34900368556499, lng: 78.50939177771839 },
        { lat: 17.34902060028067, lng: 78.50921487324769 },
        { lat: 17.34903050096647, lng: 78.50896377127496 },
        { lat: 17.34903224085496, lng: 78.50889535806608 },
        { lat: 17.34902343192319, lng: 78.50857198760801 },
        { lat: 17.34901271344802, lng: 78.50856241902598 },
        { lat: 17.3486974237902, lng: 78.50859465442551 },
        { lat: 17.3481709535583, lng: 78.50856603961476 },
        { lat: 17.34764631324517, lng: 78.5084584125519 },
        { lat: 17.34682213900241, lng: 78.50829038521114 },
        { lat: 17.34610322169338, lng: 78.50813088895363 },
        { lat: 17.34566221516124, lng: 78.5080273607791 },
        { lat: 17.34472273344556, lng: 78.50781112614284 },
        { lat: 17.34438710604483, lng: 78.50772608121297 },
        { lat: 17.34410397363265, lng: 78.50755617252624 },
        { lat: 17.34403101133483, lng: 78.50750808302566 },
        { lat: 17.3438861311399, lng: 78.50734554592141 },
        { lat: 17.34381751138928, lng: 78.50727592709006 },
        { lat: 17.34377381185929, lng: 78.50721953774098 },
        { lat: 17.34361899076367, lng: 78.50704584800249 },
        { lat: 17.34358437543001, lng: 78.50698784066888 },
        { lat: 17.34359714087558, lng: 78.50691591275674 },
        { lat: 17.34359640900372, lng: 78.50690661677315 },
        { lat: 17.34341368121566, lng: 78.50668316772328 },
        { lat: 17.34329066594615, lng: 78.50648183289782 },
        { lat: 17.34319685304285, lng: 78.50653896145015 },
        { lat: 17.34297411165948, lng: 78.50707446942705 },
        { lat: 17.34264660266847, lng: 78.50802444929688 },
        { lat: 17.34236107558351, lng: 78.50889174527065 },
        { lat: 17.3421412390592, lng: 78.50966110749994 },
        { lat: 17.34252855995805, lng: 78.50986738638582 },
        { lat: 17.34309793741255, lng: 78.51010853010008 },
        { lat: 17.34290620035623, lng: 78.51121592733946 },
        { lat: 17.34277313814953, lng: 78.51223792884613 },
        { lat: 17.34257722123813, lng: 78.51358674429154 },
        { lat: 17.34241548730777, lng: 78.514994817741 },
        { lat: 17.34227580514152, lng: 78.51618772780675 },
        { lat: 17.3421541083339, lng: 78.51716478293103 },
        { lat: 17.34175721413231, lng: 78.51830479024845 },
        { lat: 17.34161784016936, lng: 78.51859800698689 },
        { lat: 17.34132867912113, lng: 78.51920634334436 },
        { lat: 17.34125320516533, lng: 78.51928698483968 },
        { lat: 17.34113851495462, lng: 78.51928852691573 },
        { lat: 17.34107706957463, lng: 78.5193440951863 },
        { lat: 17.34090830452015, lng: 78.51961012171395 },
        { lat: 17.3405400649414, lng: 78.51997836396573 },
        { lat: 17.34029465240666, lng: 78.52023048959325 },
        { lat: 17.33984541844741, lng: 78.5206197242313 },
        { lat: 17.3396134170757, lng: 78.52079701960443 },
        { lat: 17.33932983594825, lng: 78.52105463434017 },
        { lat: 17.33906040390849, lng: 78.52129712765432 },
        { lat: 17.33881927515097, lng: 78.52150938373272 },
        { lat: 17.33871065829196, lng: 78.52161534780012 },
        { lat: 17.33865883185501, lng: 78.52167576312091 },
        { lat: 17.33860583419514, lng: 78.52164163798328 },
        { lat: 17.3385376980034, lng: 78.52154302484863 },
        { lat: 17.33850773082022, lng: 78.52143891852111 },
        { lat: 17.33854300238132, lng: 78.52119957173879 },
        { lat: 17.33872037065567, lng: 78.52047061402797 },
        { lat: 17.33906465255567, lng: 78.51932636001702 },
        { lat: 17.33916602247151, lng: 78.51902142943867 },
        { lat: 17.33932957593124, lng: 78.51872063829326 },
        { lat: 17.33938377327442, lng: 78.51846610523748 },
        { lat: 17.33944274931908, lng: 78.51821150685629 },
        { lat: 17.33941737428817, lng: 78.51809241130586 },
        { lat: 17.33932099604302, lng: 78.5180290124136 },
        { lat: 17.3386884082856, lng: 78.51789320340589 },
        { lat: 17.33829022853307, lng: 78.51777414637434 },
        { lat: 17.33816622723426, lng: 78.51779571879057 },
        { lat: 17.33770608290327, lng: 78.51807561534004 },
        { lat: 17.33718424406176, lng: 78.51839117564836 },
        { lat: 17.33722886168156, lng: 78.51850420767958 },
        { lat: 17.33695643665822, lng: 78.52023968698003 },
        { lat: 17.33736677904508, lng: 78.52037600162151 },
        { lat: 17.33729209224642, lng: 78.52071291836498 },
        { lat: 17.33731452115794, lng: 78.52078726621718 },
        { lat: 17.3374729612305, lng: 78.52084485463433 },
        { lat: 17.33741913032699, lng: 78.52112923866707 },
        { lat: 17.33752776184641, lng: 78.52121735729493 },
        { lat: 17.33781559755827, lng: 78.52130306711231 },
        { lat: 17.33767731997826, lng: 78.52171548508726 },
        { lat: 17.3374083927973, lng: 78.52257754499055 },
        { lat: 17.33805061061828, lng: 78.5229123017076 },
        { lat: 17.3381346878224, lng: 78.52275441429704 },
        { lat: 17.33916435857055, lng: 78.52311383107161 },
        { lat: 17.33986235047536, lng: 78.52332094256899 },
        { lat: 17.33988678661413, lng: 78.52333059465998 },
        { lat: 17.34029042363287, lng: 78.52348999903272 },
        { lat: 17.34058653634208, lng: 78.52366518251294 },
        { lat: 17.34095011345221, lng: 78.52385246669903 },
        { lat: 17.34085166551359, lng: 78.52421834344926 },
        { lat: 17.34075189251483, lng: 78.5244983719505 },
        { lat: 17.34071057789597, lng: 78.52455864534484 },
        { lat: 17.34065744936975, lng: 78.5245912086273 },
        { lat: 17.34073225780444, lng: 78.52467555342366 },
        { lat: 17.34092289030401, lng: 78.52472477192721 },
        { lat: 17.34091242227557, lng: 78.52510365033372 },
        { lat: 17.34086902198051, lng: 78.52543836447958 },
        { lat: 17.34003400134424, lng: 78.52514790872054 },
        { lat: 17.33927389299472, lng: 78.52503840870335 },
        { lat: 17.33834556114228, lng: 78.52819682086304 },
        { lat: 17.33823765531975, lng: 78.52861662717258 },
        { lat: 17.33920034301211, lng: 78.52882665414867 },
        { lat: 17.33994731191281, lng: 78.52893608929338 },
        { lat: 17.33988162224061, lng: 78.52942218623389 },
        { lat: 17.33978677084307, lng: 78.53044987881853 },
        { lat: 17.33977809186, lng: 78.53061795490107 },
        { lat: 17.33807927011419, lng: 78.53064442145084 },
        { lat: 17.33771808616283, lng: 78.53063794660808 },
        { lat: 17.33761707655608, lng: 78.53103090081156 },
        { lat: 17.3382147572762, lng: 78.531101445937 },
        { lat: 17.33858100626223, lng: 78.53095720204152 },
        { lat: 17.33996269059368, lng: 78.53079439333489 },
        { lat: 17.34002383836305, lng: 78.53090803632641 },
        { lat: 17.34005625185992, lng: 78.53101708792575 },
        { lat: 17.34006685409043, lng: 78.5311015487624 },
        { lat: 17.34006738145372, lng: 78.53133792973273 },
        { lat: 17.34007909291066, lng: 78.5317060416687 },
        { lat: 17.34003777204417, lng: 78.53184345186743 },
        { lat: 17.33997847122852, lng: 78.53207316870417 },
        { lat: 17.3397234498142, lng: 78.53212883332633 },
        { lat: 17.33947400454414, lng: 78.53224911996995 },
        { lat: 17.33931186240735, lng: 78.53227865943045 },
        { lat: 17.33920151958615, lng: 78.53224529877245 },
        { lat: 17.33913342801304, lng: 78.53253733931636 },
        { lat: 17.33905047795123, lng: 78.532787277662 },
        { lat: 17.33900805164764, lng: 78.53283512249251 },
        { lat: 17.33895539569098, lng: 78.53302244830628 },
        { lat: 17.33893680597336, lng: 78.53325908463331 },
        { lat: 17.33888056766845, lng: 78.53354350079589 },
        { lat: 17.33899630203992, lng: 78.53362655619395 },
        { lat: 17.33913415491754, lng: 78.53375908119529 },
        { lat: 17.33925941942675, lng: 78.53403360763184 },
        { lat: 17.33924752208158, lng: 78.53411538316655 },
        { lat: 17.33920668390087, lng: 78.53429209981452 },
        { lat: 17.33921901779417, lng: 78.53436210525105 },
        { lat: 17.33917454028322, lng: 78.53459261752799 },
        { lat: 17.33913541168683, lng: 78.5347917062868 },
        { lat: 17.339007174632, lng: 78.53485761779268 },
        { lat: 17.33854193284245, lng: 78.53506612442965 },
        { lat: 17.33842376486814, lng: 78.53517345488319 },
        { lat: 17.33833348873409, lng: 78.53531400466916 },
        { lat: 17.3380981632619, lng: 78.53551372171488 },
        { lat: 17.3378491139533, lng: 78.53576338728405 },
        { lat: 17.33767952783915, lng: 78.53596471386516 },
        { lat: 17.33754022011191, lng: 78.536123832895 },
        { lat: 17.33751460276173, lng: 78.53612611788378 },
        { lat: 17.33733605805068, lng: 78.53614203657229 },
        { lat: 17.33703545095046, lng: 78.53618337434116 },
        { lat: 17.33670372726659, lng: 78.53625946481802 },
        { lat: 17.33644135160061, lng: 78.5363779253233 },
        { lat: 17.33612519472731, lng: 78.5365538354583 },
        { lat: 17.3354077801736, lng: 78.53698143765693 },
        { lat: 17.33499953727373, lng: 78.53724814995051 },
        { lat: 17.33479173546953, lng: 78.53736261342146 },
        { lat: 17.33481519132836, lng: 78.5372844380662 },
        { lat: 17.33481085520812, lng: 78.53708742866354 },
        { lat: 17.33480965470664, lng: 78.53683463786662 },
        { lat: 17.33481592818152, lng: 78.536723082505 },
        { lat: 17.33477470796855, lng: 78.53663604711015 },
        { lat: 17.33471827018649, lng: 78.53655518567831 },
        { lat: 17.33477708594532, lng: 78.53651857012831 },
        { lat: 17.33476975856263, lng: 78.53638927823461 },
        { lat: 17.33477073830638, lng: 78.53631362412825 },
        { lat: 17.33477100911523, lng: 78.53618025091987 },
        { lat: 17.33478735510278, lng: 78.53611036063445 },
        { lat: 17.33478091070383, lng: 78.53605272091576 },
        { lat: 17.33479901962624, lng: 78.53597086450898 },
        { lat: 17.33479284300596, lng: 78.53577985070494 },
        { lat: 17.33478696215207, lng: 78.53561271907468 },
        { lat: 17.33471885573107, lng: 78.53536082383201 },
        { lat: 17.33457696078392, lng: 78.53532688805653 },
        { lat: 17.33454586109876, lng: 78.53497496929397 },
        { lat: 17.3339879604066, lng: 78.53469378607024 },
        { lat: 17.33400420783016, lng: 78.53461593660431 },
        { lat: 17.33364898081215, lng: 78.53449129426525 },
        { lat: 17.33331674111883, lng: 78.53437032515714 },
        { lat: 17.33291193585594, lng: 78.53529400555816 },
        { lat: 17.33261911689889, lng: 78.53528858433836 },
        { lat: 17.3325315445957, lng: 78.53545459835495 },
        { lat: 17.33226281089334, lng: 78.53546440606071 },
        { lat: 17.33199101499561, lng: 78.53546803462822 },
        { lat: 17.33194632776651, lng: 78.53499276487176 },
        { lat: 17.33181487083602, lng: 78.53499140833156 },
        { lat: 17.33114660234033, lng: 78.53506253599937 },
        { lat: 17.33109127056967, lng: 78.53517835429676 },
        { lat: 17.32987883285403, lng: 78.5352100906192 },
        { lat: 17.32985597137135, lng: 78.53480917894005 },
        { lat: 17.32984046045163, lng: 78.5342775390828 },
        { lat: 17.32904791085346, lng: 78.5342912350283 },
        { lat: 17.32905097645137, lng: 78.53492816188331 },
        { lat: 17.32814373449134, lng: 78.53499999113414 },
        { lat: 17.32733623396087, lng: 78.5350207209802 },
        { lat: 17.32655740631787, lng: 78.53504107025074 },
        { lat: 17.32643284998876, lng: 78.535017851962 },
        { lat: 17.32624047231665, lng: 78.5349208955123 },
        { lat: 17.32636533477757, lng: 78.53458084425426 },
        { lat: 17.32652272748761, lng: 78.53416571281242 },
        { lat: 17.32666223057875, lng: 78.53385034695482 },
        { lat: 17.32625841919337, lng: 78.53366166768181 },
        { lat: 17.32596617537448, lng: 78.5336058550748 },
        { lat: 17.32529529941878, lng: 78.53346552863675 },
        { lat: 17.32461486699952, lng: 78.53332532864987 },
        { lat: 17.32413085715346, lng: 78.53322231778738 },
        { lat: 17.32391324105926, lng: 78.53418065061119 },
        { lat: 17.3239433233768, lng: 78.53429469957761 },
        { lat: 17.32417331960013, lng: 78.53434139303639 },
        { lat: 17.32419145538704, lng: 78.53503781510054 },
        { lat: 17.32421148939466, lng: 78.53550033408901 },
        { lat: 17.32475713299307, lng: 78.53556272039827 },
        { lat: 17.32485742796782, lng: 78.53555640463111 },
        { lat: 17.32487421510817, lng: 78.53536708455951 },
        { lat: 17.32526974179877, lng: 78.53556230674086 },
        { lat: 17.32548004133923, lng: 78.53556198870612 },
        { lat: 17.32572791297631, lng: 78.53559815941172 },
        { lat: 17.32573072803642, lng: 78.53621517535525 },
        { lat: 17.32579574295269, lng: 78.53662560580005 },
        { lat: 17.32579374284839, lng: 78.53667504991273 },
        { lat: 17.32549727118034, lng: 78.5366640766793 },
        { lat: 17.32525924742044, lng: 78.53674189278132 },
        { lat: 17.32504003226341, lng: 78.53679457990245 },
        { lat: 17.32500419025144, lng: 78.53698912894222 },
        { lat: 17.32449891842736, lng: 78.53710036819673 },
        { lat: 17.32381797260363, lng: 78.53708743616308 },
        { lat: 17.32379879779865, lng: 78.537982453232 },
        { lat: 17.32355411188245, lng: 78.53800437570122 },
        { lat: 17.32356084659225, lng: 78.53830907853053 },
        { lat: 17.32305661574911, lng: 78.53835934003955 },
        { lat: 17.32304056826339, lng: 78.53851194933354 },
        { lat: 17.32281920258221, lng: 78.53848690717949 },
        { lat: 17.32272411841526, lng: 78.5387711931168 },
        { lat: 17.32230902061061, lng: 78.53926812041665 },
        { lat: 17.32218192310894, lng: 78.53949996020428 },
        { lat: 17.32198799199175, lng: 78.54024896312664 },
        { lat: 17.32164533048564, lng: 78.54104970811495 },
        { lat: 17.32155311332913, lng: 78.54132462277695 },
        { lat: 17.32150446683038, lng: 78.54174202146102 },
        { lat: 17.32108823236302, lng: 78.54248775892432 },
        { lat: 17.32027246166411, lng: 78.54378244732845 },
        { lat: 17.31977305090256, lng: 78.54440333472917 },
        { lat: 17.31965803360026, lng: 78.54453424322385 },
        { lat: 17.31862791423496, lng: 78.54580190228805 },
        { lat: 17.31646580326095, lng: 78.54925711736826 },
        { lat: 17.31567399704311, lng: 78.55048577385395 },
        { lat: 17.31498601036106, lng: 78.55157662888178 },
        { lat: 17.31459255811652, lng: 78.55238110766335 },
        { lat: 17.31470999408581, lng: 78.55245730255069 },
        { lat: 17.31441311320392, lng: 78.55285309197917 },
        { lat: 17.31430997979824, lng: 78.5529695269963 },
        { lat: 17.31416881621223, lng: 78.55315177572143 },
        { lat: 17.31408455322026, lng: 78.55334570968377 },
        { lat: 17.31402827300295, lng: 78.55362946282385 },
        { lat: 17.31396995512007, lng: 78.55399099282151 },
        { lat: 17.31391574927082, lng: 78.55420007888002 },
        { lat: 17.31373363980662, lng: 78.55518835125538 },
        { lat: 17.31355362854872, lng: 78.55585937818937 },
        { lat: 17.31346347587769, lng: 78.55630529632835 },
        { lat: 17.31328534735328, lng: 78.5568861071438 },
        { lat: 17.31311357015516, lng: 78.5574979318853 },
        { lat: 17.31293294409519, lng: 78.55811920355698 },
        { lat: 17.31291071761087, lng: 78.55825633579065 },
        { lat: 17.3123109261961, lng: 78.55806522217748 },
        { lat: 17.31189995025343, lng: 78.55792448400845 },
        { lat: 17.3118334815596, lng: 78.55786316313183 },
        { lat: 17.31157579804685, lng: 78.55772114589763 },
        { lat: 17.31120893623913, lng: 78.55762149936042 },
        { lat: 17.31087093075637, lng: 78.55753639949202 },
        { lat: 17.31047370716526, lng: 78.55757299656344 },
        { lat: 17.31047799423458, lng: 78.55949363229958 },
        { lat: 17.31057328606117, lng: 78.56025368645733 },
        { lat: 17.31045890158196, lng: 78.56067317035513 },
        { lat: 17.3101466288336, lng: 78.56345549645836 },
        { lat: 17.31047700451898, lng: 78.56514012286938 },
        { lat: 17.31021591874521, lng: 78.5653642713733 },
        { lat: 17.30988194046187, lng: 78.56565362963313 },
        { lat: 17.30953398917116, lng: 78.56595748062651 },
        { lat: 17.30923147759244, lng: 78.5662151905859 },
        { lat: 17.30881736252435, lng: 78.56657471400928 },
        { lat: 17.30851925297099, lng: 78.56683262348419 },
        { lat: 17.30817987854627, lng: 78.56712785466891 },
        { lat: 17.3079465794834, lng: 78.56732947418686 },
        { lat: 17.30786048837078, lng: 78.56741024413908 },
        { lat: 17.30777261989832, lng: 78.56749103739901 },
        { lat: 17.30760403342569, lng: 78.56765623256841 },
        { lat: 17.30717455062286, lng: 78.5680827325071 },
        { lat: 17.30674023183251, lng: 78.56853136310933 },
        { lat: 17.30624119297935, lng: 78.56903399058079 },
        { lat: 17.30552272068381, lng: 78.56977398519473 },
        { lat: 17.30472917779186, lng: 78.57057556456805 },
        { lat: 17.30455236125583, lng: 78.57076058033797 },
        { lat: 17.30432174892223, lng: 78.57099765024279 },
        { lat: 17.30421014951067, lng: 78.57111535959824 },
        { lat: 17.30411780689948, lng: 78.57122661745082 },
        { lat: 17.30404401364625, lng: 78.57131776684753 },
        { lat: 17.30396659604693, lng: 78.57143347732953 },
        { lat: 17.30391112482018, lng: 78.57151945128696 },
        { lat: 17.30385866596957, lng: 78.57160848673814 },
        { lat: 17.30378915199888, lng: 78.5717628409673 },
        { lat: 17.30358691714998, lng: 78.57229908622423 },
        { lat: 17.30343868575854, lng: 78.57273549006433 },
        { lat: 17.30328021644561, lng: 78.57319999202963 },
        { lat: 17.30312083179383, lng: 78.57367015837083 },
        { lat: 17.30296980356674, lng: 78.5741378448633 },
        { lat: 17.30282180595757, lng: 78.57456601179331 },
        { lat: 17.30265039360872, lng: 78.57507260469542 },
        { lat: 17.30254994693682, lng: 78.57537460473715 },
        { lat: 17.30243885790768, lng: 78.57570216950626 },
        { lat: 17.3024208866821, lng: 78.57576653864999 },
        { lat: 17.30237441526461, lng: 78.57598380613332 },
        { lat: 17.30234816123926, lng: 78.57614528244609 },
        { lat: 17.30234273392996, lng: 78.57630104338699 },
        { lat: 17.30238786650236, lng: 78.58009577931713 },
        { lat: 17.30234630076399, lng: 78.58254112614894 },
        { lat: 17.30226849211394, lng: 78.58741265867806 },
        { lat: 17.30219401315349, lng: 78.59210826746296 },
        { lat: 17.30225884855534, lng: 78.5924090888178 },
        { lat: 17.30238198997514, lng: 78.59304734520506 },
        { lat: 17.30244630791984, lng: 78.59338070949975 },
        { lat: 17.30263988946197, lng: 78.59439001756301 },
        { lat: 17.30335143785077, lng: 78.59811378602635 },
        { lat: 17.30388864580802, lng: 78.60092234969015 },
        { lat: 17.30402407269224, lng: 78.60162444308533 },
        { lat: 17.30433917399296, lng: 78.60213581003579 },
        { lat: 17.30521474610894, lng: 78.60351947500155 },
        { lat: 17.30644810067854, lng: 78.6054831899397 },
        { lat: 17.30650530584531, lng: 78.60562703804753 },
        { lat: 17.30687202731349, lng: 78.60692317700705 },
        { lat: 17.30778185906318, lng: 78.61006011256012 },
        { lat: 17.30860897871304, lng: 78.61291528512943 },
        { lat: 17.3086518286413, lng: 78.612996432827 },
        { lat: 17.30907190184444, lng: 78.61367590002125 },
        { lat: 17.30988615411286, lng: 78.61495377563772 },
        { lat: 17.31152683509528, lng: 78.61755946079643 },
        { lat: 17.31131531120473, lng: 78.61946617283773 },
        { lat: 17.31133760681694, lng: 78.62026538976687 },
        { lat: 17.31139591778719, lng: 78.62086426755684 },
        { lat: 17.31155265438435, lng: 78.62112875238259 },
        { lat: 17.3125647769778, lng: 78.62120900269186 },
        { lat: 17.31369192105275, lng: 78.62127444766784 },
        { lat: 17.31398626728576, lng: 78.621270659285 },
        { lat: 17.31427128104263, lng: 78.6210695152006 },
        { lat: 17.31555521917689, lng: 78.62171219590807 },
        { lat: 17.31679518495104, lng: 78.62121220479663 },
        { lat: 17.31764359106507, lng: 78.62086339862971 },
        { lat: 17.32005412570092, lng: 78.61987418209449 },
        { lat: 17.319913753471, lng: 78.61912332115554 },
        { lat: 17.32015278422984, lng: 78.6191264606075 },
        { lat: 17.32063320289287, lng: 78.6192104245112 },
        { lat: 17.32096465245128, lng: 78.6192678600482 },
        { lat: 17.32120625385554, lng: 78.61932645263964 },
        { lat: 17.32196518564226, lng: 78.61947790754168 },
        { lat: 17.32300768075237, lng: 78.61967945332886 },
        { lat: 17.32302206975336, lng: 78.6194423905646 },
        { lat: 17.32306671383432, lng: 78.61917707030338 },
        { lat: 17.32309630651496, lng: 78.61909308531945 },
        { lat: 17.32313220123073, lng: 78.61905679254667 },
        { lat: 17.32317777312172, lng: 78.61903032751482 },
        { lat: 17.32326298706864, lng: 78.61903134411214 },
        { lat: 17.32384185712608, lng: 78.61917441912557 },
        { lat: 17.32392068262344, lng: 78.61917091565024 },
        { lat: 17.32397266187294, lng: 78.61912048106973 },
        { lat: 17.32423333761447, lng: 78.61772869384217 },
        { lat: 17.32537560268841, lng: 78.61700277574366 },
        { lat: 17.3254363449369, lng: 78.61697685609944 },
        { lat: 17.32567167275961, lng: 78.61698629169011 },
        { lat: 17.32837066857773, lng: 78.61714610394199 },
        { lat: 17.33052972242342, lng: 78.61726266891338 },
        { lat: 17.3313488294935, lng: 78.61793086798002 },
        { lat: 17.33311991009731, lng: 78.6194038551575 },
        { lat: 17.33425563291708, lng: 78.62034456106764 },
        { lat: 17.33432982851822, lng: 78.62040018010596 },
        { lat: 17.3347913663986, lng: 78.62059539190533 },
        { lat: 17.33604825495011, lng: 78.62109450767653 },
        { lat: 17.33644838556441, lng: 78.62117103201858 },
        { lat: 17.33762351295889, lng: 78.62136948174178 },
        { lat: 17.33864722620105, lng: 78.62155015090099 },
        { lat: 17.33958073289356, lng: 78.62171490056356 },
        { lat: 17.33979793138379, lng: 78.62163036341092 },
        { lat: 17.34119832027638, lng: 78.62102767102208 },
        { lat: 17.34332976808005, lng: 78.61783176964525 },
        { lat: 17.34455207062684, lng: 78.61600540961034 },
        { lat: 17.34605012320035, lng: 78.61298740760026 },
        { lat: 17.34719421253736, lng: 78.61069682215006 },
        { lat: 17.34721167468848, lng: 78.61064632779141 },
        { lat: 17.34711435379387, lng: 78.60285904463439 },
        { lat: 17.34605264581435, lng: 78.60106246749237 },
        { lat: 17.34569068777306, lng: 78.59825729829134 },
        { lat: 17.34579915463144, lng: 78.59770897548773 },
        { lat: 17.34598694791474, lng: 78.59681392255563 },
        { lat: 17.3466527886726, lng: 78.59355522601722 },
        { lat: 17.34729777755869, lng: 78.5904412648648 },
        { lat: 17.3476004697771, lng: 78.58762736620884 },
        { lat: 17.34758743896499, lng: 78.5861440962767 },
        { lat: 17.35053899684776, lng: 78.58611283850242 },
        { lat: 17.3513389251727, lng: 78.58610436546806 },
        { lat: 17.35509367766263, lng: 78.58605488083377 },
        { lat: 17.35523700472725, lng: 78.5860322663987 },
        { lat: 17.35586189692379, lng: 78.5859079116653 },
        { lat: 17.35655796790205, lng: 78.5857785019807 },
        { lat: 17.35703851043339, lng: 78.5856851521273 },
        { lat: 17.35715804114374, lng: 78.58565873456953 },
        { lat: 17.3579506422765, lng: 78.58466553924248 },
        { lat: 17.35917192975609, lng: 78.58314443572561 },
        { lat: 17.3593663097135, lng: 78.5827769031049 },
        { lat: 17.36006015461241, lng: 78.58148660386685 },
        { lat: 17.3605164619357, lng: 78.58063892674406 },
        { lat: 17.36096329827481, lng: 78.58038417179291 },
        { lat: 17.36198496905718, lng: 78.57980270464948 },
        { lat: 17.3622350356587, lng: 78.57965910530554 },
        { lat: 17.36224367186787, lng: 78.5796660557764 },
        { lat: 17.36299759173721, lng: 78.57922120450094 },
        { lat: 17.36351292181709, lng: 78.57892834863412 },
        { lat: 17.36399906351249, lng: 78.57865233898417 },
        { lat: 17.36472429347391, lng: 78.5782364634993 },
        { lat: 17.36515540241163, lng: 78.57799028349532 },
        { lat: 17.36530585438279, lng: 78.57790539040005 },
        { lat: 17.36555506547096, lng: 78.57776112696487 },
        { lat: 17.36560234057438, lng: 78.57774389223229 },
        { lat: 17.36678737154916, lng: 78.5781975919993 },
        { lat: 17.36647156598511, lng: 78.58144493253184 },
        { lat: 17.36760671407185, lng: 78.58163908375253 },
        { lat: 17.36867168006235, lng: 78.58077394390266 },
        { lat: 17.36961050220749, lng: 78.58014937411713 },
        { lat: 17.36971633617566, lng: 78.58028436872799 },
        { lat: 17.36980852250067, lng: 78.5803976409404 },
        { lat: 17.36991083004658, lng: 78.58045851648122 },
        { lat: 17.37015113437912, lng: 78.58056735518535 },
        { lat: 17.37034917159891, lng: 78.58063941715086 },
        { lat: 17.37055355874164, lng: 78.58074250572857 },
        { lat: 17.37057524967502, lng: 78.58074222080222 },
        { lat: 17.37045795980537, lng: 78.58116312266323 },
        { lat: 17.37044487085291, lng: 78.58166105278757 },
        { lat: 17.37189184717586, lng: 78.58222965882199 },
        { lat: 17.37222517504146, lng: 78.58273568364784 },
        { lat: 17.37298151279321, lng: 78.5838866769793 },
        { lat: 17.37357368799963, lng: 78.58475378562932 },
        { lat: 17.37418330553571, lng: 78.58503194333251 },
        { lat: 17.376229405601, lng: 78.58596689755866 },
        { lat: 17.37733602416865, lng: 78.58647061781161 },
        { lat: 17.37801701122962, lng: 78.58487754171026 },
        { lat: 17.37848595625157, lng: 78.58377662474608 },
        { lat: 17.37868365171401, lng: 78.58331375006227 },
        { lat: 17.37932629749612, lng: 78.58182082827693 },
        { lat: 17.37949028718645, lng: 78.58182277535158 },
        { lat: 17.38185776942978, lng: 78.5817914642135 },
        { lat: 17.38308226337888, lng: 78.58177938595723 },
        { lat: 17.38342095564431, lng: 78.58334654426147 },
        { lat: 17.38398743521319, lng: 78.58593915487614 },
        { lat: 17.38454220999438, lng: 78.58850283475977 },
        { lat: 17.38551237112685, lng: 78.588946202648 },
        { lat: 17.38569213792819, lng: 78.58894383207327 },
        { lat: 17.38571201781926, lng: 78.58890622853706 },
        { lat: 17.38575965815962, lng: 78.58891794848479 },
        { lat: 17.38618974158079, lng: 78.58885847118181 },
        { lat: 17.38628532138849, lng: 78.58881575513544 },
        { lat: 17.38652225658717, lng: 78.58868399601218 },
        { lat: 17.38656953264876, lng: 78.58866676126978 },
        { lat: 17.38680360167988, lng: 78.58857664216559 },
        { lat: 17.38718068276816, lng: 78.58843891932278 },
        { lat: 17.38829872461643, lng: 78.58877258036203 },
        { lat: 17.38830262356838, lng: 78.58872313294857 },
        { lat: 17.38838834093621, lng: 78.58825715831568 },
        { lat: 17.3884746171384, lng: 78.58783571628203 },
        { lat: 17.38848740293567, lng: 78.58759430361103 },
        { lat: 17.38855043279785, lng: 78.58721256800254 },
        { lat: 17.38855941357662, lng: 78.58702809920693 },
        { lat: 17.38862052002106, lng: 78.58685235030903 },
        { lat: 17.38867030981639, lng: 78.58658633905488 },
        { lat: 17.38869848809406, lng: 78.58613126486237 },
        { lat: 17.38872057355922, lng: 78.58591016473197 },
        { lat: 17.38879939775171, lng: 78.58552571878229 },
        { lat: 17.38888927136334, lng: 78.58521037163752 },
        { lat: 17.38900544679309, lng: 78.58464990401315 },
        { lat: 17.38916400999696, lng: 78.58413282872081 },
        { lat: 17.38930757753286, lng: 78.58377149177608 },
        { lat: 17.38939271545707, lng: 78.58352912039298 },
        { lat: 17.3894653606264, lng: 78.58337188824632 },
        { lat: 17.38972665018182, lng: 78.58248357617066 },
        { lat: 17.39531806762131, lng: 78.58075817502423 },
        { lat: 17.40544644546165, lng: 78.58262631611281 },
        { lat: 17.40686555748895, lng: 78.57646573810212 },
        { lat: 17.41152850085164, lng: 78.56851375639593 },
        { lat: 17.41285089493818, lng: 78.56751970629992 },
        { lat: 17.41320411073869, lng: 78.56725418843877 },
        { lat: 17.41750735938553, lng: 78.5667716013347 },
        { lat: 17.4175812766035, lng: 78.56671547906403 },
        { lat: 17.41785539419002, lng: 78.56675240442799 },
        { lat: 17.41953146983242, lng: 78.56597444696247 },
        { lat: 17.42094273836467, lng: 78.56500342142493 },
        { lat: 17.42377172273049, lng: 78.56285921147315 },
        { lat: 17.42396342182616, lng: 78.56254905762538 },
        { lat: 17.42429358995869, lng: 78.56232599990307 },
        { lat: 17.42491244324897, lng: 78.56193414857447 },
        { lat: 17.42500777715595, lng: 78.56185670235264 },
        { lat: 17.42505714580132, lng: 78.56192933236424 },
        { lat: 17.42528035661041, lng: 78.56241561713702 },
        { lat: 17.42605241322057, lng: 78.56451241275592 },
        { lat: 17.42627174496256, lng: 78.56507211610776 },
        { lat: 17.42648494807061, lng: 78.5656764887515 },
        { lat: 17.42661350174536, lng: 78.5659903436801 },
        { lat: 17.42665135232194, lng: 78.56604202341558 },
        { lat: 17.42669491625646, lng: 78.56606823190042 },
        { lat: 17.42674837961731, lng: 78.56606412618856 },
        { lat: 17.42683819301025, lng: 78.56603015338494 },
        { lat: 17.426935101926, lng: 78.56597856173423 },
        { lat: 17.42699895037443, lng: 78.56594522958004 },
        { lat: 17.4271736487595, lng: 78.565868765939 },
        { lat: 17.42721974097572, lng: 78.56587421325978 },
        { lat: 17.42724699812171, lng: 78.56589557114745 },
        { lat: 17.42734831408876, lng: 78.56612418416695 },
        { lat: 17.42772126439226, lng: 78.56716282680334 },
        { lat: 17.42791179632589, lng: 78.56769090561045 },
        { lat: 17.42804069848937, lng: 78.56809884089542 },
        { lat: 17.42771225194867, lng: 78.56821202756973 },
        { lat: 17.42802925526153, lng: 78.56966701228583 },
        { lat: 17.42833578776143, lng: 78.57215425479141 },
        { lat: 17.4285842268689, lng: 78.57437497275886 },
        { lat: 17.42904175463866, lng: 78.57477179257228 },
        { lat: 17.43090168702751, lng: 78.5763626444871 },
        { lat: 17.4306395592641, lng: 78.57669547090696 },
        { lat: 17.43053970209417, lng: 78.57685391867781 },
        { lat: 17.43045904185082, lng: 78.57702649802205 },
        { lat: 17.43045797322213, lng: 78.577077713847 },
        { lat: 17.43047176214839, lng: 78.57710443349936 },
        { lat: 17.43050686769269, lng: 78.57713382157179 },
        { lat: 17.43058264646005, lng: 78.57720477821894 },
        { lat: 17.43143504349008, lng: 78.57791549843155 },
        { lat: 17.43192405965821, lng: 78.57838260319576 },
        { lat: 17.43208705683983, lng: 78.57827962550444 },
        { lat: 17.43252771928344, lng: 78.57803668265092 },
        { lat: 17.43288863579803, lng: 78.577816209497 },
        { lat: 17.43328486205184, lng: 78.57756435572784 },
        { lat: 17.43374431731639, lng: 78.57720496316014 },
        { lat: 17.43412407699393, lng: 78.57800983797215 },
        { lat: 17.43433013711075, lng: 78.57848302118302 },
        { lat: 17.43449571196244, lng: 78.57876830865766 },
        { lat: 17.43556466150598, lng: 78.57989145255681 },
        { lat: 17.43602653150392, lng: 78.58028710254419 },
        { lat: 17.43989509564755, lng: 78.58366660608604 },
        { lat: 17.44210793624022, lng: 78.58763204165454 },
        { lat: 17.44539932969442, lng: 78.59366799665985 },
        { lat: 17.44625075988267, lng: 78.59545090010967 },
        { lat: 17.44627784685657, lng: 78.59769344752131 },
        { lat: 17.44647311185988, lng: 78.60397776422448 },
        { lat: 17.44662036691092, lng: 78.60876882399756 },
        { lat: 17.44987164073416, lng: 78.61084283495096 },
        { lat: 17.45381920864999, lng: 78.61119599066252 },
        { lat: 17.4558525441658, lng: 78.61135623117485 },
        { lat: 17.45577526821219, lng: 78.61238436122161 },
        { lat: 17.45810878911405, lng: 78.61266520324536 },
        { lat: 17.45974784920448, lng: 78.61233258571349 },
        { lat: 17.46008313421288, lng: 78.61288847790084 },
        { lat: 17.46027989232513, lng: 78.61328598018267 },
        { lat: 17.46025387180045, lng: 78.61355516690014 },
        { lat: 17.4602373769913, lng: 78.61363221505441 },
        { lat: 17.46016054258187, lng: 78.6136346362212 },
        { lat: 17.45985764915273, lng: 78.61485274230495 },
        { lat: 17.4615883946158, lng: 78.61543002930894 },
        { lat: 17.4615392946867, lng: 78.6160630649829 },
        { lat: 17.46434604626185, lng: 78.61678517589208 },
        { lat: 17.46441597275815, lng: 78.61656742866387 },
        { lat: 17.46446815905883, lng: 78.61630789098815 },
        { lat: 17.46448042779852, lng: 78.61614853739026 },
        { lat: 17.46478468241938, lng: 78.61598935787252 },
        { lat: 17.46502085615832, lng: 78.6158548385409 },
        { lat: 17.46526837641367, lng: 78.61569010324004 },
        { lat: 17.46547402681544, lng: 78.6155189237112 },
        { lat: 17.46606413567465, lng: 78.61523346233221 },
        { lat: 17.46637751599848, lng: 78.61510847906315 },
        { lat: 17.4663824532571, lng: 78.61511721267323 },
        { lat: 17.46645121092756, lng: 78.61511292894335 },
        { lat: 17.46657351576541, lng: 78.61515364275755 },
        { lat: 17.46668514611279, lng: 78.6151865532281 },
        { lat: 17.46735340692403, lng: 78.61558113150774 },
        { lat: 17.46786731528296, lng: 78.61591781072254 },
        { lat: 17.46801217377065, lng: 78.61597050343688 },
        { lat: 17.46801865260163, lng: 78.61597205952091 },
        { lat: 17.47165308155063, lng: 78.6164898618739 },
        { lat: 17.47171380449388, lng: 78.61651267321369 },
        { lat: 17.47186510120672, lng: 78.61657935493601 },
        { lat: 17.47206751662574, lng: 78.61664220498437 },
        { lat: 17.47442407530407, lng: 78.61774649837301 },
        { lat: 17.47495807592624, lng: 78.61807986658661 },
        { lat: 17.47600080193076, lng: 78.61846868277158 },
        { lat: 17.47626698491485, lng: 78.61850627404738 },
        { lat: 17.47671328274387, lng: 78.61856681632486 },
        { lat: 17.47681404639369, lng: 78.6185781614113 },
        { lat: 17.47688493044115, lng: 78.6185857050944 },
        { lat: 17.4769730536782, lng: 78.61859124082612 },
        { lat: 17.47701228221215, lng: 78.61855812576903 },
        { lat: 17.47704926717411, lng: 78.61848455742653 },
        { lat: 17.47709203616613, lng: 78.61840884028406 },
        { lat: 17.47721551335091, lng: 78.61841136602628 },
        { lat: 17.47735560097546, lng: 78.61844005966344 },
        { lat: 17.47759215937755, lng: 78.61847146305062 },
        { lat: 17.47777504482671, lng: 78.61848750509743 },
        { lat: 17.47788963801246, lng: 78.61849082979595 },
        { lat: 17.47855240877435, lng: 78.6157665275472 },
        { lat: 17.47848188550332, lng: 78.61096370334778 },
        { lat: 17.47927734271661, lng: 78.6110240039694 },
        { lat: 17.47968166277142, lng: 78.60458519510591 },
        { lat: 17.47960232262669, lng: 78.6045521213803 },
        { lat: 17.47891993085517, lng: 78.60426370865619 },
        { lat: 17.47845278197144, lng: 78.60404905602516 },
        { lat: 17.47802568908087, lng: 78.60386429777533 },
        { lat: 17.47764442174713, lng: 78.60369022048582 },
        { lat: 17.47762114441239, lng: 78.60367836118243 },
        { lat: 17.47772983684677, lng: 78.60341930954219 },
        { lat: 17.47791711005122, lng: 78.60296780070945 },
        { lat: 17.47806453059383, lng: 78.6026302354294 },
        { lat: 17.47819548215267, lng: 78.60232805938895 },
        { lat: 17.47833423992838, lng: 78.60200117743635 },
        { lat: 17.47847950522686, lng: 78.60165620062556 },
        { lat: 17.47856616562367, lng: 78.6014150663941 },
        { lat: 17.47865951566258, lng: 78.60123037053657 },
        { lat: 17.47871544571709, lng: 78.60108393028831 },
        { lat: 17.47877571446059, lng: 78.60093131990479 },
        { lat: 17.47881718843455, lng: 78.60085173598654 },
        { lat: 17.47890039970679, lng: 78.60072268148174 },
        { lat: 17.47902405457373, lng: 78.60044618267996 },
        { lat: 17.47914226727278, lng: 78.60008844169924 },
        { lat: 17.47932667392605, lng: 78.59990685997778 },
        { lat: 17.47947343687134, lng: 78.59956341801339 },
        { lat: 17.47961427587712, lng: 78.59924795182351 },
        { lat: 17.47971242876129, lng: 78.59799694649325 },
        { lat: 17.47861225739842, lng: 78.59433194229071 },
        { lat: 17.47852125915042, lng: 78.59412847826346 },
        { lat: 17.47854059893087, lng: 78.59364665131608 },
        { lat: 17.47909917480427, lng: 78.59229346650089 },
        { lat: 17.47912585461441, lng: 78.59222039202773 },
        { lat: 17.47929356250795, lng: 78.59182120100841 },
        { lat: 17.47944783787917, lng: 78.59143442941843 },
        { lat: 17.47957966958947, lng: 78.59109550173207 },
        { lat: 17.48012228746455, lng: 78.58977752638157 },
        { lat: 17.48035073502529, lng: 78.59029188821704 },
        { lat: 17.48085389728493, lng: 78.58999796195191 },
        { lat: 17.48086010011658, lng: 78.59001070900358 },
        { lat: 17.48093961392202, lng: 78.58966213731107 },
        { lat: 17.48101961245141, lng: 78.58930406589207 },
        { lat: 17.48223102756223, lng: 78.58871294785901 },
        { lat: 17.48230192793672, lng: 78.58874521108977 },
        { lat: 17.48256157208886, lng: 78.58887572078987 },
        { lat: 17.48260794707769, lng: 78.58889397162474 },
        { lat: 17.48264852488237, lng: 78.58890440012942 },
        { lat: 17.48268827530016, lng: 78.58889310102663 },
        { lat: 17.4827098076763, lng: 78.58887745641496 },
        { lat: 17.48272471524869, lng: 78.58885746689941 },
        { lat: 17.48285949556763, lng: 78.58853359173476 },
        { lat: 17.48302088815327, lng: 78.58860304986203 },
        { lat: 17.48318580136329, lng: 78.588666462304 },
        { lat: 17.48338988331306, lng: 78.58874841364212 },
        { lat: 17.48393348835322, lng: 78.58877865646384 },
        { lat: 17.48456120396089, lng: 78.58877533193278 },
        { lat: 17.48494997260766, lng: 78.5887753578646 },
        { lat: 17.48522202801476, lng: 78.58876499886391 },
        { lat: 17.485425014624, lng: 78.58876960216158 },
        { lat: 17.48566438834483, lng: 78.58876896866776 },
        { lat: 17.48602233820079, lng: 78.58870994333358 },
        { lat: 17.48656500151797, lng: 78.58848352432784 },
        { lat: 17.48724386966658, lng: 78.58819244340695 },
        { lat: 17.48824443933935, lng: 78.58770957843569 },
        { lat: 17.48839780489881, lng: 78.58809681795859 },
        { lat: 17.48854411703216, lng: 78.58839926138903 },
        { lat: 17.48856822051624, lng: 78.58842010477144 },
        { lat: 17.48877531351201, lng: 78.58832641710666 },
        { lat: 17.48884340053877, lng: 78.58828774647849 },
        { lat: 17.4903150746654, lng: 78.58830900555915 },
        { lat: 17.49046212352675, lng: 78.58831723338957 },
        { lat: 17.49055227776406, lng: 78.58831633313936 },
        { lat: 17.49064330372555, lng: 78.58830815293467 },
        { lat: 17.49080582986855, lng: 78.58829541884406 },
        { lat: 17.49105850759343, lng: 78.58827814644573 },
        { lat: 17.4912721451019, lng: 78.58826541665324 },
        { lat: 17.49146157588518, lng: 78.58825450369355 },
        { lat: 17.49170389697359, lng: 78.58824266421277 },
        { lat: 17.49185962141107, lng: 78.58822716283723 },
        { lat: 17.49204297150724, lng: 78.58821721756192 },
        { lat: 17.49234227944474, lng: 78.58819882781742 },
        { lat: 17.4923429370057, lng: 78.58823035181321 },
        { lat: 17.49235907346533, lng: 78.58836841582678 },
        { lat: 17.49236556911877, lng: 78.58839759434306 },
        { lat: 17.49237908846339, lng: 78.58843004620266 },
        { lat: 17.49239905412849, lng: 78.58844627394272 },
        { lat: 17.49243512680568, lng: 78.5884570943144 },
        { lat: 17.49244055656642, lng: 78.58846336687604 },
        { lat: 17.4924418386231, lng: 78.58846517980102 },
        { lat: 17.49250404568314, lng: 78.58842526710345 },
        { lat: 17.49251866940761, lng: 78.58842178066753 },
        { lat: 17.49253503736139, lng: 78.588419339568 },
        { lat: 17.49257524990294, lng: 78.58842073869734 },
        { lat: 17.49259043470097, lng: 78.58842336220448 },
        { lat: 17.49270507121325, lng: 78.5884303176279 },
        { lat: 17.49271445002961, lng: 78.58857311440207 },
        { lat: 17.49303702262789, lng: 78.58854807108932 },
        { lat: 17.49304214965351, lng: 78.58866207876937 },
        { lat: 17.49304999403167, lng: 78.58878430280247 },
        { lat: 17.49332144627607, lng: 78.58876862582417 },
        { lat: 17.49393963191505, lng: 78.58873368433142 },
        { lat: 17.49440869668653, lng: 78.58869996685635 },
        { lat: 17.49441129111619, lng: 78.58874311877413 },
        { lat: 17.49474303580212, lng: 78.5887268163385 },
        { lat: 17.49475683709087, lng: 78.5889657803643 },
        { lat: 17.49476648788516, lng: 78.58910986666346 },
        { lat: 17.49516384736181, lng: 78.58908656302668 },
        { lat: 17.495153296183, lng: 78.58890352835839 },
        { lat: 17.49622631539422, lng: 78.58884755241188 },
        { lat: 17.49650093387639, lng: 78.58898984344201 },
        { lat: 17.49676253976629, lng: 78.58889899568811 },
        { lat: 17.49703529827573, lng: 78.5888130025458 },
        { lat: 17.49724805184433, lng: 78.58874112301916 },
        { lat: 17.49743096781605, lng: 78.58869567053169 },
        { lat: 17.4974679885944, lng: 78.58868549890506 },
        { lat: 17.49760112804475, lng: 78.58864077461327 },
        { lat: 17.49816000318468, lng: 78.58849313460551 },
        { lat: 17.49852103457138, lng: 78.58836279920244 },
        { lat: 17.49878187251124, lng: 78.58829524537863 },
        { lat: 17.49912923149719, lng: 78.58818849791493 },
        { lat: 17.49953796392498, lng: 78.58805258005398 },
        { lat: 17.49971501884343, lng: 78.58801036148378 },
        { lat: 17.49987608029682, lng: 78.58796029817697 },
        { lat: 17.5001824797463, lng: 78.58785678487723 },
        { lat: 17.50015074429119, lng: 78.58782180289195 },
        { lat: 17.50007150169306, lng: 78.5875502493566 },
        { lat: 17.50011076519431, lng: 78.58754394659546 },
        { lat: 17.50034951463187, lng: 78.5874858338465 },
        { lat: 17.50063439524233, lng: 78.58741163749703 },
        { lat: 17.50098196707351, lng: 78.58727150208482 },
        { lat: 17.5009715442065, lng: 78.58724807853562 },
        { lat: 17.5016951916314, lng: 78.58676352033804 },
        { lat: 17.50159276972595, lng: 78.58617783179336 },
        { lat: 17.50175325855502, lng: 78.58609582907583 },
        { lat: 17.50189613183338, lng: 78.58599805741842 },
        { lat: 17.50228693138167, lng: 78.58575975331178 },
        { lat: 17.50231748868246, lng: 78.58573959489179 },
        { lat: 17.50222317815878, lng: 78.58557192633606 },
        { lat: 17.50203775178999, lng: 78.58526622555691 },
        { lat: 17.50190645563671, lng: 78.58505558559187 },
        { lat: 17.50180734820893, lng: 78.58489532540338 },
        { lat: 17.50319495042022, lng: 78.5840102396684 },
        { lat: 17.50341603373332, lng: 78.58387145581762 },
        { lat: 17.50330133902226, lng: 78.58368762339524 },
        { lat: 17.50305501349614, lng: 78.5832468558815 },
        { lat: 17.5029350568646, lng: 78.58303729213723 },
        { lat: 17.50351119958697, lng: 78.58268196559288 },
        { lat: 17.50374391940575, lng: 78.58253504537109 },
        { lat: 17.50441965837497, lng: 78.5821271115131 },
        { lat: 17.50439136477961, lng: 78.58210529503548 },
        { lat: 17.50419590348567, lng: 78.58192514149948 },
        { lat: 17.50401312174072, lng: 78.5817981901581 },
        { lat: 17.5039223331833, lng: 78.58173122085958 },
        { lat: 17.5041655544741, lng: 78.58140078315614 },
        { lat: 17.50441794468433, lng: 78.58102528775424 },
        { lat: 17.50460066687168, lng: 78.58036730891223 },
        { lat: 17.50472438915168, lng: 78.58016877897244 },
        { lat: 17.50518188183667, lng: 78.58015819158231 },
        { lat: 17.50510285050056, lng: 78.579607796084 },
        { lat: 17.50579103102318, lng: 78.57945146131699 },
        { lat: 17.50598830237761, lng: 78.57942592548629 },
        { lat: 17.50592437592191, lng: 78.57893455037953 },
        { lat: 17.50588160632145, lng: 78.57859950382156 },
        { lat: 17.50585217219602, lng: 78.57838008218494 },
        { lat: 17.50584006744269, lng: 78.57826750334237 },
        { lat: 17.50654939052073, lng: 78.57814914499177 },
        { lat: 17.50653764747047, lng: 78.57807375429444 },
        { lat: 17.50652641993036, lng: 78.57800300699975 },
        { lat: 17.50652897657788, lng: 78.57798898853295 },
        { lat: 17.50652693289386, lng: 78.57797251957034 },
        { lat: 17.50651909122863, lng: 78.5779539002799 },
        { lat: 17.50650715802419, lng: 78.57794343172226 },
        { lat: 17.50649314156231, lng: 78.57794195800555 },
        { lat: 17.50651900772718, lng: 78.5779029682441 },
        { lat: 17.50651739803448, lng: 78.57781521989145 },
        { lat: 17.50698817923705, lng: 78.57774226828712 },
        { lat: 17.50696915672613, lng: 78.57751309168104 },
        { lat: 17.50693178590436, lng: 78.57676584299969 },
        { lat: 17.5068961898068, lng: 78.5763005410048 },
        { lat: 17.50689459990982, lng: 78.57595041864566 },
        { lat: 17.50740885288076, lng: 78.5759145698812 },
        { lat: 17.50792576802754, lng: 78.57584704294078 },
        { lat: 17.5079236634232, lng: 78.57582989129007 },
        { lat: 17.50832883968467, lng: 78.5757729667538 },
        { lat: 17.50927057728045, lng: 78.57455702403264 },
        { lat: 17.50871794115465, lng: 78.57224227385107 },
        { lat: 17.50826587913225, lng: 78.57066380151603 },
        { lat: 17.50772591133878, lng: 78.57067099721131 },
        { lat: 17.50756701788153, lng: 78.57073626538319 },
        { lat: 17.5071085899713, lng: 78.5708075581803 },
        { lat: 17.50702186355933, lng: 78.56992235216525 },
        { lat: 17.50685835735728, lng: 78.56952583136822 },
        { lat: 17.50679848766983, lng: 78.56922024148331 },
        { lat: 17.5068780939495, lng: 78.56890817528677 },
        { lat: 17.50650962274485, lng: 78.56886465367597 },
        { lat: 17.50648234045484, lng: 78.56873088589447 },
        { lat: 17.50620858895367, lng: 78.5686256607411 },
        { lat: 17.50613885797683, lng: 78.56834539563654 },
        { lat: 17.50572075029114, lng: 78.56651731312927 },
        { lat: 17.50712658601627, lng: 78.56389180997334 },
        { lat: 17.50726618885059, lng: 78.56388817443705 },
        { lat: 17.50822156105809, lng: 78.56373342579691 },
        { lat: 17.50896584646953, lng: 78.5616934995043 },
      ],
      [
        { lat: 17.40967893118723, lng: 78.57118522865319 },
        { lat: 17.40955095579474, lng: 78.57155149976457 },
        { lat: 17.40896932023577, lng: 78.5712728460085 },
        { lat: 17.40869438741945, lng: 78.5718615355832 },
        { lat: 17.4083100121258, lng: 78.5716973433587 },
        { lat: 17.40803962470148, lng: 78.57225851670692 },
        { lat: 17.40790981518348, lng: 78.57258881759097 },
        { lat: 17.40671967089649, lng: 78.57219629864115 },
        { lat: 17.40673757455236, lng: 78.57209649189765 },
        { lat: 17.40683737528536, lng: 78.57165706160073 },
        { lat: 17.40690959391317, lng: 78.57130760993473 },
        { lat: 17.406838929656, lng: 78.57099987462543 },
        { lat: 17.40669265026373, lng: 78.57076283818722 },
        { lat: 17.40667038122876, lng: 78.57050424922407 },
        { lat: 17.40668319158534, lng: 78.57008463861067 },
        { lat: 17.4066864724607, lng: 78.5698636732082 },
        { lat: 17.40664442022242, lng: 78.56959974543493 },
        { lat: 17.40664539760623, lng: 78.56943481866645 },
        { lat: 17.40551194240533, lng: 78.56917622037089 },
        { lat: 17.4051375058068, lng: 78.5690886928197 },
        { lat: 17.40520399182675, lng: 78.56894421881616 },
        { lat: 17.40522289580708, lng: 78.56887183747102 },
        { lat: 17.40522779996639, lng: 78.56878727619309 },
        { lat: 17.40521915835732, lng: 78.56872762435424 },
        { lat: 17.40519852165927, lng: 78.56865782741687 },
        { lat: 17.40523114306389, lng: 78.5685359621575 },
        { lat: 17.40524277901226, lng: 78.5683911890976 },
        { lat: 17.40604645633907, lng: 78.56844776461705 },
        { lat: 17.40612701254588, lng: 78.56799863301964 },
        { lat: 17.40619386863765, lng: 78.56760195717958 },
        { lat: 17.40653214801912, lng: 78.5677094965297 },
        { lat: 17.40798453020718, lng: 78.56804872766604 },
        { lat: 17.40796430075187, lng: 78.56815354583587 },
        { lat: 17.40848932245315, lng: 78.568288485878 },
        { lat: 17.40835709739284, lng: 78.56887030362105 },
        { lat: 17.4082547543004, lng: 78.56959821176238 },
        { lat: 17.4095905166619, lng: 78.56995742456289 },
        { lat: 17.40953437266784, lng: 78.570053455088 },
        { lat: 17.40925581571334, lng: 78.57103954012156 },
        { lat: 17.40967893118723, lng: 78.57118522865319 },
      ],
      [
        { lat: 17.32918922919198, lng: 78.58756262624166 },
        { lat: 17.3296814683277, lng: 78.58755619481862 },
        { lat: 17.32970566293388, lng: 78.58758076081082 },
        { lat: 17.32966009235887, lng: 78.58776548648056 },
        { lat: 17.32952181798912, lng: 78.58819029522319 },
        { lat: 17.32942839643221, lng: 78.58837066881875 },
        { lat: 17.3293919622477, lng: 78.58852043909546 },
        { lat: 17.32933928970671, lng: 78.58890929335585 },
        { lat: 17.32924696106807, lng: 78.5895773486957 },
        { lat: 17.32922418879877, lng: 78.58982156525036 },
        { lat: 17.32921828904544, lng: 78.58982384570514 },
        { lat: 17.32917905233123, lng: 78.59013787698296 },
        { lat: 17.32859051328646, lng: 78.59008584056444 },
        { lat: 17.32776505292293, lng: 78.5900070366961 },
        { lat: 17.32767457543655, lng: 78.59082933193488 },
        { lat: 17.32639695799324, lng: 78.59071163669802 },
        { lat: 17.32633351863952, lng: 78.59080203961288 },
        { lat: 17.32635753961435, lng: 78.59101073527633 },
        { lat: 17.32629213972422, lng: 78.5915341127708 },
        { lat: 17.32620685004836, lng: 78.59219211139127 },
        { lat: 17.32581195057521, lng: 78.59214500738553 },
        { lat: 17.32560361360731, lng: 78.59211040119271 },
        { lat: 17.32535244492517, lng: 78.59209128168823 },
        { lat: 17.32508075851828, lng: 78.59215454034594 },
        { lat: 17.32495903455468, lng: 78.59234703187757 },
        { lat: 17.3246804109486, lng: 78.59225264263914 },
        { lat: 17.32205995806553, lng: 78.59195997081035 },
        { lat: 17.32204263389948, lng: 78.5918609466575 },
        { lat: 17.32206299879279, lng: 78.59156707932155 },
        { lat: 17.32211394258837, lng: 78.59103395029744 },
        { lat: 17.32213895429488, lng: 78.59033196616879 },
        { lat: 17.32214758897457, lng: 78.58946100081154 },
        { lat: 17.3221551109058, lng: 78.5892917085709 },
        { lat: 17.32222135790169, lng: 78.58923610515501 },
        { lat: 17.32263127570745, lng: 78.589141181946 },
        { lat: 17.32318450490405, lng: 78.58903941099508 },
        { lat: 17.32343205542585, lng: 78.58895655834414 },
        { lat: 17.32389722465387, lng: 78.58868674001627 },
        { lat: 17.32429070720838, lng: 78.58841785621713 },
        { lat: 17.32474547751938, lng: 78.58807850222827 },
        { lat: 17.32501996291442, lng: 78.58785098051084 },
        { lat: 17.32506123540456, lng: 78.58770612731395 },
        { lat: 17.3251093081884, lng: 78.58733227136312 },
        { lat: 17.32516055775996, lng: 78.58722212158666 },
        { lat: 17.3253282434783, lng: 78.58725476580035 },
        { lat: 17.32577861007584, lng: 78.58734343363493 },
        { lat: 17.32609426549397, lng: 78.5873592148296 },
        { lat: 17.32615615306393, lng: 78.58733850139537 },
        { lat: 17.32622783821104, lng: 78.58733756488313 },
        { lat: 17.32636660999897, lng: 78.58735068110678 },
        { lat: 17.32641904033285, lng: 78.58694193043118 },
        { lat: 17.32677806664047, lng: 78.58698700349395 },
        { lat: 17.32746756425484, lng: 78.58708747552102 },
        { lat: 17.32811291210038, lng: 78.58709397214392 },
        { lat: 17.32808479644754, lng: 78.58753724343701 },
        { lat: 17.32918922919198, lng: 78.58756262624166 },
      ],
    ],
  },
  {
    name: "KHAIRATHABAD ZONE",
    color: "#3498db",
    polygons: [
      [
        { lat: 17.44073807332421, lng: 78.4545699225471 },
        { lat: 17.44145451054156, lng: 78.45413748525058 },
        { lat: 17.44669337784892, lng: 78.45189567030623 },
        { lat: 17.44716041856665, lng: 78.45176315318051 },
        { lat: 17.44721100590769, lng: 78.45175303089563 },
        { lat: 17.44753327690489, lng: 78.45168853977869 },
        { lat: 17.44906175228137, lng: 78.45139656405038 },
        { lat: 17.44997895803451, lng: 78.451235651917 },
        { lat: 17.45067993415401, lng: 78.45111267227013 },
        { lat: 17.45235592785814, lng: 78.45079529441081 },
        { lat: 17.45428228617404, lng: 78.45043708041621 },
        { lat: 17.4556902922669, lng: 78.4501840970666 },
        { lat: 17.4566288638924, lng: 78.45000765962595 },
        { lat: 17.45763450498752, lng: 78.44982095115483 },
        { lat: 17.45825474223719, lng: 78.44962560170961 },
        { lat: 17.4587534362391, lng: 78.44938526291934 },
        { lat: 17.45937545722957, lng: 78.44897983053717 },
        { lat: 17.45986655690703, lng: 78.44849686427555 },
        { lat: 17.46016769942922, lng: 78.44813660760968 },
        { lat: 17.46082565448533, lng: 78.44662936241721 },
        { lat: 17.46103641238139, lng: 78.44395162079792 },
        { lat: 17.46128139812683, lng: 78.44147756556427 },
        { lat: 17.46139134893316, lng: 78.43967190051417 },
        { lat: 17.46153026589929, lng: 78.43791376884434 },
        { lat: 17.46186971697181, lng: 78.43137134717169 },
        { lat: 17.46100282531656, lng: 78.43175630304715 },
        { lat: 17.46010644680923, lng: 78.43217062982615 },
        { lat: 17.45954485904745, lng: 78.43242085725655 },
        { lat: 17.45870982545445, lng: 78.43280361174595 },
        { lat: 17.45765456366147, lng: 78.4332913833922 },
        { lat: 17.45723300555145, lng: 78.43348967035116 },
        { lat: 17.45686915964288, lng: 78.43365144437772 },
        { lat: 17.45645316595857, lng: 78.43384592890882 },
        { lat: 17.45611162296523, lng: 78.4339898318579 },
        { lat: 17.45609351908369, lng: 78.43399732733897 },
        { lat: 17.4554545481714, lng: 78.43426955925577 },
        { lat: 17.45434387729247, lng: 78.43475430077737 },
        { lat: 17.45392202418265, lng: 78.43494264530904 },
        { lat: 17.4527861796732, lng: 78.43558600646453 },
        { lat: 17.45115282226505, lng: 78.43637933198833 },
        { lat: 17.45031012807746, lng: 78.43684758770576 },
        { lat: 17.44981625407351, lng: 78.43707343694837 },
        { lat: 17.44873160160647, lng: 78.43755609250763 },
        { lat: 17.44808304619658, lng: 78.43790510301824 },
        { lat: 17.44797079324781, lng: 78.43797552192709 },
        { lat: 17.44750000994051, lng: 78.4382708549349 },
        { lat: 17.44748762825104, lng: 78.43827715641609 },
        { lat: 17.446496069342, lng: 78.43878173874202 },
        { lat: 17.4455881534584, lng: 78.43933837680818 },
        { lat: 17.44488350959778, lng: 78.43971346282656 },
        { lat: 17.44468133935743, lng: 78.43982695409048 },
        { lat: 17.44461864707978, lng: 78.4398661522128 },
        { lat: 17.44450236078967, lng: 78.43994481086906 },
        { lat: 17.44441508212089, lng: 78.44000827844013 },
        { lat: 17.44431845334693, lng: 78.4400733951824 },
        { lat: 17.44419972044921, lng: 78.44013486854894 },
        { lat: 17.44389984021785, lng: 78.44028534884261 },
        { lat: 17.44362752857904, lng: 78.44046099763827 },
        { lat: 17.44283726266325, lng: 78.44086852549316 },
        { lat: 17.44025238476236, lng: 78.4423623185689 },
        { lat: 17.43994486075253, lng: 78.44250131515882 },
        { lat: 17.43987200519604, lng: 78.44231813250595 },
        { lat: 17.43984891844312, lng: 78.442216236067 },
        { lat: 17.43984278801262, lng: 78.44168268889413 },
        { lat: 17.43983780556073, lng: 78.44158350484237 },
        { lat: 17.43984946475577, lng: 78.44152920558483 },
        { lat: 17.4398621364756, lng: 78.44145748899585 },
        { lat: 17.43985437588504, lng: 78.44133042389169 },
        { lat: 17.43983838960068, lng: 78.44124041773708 },
        { lat: 17.43985790697585, lng: 78.44097564055126 },
        { lat: 17.4398807746791, lng: 78.44078390511518 },
        { lat: 17.43988178153771, lng: 78.44074252084235 },
        { lat: 17.43923230795886, lng: 78.44057860343797 },
        { lat: 17.43893366095486, lng: 78.44050843657055 },
        { lat: 17.43879002671819, lng: 78.44046325450697 },
        { lat: 17.43863772165336, lng: 78.44040926333898 },
        { lat: 17.43783772443559, lng: 78.4403157008666 },
        { lat: 17.43767049913848, lng: 78.44030990156192 },
        { lat: 17.43762752183765, lng: 78.44022317036057 },
        { lat: 17.43756565054266, lng: 78.44013007706478 },
        { lat: 17.43749458323184, lng: 78.44008207798795 },
        { lat: 17.43726639871966, lng: 78.44001119876188 },
        { lat: 17.43710363264088, lng: 78.43996861968714 },
        { lat: 17.43699862463491, lng: 78.43993006789407 },
        { lat: 17.43686340199034, lng: 78.43989046536609 },
        { lat: 17.43675147646258, lng: 78.43985197351176 },
        { lat: 17.43664298814515, lng: 78.43980461372756 },
        { lat: 17.43659948827156, lng: 78.43977403010648 },
        { lat: 17.43656224556274, lng: 78.43970847627212 },
        { lat: 17.43652697341243, lng: 78.43967001636315 },
        { lat: 17.4365010552321, lng: 78.43963372074697 },
        { lat: 17.43646241514949, lng: 78.43956654179594 },
        { lat: 17.43643640746456, lng: 78.43950566461257 },
        { lat: 17.43632343941641, lng: 78.4395054934295 },
        { lat: 17.43626089599693, lng: 78.43950136846884 },
        { lat: 17.43612180782753, lng: 78.43948059025672 },
        { lat: 17.43596387598577, lng: 78.43945146215363 },
        { lat: 17.43582835628692, lng: 78.43942345513865 },
        { lat: 17.43571001079115, lng: 78.43939667431691 },
        { lat: 17.43554732810786, lng: 78.43935173504664 },
        { lat: 17.43542285665675, lng: 78.4393144415893 },
        { lat: 17.43531033809395, lng: 78.4392842656957 },
        { lat: 17.43517651437791, lng: 78.4392504881977 },
        { lat: 17.43505234341227, lng: 78.4392117699115 },
        { lat: 17.43494905815658, lng: 78.43917704585058 },
        { lat: 17.43481293438967, lng: 78.43913732592358 },
        { lat: 17.43468157351128, lng: 78.43910150445545 },
        { lat: 17.43455084984036, lng: 78.43906249016496 },
        { lat: 17.43427504619757, lng: 78.43898232403642 },
        { lat: 17.43412625006448, lng: 78.43893614706563 },
        { lat: 17.43395215670465, lng: 78.438886715036 },
        { lat: 17.43358136984675, lng: 78.43877485510757 },
        { lat: 17.43359213718594, lng: 78.43872681477588 },
        { lat: 17.43360493449939, lng: 78.43865530023315 },
        { lat: 17.43362200848699, lng: 78.43853929370904 },
        { lat: 17.43364199279992, lng: 78.43843398671436 },
        { lat: 17.43366198052637, lng: 78.43832396583139 },
        { lat: 17.43366979909218, lng: 78.43825972605862 },
        { lat: 17.43369073768055, lng: 78.43815685858026 },
        { lat: 17.43369831300313, lng: 78.43811821892083 },
        { lat: 17.43371531772736, lng: 78.43804507240597 },
        { lat: 17.43372342661153, lng: 78.43801547188029 },
        { lat: 17.43373298494024, lng: 78.43797638582406 },
        { lat: 17.43373772970716, lng: 78.43794364268261 },
        { lat: 17.43374151789113, lng: 78.43791446943878 },
        { lat: 17.43374359329266, lng: 78.43788940825343 },
        { lat: 17.43375046660901, lng: 78.43778576805289 },
        { lat: 17.43375467520691, lng: 78.43769487546217 },
        { lat: 17.43376389316296, lng: 78.43757250810283 },
        { lat: 17.43377973652114, lng: 78.43742774361525 },
        { lat: 17.43379365135378, lng: 78.43733973096329 },
        { lat: 17.43380951708007, lng: 78.43727719463027 },
        { lat: 17.43383860927955, lng: 78.43718389480495 },
        { lat: 17.43386279190702, lng: 78.43711859649238 },
        { lat: 17.4338749809291, lng: 78.43708659235237 },
        { lat: 17.43388313095044, lng: 78.43706398761061 },
        { lat: 17.43389401457375, lng: 78.43703729134948 },
        { lat: 17.43391012483303, lng: 78.43700007166869 },
        { lat: 17.43396244782179, lng: 78.43688730960845 },
        { lat: 17.43401869037658, lng: 78.43677117140253 },
        { lat: 17.43405308063046, lng: 78.43669564407544 },
        { lat: 17.43409111340217, lng: 78.43660069207534 },
        { lat: 17.43410612679809, lng: 78.43656281586001 },
        { lat: 17.43411271428176, lng: 78.43653922992468 },
        { lat: 17.43411956171996, lng: 78.4365126859784 },
        { lat: 17.43412100854107, lng: 78.4364991443108 },
        { lat: 17.43412050645011, lng: 78.43648989114313 },
        { lat: 17.43411657185581, lng: 78.43647997087038 },
        { lat: 17.43411118550274, lng: 78.43647409034332 },
        { lat: 17.43410001677123, lng: 78.43646664407433 },
        { lat: 17.43414985702349, lng: 78.43635117849814 },
        { lat: 17.43421173620854, lng: 78.43623078561797 },
        { lat: 17.43426284318333, lng: 78.43614222940043 },
        { lat: 17.43430260656244, lng: 78.43608069207029 },
        { lat: 17.43436037702061, lng: 78.43600440680879 },
        { lat: 17.43445848835576, lng: 78.43588850052222 },
        { lat: 17.43456761549057, lng: 78.43576796150889 },
        { lat: 17.4346885917842, lng: 78.43562089400163 },
        { lat: 17.43477418925968, lng: 78.43551759325236 },
        { lat: 17.43484613684978, lng: 78.43542892680688 },
        { lat: 17.43494257359009, lng: 78.43531430505357 },
        { lat: 17.4349909995375, lng: 78.43526164674408 },
        { lat: 17.43508242942068, lng: 78.43515568042896 },
        { lat: 17.43517471446304, lng: 78.43503141305216 },
        { lat: 17.43525174728338, lng: 78.43493992395618 },
        { lat: 17.43535524974389, lng: 78.43482254393223 },
        { lat: 17.43543959333041, lng: 78.4347233951892 },
        { lat: 17.43546639167831, lng: 78.43469770858411 },
        { lat: 17.43539242877689, lng: 78.43462476456659 },
        { lat: 17.43534644188363, lng: 78.43458079732203 },
        { lat: 17.43531028610181, lng: 78.43454798421432 },
        { lat: 17.43521726515165, lng: 78.43445848001278 },
        { lat: 17.43509235542708, lng: 78.43433437948397 },
        { lat: 17.43494797874305, lng: 78.4341828770991 },
        { lat: 17.434771168386, lng: 78.43400307045572 },
        { lat: 17.43457456304214, lng: 78.43378730852974 },
        { lat: 17.43451123659729, lng: 78.43372481266968 },
        { lat: 17.43444996511545, lng: 78.4336783123048 },
        { lat: 17.43439335411401, lng: 78.4336431032393 },
        { lat: 17.43430375278966, lng: 78.43358958228482 },
        { lat: 17.43424218483934, lng: 78.43354453700181 },
        { lat: 17.43419248844894, lng: 78.43350932630118 },
        { lat: 17.4341218865898, lng: 78.43345373973497 },
        { lat: 17.43411519589243, lng: 78.43344771196199 },
        { lat: 17.43401956654801, lng: 78.43335585083219 },
        { lat: 17.43393644101663, lng: 78.43326002779897 },
        { lat: 17.43388273330848, lng: 78.4331846525676 },
        { lat: 17.43385173809054, lng: 78.43313131773138 },
        { lat: 17.4338410556616, lng: 78.4331364491683 },
        { lat: 17.43381755947391, lng: 78.43314266032142 },
        { lat: 17.43381039196539, lng: 78.43314322258368 },
        { lat: 17.43379408497896, lng: 78.4331403966569 },
        { lat: 17.43360564826617, lng: 78.4330633436151 },
        { lat: 17.43346419981938, lng: 78.43300815502734 },
        { lat: 17.43330262674372, lng: 78.43293900698352 },
        { lat: 17.43319953818577, lng: 78.43289745421534 },
        { lat: 17.4330459897022, lng: 78.43283159626 },
        { lat: 17.43292803310372, lng: 78.43277924904449 },
        { lat: 17.43282964849291, lng: 78.43273596619157 },
        { lat: 17.43278677360017, lng: 78.43271139963716 },
        { lat: 17.43274727069817, lng: 78.4326788148131 },
        { lat: 17.43270774181812, lng: 78.43263840228808 },
        { lat: 17.43267103387844, lng: 78.43260383076928 },
        { lat: 17.43262937259493, lng: 78.43257280229118 },
        { lat: 17.43248922278957, lng: 78.43250724462241 },
        { lat: 17.43236081084817, lng: 78.4324496961343 },
        { lat: 17.43220835504953, lng: 78.432379980962 },
        { lat: 17.43198762790821, lng: 78.43227650417502 },
        { lat: 17.43194905193767, lng: 78.4322611028913 },
        { lat: 17.43168861530667, lng: 78.43217345807923 },
        { lat: 17.43138123183866, lng: 78.43208523517731 },
        { lat: 17.43110255995565, lng: 78.43198909407052 },
        { lat: 17.43091102004902, lng: 78.43192866072415 },
        { lat: 17.43075542284426, lng: 78.43188946871592 },
        { lat: 17.43069032893936, lng: 78.431880785812 },
        { lat: 17.43039584471112, lng: 78.43186660116098 },
        { lat: 17.43026171581166, lng: 78.4318610955228 },
        { lat: 17.42999209071828, lng: 78.43184862151044 },
        { lat: 17.42969263626254, lng: 78.43183358903094 },
        { lat: 17.4297019952383, lng: 78.43163495190016 },
        { lat: 17.42971458825919, lng: 78.43144485766173 },
        { lat: 17.42973081958531, lng: 78.4311621790458 },
        { lat: 17.42973732421012, lng: 78.43104113497172 },
        { lat: 17.42974442658134, lng: 78.43086100226343 },
        { lat: 17.42974855691293, lng: 78.43070652322358 },
        { lat: 17.429752004126, lng: 78.43050289297204 },
        { lat: 17.42975246370771, lng: 78.43033217628147 },
        { lat: 17.42974720936699, lng: 78.43014568617511 },
        { lat: 17.42975038741434, lng: 78.43002950215437 },
        { lat: 17.42976204349783, lng: 78.429644349254 },
        { lat: 17.42976949808952, lng: 78.42949495892611 },
        { lat: 17.4297727729223, lng: 78.42936342442067 },
        { lat: 17.42977261013383, lng: 78.42920005241984 },
        { lat: 17.42977437834676, lng: 78.4290237523431 },
        { lat: 17.42977985282441, lng: 78.42887492889669 },
        { lat: 17.42978475677323, lng: 78.42873145093421 },
        { lat: 17.42979362623943, lng: 78.4285441073266 },
        { lat: 17.42979485726622, lng: 78.42842353615347 },
        { lat: 17.42979493587915, lng: 78.4283053502178 },
        { lat: 17.4297937138494, lng: 78.42820793218263 },
        { lat: 17.42979158870364, lng: 78.42813940171514 },
        { lat: 17.42979560524578, lng: 78.4280010309712 },
        { lat: 17.42980151042963, lng: 78.42781708969946 },
        { lat: 17.4298027546288, lng: 78.42764520594025 },
        { lat: 17.42980727808237, lng: 78.4274760498689 },
        { lat: 17.42980773345145, lng: 78.42733205289947 },
        { lat: 17.42980603719109, lng: 78.42720775377637 },
        { lat: 17.42980726254284, lng: 78.42684664342454 },
        { lat: 17.42980588446351, lng: 78.42669401352475 },
        { lat: 17.42979091375773, lng: 78.42652741439379 },
        { lat: 17.42978807898883, lng: 78.42640255457793 },
        { lat: 17.42978929173854, lng: 78.42629653227223 },
        { lat: 17.42979560875749, lng: 78.42622017977077 },
        { lat: 17.429799202481, lng: 78.42617196883205 },
        { lat: 17.42982137555996, lng: 78.4259899154958 },
        { lat: 17.42984322332731, lng: 78.42580374010646 },
        { lat: 17.4298742096783, lng: 78.42561160035135 },
        { lat: 17.42990264802837, lng: 78.425444469445 },
        { lat: 17.42995071628573, lng: 78.42523695154162 },
        { lat: 17.43013119646922, lng: 78.42531534588188 },
        { lat: 17.43017611973779, lng: 78.42533511048765 },
        { lat: 17.43030696359858, lng: 78.4250042518064 },
        { lat: 17.43045113828748, lng: 78.42464272649838 },
        { lat: 17.43056389917538, lng: 78.42435373026342 },
        { lat: 17.43075852117587, lng: 78.42388663701414 },
        { lat: 17.43105889037223, lng: 78.4230878252297 },
        { lat: 17.43116129648034, lng: 78.4228147190088 },
        { lat: 17.43123857338337, lng: 78.42259846518445 },
        { lat: 17.43127036409876, lng: 78.42251525574174 },
        { lat: 17.43130418333087, lng: 78.422402329838 },
        { lat: 17.43134338251711, lng: 78.42227823367665 },
        { lat: 17.43137977767356, lng: 78.42216651344464 },
        { lat: 17.43138681328682, lng: 78.42212423859159 },
        { lat: 17.43139020937762, lng: 78.42209370037439 },
        { lat: 17.43138750639477, lng: 78.42206176505502 },
        { lat: 17.43138496627312, lng: 78.42204624548212 },
        { lat: 17.43137765088558, lng: 78.42202289353357 },
        { lat: 17.43137141088161, lng: 78.42200537957578 },
        { lat: 17.43134289762792, lng: 78.42195428217417 },
        { lat: 17.43127666477193, lng: 78.42183378156012 },
        { lat: 17.43123330933403, lng: 78.42174337569486 },
        { lat: 17.43121706654775, lng: 78.4216993374001 },
        { lat: 17.43121291894898, lng: 78.4216873884238 },
        { lat: 17.43120560110408, lng: 78.42165994380802 },
        { lat: 17.43120541829098, lng: 78.42162811048583 },
        { lat: 17.43121052179107, lng: 78.42157578150197 },
        { lat: 17.43123019369813, lng: 78.42145360529547 },
        { lat: 17.43127204535433, lng: 78.42122424594693 },
        { lat: 17.43130197525082, lng: 78.42108227563223 },
        { lat: 17.43115546523088, lng: 78.42101761201282 },
        { lat: 17.43098505258861, lng: 78.4209471933481 },
        { lat: 17.43085708637839, lng: 78.4208950225855 },
        { lat: 17.43068652237459, lng: 78.4208159879917 },
        { lat: 17.43064083371132, lng: 78.42079586740051 },
        { lat: 17.43060785394896, lng: 78.4207731388765 },
        { lat: 17.43059201611059, lng: 78.42075228914344 },
        { lat: 17.43056134934326, lng: 78.42069741856925 },
        { lat: 17.4304928943208, lng: 78.42055657974865 },
        { lat: 17.43041836214988, lng: 78.42039247915035 },
        { lat: 17.4303985353177, lng: 78.42033442485985 },
        { lat: 17.43038931898255, lng: 78.42029520786491 },
        { lat: 17.43038881973623, lng: 78.42025165328369 },
        { lat: 17.43039316720033, lng: 78.42021983829324 },
        { lat: 17.43040362450208, lng: 78.4201813984527 },
        { lat: 17.43041451342775, lng: 78.42014908691678 },
        { lat: 17.43044451634335, lng: 78.42009889381094 },
        { lat: 17.4304863322737, lng: 78.4200389190431 },
        { lat: 17.4305852273122, lng: 78.41993080716861 },
        { lat: 17.43069602496113, lng: 78.41981425766943 },
        { lat: 17.43078829162003, lng: 78.41972064704852 },
        { lat: 17.4308389661169, lng: 78.41978309792802 },
        { lat: 17.43091971394124, lng: 78.41989063993562 },
        { lat: 17.43101167957669, lng: 78.42001370370414 },
        { lat: 17.43112245441081, lng: 78.42016925536684 },
        { lat: 17.43121751498306, lng: 78.42030305062798 },
        { lat: 17.43125479998827, lng: 78.4203539989521 },
        { lat: 17.43128000556278, lng: 78.42039214643471 },
        { lat: 17.43129919040089, lng: 78.42042072252995 },
        { lat: 17.43131970768703, lng: 78.42044729938728 },
        { lat: 17.43135094174853, lng: 78.42048272114616 },
        { lat: 17.43138839923902, lng: 78.42051645125399 },
        { lat: 17.43142526724088, lng: 78.42054162782962 },
        { lat: 17.43146755587928, lng: 78.42056065965286 },
        { lat: 17.43149537865301, lng: 78.42057293248484 },
        { lat: 17.43151874499134, lng: 78.42058002737502 },
        { lat: 17.43153926937994, lng: 78.42058456544373 },
        { lat: 17.43158006050403, lng: 78.42058978767292 },
        { lat: 17.4316117682493, lng: 78.42058682979581 },
        { lat: 17.43167290738309, lng: 78.42057112343933 },
        { lat: 17.43170645833951, lng: 78.42055358450227 },
        { lat: 17.4317323217223, lng: 78.42053800713899 },
        { lat: 17.43176327222291, lng: 78.42051006117593 },
        { lat: 17.43179651924423, lng: 78.42047533692958 },
        { lat: 17.43180821054952, lng: 78.42045546147932 },
        { lat: 17.43181477945225, lng: 78.42044174542924 },
        { lat: 17.43181849670874, lng: 78.42042123880879 },
        { lat: 17.43182049814558, lng: 78.42035229811854 },
        { lat: 17.43182033462126, lng: 78.42032434080083 },
        { lat: 17.43181258766813, lng: 78.42018753351807 },
        { lat: 17.43180419343363, lng: 78.41997757013579 },
        { lat: 17.43180213655766, lng: 78.41985849717699 },
        { lat: 17.43180108838482, lng: 78.41978785692308 },
        { lat: 17.43180588403366, lng: 78.41971752682616 },
        { lat: 17.43181241030215, lng: 78.41964066068141 },
        { lat: 17.43181932016473, lng: 78.41954029298766 },
        { lat: 17.43182990540119, lng: 78.41936797855465 },
        { lat: 17.43184025283001, lng: 78.41916116417126 },
        { lat: 17.43184765355171, lng: 78.41909060078484 },
        { lat: 17.43185242835651, lng: 78.41904216201442 },
        { lat: 17.43186032414509, lng: 78.4190012927935 },
        { lat: 17.43186851349779, lng: 78.41896565251527 },
        { lat: 17.43188411967028, lng: 78.4189215191662 },
        { lat: 17.43190828626671, lng: 78.41886528631994 },
        { lat: 17.43194040278083, lng: 78.41879507612481 },
        { lat: 17.43197530856707, lng: 78.41871987678631 },
        { lat: 17.43201591340324, lng: 78.4186298510963 },
        { lat: 17.43205500720067, lng: 78.4185421931432 },
        { lat: 17.43208281768883, lng: 78.41847911590216 },
        { lat: 17.43212207835761, lng: 78.41839102933224 },
        { lat: 17.43215378382674, lng: 78.41831504410874 },
        { lat: 17.43218208927151, lng: 78.41825392530457 },
        { lat: 17.43222131230925, lng: 78.4181753428395 },
        { lat: 17.43227249276422, lng: 78.41805466624089 },
        { lat: 17.43233843291608, lng: 78.41790407219469 },
        { lat: 17.432445989889, lng: 78.4176698713641 },
        { lat: 17.43249343430167, lng: 78.4175686731246 },
        { lat: 17.43255349014988, lng: 78.417433341502 },
        { lat: 17.43258412557948, lng: 78.41737919627435 },
        { lat: 17.43261445579123, lng: 78.41733501250023 },
        { lat: 17.43263866852078, lng: 78.41730855322992 },
        { lat: 17.43271137155281, lng: 78.41726780357469 },
        { lat: 17.4328045029762, lng: 78.4172262092946 },
        { lat: 17.43290208574938, lng: 78.41718619316858 },
        { lat: 17.43301402899574, lng: 78.41714612911574 },
        { lat: 17.43310059745892, lng: 78.41711284462257 },
        { lat: 17.43317083804897, lng: 78.4170802114885 },
        { lat: 17.43327009034968, lng: 78.41701858721777 },
        { lat: 17.43333524694355, lng: 78.41697425156524 },
        { lat: 17.43350760482571, lng: 78.41682432841607 },
        { lat: 17.43363123739896, lng: 78.41671736440728 },
        { lat: 17.43380935063794, lng: 78.41655844683967 },
        { lat: 17.43399462286919, lng: 78.41638378802148 },
        { lat: 17.43408480718688, lng: 78.41626683955057 },
        { lat: 17.4341438356379, lng: 78.41619146755897 },
        { lat: 17.43419028732544, lng: 78.41611906706122 },
        { lat: 17.43423409170462, lng: 78.4160323922068 },
        { lat: 17.43426887318504, lng: 78.41595146801144 },
        { lat: 17.43430309634552, lng: 78.41584729422053 },
        { lat: 17.43434130822181, lng: 78.41571441933084 },
        { lat: 17.43436843530059, lng: 78.41559592562304 },
        { lat: 17.43439358995888, lng: 78.41548753078277 },
        { lat: 17.43441922265098, lng: 78.41537909154955 },
        { lat: 17.43449952854344, lng: 78.41539119061721 },
        { lat: 17.43453586308195, lng: 78.41539735511047 },
        { lat: 17.43458006026322, lng: 78.41540718831268 },
        { lat: 17.43474090338037, lng: 78.41545108325556 },
        { lat: 17.43490869958612, lng: 78.41550135445588 },
        { lat: 17.43506926936512, lng: 78.41554332645785 },
        { lat: 17.43532408814394, lng: 78.41562816081273 },
        { lat: 17.43563344260279, lng: 78.41572554797786 },
        { lat: 17.43564305885548, lng: 78.4156676227335 },
        { lat: 17.4356578182876, lng: 78.41556591834265 },
        { lat: 17.43567271119257, lng: 78.41543303884063 },
        { lat: 17.43568210285681, lng: 78.41526336095853 },
        { lat: 17.43568128458751, lng: 78.41520722739006 },
        { lat: 17.43571290216361, lng: 78.41520805296939 },
        { lat: 17.43573678911335, lng: 78.4152100911389 },
        { lat: 17.4357929026683, lng: 78.41521854265899 },
        { lat: 17.43583784624005, lng: 78.41522743102878 },
        { lat: 17.43602099108615, lng: 78.41526764332693 },
        { lat: 17.43613691144883, lng: 78.41529465118192 },
        { lat: 17.43614553402908, lng: 78.41539621830901 },
        { lat: 17.43711980681863, lng: 78.41568128953952 },
        { lat: 17.43807626082263, lng: 78.41597461740747 },
        { lat: 17.4383754741326, lng: 78.415351453532 },
        { lat: 17.43861562347709, lng: 78.41471578230528 },
        { lat: 17.43970902702483, lng: 78.41510321999024 },
        { lat: 17.44019578399773, lng: 78.41531512696884 },
        { lat: 17.44109263315696, lng: 78.4157052747242 },
        { lat: 17.44140227570614, lng: 78.41508273533852 },
        { lat: 17.44159056497452, lng: 78.41516118923684 },
        { lat: 17.44170299844738, lng: 78.41490750990468 },
        { lat: 17.44226650169432, lng: 78.415199886759 },
        { lat: 17.44290772235892, lng: 78.41499574696361 },
        { lat: 17.44335925015606, lng: 78.414281320638 },
        { lat: 17.44449727375754, lng: 78.41312316055445 },
        { lat: 17.44547962184808, lng: 78.41229162322583 },
        { lat: 17.44564703231783, lng: 78.41196630689674 },
        { lat: 17.44583362336551, lng: 78.41203619002506 },
        { lat: 17.4459096424789, lng: 78.41206616843024 },
        { lat: 17.44596451011102, lng: 78.41208721870183 },
        { lat: 17.44600914169862, lng: 78.41210384809698 },
        { lat: 17.44603863965663, lng: 78.41211308748704 },
        { lat: 17.44605068601408, lng: 78.412071432719 },
        { lat: 17.44606993417927, lng: 78.41201659074393 },
        { lat: 17.44612355902535, lng: 78.41188377396652 },
        { lat: 17.44616422613372, lng: 78.41177809587913 },
        { lat: 17.44620542398276, lng: 78.41167510602507 },
        { lat: 17.44621554947633, lng: 78.41165103422304 },
        { lat: 17.44616552790403, lng: 78.41163440952955 },
        { lat: 17.44574204246175, lng: 78.41150219496701 },
        { lat: 17.44574918369311, lng: 78.4114408961083 },
        { lat: 17.44597096454007, lng: 78.41143275950078 },
        { lat: 17.4460322942846, lng: 78.41131240658052 },
        { lat: 17.44605557668758, lng: 78.41112436782099 },
        { lat: 17.44607193306318, lng: 78.41100674070044 },
        { lat: 17.44608729262188, lng: 78.4109087808592 },
        { lat: 17.44610615729733, lng: 78.41076751692904 },
        { lat: 17.44612859676672, lng: 78.41062953149728 },
        { lat: 17.44615001085783, lng: 78.41047307218696 },
        { lat: 17.44617304758879, lng: 78.4103104221327 },
        { lat: 17.44619028953931, lng: 78.4101864179594 },
        { lat: 17.44620451416422, lng: 78.41003370439306 },
        { lat: 17.44621866511896, lng: 78.40986847277998 },
        { lat: 17.44622678026217, lng: 78.40973966894435 },
        { lat: 17.44624268587722, lng: 78.40951187453095 },
        { lat: 17.44624964807045, lng: 78.40938693256862 },
        { lat: 17.44626015741497, lng: 78.40926432196808 },
        { lat: 17.44626487981897, lng: 78.40914695415813 },
        { lat: 17.44627163565064, lng: 78.40904162315664 },
        { lat: 17.44627564458334, lng: 78.40894673672867 },
        { lat: 17.44627964487174, lng: 78.40881658530634 },
        { lat: 17.44628007222669, lng: 78.40869538089137 },
        { lat: 17.44628550426555, lng: 78.40852428161182 },
        { lat: 17.44622414265785, lng: 78.40705686210536 },
        { lat: 17.4462511789707, lng: 78.40633156285735 },
        { lat: 17.44623303644033, lng: 78.40564528079439 },
        { lat: 17.44547049410995, lng: 78.40587675907854 },
        { lat: 17.44422595541234, lng: 78.4063686227655 },
        { lat: 17.44398357655055, lng: 78.40647287759595 },
        { lat: 17.44243813144409, lng: 78.40670385636342 },
        { lat: 17.44229051758181, lng: 78.40665366547047 },
        { lat: 17.4422524426483, lng: 78.40648242903168 },
        { lat: 17.44206073076349, lng: 78.40524911046703 },
        { lat: 17.44175513182676, lng: 78.40435348748007 },
        { lat: 17.44158775565965, lng: 78.4036127477488 },
        { lat: 17.44158152020783, lng: 78.40313485661669 },
        { lat: 17.44161380107862, lng: 78.40286180210632 },
        { lat: 17.44111069776699, lng: 78.40193911145191 },
        { lat: 17.44085128219267, lng: 78.40156189941106 },
        { lat: 17.44056773151411, lng: 78.4009833843136 },
        { lat: 17.44046034962179, lng: 78.40080189183205 },
        { lat: 17.44032457432213, lng: 78.40061755503946 },
        { lat: 17.44030059510139, lng: 78.40055748390131 },
        { lat: 17.44012973799801, lng: 78.40027698873122 },
        { lat: 17.43985001618853, lng: 78.39993026899877 },
        { lat: 17.43979461498164, lng: 78.39982474698937 },
        { lat: 17.4394273433731, lng: 78.39927966149493 },
        { lat: 17.43918721597091, lng: 78.39893522834163 },
        { lat: 17.43916964252514, lng: 78.39894870271068 },
        { lat: 17.43907973740589, lng: 78.39902841680667 },
        { lat: 17.43895723640676, lng: 78.39915019252552 },
        { lat: 17.43885714885574, lng: 78.39923721379512 },
        { lat: 17.43883111918897, lng: 78.3992602931022 },
        { lat: 17.43852267684756, lng: 78.39882393549559 },
        { lat: 17.43841380077962, lng: 78.39867038548019 },
        { lat: 17.43842864729443, lng: 78.39838421974937 },
        { lat: 17.43860538616397, lng: 78.3978014270327 },
        { lat: 17.43890052863435, lng: 78.39691998142831 },
        { lat: 17.43911610677739, lng: 78.39649153942898 },
        { lat: 17.43927810779076, lng: 78.39630225338149 },
        { lat: 17.43936790357303, lng: 78.39621593545499 },
        { lat: 17.43926214138154, lng: 78.39614874021139 },
        { lat: 17.4391328407039, lng: 78.39607182590686 },
        { lat: 17.43895824844384, lng: 78.39598464432532 },
        { lat: 17.43852472225085, lng: 78.39578670114173 },
        { lat: 17.43713276749719, lng: 78.39515388223063 },
        { lat: 17.43648317683112, lng: 78.39662445660072 },
        { lat: 17.43622199960497, lng: 78.39716872982532 },
        { lat: 17.43604394638786, lng: 78.3973263665084 },
        { lat: 17.43582282794645, lng: 78.39753005319723 },
        { lat: 17.43560545838233, lng: 78.39771744963197 },
        { lat: 17.4355588980776, lng: 78.39776557228193 },
        { lat: 17.43555620146974, lng: 78.39777415362059 },
        { lat: 17.43555570169791, lng: 78.39778221171892 },
        { lat: 17.43555699014853, lng: 78.39778716028255 },
        { lat: 17.43538070161831, lng: 78.39789640638617 },
        { lat: 17.43515675923262, lng: 78.39802989317955 },
        { lat: 17.43492485621469, lng: 78.3981858945307 },
        { lat: 17.43478989734563, lng: 78.39828824512406 },
        { lat: 17.43474823750584, lng: 78.3982365230096 },
        { lat: 17.43455116707065, lng: 78.39790661204314 },
        { lat: 17.43450139322555, lng: 78.39790104160211 },
        { lat: 17.43385329541022, lng: 78.39720516061212 },
        { lat: 17.43378471818671, lng: 78.39733403300175 },
        { lat: 17.43352111226502, lng: 78.3978486811393 },
        { lat: 17.43308882806293, lng: 78.39859261306103 },
        { lat: 17.43288325143102, lng: 78.39894967067443 },
        { lat: 17.43286461775135, lng: 78.39893252998932 },
        { lat: 17.43284779472007, lng: 78.39891752007505 },
        { lat: 17.43280646739418, lng: 78.39888203930327 },
        { lat: 17.43278029816021, lng: 78.39886602818359 },
        { lat: 17.43236419590484, lng: 78.3986300356324 },
        { lat: 17.43218907727202, lng: 78.39855045294851 },
        { lat: 17.43205099105996, lng: 78.3985441935732 },
        { lat: 17.43189452285838, lng: 78.39855913627324 },
        { lat: 17.43169090920607, lng: 78.39858366571639 },
        { lat: 17.43157810315746, lng: 78.39857707511524 },
        { lat: 17.43147542731592, lng: 78.39854446380478 },
        { lat: 17.43130033557521, lng: 78.39850495645166 },
        { lat: 17.43117162618492, lng: 78.39847985348587 },
        { lat: 17.43110314151402, lng: 78.39849098567481 },
        { lat: 17.43108417570575, lng: 78.39836748448876 },
        { lat: 17.43105901847387, lng: 78.39821935607176 },
        { lat: 17.43101203206965, lng: 78.39795532600186 },
        { lat: 17.43090610973102, lng: 78.39761847051244 },
        { lat: 17.43082515151562, lng: 78.3973802728952 },
        { lat: 17.43073463844459, lng: 78.39703697591284 },
        { lat: 17.43062588886294, lng: 78.39647211389456 },
        { lat: 17.43053366645771, lng: 78.39589946699206 },
        { lat: 17.43050727653049, lng: 78.39541783562416 },
        { lat: 17.43051084958853, lng: 78.39526029759197 },
        { lat: 17.43053809257109, lng: 78.39495761404979 },
        { lat: 17.43059250471946, lng: 78.3946225156495 },
        { lat: 17.4306305078925, lng: 78.39458826192423 },
        { lat: 17.43058507985197, lng: 78.39428403988538 },
        { lat: 17.43051132700645, lng: 78.39382394123473 },
        { lat: 17.43049351895241, lng: 78.39362123157272 },
        { lat: 17.43045303595578, lng: 78.39344857085582 },
        { lat: 17.43043182613691, lng: 78.39340755992131 },
        { lat: 17.43040209778257, lng: 78.39337385614236 },
        { lat: 17.43030589353833, lng: 78.39332711402743 },
        { lat: 17.43030844168229, lng: 78.39330334141678 },
        { lat: 17.4302885512572, lng: 78.3933010272807 },
        { lat: 17.43028665169411, lng: 78.39331873826234 },
        { lat: 17.43022619321907, lng: 78.39329078024664 },
        { lat: 17.43016690940944, lng: 78.39327176609584 },
        { lat: 17.43013596658361, lng: 78.39326436757631 },
        { lat: 17.43008772990038, lng: 78.39326445354978 },
        { lat: 17.43003498073762, lng: 78.39327072000941 },
        { lat: 17.42998083434186, lng: 78.39328512196987 },
        { lat: 17.42992089423482, lng: 78.39329193182549 },
        { lat: 17.42986832337946, lng: 78.39331657966817 },
        { lat: 17.42982454790006, lng: 78.39335279243261 },
        { lat: 17.42976010936642, lng: 78.39342315562251 },
        { lat: 17.42970059685247, lng: 78.39350175260049 },
        { lat: 17.42969067759481, lng: 78.39353362693758 },
        { lat: 17.4296920838338, lng: 78.39355336356255 },
        { lat: 17.42918363737693, lng: 78.39465690657472 },
        { lat: 17.42826395281035, lng: 78.39429971051692 },
        { lat: 17.42800047495503, lng: 78.39465900914595 },
        { lat: 17.42785004019771, lng: 78.39480717812174 },
        { lat: 17.42764334853913, lng: 78.39484820640033 },
        { lat: 17.42738740869568, lng: 78.39485183968371 },
        { lat: 17.42723398427637, lng: 78.39477147920334 },
        { lat: 17.42698906840823, lng: 78.39468606713382 },
        { lat: 17.42695142545425, lng: 78.39460406133766 },
        { lat: 17.42682019793892, lng: 78.39468354678137 },
        { lat: 17.42652528958649, lng: 78.39559460569673 },
        { lat: 17.42623396630654, lng: 78.39636110615348 },
        { lat: 17.42580845852216, lng: 78.3969841540105 },
        { lat: 17.42568465459861, lng: 78.39722279722349 },
        { lat: 17.42522194966496, lng: 78.39742768355464 },
        { lat: 17.42488405520496, lng: 78.39760170822193 },
        { lat: 17.4236479936575, lng: 78.3979179401716 },
        { lat: 17.42314373958377, lng: 78.39773092975263 },
        { lat: 17.4230023414014, lng: 78.39788228681213 },
        { lat: 17.42226623094725, lng: 78.39808351824254 },
        { lat: 17.42194770474665, lng: 78.39808263833748 },
        { lat: 17.42098258078638, lng: 78.39804943911996 },
        { lat: 17.42089311042601, lng: 78.39833447570274 },
        { lat: 17.42066492165073, lng: 78.3984273188477 },
        { lat: 17.4203226621132, lng: 78.39831790508154 },
        { lat: 17.41990941754896, lng: 78.398213998295 },
        { lat: 17.41923913968104, lng: 78.3984510976979 },
        { lat: 17.41843715139225, lng: 78.39873611597439 },
        { lat: 17.41842753996878, lng: 78.3987092667871 },
        { lat: 17.41840587415382, lng: 78.39865993062216 },
        { lat: 17.4183760853347, lng: 78.39861480759077 },
        { lat: 17.41831547324018, lng: 78.3985512360505 },
        { lat: 17.41815863119312, lng: 78.39844917182695 },
        { lat: 17.41803374430795, lng: 78.39836343284863 },
        { lat: 17.41791804384727, lng: 78.39824128555028 },
        { lat: 17.41768606163025, lng: 78.39797268622844 },
        { lat: 17.41752271982352, lng: 78.39778822114792 },
        { lat: 17.41749274190678, lng: 78.39769384875915 },
        { lat: 17.41728534023238, lng: 78.39783006178554 },
        { lat: 17.41662403584053, lng: 78.39826889653406 },
        { lat: 17.41539854740818, lng: 78.39860868657641 },
        { lat: 17.4149315922382, lng: 78.398732136945 },
        { lat: 17.41460579294753, lng: 78.39881229830675 },
        { lat: 17.41444992271839, lng: 78.39882555135706 },
        { lat: 17.41422183619682, lng: 78.3988420134596 },
        { lat: 17.41407003125352, lng: 78.39885327745918 },
        { lat: 17.41404160091264, lng: 78.39885582690933 },
        { lat: 17.41385765307528, lng: 78.39876698101772 },
        { lat: 17.41335948564092, lng: 78.39854799836058 },
        { lat: 17.41279687390774, lng: 78.39828508014638 },
        { lat: 17.41203015718824, lng: 78.39794498188732 },
        { lat: 17.41161145728978, lng: 78.39772191958532 },
        { lat: 17.41132978332937, lng: 78.39756163252709 },
        { lat: 17.41091491456726, lng: 78.39719459352233 },
        { lat: 17.41099501076328, lng: 78.39709332050285 },
        { lat: 17.41146051551661, lng: 78.39651780984275 },
        { lat: 17.41164380189739, lng: 78.39629193683204 },
        { lat: 17.41198870131542, lng: 78.39588356031405 },
        { lat: 17.41216722122339, lng: 78.39568369846265 },
        { lat: 17.4124051907456, lng: 78.39539491483573 },
        { lat: 17.41258738628422, lng: 78.39520137444565 },
        { lat: 17.41280952826652, lng: 78.39499377961559 },
        { lat: 17.41277390314703, lng: 78.39497978227114 },
        { lat: 17.41268484171334, lng: 78.39494478985144 },
        { lat: 17.41255067815845, lng: 78.3949149169656 },
        { lat: 17.41244981678469, lng: 78.39490663797287 },
        { lat: 17.4122689117639, lng: 78.39490743879584 },
        { lat: 17.4121232542135, lng: 78.39490509150664 },
        { lat: 17.41187038335514, lng: 78.39490779249824 },
        { lat: 17.4115828334289, lng: 78.3949162929125 },
        { lat: 17.41131239564402, lng: 78.39493158354591 },
        { lat: 17.41117437957444, lng: 78.39493089260407 },
        { lat: 17.41092223322775, lng: 78.39492649272722 },
        { lat: 17.41085050451305, lng: 78.39491246937193 },
        { lat: 17.41079787222379, lng: 78.39488872643334 },
        { lat: 17.41078153785768, lng: 78.39486446781663 },
        { lat: 17.41077459388245, lng: 78.39482337886189 },
        { lat: 17.4107718589105, lng: 78.39461414278183 },
        { lat: 17.4107661742997, lng: 78.39434261147562 },
        { lat: 17.41075105121144, lng: 78.39392248153051 },
        { lat: 17.41075090691644, lng: 78.39366645606061 },
        { lat: 17.41077595490414, lng: 78.39305067744203 },
        { lat: 17.41078450085634, lng: 78.39272439863926 },
        { lat: 17.41078574818245, lng: 78.39265481245043 },
        { lat: 17.41076959276288, lng: 78.39256264910095 },
        { lat: 17.41072137123797, lng: 78.39238634044027 },
        { lat: 17.41068509754714, lng: 78.39222544652958 },
        { lat: 17.41067968121961, lng: 78.392152609735 },
        { lat: 17.41068501022736, lng: 78.39207015941486 },
        { lat: 17.41073161378075, lng: 78.39187803433968 },
        { lat: 17.41077700505966, lng: 78.39167479372108 },
        { lat: 17.41086397432533, lng: 78.39127890360687 },
        { lat: 17.41088961456625, lng: 78.39119389289806 },
        { lat: 17.41078875254423, lng: 78.3911085545431 },
        { lat: 17.41065068471132, lng: 78.39100280295798 },
        { lat: 17.41047739609682, lng: 78.39080267393672 },
        { lat: 17.41042130194614, lng: 78.39076701342096 },
        { lat: 17.41018751988588, lng: 78.39069418150336 },
        { lat: 17.41017298276694, lng: 78.39068948111627 },
        { lat: 17.41013345428674, lng: 78.39066867004438 },
        { lat: 17.41008327072222, lng: 78.3906431834218 },
        { lat: 17.41004077164624, lng: 78.39062449922466 },
        { lat: 17.40994682765427, lng: 78.3905925655279 },
        { lat: 17.40985174939199, lng: 78.39056429424386 },
        { lat: 17.4097827291676, lng: 78.39055337999224 },
        { lat: 17.40974260614236, lng: 78.39054703552189 },
        { lat: 17.40966537956861, lng: 78.3905299518782 },
        { lat: 17.40963987091696, lng: 78.39052448167205 },
        { lat: 17.40952538537928, lng: 78.3904909273372 },
        { lat: 17.40943342963351, lng: 78.39046482156176 },
        { lat: 17.40933583456352, lng: 78.39042829173074 },
        { lat: 17.4092676110624, lng: 78.39040193639015 },
        { lat: 17.40918898067956, lng: 78.39036551258322 },
        { lat: 17.40906264382767, lng: 78.39030765653666 },
        { lat: 17.40891458244557, lng: 78.39025129446719 },
        { lat: 17.4088223292377, lng: 78.39020757422733 },
        { lat: 17.40871830771275, lng: 78.39016265432194 },
        { lat: 17.40866121589562, lng: 78.39014033476542 },
        { lat: 17.40857425789866, lng: 78.39010965875222 },
        { lat: 17.40849745548645, lng: 78.39008041139013 },
        { lat: 17.40842800611768, lng: 78.39005734551202 },
        { lat: 17.40828159938739, lng: 78.39001616799894 },
        { lat: 17.40822253969813, lng: 78.39000130442538 },
        { lat: 17.40813431957623, lng: 78.3899820461263 },
        { lat: 17.40807162005016, lng: 78.38996710069264 },
        { lat: 17.40800282118396, lng: 78.38995226166627 },
        { lat: 17.40792325541646, lng: 78.38993558879484 },
        { lat: 17.40782251241853, lng: 78.38991254517828 },
        { lat: 17.4077595007702, lng: 78.38989976598826 },
        { lat: 17.40789062624019, lng: 78.38887862769293 },
        { lat: 17.4081777520101, lng: 78.38888541912789 },
        { lat: 17.40822024465105, lng: 78.38835545127266 },
        { lat: 17.40821741579643, lng: 78.3880953593729 },
        { lat: 17.40828870396928, lng: 78.38699754830039 },
        { lat: 17.40793089994027, lng: 78.38696557068896 },
        { lat: 17.40777551439807, lng: 78.38697500714358 },
        { lat: 17.4075621313217, lng: 78.3869702131277 },
        { lat: 17.40746103391222, lng: 78.38694322429201 },
        { lat: 17.4073959213229, lng: 78.38736639477054 },
        { lat: 17.40720479093925, lng: 78.387331021942 },
        { lat: 17.40715070640791, lng: 78.38732586258965 },
        { lat: 17.40712518899146, lng: 78.38733116512306 },
        { lat: 17.40709983985729, lng: 78.3873493079077 },
        { lat: 17.40702910604645, lng: 78.38741948068227 },
        { lat: 17.40694127185015, lng: 78.38751458088923 },
        { lat: 17.40687912330198, lng: 78.38761721970427 },
        { lat: 17.40683601559742, lng: 78.38765906690571 },
        { lat: 17.40655556227376, lng: 78.38795326213048 },
        { lat: 17.406359967388, lng: 78.38814940871362 },
        { lat: 17.40632151461439, lng: 78.38857955586882 },
        { lat: 17.40627555411814, lng: 78.38906122708862 },
        { lat: 17.40625080645689, lng: 78.38940786145925 },
        { lat: 17.40619101651802, lng: 78.38985005538535 },
        { lat: 17.40613462760178, lng: 78.39012590551229 },
        { lat: 17.40612702990117, lng: 78.39019334206911 },
        { lat: 17.40611001261868, lng: 78.39035807667476 },
        { lat: 17.4061080402536, lng: 78.39038754521275 },
        { lat: 17.40608793813142, lng: 78.3903876180937 },
        { lat: 17.40604133288464, lng: 78.39038531671821 },
        { lat: 17.40593901859373, lng: 78.39037794586228 },
        { lat: 17.40592084157735, lng: 78.3903746076641 },
        { lat: 17.40559272699864, lng: 78.39033198727282 },
        { lat: 17.40528046079083, lng: 78.39029447287241 },
        { lat: 17.40498563581452, lng: 78.39027225412539 },
        { lat: 17.40471137462197, lng: 78.39024666254424 },
        { lat: 17.40468461662966, lng: 78.39034839218937 },
        { lat: 17.40398223608441, lng: 78.39054745651792 },
        { lat: 17.4034927370786, lng: 78.39068482710788 },
        { lat: 17.40320680630506, lng: 78.39081534458823 },
        { lat: 17.40320567407983, lng: 78.39080246275871 },
        { lat: 17.40320805202495, lng: 78.39069638417303 },
        { lat: 17.4032304882639, lng: 78.39039138783878 },
        { lat: 17.4032570685575, lng: 78.39009156668178 },
        { lat: 17.40295618499633, lng: 78.39007519019012 },
        { lat: 17.40285629649166, lng: 78.39012184104843 },
        { lat: 17.40232663870913, lng: 78.3900304803305 },
        { lat: 17.40194390943717, lng: 78.38996138043856 },
        { lat: 17.40188611835378, lng: 78.39041109757714 },
        { lat: 17.40182173261919, lng: 78.39040173561116 },
        { lat: 17.40177546399265, lng: 78.39093312985985 },
        { lat: 17.40217702390653, lng: 78.3909697326338 },
        { lat: 17.40226124581838, lng: 78.39097008454004 },
        { lat: 17.40257904369148, lng: 78.39100179288512 },
        { lat: 17.40266881910976, lng: 78.39102665382919 },
        { lat: 17.40264455611253, lng: 78.39170794193126 },
        { lat: 17.40232724096256, lng: 78.39169346182892 },
        { lat: 17.40225776533368, lng: 78.39169302355882 },
        { lat: 17.40194804818625, lng: 78.3916701085913 },
        { lat: 17.40146432297357, lng: 78.3916551292763 },
        { lat: 17.40119311354427, lng: 78.39163893746799 },
        { lat: 17.4009882713279, lng: 78.3916254781954 },
        { lat: 17.39868368865646, lng: 78.39129246687224 },
        { lat: 17.3984667047765, lng: 78.39126507654164 },
        { lat: 17.3982893283556, lng: 78.39124424885728 },
        { lat: 17.39829930509666, lng: 78.39118118852029 },
        { lat: 17.39831653493358, lng: 78.39103907366216 },
        { lat: 17.39795958424758, lng: 78.39100511263817 },
        { lat: 17.39784330148222, lng: 78.39099246463158 },
        { lat: 17.39774899550099, lng: 78.39097523411603 },
        { lat: 17.39763940518938, lng: 78.39094644239647 },
        { lat: 17.39763163007963, lng: 78.3909417525007 },
        { lat: 17.3976210057382, lng: 78.39093086358245 },
        { lat: 17.39760955548563, lng: 78.39092063168509 },
        { lat: 17.39759435420922, lng: 78.39090810134911 },
        { lat: 17.39758448988207, lng: 78.39090449747577 },
        { lat: 17.39757552826378, lng: 78.39090293144973 },
        { lat: 17.39756260695725, lng: 78.39090244694592 },
        { lat: 17.39752713517133, lng: 78.39090722003196 },
        { lat: 17.39746761152424, lng: 78.39091466917895 },
        { lat: 17.39739424214201, lng: 78.39092656568216 },
        { lat: 17.39731688799926, lng: 78.39094246011543 },
        { lat: 17.39728389532912, lng: 78.39094978671586 },
        { lat: 17.39729258869369, lng: 78.39098214364878 },
        { lat: 17.39730017321812, lng: 78.39102204354029 },
        { lat: 17.39717846185783, lng: 78.39103488841518 },
        { lat: 17.39710044810311, lng: 78.39104109386227 },
        { lat: 17.39670338655022, lng: 78.39106710295837 },
        { lat: 17.39658582452586, lng: 78.39107334274864 },
        { lat: 17.39647333976647, lng: 78.39107694246613 },
        { lat: 17.39635718315973, lng: 78.39108153493281 },
        { lat: 17.39624763016998, lng: 78.39108418057883 },
        { lat: 17.39620263287713, lng: 78.39108439481608 },
        { lat: 17.3962074685194, lng: 78.39119129920064 },
        { lat: 17.39621500270018, lng: 78.39131781479831 },
        { lat: 17.39623468667998, lng: 78.39167588076648 },
        { lat: 17.3962468391549, lng: 78.39189280008011 },
        { lat: 17.39606864171557, lng: 78.39189766248539 },
        { lat: 17.39588311417887, lng: 78.39190638018393 },
        { lat: 17.39581636263836, lng: 78.39190782556422 },
        { lat: 17.39546555418127, lng: 78.39192684364987 },
        { lat: 17.39521577591828, lng: 78.39194066972821 },
        { lat: 17.39510643819379, lng: 78.39194804319645 },
        { lat: 17.39508412725595, lng: 78.39195263022461 },
        { lat: 17.39507028148095, lng: 78.3919666100448 },
        { lat: 17.39506548264259, lng: 78.39197327775418 },
        { lat: 17.39502562181262, lng: 78.3919477502507 },
        { lat: 17.39500917823479, lng: 78.39194450304967 },
        { lat: 17.39480122492723, lng: 78.39193244907881 },
        { lat: 17.39458240995794, lng: 78.3919151121749 },
        { lat: 17.39446557385618, lng: 78.39190435266042 },
        { lat: 17.39430140876297, lng: 78.39189051121942 },
        { lat: 17.39411161333397, lng: 78.39187080054194 },
        { lat: 17.39411633649915, lng: 78.39169346590616 },
        { lat: 17.39412022541365, lng: 78.39156195471627 },
        { lat: 17.39412415597861, lng: 78.39147680105857 },
        { lat: 17.39412609671592, lng: 78.3913202933695 },
        { lat: 17.39412739898308, lng: 78.39115350967181 },
        { lat: 17.39412698962479, lng: 78.39087755386505 },
        { lat: 17.39413095902973, lng: 78.39072185744459 },
        { lat: 17.39413276007162, lng: 78.39068127196434 },
        { lat: 17.39405223965906, lng: 78.39067204760362 },
        { lat: 17.39384348283497, lng: 78.39065103259838 },
        { lat: 17.39372120969149, lng: 78.39064095303733 },
        { lat: 17.39367673088545, lng: 78.39063668526848 },
        { lat: 17.39305299193923, lng: 78.39058102895147 },
        { lat: 17.39239576544251, lng: 78.39052821545532 },
        { lat: 17.39235523660987, lng: 78.39074107923695 },
        { lat: 17.39230753588727, lng: 78.39114097654343 },
        { lat: 17.39231630974986, lng: 78.39164420465107 },
        { lat: 17.39235462731729, lng: 78.39205778374402 },
        { lat: 17.39240215892568, lng: 78.3921692202381 },
        { lat: 17.39252264769827, lng: 78.39232309508863 },
        { lat: 17.39271544054138, lng: 78.39261904620318 },
        { lat: 17.3927799847116, lng: 78.39288384926363 },
        { lat: 17.39278143530099, lng: 78.39299484930332 },
        { lat: 17.39273018619522, lng: 78.39325257134638 },
        { lat: 17.39269208849104, lng: 78.39337724170396 },
        { lat: 17.39264344165935, lng: 78.39353320346365 },
        { lat: 17.39261768477539, lng: 78.39363765086458 },
        { lat: 17.39259207682852, lng: 78.39377493404378 },
        { lat: 17.39257318756495, lng: 78.39391355176869 },
        { lat: 17.39254938938286, lng: 78.39412855355144 },
        { lat: 17.39253870773125, lng: 78.39424975178565 },
        { lat: 17.39252102294821, lng: 78.3944709363175 },
        { lat: 17.39251745848388, lng: 78.39452648486764 },
        { lat: 17.3925179487904, lng: 78.39474521551197 },
        { lat: 17.39252523640691, lng: 78.39493673110361 },
        { lat: 17.39253773091643, lng: 78.39507259965407 },
        { lat: 17.39257176432983, lng: 78.39532736178751 },
        { lat: 17.39258076609741, lng: 78.39545997823143 },
        { lat: 17.3925862819192, lng: 78.39566456585717 },
        { lat: 17.39258933173424, lng: 78.39585460842626 },
        { lat: 17.3925912198945, lng: 78.39594874977759 },
        { lat: 17.39258889564031, lng: 78.39607166871049 },
        { lat: 17.3925771651581, lng: 78.39629458924396 },
        { lat: 17.39254352240295, lng: 78.39664680140739 },
        { lat: 17.39248543747837, lng: 78.3971932078728 },
        { lat: 17.39246760451382, lng: 78.39739082668284 },
        { lat: 17.39241901942479, lng: 78.39791527554065 },
        { lat: 17.39239350136328, lng: 78.39823349985082 },
        { lat: 17.3923602398736, lng: 78.39862214700675 },
        { lat: 17.39233669001014, lng: 78.39891131506845 },
        { lat: 17.39231904986537, lng: 78.39922015312031 },
        { lat: 17.39229660658798, lng: 78.39950282444877 },
        { lat: 17.39228578640618, lng: 78.39960880021661 },
        { lat: 17.39227980957363, lng: 78.39978911267345 },
        { lat: 17.39227931986714, lng: 78.39979831348057 },
        { lat: 17.39225248057436, lng: 78.39979225609666 },
        { lat: 17.39225171711547, lng: 78.39973596729796 },
        { lat: 17.39230782641825, lng: 78.39895462241985 },
        { lat: 17.39233537291082, lng: 78.3985682196781 },
        { lat: 17.39235115092004, lng: 78.39839777333863 },
        { lat: 17.39237374215993, lng: 78.3981462362386 },
        { lat: 17.39244515900682, lng: 78.39732689441635 },
        { lat: 17.3924921412163, lng: 78.39678998584245 },
        { lat: 17.39253132718771, lng: 78.39634520626393 },
        { lat: 17.39255652845582, lng: 78.39586975734659 },
        { lat: 17.3925690966094, lng: 78.39562968173958 },
        { lat: 17.39256654134088, lng: 78.39544156336505 },
        { lat: 17.39254062731414, lng: 78.39536505422393 },
        { lat: 17.3924794380785, lng: 78.39518879639309 },
        { lat: 17.392465262063, lng: 78.39506081829849 },
        { lat: 17.39245512853624, lng: 78.39489750408707 },
        { lat: 17.39245114701692, lng: 78.3945212527467 },
        { lat: 17.39245043554113, lng: 78.39438573287813 },
        { lat: 17.39245774110848, lng: 78.39425774216797 },
        { lat: 17.39249746143429, lng: 78.39385264484972 },
        { lat: 17.39256584609925, lng: 78.39356003077376 },
        { lat: 17.39262659308197, lng: 78.39337101076329 },
        { lat: 17.3926784517434, lng: 78.3931935821586 },
        { lat: 17.39257843406922, lng: 78.39315531972385 },
        { lat: 17.39230687314963, lng: 78.39314037777372 },
        { lat: 17.39166337823541, lng: 78.39304606988667 },
        { lat: 17.39097389855677, lng: 78.39289597316674 },
        { lat: 17.3908369671933, lng: 78.39280384966037 },
        { lat: 17.39047049568825, lng: 78.39246099596932 },
        { lat: 17.3901552137576, lng: 78.39189163059257 },
        { lat: 17.38987546443987, lng: 78.39127472249544 },
        { lat: 17.38955941179307, lng: 78.39064892706627 },
        { lat: 17.38933392078659, lng: 78.3900312496121 },
        { lat: 17.38896424462845, lng: 78.38945326204382 },
        { lat: 17.38855916038079, lng: 78.3889322271368 },
        { lat: 17.38809968768139, lng: 78.38840256429523 },
        { lat: 17.38755105916596, lng: 78.3879682522963 },
        { lat: 17.38704777591511, lng: 78.38754270121764 },
        { lat: 17.3865450045244, lng: 78.38715477515638 },
        { lat: 17.38623035133007, lng: 78.3866324601398 },
        { lat: 17.38609400196562, lng: 78.38591945199109 },
        { lat: 17.38600338117905, lng: 78.38524342048599 },
        { lat: 17.38595746158532, lng: 78.38452912087259 },
        { lat: 17.38614288479432, lng: 78.38419721260537 },
        { lat: 17.38628501368155, lng: 78.38400703288934 },
        { lat: 17.38687880141392, lng: 78.38377276150557 },
        { lat: 17.38747194762286, lng: 78.38349146122944 },
        { lat: 17.38802879045042, lng: 78.38320127011222 },
        { lat: 17.38862321858637, lng: 78.38301402155894 },
        { lat: 17.38930936406686, lng: 78.38291953339956 },
        { lat: 17.38995362898445, lng: 78.3830702382178 },
        { lat: 17.390543504682, lng: 78.38321231506569 },
        { lat: 17.3911877695931, lng: 78.38336302226558 },
        { lat: 17.39183254777315, lng: 78.38355135205543 },
        { lat: 17.39246712824182, lng: 78.38365516111061 },
        { lat: 17.39310933994934, lng: 78.38365537641565 },
        { lat: 17.39375866940561, lng: 78.38351437369276 },
        { lat: 17.39435309688289, lng: 78.38332711756921 },
        { lat: 17.39485375119487, lng: 78.38289660108263 },
        { lat: 17.39421737334122, lng: 78.38266111177498 },
        { lat: 17.39283840853791, lng: 78.38236099795161 },
        { lat: 17.39220331534647, lng: 78.38221957060732 },
        { lat: 17.39155853649328, lng: 78.38203124454444 },
        { lat: 17.391049151297, lng: 78.38182216641515 },
        { lat: 17.39033978468174, lng: 78.38154069173625 },
        { lat: 17.38963234366175, lng: 78.38140030452155 },
        { lat: 17.38899712152491, lng: 78.38124947615859 },
        { lat: 17.38835362661689, lng: 78.38115521169473 },
        { lat: 17.38775470629683, lng: 78.38101327109305 },
        { lat: 17.38785410796704, lng: 78.3803439232821 },
        { lat: 17.38817196216275, lng: 78.37977492518442 },
        { lat: 17.38849885769836, lng: 78.37920579643436 },
        { lat: 17.38767565157787, lng: 78.37919878090939 },
        { lat: 17.38707154238404, lng: 78.37933914182486 },
        { lat: 17.38643126001612, lng: 78.37948002054699 },
        { lat: 17.38579033548955, lng: 78.37957387047501 },
        { lat: 17.3851914148774, lng: 78.37943193689415 },
        { lat: 17.38468863112414, lng: 78.37904403850295 },
        { lat: 17.38437331619469, lng: 78.37847471819936 },
        { lat: 17.38377298214038, lng: 78.37822933079984 },
        { lat: 17.38331819469068, lng: 78.37870620615776 },
        { lat: 17.38285436254578, lng: 78.37918320983569 },
        { lat: 17.38226307247304, lng: 78.37893769155382 },
        { lat: 17.38203300384496, lng: 78.3786493684427 },
        { lat: 17.38184828089407, lng: 78.37836980399716 },
        { lat: 17.38144304534245, lng: 78.377839410739 },
        { lat: 17.38089504295791, lng: 78.3774521716797 },
        { lat: 17.38025283345815, lng: 78.37745197184601 },
        { lat: 17.3796099817331, lng: 78.37740474584514 },
        { lat: 17.37896635794915, lng: 78.37730109037763 },
        { lat: 17.37841784203463, lng: 78.37687623641803 },
        { lat: 17.3781023948358, lng: 78.37629753389051 },
        { lat: 17.37777738952926, lng: 78.37568134369332 },
        { lat: 17.3777327265495, lng: 78.37506113366149 },
        { lat: 17.37759501767486, lng: 78.37491259994984 },
        { lat: 17.3772286512507, lng: 78.37457921098787 },
        { lat: 17.37672856395645, lng: 78.37438884446208 },
        { lat: 17.3766374864142, lng: 78.37434311783562 },
        { lat: 17.37654628065636, lng: 78.37428798569212 },
        { lat: 17.37622402613089, lng: 78.37519565881782 },
        { lat: 17.37598898539276, lng: 78.37586690947744 },
        { lat: 17.37576285727722, lng: 78.37652862336155 },
        { lat: 17.37543596435787, lng: 78.37709771395599 },
        { lat: 17.37520931775025, lng: 78.37772180561937 },
        { lat: 17.37501935662207, lng: 78.37838299724382 },
        { lat: 17.37469322815735, lng: 78.37900851200982 },
        { lat: 17.37442058745319, lng: 78.37957681865996 },
        { lat: 17.37413890163824, lng: 78.38014525248343 },
        { lat: 17.37395746153593, lng: 78.38076869012824 },
        { lat: 17.37377589056817, lng: 78.38138272228448 },
        { lat: 17.3736771201121, lng: 78.38209904215849 },
        { lat: 17.37363196676578, lng: 78.3827675611221 },
        { lat: 17.37344211517694, lng: 78.38343814953339 },
        { lat: 17.3732153190103, lng: 78.38405282463006 },
        { lat: 17.37302546271051, lng: 78.38472341076226 },
        { lat: 17.37288973692799, lng: 78.38538381515937 },
        { lat: 17.37279159124922, lng: 78.3861471558871 },
        { lat: 17.37270184610925, lng: 78.38686334250393 },
        { lat: 17.37255719801938, lng: 78.38753327890424 },
        { lat: 17.37237637250746, lng: 78.38820373143636 },
        { lat: 17.37228521276437, lng: 78.38881646411222 },
        { lat: 17.37223227084207, lng: 78.3895791566345 },
        { lat: 17.37227752559918, lng: 78.39024638286855 },
        { lat: 17.37227756152915, lng: 78.39091425420608 },
        { lat: 17.37232217238193, lng: 78.39153445801843 },
        { lat: 17.37226794309729, lng: 78.39220310330889 },
        { lat: 17.37222275395465, lng: 78.39287161955936 },
        { lat: 17.37222467060101, lng: 78.39301269222042 },
        { lat: 17.37221894841949, lng: 78.39325734655463 },
        { lat: 17.37222278016454, lng: 78.39353949198843 },
        { lat: 17.3722188892903, lng: 78.39525156172338 },
        { lat: 17.37216590458013, lng: 78.39534638226377 },
        { lat: 17.37211942962353, lng: 78.39592085057718 },
        { lat: 17.37212274720746, lng: 78.3961653763788 },
        { lat: 17.37212008389318, lng: 78.39663574875462 },
        { lat: 17.37211690835454, lng: 78.3970685011823 },
        { lat: 17.37212009744922, lng: 78.39730362264032 },
        { lat: 17.372116283302, lng: 78.3976893505719 },
        { lat: 17.3721117033869, lng: 78.39801865027235 },
        { lat: 17.37224736576591, lng: 78.3986845961992 },
        { lat: 17.37247358874632, lng: 78.3993586641554 },
        { lat: 17.37270808945571, lng: 78.3999761758781 },
        { lat: 17.37288832717526, lng: 78.40059446013099 },
        { lat: 17.37297812641283, lng: 78.40121402979206 },
        { lat: 17.37287928288065, lng: 78.40193034619014 },
        { lat: 17.3728340611148, lng: 78.40259886702066 },
        { lat: 17.37283469182288, lng: 78.40331377146637 },
        { lat: 17.37278042283667, lng: 78.40398242089206 },
        { lat: 17.37259890443415, lng: 78.40460584103666 },
        { lat: 17.37250578435458, lng: 78.4050774994022 },
        { lat: 17.37246183804445, lng: 78.40517218956809 },
        { lat: 17.37245406631356, lng: 78.40526636712067 },
        { lat: 17.37227254358848, lng: 78.40588978636575 },
        { lat: 17.3721291003985, lng: 78.40665376456431 },
        { lat: 17.37212971620938, lng: 78.40736866838488 },
        { lat: 17.37217427635241, lng: 78.40798888216487 },
        { lat: 17.37226717197235, lng: 78.40867190808231 },
        { lat: 17.37228836188994, lng: 78.40873392790023 },
        { lat: 17.37235281723254, lng: 78.40898567526105 },
        { lat: 17.37236253348177, lng: 78.40928655423794 },
        { lat: 17.37232972081177, lng: 78.40953600409321 },
        { lat: 17.37232883701271, lng: 78.40972180069076 },
        { lat: 17.37234918150918, lng: 78.40988877643925 },
        { lat: 17.37237416975951, lng: 78.41014843186427 },
        { lat: 17.37243676539565, lng: 78.41043004334524 },
        { lat: 17.37247097444718, lng: 78.4106190176428 },
        { lat: 17.37251239657915, lng: 78.41075600597621 },
        { lat: 17.3724718928894, lng: 78.41093839461148 },
        { lat: 17.3723960510796, lng: 78.41109952976002 },
        { lat: 17.37235544919486, lng: 78.41127471781581 },
        { lat: 17.37236144590469, lng: 78.41146776551054 },
        { lat: 17.37233403236657, lng: 78.41169861902803 },
        { lat: 17.37219962997544, lng: 78.411793412127 },
        { lat: 17.37210702560438, lng: 78.41188540919003 },
        { lat: 17.37199350318446, lng: 78.41201929693744 },
        { lat: 17.37188896622398, lng: 78.4122325742263 },
        { lat: 17.37179174152499, lng: 78.41240121257431 },
        { lat: 17.37166617482884, lng: 78.41264815185491 },
        { lat: 17.37154065998514, lng: 78.412898911546 },
        { lat: 17.3714657129772, lng: 78.41312661407119 },
        { lat: 17.3713892875109, lng: 78.41332846931006 },
        { lat: 17.3713599386726, lng: 78.41349982241596 },
        { lat: 17.37135452974872, lng: 78.41368568204678 },
        { lat: 17.37133711441091, lng: 78.41381968011525 },
        { lat: 17.3713182895276, lng: 78.41401689998351 },
        { lat: 17.37126685952995, lng: 78.41414388325381 },
        { lat: 17.37125842186748, lng: 78.41427290384763 },
        { lat: 17.37095650678236, lng: 78.41427099570683 },
        { lat: 17.37035583900369, lng: 78.41483756326076 },
        { lat: 17.37033426093013, lng: 78.415082295623 },
        { lat: 17.3703558737936, lng: 78.41542768641283 },
        { lat: 17.37041054696466, lng: 78.41570926305711 },
        { lat: 17.37045228649108, lng: 78.41595398273293 },
        { lat: 17.3704768663509, lng: 78.41618395572362 },
        { lat: 17.37052701816858, lng: 78.41646574118572 },
        { lat: 17.37058991304922, lng: 78.41660227920318 },
        { lat: 17.37061598415093, lng: 78.41669112804789 },
        { lat: 17.37063052668872, lng: 78.41684745636653 },
        { lat: 17.37066996665256, lng: 78.41717349013805 },
        { lat: 17.37070901791375, lng: 78.41755464657943 },
        { lat: 17.37073708952194, lng: 78.41787613745147 },
        { lat: 17.37077421239403, lng: 78.4181141624568 },
        { lat: 17.37082505447685, lng: 78.41844738474518 },
        { lat: 17.37089770257442, lng: 78.4187206256902 },
        { lat: 17.37092351984911, lng: 78.41895881059646 },
        { lat: 17.37097178689324, lng: 78.41918477362807 },
        { lat: 17.37102118235717, lng: 78.41941057427125 },
        { lat: 17.37106649213467, lng: 78.41966891610559 },
        { lat: 17.3711088229508, lng: 78.41995801823526 },
        { lat: 17.37115950202258, lng: 78.42027933881356 },
        { lat: 17.37124425181022, lng: 78.42061193742427 },
        { lat: 17.37128137247934, lng: 78.42084996408006 },
        { lat: 17.3713892135799, lng: 78.42121810226652 },
        { lat: 17.37143924980283, lng: 78.42149181083413 },
        { lat: 17.37144149363116, lng: 78.42165875023568 },
        { lat: 17.371433714418, lng: 78.42192122093788 },
        { lat: 17.37146955003477, lng: 78.4220637285795 },
        { lat: 17.37144950587287, lng: 78.42225493974327 },
        { lat: 17.37138295043942, lng: 78.42243475341797 },
        { lat: 17.37135223907989, lng: 78.42267358918345 },
        { lat: 17.37140583415577, lng: 78.42287566861688 },
        { lat: 17.37141938149952, lng: 78.42304244903481 },
        { lat: 17.37142130231307, lng: 78.42318543438337 },
        { lat: 17.37141194201079, lng: 78.4233303430177 },
        { lat: 17.37139638576244, lng: 78.42343491895559 },
        { lat: 17.37136120864671, lng: 78.42367808073736 },
        { lat: 17.371365238445, lng: 78.4239781590592 },
        { lat: 17.37139617810605, lng: 78.4242613975881 },
        { lat: 17.37139642290031, lng: 78.42453228152786 },
        { lat: 17.37143168032135, lng: 78.42471609964602 },
        { lat: 17.37139660873349, lng: 78.42505141651236 },
        { lat: 17.37137347896889, lng: 78.42518152716232 },
        { lat: 17.37192048566322, lng: 78.42771120192549 },
        { lat: 17.37192197043429, lng: 78.42771807078479 },
        { lat: 17.37198612014121, lng: 78.42786444476125 },
        { lat: 17.37225319330807, lng: 78.42847732200464 },
        { lat: 17.37261185989649, lng: 78.4293006208123 },
        { lat: 17.37274907076863, lng: 78.4296161929435 },
        { lat: 17.37286219991715, lng: 78.42978951382014 },
        { lat: 17.37302605096256, lng: 78.43011968883206 },
        { lat: 17.37309439769767, lng: 78.43024190032833 },
        { lat: 17.37317198982557, lng: 78.4303788288183 },
        { lat: 17.37330353400469, lng: 78.43066080771406 },
        { lat: 17.3733373594365, lng: 78.4307380878305 },
        { lat: 17.37346328517273, lng: 78.43102264288855 },
        { lat: 17.37353920038941, lng: 78.43128776315672 },
        { lat: 17.3736419462571, lng: 78.43169905224072 },
        { lat: 17.37385720430775, lng: 78.43215315268903 },
        { lat: 17.37411571633767, lng: 78.43254447169969 },
        { lat: 17.37423818116429, lng: 78.43282408044215 },
        { lat: 17.37428344794047, lng: 78.43324940750864 },
        { lat: 17.37424931988623, lng: 78.43348726656092 },
        { lat: 17.37421301094768, lng: 78.43364681263697 },
        { lat: 17.37417123318469, lng: 78.43373558984388 },
        { lat: 17.37401392788318, lng: 78.43380967044462 },
        { lat: 17.37394679303614, lng: 78.43386249853461 },
        { lat: 17.37390653541474, lng: 78.43389583954367 },
        { lat: 17.37379695532022, lng: 78.43398762414867 },
        { lat: 17.37366153602068, lng: 78.43409182592848 },
        { lat: 17.37358986366664, lng: 78.43414353944047 },
        { lat: 17.37346837291765, lng: 78.43427458926132 },
        { lat: 17.37333952973593, lng: 78.43444777923828 },
        { lat: 17.37329696964757, lng: 78.43456272873838 },
        { lat: 17.37326747880138, lng: 78.43464030781968 },
        { lat: 17.37323723245253, lng: 78.43483048936744 },
        { lat: 17.37324053939087, lng: 78.4349086385938 },
        { lat: 17.37323935415277, lng: 78.43498905604379 },
        { lat: 17.37327999815532, lng: 78.43506903189976 },
        { lat: 17.3732806198876, lng: 78.43520013322009 },
        { lat: 17.37328143570699, lng: 78.43526112166457 },
        { lat: 17.37333534302736, lng: 78.43540293886763 },
        { lat: 17.37332011373021, lng: 78.43553220117127 },
        { lat: 17.37329728329052, lng: 78.43568523974909 },
        { lat: 17.3732880622596, lng: 78.43575665785079 },
        { lat: 17.37328337099382, lng: 78.43582859790291 },
        { lat: 17.37325016394691, lng: 78.43588197783316 },
        { lat: 17.37322144904314, lng: 78.4359330895508 },
        { lat: 17.37318940084813, lng: 78.4359886589487 },
        { lat: 17.37314073673143, lng: 78.436069886156 },
        { lat: 17.37307113223732, lng: 78.43619168295777 },
        { lat: 17.37296229656699, lng: 78.43633916169023 },
        { lat: 17.3728709200379, lng: 78.43643936304814 },
        { lat: 17.37280595792643, lng: 78.43648569133195 },
        { lat: 17.37277065214018, lng: 78.43646663688395 },
        { lat: 17.3727641103783, lng: 78.43640014411446 },
        { lat: 17.37275592586573, lng: 78.4362954607777 },
        { lat: 17.37272611854059, lng: 78.43626486522122 },
        { lat: 17.37266524266004, lng: 78.4362783568646 },
        { lat: 17.37263463373404, lng: 78.43635698190457 },
        { lat: 17.37258416967649, lng: 78.43647277620147 },
        { lat: 17.37253525861645, lng: 78.43653548854557 },
        { lat: 17.37249526790674, lng: 78.43658896257166 },
        { lat: 17.37244411355833, lng: 78.4366530304035 },
        { lat: 17.37240432144572, lng: 78.4367213465936 },
        { lat: 17.37235247997414, lng: 78.43681878773204 },
        { lat: 17.37230932896445, lng: 78.43688950202841 },
        { lat: 17.37224714276913, lng: 78.43697430099324 },
        { lat: 17.37217924522377, lng: 78.43705462422984 },
        { lat: 17.37211335280423, lng: 78.43711595485986 },
        { lat: 17.37206092745977, lng: 78.43716960452548 },
        { lat: 17.37200281904489, lng: 78.43722097995698 },
        { lat: 17.3719280758638, lng: 78.43729684122422 },
        { lat: 17.37186437482995, lng: 78.43735285238533 },
        { lat: 17.37181341691091, lng: 78.43743175917392 },
        { lat: 17.37176340968741, lng: 78.43749698628392 },
        { lat: 17.37172885229933, lng: 78.43753407018418 },
        { lat: 17.37166089991469, lng: 78.43761042268889 },
        { lat: 17.37162618525811, lng: 78.4376356030732 },
        { lat: 17.37153012464989, lng: 78.43772381395445 },
        { lat: 17.37145944427557, lng: 78.43776522470586 },
        { lat: 17.37139132806157, lng: 78.43782937924485 },
        { lat: 17.37132092052721, lng: 78.43789121514796 },
        { lat: 17.37122674542737, lng: 78.43795118075558 },
        { lat: 17.37113818944351, lng: 78.43800886156434 },
        { lat: 17.37100591443487, lng: 78.4380946393706 },
        { lat: 17.3709437143786, lng: 78.43817840760663 },
        { lat: 17.37089038767473, lng: 78.43824926730977 },
        { lat: 17.37084262909933, lng: 78.43831372612935 },
        { lat: 17.37080376833984, lng: 78.43836718168518 },
        { lat: 17.37075155890758, lng: 78.43843699488755 },
        { lat: 17.37071265863527, lng: 78.43848751357274 },
        { lat: 17.37056983392992, lng: 78.43863002630772 },
        { lat: 17.37005662688208, lng: 78.43914146624981 },
        { lat: 17.36929442133611, lng: 78.43990103668062 },
        { lat: 17.36912593521054, lng: 78.44006948126378 },
        { lat: 17.36896499727691, lng: 78.44021048253767 },
        { lat: 17.36853973200263, lng: 78.44054008046034 },
        { lat: 17.36805609506585, lng: 78.44090150707716 },
        { lat: 17.3678829577259, lng: 78.44106046103427 },
        { lat: 17.36764727267801, lng: 78.44127717063373 },
        { lat: 17.36735478658095, lng: 78.441558757353 },
        { lat: 17.36642267127691, lng: 78.44237487808442 },
        { lat: 17.36599873919879, lng: 78.44272002850592 },
        { lat: 17.36564510058223, lng: 78.44290986702224 },
        { lat: 17.36527974705246, lng: 78.44323876367291 },
        { lat: 17.36489907946382, lng: 78.4435215737349 },
        { lat: 17.36479990846865, lng: 78.44354632780623 },
        { lat: 17.36472287651061, lng: 78.44362030495307 },
        { lat: 17.36440908510192, lng: 78.44391555505207 },
        { lat: 17.36422196301291, lng: 78.44412834563151 },
        { lat: 17.36400038829894, lng: 78.44430119727505 },
        { lat: 17.36370040556752, lng: 78.44461462480672 },
        { lat: 17.36351864364241, lng: 78.44480543933481 },
        { lat: 17.36337568351545, lng: 78.44493824358621 },
        { lat: 17.36293852571374, lng: 78.44522462829943 },
        { lat: 17.36246221288306, lng: 78.44562752172062 },
        { lat: 17.36197157664187, lng: 78.44614363755657 },
        { lat: 17.36184787086536, lng: 78.44627896419946 },
        { lat: 17.36143397723582, lng: 78.44669935480222 },
        { lat: 17.36118472918907, lng: 78.44691712023152 },
        { lat: 17.36085080912468, lng: 78.44731464023278 },
        { lat: 17.36066444183639, lng: 78.4474994869784 },
        { lat: 17.36052964319875, lng: 78.44756603421268 },
        { lat: 17.36016188021635, lng: 78.44779955865204 },
        { lat: 17.35959929962963, lng: 78.44817777420835 },
        { lat: 17.35945781461362, lng: 78.4483367136136 },
        { lat: 17.35939413832167, lng: 78.44864992206269 },
        { lat: 17.35931421001342, lng: 78.44893146175698 },
        { lat: 17.35919470200869, lng: 78.44929776777808 },
        { lat: 17.35915064868955, lng: 78.44989656573667 },
        { lat: 17.35917275398098, lng: 78.450198583328 },
        { lat: 17.35919354854966, lng: 78.45048709843476 },
        { lat: 17.35919915192992, lng: 78.45056844449174 },
        { lat: 17.35920749280688, lng: 78.45068561333933 },
        { lat: 17.35925708408743, lng: 78.4508438018508 },
        { lat: 17.35930547449011, lng: 78.45099671670731 },
        { lat: 17.3593323856967, lng: 78.4510648323772 },
        { lat: 17.35937886029955, lng: 78.45115869010785 },
        { lat: 17.35940790885841, lng: 78.45130261429193 },
        { lat: 17.35943832868782, lng: 78.45137949975602 },
        { lat: 17.35941908870148, lng: 78.45146324833367 },
        { lat: 17.35947966537124, lng: 78.45159732871502 },
        { lat: 17.35951582272255, lng: 78.45176569929718 },
        { lat: 17.35957084213836, lng: 78.4518218121564 },
        { lat: 17.35960979333556, lng: 78.45194516994505 },
        { lat: 17.35956274583841, lng: 78.45206355176184 },
        { lat: 17.35959741117009, lng: 78.45220475206006 },
        { lat: 17.35967921600637, lng: 78.45231957867968 },
        { lat: 17.35972071129082, lng: 78.45237911315265 },
        { lat: 17.35972881545119, lng: 78.452478501673 },
        { lat: 17.35986261494221, lng: 78.45250691774457 },
        { lat: 17.35989129678163, lng: 78.45253811779072 },
        { lat: 17.35993372897699, lng: 78.45258294390982 },
        { lat: 17.35997068603371, lng: 78.45272646423459 },
        { lat: 17.36001613690162, lng: 78.45282842065689 },
        { lat: 17.36004068541927, lng: 78.45297417422708 },
        { lat: 17.36009254374513, lng: 78.45304767440722 },
        { lat: 17.36011652535302, lng: 78.45323591144769 },
        { lat: 17.36018536860109, lng: 78.45331123298014 },
        { lat: 17.36022191475308, lng: 78.45342389449198 },
        { lat: 17.36030726784528, lng: 78.45355057623252 },
        { lat: 17.36031638520421, lng: 78.45364113385486 },
        { lat: 17.36031316233602, lng: 78.45373906447537 },
        { lat: 17.36031142561471, lng: 78.45377862400572 },
        { lat: 17.36036227800449, lng: 78.45394679201846 },
        { lat: 17.36041821627342, lng: 78.45398702003567 },
        { lat: 17.36043563596871, lng: 78.45402161140167 },
        { lat: 17.36050353445384, lng: 78.4541110570133 },
        { lat: 17.36058041970362, lng: 78.45419611611203 },
        { lat: 17.36068453906013, lng: 78.45428843887596 },
        { lat: 17.3607346514164, lng: 78.45431566775407 },
        { lat: 17.36077223100722, lng: 78.4543357224486 },
        { lat: 17.36082638470618, lng: 78.45441183825233 },
        { lat: 17.36090377423808, lng: 78.4544497104361 },
        { lat: 17.36097661709602, lng: 78.45448573620051 },
        { lat: 17.36108767662034, lng: 78.45450462165496 },
        { lat: 17.36113120263702, lng: 78.4545467868023 },
        { lat: 17.36125805861766, lng: 78.45456310090292 },
        { lat: 17.36138012248888, lng: 78.45464444589071 },
        { lat: 17.36147292739312, lng: 78.45473619195283 },
        { lat: 17.36153111669585, lng: 78.45486090096234 },
        { lat: 17.3616134854968, lng: 78.45493309773467 },
        { lat: 17.36168418207598, lng: 78.45497782507522 },
        { lat: 17.36177920879711, lng: 78.45506660068955 },
        { lat: 17.36188836981499, lng: 78.45519809733803 },
        { lat: 17.36195378900186, lng: 78.45527111724813 },
        { lat: 17.36200776588196, lng: 78.45533400870185 },
        { lat: 17.36205489933262, lng: 78.45547753946614 },
        { lat: 17.36216574391338, lng: 78.45556550737773 },
        { lat: 17.36223073136399, lng: 78.45560605051251 },
        { lat: 17.36227178207392, lng: 78.45563208363296 },
        { lat: 17.36230590909103, lng: 78.45564762955756 },
        { lat: 17.36240602800788, lng: 78.45569415281679 },
        { lat: 17.36253493020082, lng: 78.45577951940224 },
        { lat: 17.36257914004872, lng: 78.45578801795982 },
        { lat: 17.36269093584005, lng: 78.45577705766165 },
        { lat: 17.3627993316406, lng: 78.45568045730563 },
        { lat: 17.36293512400079, lng: 78.45568856492122 },
        { lat: 17.36300887308551, lng: 78.4557076757514 },
        { lat: 17.36309470547902, lng: 78.45570001585989 },
        { lat: 17.36316379767672, lng: 78.45570905019581 },
        { lat: 17.36322664343494, lng: 78.45584383718266 },
        { lat: 17.36324539060066, lng: 78.45589325534907 },
        { lat: 17.36326393412458, lng: 78.45592739080473 },
        { lat: 17.3633094118537, lng: 78.45594615944742 },
        { lat: 17.36341438101842, lng: 78.45601730978491 },
        { lat: 17.36344782211215, lng: 78.45606637653118 },
        { lat: 17.36348625383578, lng: 78.45606554773386 },
        { lat: 17.36352355117241, lng: 78.45606429442836 },
        { lat: 17.36358251569014, lng: 78.45607699668456 },
        { lat: 17.36361504124132, lng: 78.4560569966966 },
        { lat: 17.3636459018328, lng: 78.45599674788451 },
        { lat: 17.36368585479049, lng: 78.45594004723074 },
        { lat: 17.36373961022886, lng: 78.45590093865111 },
        { lat: 17.3638518003415, lng: 78.455919810354 },
        { lat: 17.36396298038803, lng: 78.45594780793162 },
        { lat: 17.36402331998888, lng: 78.45597714148778 },
        { lat: 17.36407558660685, lng: 78.45599815180289 },
        { lat: 17.3641324259799, lng: 78.4560210007516 },
        { lat: 17.36420050152934, lng: 78.45603857333403 },
        { lat: 17.36428900807491, lng: 78.4560620365585 },
        { lat: 17.36438492690597, lng: 78.4561328701813 },
        { lat: 17.36445885071266, lng: 78.4561652075285 },
        { lat: 17.36460094065464, lng: 78.45622187785303 },
        { lat: 17.36468987971901, lng: 78.45627796349304 },
        { lat: 17.36472095847387, lng: 78.45640466907388 },
        { lat: 17.36479243452768, lng: 78.45659342594902 },
        { lat: 17.36485725093243, lng: 78.45662103890335 },
        { lat: 17.36491299741325, lng: 78.45664686779133 },
        { lat: 17.36492946553295, lng: 78.45669499555619 },
        { lat: 17.36504688731687, lng: 78.45668204660932 },
        { lat: 17.36506065206552, lng: 78.4567820976828 },
        { lat: 17.36508495954362, lng: 78.45682452857758 },
        { lat: 17.36513816835819, lng: 78.45682952194365 },
        { lat: 17.36519289440962, lng: 78.45686359570368 },
        { lat: 17.36518124806988, lng: 78.45692328437738 },
        { lat: 17.36523636733031, lng: 78.45698704287331 },
        { lat: 17.36525755575724, lng: 78.45705009692229 },
        { lat: 17.36538944316858, lng: 78.45710485198339 },
        { lat: 17.36543590482699, lng: 78.45711258431325 },
        { lat: 17.36547568099312, lng: 78.45712775834374 },
        { lat: 17.36555413357335, lng: 78.45716047390447 },
        { lat: 17.36571709421602, lng: 78.45725624628959 },
        { lat: 17.36573946922252, lng: 78.45732354671422 },
        { lat: 17.36581828690447, lng: 78.45738374294284 },
        { lat: 17.36604719162734, lng: 78.45750696581624 },
        { lat: 17.36624579605486, lng: 78.4575621182735 },
        { lat: 17.36639558889345, lng: 78.45760280917754 },
        { lat: 17.36650943530684, lng: 78.45766134281519 },
        { lat: 17.3666979278736, lng: 78.45772133876619 },
        { lat: 17.36678927167029, lng: 78.45778826903417 },
        { lat: 17.36679305497617, lng: 78.45779762609975 },
        { lat: 17.36681615955828, lng: 78.45785477212863 },
        { lat: 17.36680704029907, lng: 78.45793456271915 },
        { lat: 17.36686389689754, lng: 78.45812940447385 },
        { lat: 17.36692894010755, lng: 78.45825946194886 },
        { lat: 17.36696885623215, lng: 78.45837046637975 },
        { lat: 17.36806486042346, lng: 78.45796989010002 },
        { lat: 17.36807674137957, lng: 78.45801364362191 },
        { lat: 17.3681047637694, lng: 78.45816582301397 },
        { lat: 17.3680977394827, lng: 78.45831833935735 },
        { lat: 17.36812016933953, lng: 78.45838975685761 },
        { lat: 17.36813492584602, lng: 78.45847935780212 },
        { lat: 17.36815872235461, lng: 78.45865393582636 },
        { lat: 17.36812076094169, lng: 78.4587755772651 },
        { lat: 17.36811766485945, lng: 78.45888320865419 },
        { lat: 17.36813194329173, lng: 78.45893680789096 },
        { lat: 17.36819339945734, lng: 78.45898797675191 },
        { lat: 17.36825134050087, lng: 78.45908558725633 },
        { lat: 17.36827378469038, lng: 78.45923086034625 },
        { lat: 17.3683010352257, lng: 78.45932469848456 },
        { lat: 17.36830580433554, lng: 78.45939956432312 },
        { lat: 17.3683073042712, lng: 78.45951749461574 },
        { lat: 17.36830179787605, lng: 78.45983610738243 },
        { lat: 17.36832082774168, lng: 78.46001087671745 },
        { lat: 17.36831083723319, lng: 78.46006461704913 },
        { lat: 17.36833368261604, lng: 78.46016748155142 },
        { lat: 17.36836158582533, lng: 78.46031069602198 },
        { lat: 17.36839876698459, lng: 78.46055681737973 },
        { lat: 17.36840054686297, lng: 78.46069127998375 },
        { lat: 17.36843214009432, lng: 78.46077168382996 },
        { lat: 17.36843480182448, lng: 78.4607772284291 },
        { lat: 17.3684586935246, lng: 78.46089905360947 },
        { lat: 17.36849907304707, lng: 78.4610677201111 },
        { lat: 17.36862521211374, lng: 78.46121529571316 },
        { lat: 17.36873135211119, lng: 78.4612934673879 },
        { lat: 17.36876925907386, lng: 78.46136987267663 },
        { lat: 17.36878739130502, lng: 78.46155605290814 },
        { lat: 17.36880173054947, lng: 78.46161420600664 },
        { lat: 17.36887520956087, lng: 78.46169843669922 },
        { lat: 17.36893339722263, lng: 78.4618231531872 },
        { lat: 17.36900104120688, lng: 78.46206444294046 },
        { lat: 17.36901158856044, lng: 78.46209798772195 },
        { lat: 17.36916906353511, lng: 78.46264122602976 },
        { lat: 17.36948255794378, lng: 78.46371639401804 },
        { lat: 17.36954385016725, lng: 78.46394977149177 },
        { lat: 17.36964005872577, lng: 78.46425707878711 },
        { lat: 17.36971945744662, lng: 78.46452972552034 },
        { lat: 17.36978764541292, lng: 78.46477156042613 },
        { lat: 17.36988241493345, lng: 78.46509772722477 },
        { lat: 17.36993191175617, lng: 78.4652496124094 },
        { lat: 17.36999040642408, lng: 78.4653754065284 },
        { lat: 17.37000736923667, lng: 78.46542686413329 },
        { lat: 17.37002541720196, lng: 78.46556262823418 },
        { lat: 17.3700336766643, lng: 78.4656885268979 },
        { lat: 17.37005405828871, lng: 78.46609316792016 },
        { lat: 17.37004502918344, lng: 78.46624090291215 },
        { lat: 17.37003693323252, lng: 78.46635142162351 },
        { lat: 17.37001620366565, lng: 78.46669138737802 },
        { lat: 17.36999776350217, lng: 78.466930114039 },
        { lat: 17.3700023072553, lng: 78.46728841013284 },
        { lat: 17.37007061046389, lng: 78.46768853734527 },
        { lat: 17.37012899748695, lng: 78.46809940908453 },
        { lat: 17.37021535275113, lng: 78.4687306893761 },
        { lat: 17.37024574201962, lng: 78.46889136414322 },
        { lat: 17.37025006220632, lng: 78.46904725416853 },
        { lat: 17.37026731906213, lng: 78.46913075463637 },
        { lat: 17.37040143333413, lng: 78.46980049686819 },
        { lat: 17.37046170987251, lng: 78.47017640589483 },
        { lat: 17.37051918210747, lng: 78.47042272796001 },
        { lat: 17.370692071041, lng: 78.47118107886361 },
        { lat: 17.37073091518981, lng: 78.47133020961493 },
        { lat: 17.37074455091744, lng: 78.47138865250504 },
        { lat: 17.37081748321448, lng: 78.47168881748216 },
        { lat: 17.37087928648978, lng: 78.4719166731524 },
        { lat: 17.37099059710759, lng: 78.47236852905839 },
        { lat: 17.37106470913381, lng: 78.47267909388039 },
        { lat: 17.37100600219752, lng: 78.47243106290625 },
        { lat: 17.37117197734288, lng: 78.47310483088239 },
        { lat: 17.37120510730009, lng: 78.47324267122724 },
        { lat: 17.37130667383502, lng: 78.47367122622519 },
        { lat: 17.37131472815048, lng: 78.47369875762638 },
        { lat: 17.37131912510705, lng: 78.47371705281257 },
        { lat: 17.37134062051341, lng: 78.47378726415228 },
        { lat: 17.37157642445975, lng: 78.47459329927585 },
        { lat: 17.37181573536002, lng: 78.4753769836588 },
        { lat: 17.3719250679871, lng: 78.47576782308066 },
        { lat: 17.3721149123119, lng: 78.47610239211359 },
        { lat: 17.37211622757654, lng: 78.47610205146432 },
        { lat: 17.37213100203584, lng: 78.47611870151795 },
        { lat: 17.37231098866647, lng: 78.47605162544177 },
        { lat: 17.37256537231592, lng: 78.4759637450425 },
        { lat: 17.37271636637725, lng: 78.47600987321113 },
        { lat: 17.37303377719845, lng: 78.47641485608365 },
        { lat: 17.3733516854712, lng: 78.47677176719515 },
        { lat: 17.37356302801978, lng: 78.47702182040926 },
        { lat: 17.37364933884296, lng: 78.47739398010262 },
        { lat: 17.3736536184815, lng: 78.47771905821972 },
        { lat: 17.37355420609728, lng: 78.47806967359422 },
        { lat: 17.3735469970215, lng: 78.47846708116838 },
        { lat: 17.37355016476182, lng: 78.47870795147175 },
        { lat: 17.37376390339544, lng: 78.47905425072005 },
        { lat: 17.3740596492043, lng: 78.47953185739513 },
        { lat: 17.37438630169707, lng: 78.47978017871615 },
        { lat: 17.37469179291774, lng: 78.48005304684192 },
        { lat: 17.3750420266468, lng: 78.48028899232267 },
        { lat: 17.37513111738329, lng: 78.48033030358418 },
        { lat: 17.37534464184735, lng: 78.48042931330127 },
        { lat: 17.37582294362171, lng: 78.48068775103965 },
        { lat: 17.37638343082022, lng: 78.48100517636196 },
        { lat: 17.37680262744583, lng: 78.48124032307307 },
        { lat: 17.37680308233517, lng: 78.48123943831301 },
        { lat: 17.37687290324104, lng: 78.48127881858143 },
        { lat: 17.37698160889721, lng: 78.48104873480384 },
        { lat: 17.37710982524436, lng: 78.4807977560247 },
        { lat: 17.37714404789782, lng: 78.48072807134908 },
        { lat: 17.37717882295565, lng: 78.48065936297684 },
        { lat: 17.37721061867211, lng: 78.48059733800478 },
        { lat: 17.37724358220773, lng: 78.48061397603747 },
        { lat: 17.37750894002401, lng: 78.48073794330529 },
        { lat: 17.37751047879262, lng: 78.48074178631528 },
        { lat: 17.37758390210818, lng: 78.48084705095056 },
        { lat: 17.37799101536682, lng: 78.48106883009244 },
        { lat: 17.3780727620274, lng: 78.48107856251215 },
        { lat: 17.37816708984086, lng: 78.48108897874417 },
        { lat: 17.37820949656686, lng: 78.48109754884607 },
        { lat: 17.37826041705821, lng: 78.48111687418638 },
        { lat: 17.37835583067782, lng: 78.48116495889337 },
        { lat: 17.37839223621389, lng: 78.48118123396007 },
        { lat: 17.37844317508259, lng: 78.48117753257543 },
        { lat: 17.37853019253846, lng: 78.48120199084208 },
        { lat: 17.37862197572031, lng: 78.48122433711171 },
        { lat: 17.3786400082558, lng: 78.48120924539644 },
        { lat: 17.37882704990214, lng: 78.48127654260591 },
        { lat: 17.37941095552798, lng: 78.48138051586417 },
        { lat: 17.37924825337887, lng: 78.48167249186298 },
        { lat: 17.37904795441647, lng: 78.48208594000309 },
        { lat: 17.37902578542075, lng: 78.48212926856529 },
        { lat: 17.37904566684479, lng: 78.48215463627497 },
        { lat: 17.37941342614193, lng: 78.48260341316279 },
        { lat: 17.37945185485761, lng: 78.48273071939882 },
        { lat: 17.37985594863117, lng: 78.48314065200863 },
        { lat: 17.38014296817408, lng: 78.48351383547677 },
        { lat: 17.38039421715812, lng: 78.48397060313535 },
        { lat: 17.38054736670722, lng: 78.48443510174252 },
        { lat: 17.38064448350291, lng: 78.48483645241527 },
        { lat: 17.38067305390144, lng: 78.48515564600012 },
        { lat: 17.38064929674784, lng: 78.48570565761092 },
        { lat: 17.38063114592648, lng: 78.4871887808672 },
        { lat: 17.3806335642576, lng: 78.48751330638058 },
        { lat: 17.38064004982646, lng: 78.48838391061544 },
        { lat: 17.38073734483181, lng: 78.48977597826581 },
        { lat: 17.38077562833719, lng: 78.49086844167024 },
        { lat: 17.38081177200944, lng: 78.49130258639781 },
        { lat: 17.38086359227559, lng: 78.49151919889947 },
        { lat: 17.38097644628305, lng: 78.49165774155173 },
        { lat: 17.3809820283896, lng: 78.49166459426313 },
        { lat: 17.38140527173533, lng: 78.49164604252864 },
        { lat: 17.38216785523699, lng: 78.49176987598531 },
        { lat: 17.38280723426263, lng: 78.49185703872779 },
        { lat: 17.38344540691648, lng: 78.49184834076496 },
        { lat: 17.38428463195692, lng: 78.49172184779015 },
        { lat: 17.38472814405995, lng: 78.49180571641675 },
        { lat: 17.38474045633918, lng: 78.49174971359459 },
        { lat: 17.38494673275131, lng: 78.4908973478725 },
        { lat: 17.38482255873143, lng: 78.49087509558764 },
        { lat: 17.38448630660156, lng: 78.49067722674474 },
        { lat: 17.38444788228939, lng: 78.49054991291726 },
        { lat: 17.38456664105914, lng: 78.48979562250233 },
        { lat: 17.38485549811347, lng: 78.48983871320071 },
        { lat: 17.38542645156036, lng: 78.4899394582577 },
        { lat: 17.38576059567813, lng: 78.48999278294811 },
        { lat: 17.38593100620085, lng: 78.49000854729351 },
        { lat: 17.38603154300723, lng: 78.48999270451941 },
        { lat: 17.38611444305737, lng: 78.48995539730579 },
        { lat: 17.38623518165852, lng: 78.4898886294057 },
        { lat: 17.3864420658298, lng: 78.48976641876118 },
        { lat: 17.38666956113787, lng: 78.48962583933732 },
        { lat: 17.38685227062626, lng: 78.48951481142238 },
        { lat: 17.38700056737189, lng: 78.48942957957847 },
        { lat: 17.38733622785073, lng: 78.48932731747203 },
        { lat: 17.38770328465933, lng: 78.48923548090738 },
        { lat: 17.38776869221435, lng: 78.48920363430244 },
        { lat: 17.38777123918744, lng: 78.48921396675419 },
        { lat: 17.38778928845472, lng: 78.48931645188108 },
        { lat: 17.38780155038057, lng: 78.48935443186468 },
        { lat: 17.38781376007288, lng: 78.48936693899802 },
        { lat: 17.38787513017982, lng: 78.4893948806052 },
        { lat: 17.38794219323629, lng: 78.48941062294894 },
        { lat: 17.38796015472421, lng: 78.48939974251428 },
        { lat: 17.38796934043679, lng: 78.4893872622783 },
        { lat: 17.38798040929479, lng: 78.48938777346028 },
        { lat: 17.38808261512333, lng: 78.48941830908967 },
        { lat: 17.38820756690845, lng: 78.48948722922418 },
        { lat: 17.38825899515012, lng: 78.48953043837653 },
        { lat: 17.38832904174487, lng: 78.4895749907585 },
        { lat: 17.38836613820134, lng: 78.48945812226235 },
        { lat: 17.38838914910372, lng: 78.48937032487449 },
        { lat: 17.3883907916859, lng: 78.48929269625417 },
        { lat: 17.38840123786568, lng: 78.4891897372257 },
        { lat: 17.38841405659277, lng: 78.48913895361825 },
        { lat: 17.38844786923351, lng: 78.48905542995202 },
        { lat: 17.38847131454368, lng: 78.48897345879097 },
        { lat: 17.38849504302733, lng: 78.48897859085912 },
        { lat: 17.3885935446552, lng: 78.48898994555404 },
        { lat: 17.38864763884151, lng: 78.48900369369554 },
        { lat: 17.38869220806622, lng: 78.48902133458512 },
        { lat: 17.38871608567111, lng: 78.48903831722893 },
        { lat: 17.38873944503438, lng: 78.48898217544341 },
        { lat: 17.38880010565535, lng: 78.48900756333545 },
        { lat: 17.38891812174019, lng: 78.4890624038184 },
        { lat: 17.38898142864568, lng: 78.48899906887723 },
        { lat: 17.38898731330474, lng: 78.48901093524049 },
        { lat: 17.38901907769391, lng: 78.48902842169672 },
        { lat: 17.38918735727366, lng: 78.48910776018711 },
        { lat: 17.38934242681425, lng: 78.48918180431899 },
        { lat: 17.38934841483039, lng: 78.4891959993799 },
        { lat: 17.38940639495434, lng: 78.4891713747696 },
        { lat: 17.38948032837213, lng: 78.48920403186428 },
        { lat: 17.38957127008152, lng: 78.4890265340218 },
        { lat: 17.38956340011223, lng: 78.48898351282793 },
        { lat: 17.38959333149235, lng: 78.4889983104588 },
        { lat: 17.38966549982664, lng: 78.48903733559408 },
        { lat: 17.38971023699097, lng: 78.48906308205176 },
        { lat: 17.3897515046861, lng: 78.4889716736736 },
        { lat: 17.3897481841646, lng: 78.48896891857287 },
        { lat: 17.38978333192394, lng: 78.48888972763973 },
        { lat: 17.38983356699344, lng: 78.48877984112252 },
        { lat: 17.38982684590023, lng: 78.4887774438164 },
        { lat: 17.38987803240586, lng: 78.48866723289117 },
        { lat: 17.38991560197483, lng: 78.48857444406107 },
        { lat: 17.39005116661305, lng: 78.48865713764353 },
        { lat: 17.39042520140897, lng: 78.48884377870999 },
        { lat: 17.39069385802335, lng: 78.48893779346945 },
        { lat: 17.39075989190797, lng: 78.48894050990053 },
        { lat: 17.39080957581608, lng: 78.48874808351505 },
        { lat: 17.39088165899981, lng: 78.48840340192572 },
        { lat: 17.39092234685563, lng: 78.48804829328931 },
        { lat: 17.39093026047456, lng: 78.48784920221044 },
        { lat: 17.39090289796055, lng: 78.48760717810251 },
        { lat: 17.3908740463338, lng: 78.48734188853531 },
        { lat: 17.3908669858298, lng: 78.4872796932522 },
        { lat: 17.39079045920058, lng: 78.4869538791566 },
        { lat: 17.39065332717972, lng: 78.48662310921141 },
        { lat: 17.39053870596951, lng: 78.48634811050657 },
        { lat: 17.39038053877607, lng: 78.48604797946905 },
        { lat: 17.39031027099774, lng: 78.48586241811284 },
        { lat: 17.39027111766078, lng: 78.48569572701896 },
        { lat: 17.39026884865335, lng: 78.48551567071439 },
        { lat: 17.39029208816654, lng: 78.48539958059204 },
        { lat: 17.39034676462414, lng: 78.4853280839172 },
        { lat: 17.39042037134258, lng: 78.48528848679864 },
        { lat: 17.3905736769186, lng: 78.48520277860904 },
        { lat: 17.39095267859708, lng: 78.48489530366543 },
        { lat: 17.39137538575823, lng: 78.48462582070951 },
        { lat: 17.3916572166359, lng: 78.48444830658453 },
        { lat: 17.39235817501666, lng: 78.48420717397134 },
        { lat: 17.39296708621503, lng: 78.48401232230148 },
        { lat: 17.3933655798697, lng: 78.4837817546821 },
        { lat: 17.39356763016474, lng: 78.48364392198843 },
        { lat: 17.39369599484382, lng: 78.48353925621116 },
        { lat: 17.39379876883793, lng: 78.483364188132 },
        { lat: 17.3938219238477, lng: 78.48324166609193 },
        { lat: 17.39381843512497, lng: 78.48296514457265 },
        { lat: 17.39380308467342, lng: 78.4827273750825 },
        { lat: 17.39372144447155, lng: 78.4821303305816 },
        { lat: 17.39359731359399, lng: 78.48159175395753 },
        { lat: 17.39352501175458, lng: 78.4812454233937 },
        { lat: 17.39360544390163, lng: 78.48076836557112 },
        { lat: 17.3937773517559, lng: 78.4802000081171 },
        { lat: 17.39381984203503, lng: 78.48014153878283 },
        { lat: 17.39388751603484, lng: 78.48012131577985 },
        { lat: 17.39444864959079, lng: 78.4800557394556 },
        { lat: 17.39480010055001, lng: 78.48001233177669 },
        { lat: 17.39535530269908, lng: 78.47996613344611 },
        { lat: 17.39571761300945, lng: 78.47998630681289 },
        { lat: 17.39602903737223, lng: 78.48001478604236 },
        { lat: 17.39616438526353, lng: 78.47997434109487 },
        { lat: 17.39637826614817, lng: 78.47985848055794 },
        { lat: 17.39639738463036, lng: 78.47984250855397 },
        { lat: 17.39691164157297, lng: 78.47948813334503 },
        { lat: 17.39731646549168, lng: 78.4792703289068 },
        { lat: 17.3975501161663, lng: 78.47918994118803 },
        { lat: 17.39826982942127, lng: 78.47896781736277 },
        { lat: 17.39859552473417, lng: 78.47884114326746 },
        { lat: 17.39897556981673, lng: 78.47861724209831 },
        { lat: 17.39926259229133, lng: 78.4783624560358 },
        { lat: 17.39951768587613, lng: 78.47802449116668 },
        { lat: 17.39986806993284, lng: 78.4774086386423 },
        { lat: 17.40017612741224, lng: 78.47686411938031 },
        { lat: 17.40051375042937, lng: 78.47621627791118 },
        { lat: 17.40076421301124, lng: 78.4760005807832 },
        { lat: 17.40094371524038, lng: 78.47582479459749 },
        { lat: 17.40107227427225, lng: 78.47556359060353 },
        { lat: 17.40128463692068, lng: 78.47562952498474 },
        { lat: 17.40145947863774, lng: 78.47569214217991 },
        { lat: 17.40195861266604, lng: 78.47590978169947 },
        { lat: 17.40242660761595, lng: 78.47607886238946 },
        { lat: 17.40251902284573, lng: 78.476102158138 },
        { lat: 17.40264608538455, lng: 78.47613172423925 },
        { lat: 17.40295952986948, lng: 78.47619616344214 },
        { lat: 17.40357138186545, lng: 78.47623479646438 },
        { lat: 17.40386024098424, lng: 78.47627786567433 },
        { lat: 17.404156549919, lng: 78.47636063221445 },
        { lat: 17.40445628522629, lng: 78.47643973282264 },
        { lat: 17.40465169254929, lng: 78.4765094117026 },
        { lat: 17.40493424648891, lng: 78.47660322214706 },
        { lat: 17.40554893703434, lng: 78.47686614170263 },
        { lat: 17.40618272722969, lng: 78.47705618665205 },
        { lat: 17.40637761129101, lng: 78.47709444373892 },
        { lat: 17.40662362298329, lng: 78.47710440622082 },
        { lat: 17.40690593866351, lng: 78.47700453783904 },
        { lat: 17.40698621065149, lng: 78.47696611818493 },
        { lat: 17.40732268621126, lng: 78.47677183589518 },
        { lat: 17.40779956152576, lng: 78.4763922124803 },
        { lat: 17.40822760971637, lng: 78.47605828323172 },
        { lat: 17.40841031534334, lng: 78.47585637035692 },
        { lat: 17.40857290207883, lng: 78.47569611073331 },
        { lat: 17.40884968925096, lng: 78.47511552267184 },
        { lat: 17.40889508574444, lng: 78.47513536262696 },
        { lat: 17.40903915339288, lng: 78.47520519246653 },
        { lat: 17.40905373370694, lng: 78.47521325590742 },
        { lat: 17.40922885071428, lng: 78.4753171255969 },
        { lat: 17.40937468988603, lng: 78.47541415752647 },
        { lat: 17.40947892806716, lng: 78.47538746709216 },
        { lat: 17.40949278133482, lng: 78.47544616587383 },
        { lat: 17.4095225674396, lng: 78.47548030207875 },
        { lat: 17.40958783383343, lng: 78.47555246261756 },
        { lat: 17.40958602482296, lng: 78.47558791449488 },
        { lat: 17.40982156154594, lng: 78.47573285147553 },
        { lat: 17.41017072402403, lng: 78.47593517256972 },
        { lat: 17.41042886256799, lng: 78.47608185831734 },
        { lat: 17.41060860053136, lng: 78.47618904907954 },
        { lat: 17.41087391740186, lng: 78.47636768201372 },
        { lat: 17.4110299375354, lng: 78.47647416985377 },
        { lat: 17.41128964003778, lng: 78.47665523265484 },
        { lat: 17.41144680192139, lng: 78.47676273637703 },
        { lat: 17.41151610315842, lng: 78.47679691744855 },
        { lat: 17.41347048641461, lng: 78.4781426147197 },
        { lat: 17.41382676612856, lng: 78.47837218868523 },
        { lat: 17.41421010706216, lng: 78.4785990399742 },
        { lat: 17.41461470350929, lng: 78.47881046179596 },
        { lat: 17.41464169793175, lng: 78.47880244528562 },
        { lat: 17.41473257072032, lng: 78.47884618177369 },
        { lat: 17.41475386911728, lng: 78.47883412928587 },
        { lat: 17.41492079153272, lng: 78.4789100428797 },
        { lat: 17.41499169177719, lng: 78.47898139454944 },
        { lat: 17.41499080282993, lng: 78.4790003697504 },
        { lat: 17.41510602921734, lng: 78.47909507461581 },
        { lat: 17.41521556138424, lng: 78.47918588846143 },
        { lat: 17.41558283985333, lng: 78.47948176042416 },
        { lat: 17.41585223838765, lng: 78.47971547347045 },
        { lat: 17.41621164818093, lng: 78.48001410099778 },
        { lat: 17.41961740958952, lng: 78.48257127639194 },
        { lat: 17.41967780985093, lng: 78.48261587285992 },
        { lat: 17.42371042989905, lng: 78.48564306750754 },
        { lat: 17.42424471916514, lng: 78.48584362151277 },
        { lat: 17.42430143571055, lng: 78.48586474893132 },
        { lat: 17.42435248596864, lng: 78.4858841889084 },
        { lat: 17.42441992841445, lng: 78.48586062610822 },
        { lat: 17.42447279846613, lng: 78.48584534867234 },
        { lat: 17.42452347210757, lng: 78.48583495052628 },
        { lat: 17.42458982841359, lng: 78.48581478402372 },
        { lat: 17.42466173594344, lng: 78.48578718954502 },
        { lat: 17.4247372692439, lng: 78.48577851228988 },
        { lat: 17.42478153371918, lng: 78.4857970168516 },
        { lat: 17.42479299243108, lng: 78.48581038484754 },
        { lat: 17.42480237164606, lng: 78.4858378943202 },
        { lat: 17.42481413646101, lng: 78.48587551365834 },
        { lat: 17.42482238687732, lng: 78.48590303954028 },
        { lat: 17.42483632765602, lng: 78.48593416062857 },
        { lat: 17.42485792146718, lng: 78.48594547892199 },
        { lat: 17.4248782473433, lng: 78.4859457895095 },
        { lat: 17.42490412445248, lng: 78.48593867213125 },
        { lat: 17.42493553612283, lng: 78.48592280603445 },
        { lat: 17.42496993346014, lng: 78.48587514477545 },
        { lat: 17.42499745962892, lng: 78.4858197853543 },
        { lat: 17.42501608894832, lng: 78.48577513253994 },
        { lat: 17.42503682557658, lng: 78.48571854323573 },
        { lat: 17.42503861933273, lng: 78.48568176650811 },
        { lat: 17.42503810166049, lng: 78.48564075743313 },
        { lat: 17.42502623845948, lng: 78.4855953480987 },
        { lat: 17.42501908896496, lng: 78.48556560173289 },
        { lat: 17.42502217292978, lng: 78.48554159748339 },
        { lat: 17.42502513070211, lng: 78.4855075973086 },
        { lat: 17.42503166970705, lng: 78.48548898393858 },
        { lat: 17.42504213200113, lng: 78.48542342212181 },
        { lat: 17.42505697214238, lng: 78.48534692013625 },
        { lat: 17.42506897884598, lng: 78.48531426561837 },
        { lat: 17.42506837016909, lng: 78.48526605451505 },
        { lat: 17.4250655688202, lng: 78.48522301811606 },
        { lat: 17.42507095117893, lng: 78.48520221707109 },
        { lat: 17.4250917563082, lng: 78.48515106686028 },
        { lat: 17.42511710629953, lng: 78.48510220465478 },
        { lat: 17.42514376697459, lng: 78.48506773292176 },
        { lat: 17.4251730174687, lng: 78.4850595417594 },
        { lat: 17.42519558977119, lng: 78.48505893704854 },
        { lat: 17.42523182278868, lng: 78.48506726217154 },
        { lat: 17.42527398003333, lng: 78.48509770308542 },
        { lat: 17.42529881181618, lng: 78.48509721607593 },
        { lat: 17.42531872195875, lng: 78.48506460186765 },
        { lat: 17.42534836813972, lng: 78.48499833487071 },
        { lat: 17.4253761575902, lng: 78.4849638476097 },
        { lat: 17.42539301351973, lng: 78.48495758943906 },
        { lat: 17.42543127025598, lng: 78.48494736110787 },
        { lat: 17.42543639086936, lng: 78.48490583437975 },
        { lat: 17.42544022860296, lng: 78.48485212216102 },
        { lat: 17.4254489174927, lng: 78.48482495311738 },
        { lat: 17.42546788067611, lng: 78.48480675841762 },
        { lat: 17.42548908661094, lng: 78.48478735689442 },
        { lat: 17.42550452415938, lng: 78.4847581835145 },
        { lat: 17.42549967485567, lng: 78.48473178896592 },
        { lat: 17.42546635678011, lng: 78.48468608463894 },
        { lat: 17.42544685531465, lng: 78.48466165408131 },
        { lat: 17.42543182820841, lng: 78.48463392750512 },
        { lat: 17.42542473426062, lng: 78.48460859116202 },
        { lat: 17.42541759763618, lng: 78.48457987580629 },
        { lat: 17.42539229621295, lng: 78.48454317491503 },
        { lat: 17.42534890055851, lng: 78.48450407629157 },
        { lat: 17.42530112337532, lng: 78.48447562438048 },
        { lat: 17.42524092564749, lng: 78.48444704727501 },
        { lat: 17.4252024610127, lng: 78.48444081148014 },
        { lat: 17.42518083743478, lng: 78.48442714159928 },
        { lat: 17.42516026098852, lng: 78.48440698984975 },
        { lat: 17.42514877432977, lng: 78.48439141597976 },
        { lat: 17.42512688901087, lng: 78.48435702239732 },
        { lat: 17.42508819046042, lng: 78.48433226604453 },
        { lat: 17.42505738054051, lng: 78.48430637415623 },
        { lat: 17.42501192032516, lng: 78.48428259302875 },
        { lat: 17.42498364460172, lng: 78.48427856978853 },
        { lat: 17.42496105931531, lng: 78.48427814546153 },
        { lat: 17.42493972720316, lng: 78.48428755294286 },
        { lat: 17.42492748488033, lng: 78.48430153828805 },
        { lat: 17.42486696031628, lng: 78.48433647418793 },
        { lat: 17.42484448454754, lng: 78.48434472124876 },
        { lat: 17.42481838660999, lng: 78.48433434741851 },
        { lat: 17.42480107216821, lng: 78.48430430014892 },
        { lat: 17.42480754423823, lng: 78.48428039626535 },
        { lat: 17.42483324118511, lng: 78.48425902137731 },
        { lat: 17.42488039649119, lng: 78.48423823490887 },
        { lat: 17.42491417882167, lng: 78.48423130249819 },
        { lat: 17.42496141582054, lng: 78.48421698428562 },
        { lat: 17.42499415104648, lng: 78.48421653561331 },
        { lat: 17.42502245274319, lng: 78.4842226152215 },
        { lat: 17.42506892109563, lng: 78.48423682707602 },
        { lat: 17.42513238457624, lng: 78.48425580388526 },
        { lat: 17.4251800782542, lng: 78.48427764256344 },
        { lat: 17.42522784062922, lng: 78.48430492040532 },
        { lat: 17.42527220172387, lng: 78.48433106691091 },
        { lat: 17.42530980117894, lng: 78.4843581905163 },
        { lat: 17.42533716528866, lng: 78.48437942533042 },
        { lat: 17.42536798822652, lng: 78.48440634827831 },
        { lat: 17.42537835905928, lng: 78.48442296488697 },
        { lat: 17.42540126365729, lng: 78.4844486716277 },
        { lat: 17.42544464632471, lng: 78.48448674111381 },
        { lat: 17.4254664072648, lng: 78.48451128745947 },
        { lat: 17.42549261471408, lng: 78.48453033276857 },
        { lat: 17.42551874049615, lng: 78.48454291166826 },
        { lat: 17.42553816031007, lng: 78.48456087580442 },
        { lat: 17.42554404192238, lng: 78.48457961258237 },
        { lat: 17.42554223911802, lng: 78.48461565564341 },
        { lat: 17.42556153268902, lng: 78.48462362384286 },
        { lat: 17.42559550994175, lng: 78.48463212469163 },
        { lat: 17.4256507617991, lng: 78.48462666315045 },
        { lat: 17.42569907193555, lng: 78.48460791944673 },
        { lat: 17.42572019800827, lng: 78.48458219632211 },
        { lat: 17.42571165782312, lng: 78.4845317415985 },
        { lat: 17.42574097880308, lng: 78.48452913435446 },
        { lat: 17.42575150186795, lng: 78.48455780522721 },
        { lat: 17.42577076759337, lng: 78.48456356840784 },
        { lat: 17.42579893192501, lng: 78.484558771618 },
        { lat: 17.42585407425999, lng: 78.48454463859457 },
        { lat: 17.42589450874631, lng: 78.48452805952303 },
        { lat: 17.42594053341495, lng: 78.48450714168149 },
        { lat: 17.42601231073082, lng: 78.48446925884768 },
        { lat: 17.42605264865933, lng: 78.48444503554079 },
        { lat: 17.42610648210262, lng: 78.4844166605375 },
        { lat: 17.42615911803912, lng: 78.48438286180577 },
        { lat: 17.42623409234688, lng: 78.48432993942217 },
        { lat: 17.42625748896948, lng: 78.48430521437913 },
        { lat: 17.42628064052898, lng: 78.48426108812833 },
        { lat: 17.42628669853501, lng: 78.48420440594737 },
        { lat: 17.4262859669893, lng: 78.48414649208412 },
        { lat: 17.42626959007242, lng: 78.48410129124048 },
        { lat: 17.42628283860289, lng: 78.48407758781462 },
        { lat: 17.42628931059514, lng: 78.48405368184496 },
        { lat: 17.42628101907508, lng: 78.48402292359226 },
        { lat: 17.42626120372734, lng: 78.48397365264191 },
        { lat: 17.42622752710286, lng: 78.48389958027408 },
        { lat: 17.42619284791204, lng: 78.48383551750553 },
        { lat: 17.42618983268267, lng: 78.48377557824885 },
        { lat: 17.4261959165321, lng: 78.4837209524897 },
        { lat: 17.42622065173304, lng: 78.48371282295267 },
        { lat: 17.42623435516704, lng: 78.48372512986313 },
        { lat: 17.42624650480561, lng: 78.4837931765361 },
        { lat: 17.42625819763958, lng: 78.48382506611088 },
        { lat: 17.42627542675264, lng: 78.48384835172413 },
        { lat: 17.42629484660426, lng: 78.48386631395945 },
        { lat: 17.42631164862163, lng: 78.48385579235287 },
        { lat: 17.42631024315555, lng: 78.48383390810442 },
        { lat: 17.42631445753992, lng: 78.48381003495838 },
        { lat: 17.42633916115613, lng: 78.4837994050185 },
        { lat: 17.42637874344745, lng: 78.48380474281997 },
        { lat: 17.42638380271677, lng: 78.48384774662836 },
        { lat: 17.42636946256704, lng: 78.48387440621569 },
        { lat: 17.42638663781799, lng: 78.48389342854844 },
        { lat: 17.4264524406415, lng: 78.48391884268314 },
        { lat: 17.42650452886814, lng: 78.48393106562024 },
        { lat: 17.42652725342723, lng: 78.48394251501367 },
        { lat: 17.42652656468619, lng: 78.48397736501498 },
        { lat: 17.42652476201669, lng: 78.48401340826122 },
        { lat: 17.42653069754687, lng: 78.48403640841322 },
        { lat: 17.42654886419026, lng: 78.48404453880184 },
        { lat: 17.42658968297036, lng: 78.48405838590917 },
        { lat: 17.42661704897603, lng: 78.48407976754662 },
        { lat: 17.42663207432134, lng: 78.48410734748128 },
        { lat: 17.42663017877646, lng: 78.48413604002981 },
        { lat: 17.42663624983173, lng: 78.48416976995779 },
        { lat: 17.42666248519755, lng: 78.4841910222216 },
        { lat: 17.4266795490123, lng: 78.48420122449986 },
        { lat: 17.42671912945035, lng: 78.48420641563814 },
        { lat: 17.42673173193857, lng: 78.48422094500194 },
        { lat: 17.42675247366051, lng: 78.48425417842162 },
        { lat: 17.42676412372946, lng: 78.48428268719924 },
        { lat: 17.42679157142089, lng: 78.48431053722987 },
        { lat: 17.42683382346404, lng: 78.48434847376211 },
        { lat: 17.42690315374666, lng: 78.48438501171934 },
        { lat: 17.42692938909676, lng: 78.48440626404275 },
        { lat: 17.42693642551532, lng: 78.48442704187713 },
        { lat: 17.42695592702934, lng: 78.48445147258212 },
        { lat: 17.42705242836696, lng: 78.48449396087538 },
        { lat: 17.42711587512022, lng: 78.4845116133606 },
        { lat: 17.42716783710405, lng: 78.48451384233668 },
        { lat: 17.42723547048446, lng: 78.48450541841547 },
        { lat: 17.42728514699135, lng: 78.48450547141226 },
        { lat: 17.42732254964992, lng: 78.48451701328626 },
        { lat: 17.42734856591857, lng: 78.48452092075686 },
        { lat: 17.427389193459, lng: 78.48451962813053 },
        { lat: 17.42743761495586, lng: 78.48450970431166 },
        { lat: 17.42747467601033, lng: 78.48449420060072 },
        { lat: 17.42750637896333, lng: 78.48450140976088 },
        { lat: 17.42752041470079, lng: 78.48454002864936 },
        { lat: 17.42753222811798, lng: 78.4845814724161 },
        { lat: 17.4275360006702, lng: 78.48461199929034 },
        { lat: 17.42755210091865, lng: 78.48463530060728 },
        { lat: 17.42758529096243, lng: 78.48467086258081 },
        { lat: 17.42761620671836, lng: 78.48470513474238 },
        { lat: 17.42764274463246, lng: 78.48475034537144 },
        { lat: 17.42765783858104, lng: 78.48478336286287 },
        { lat: 17.42765929780702, lng: 78.48480951062375 },
        { lat: 17.4276167152282, lng: 78.48483479232179 },
        { lat: 17.42756743964929, lng: 78.48486648656328 },
        { lat: 17.42752704599472, lng: 78.48488629995116 },
        { lat: 17.42751849264067, lng: 78.48492419912986 },
        { lat: 17.42752886345702, lng: 78.48494081595179 },
        { lat: 17.42755081371935, lng: 78.48498035575027 },
        { lat: 17.42755111627065, lng: 78.48500431392965 },
        { lat: 17.42753558221932, lng: 78.48502584525953 },
        { lat: 17.42751668770577, lng: 78.48504947751769 },
        { lat: 17.42751260870792, lng: 78.48508408251392 },
        { lat: 17.42752091309146, lng: 78.48511587018065 },
        { lat: 17.42752460388329, lng: 78.4851399287059 },
        { lat: 17.42752489159017, lng: 78.48516271287006 },
        { lat: 17.42751958909778, lng: 78.48518983582191 },
        { lat: 17.42752168117698, lng: 78.48526610685617 },
        { lat: 17.42751136567449, lng: 78.48534328179186 },
        { lat: 17.42749077402642, lng: 78.48541133738463 },
        { lat: 17.42747470311848, lng: 78.48547977135634 },
        { lat: 17.42747719456166, lng: 78.48549826125927 },
        { lat: 17.42748760429084, lng: 78.48551796366874 },
        { lat: 17.42752297018069, lng: 78.48554703027325 },
        { lat: 17.42755495519691, lng: 78.48557658165954 },
        { lat: 17.42761185922014, lng: 78.48561255469619 },
        { lat: 17.42765785379845, lng: 78.48567866873209 },
        { lat: 17.42769710338523, lng: 78.48574708063404 },
        { lat: 17.42775546277936, lng: 78.48580890804622 },
        { lat: 17.42785924329474, lng: 78.48589142987174 },
        { lat: 17.42801243066058, lng: 78.48604207795115 },
        { lat: 17.42810294009499, lng: 78.48614654067465 },
        { lat: 17.42816832453896, lng: 78.48622826589819 },
        { lat: 17.42821897888483, lng: 78.48630578396285 },
        { lat: 17.42826141803028, lng: 78.4863585677255 },
        { lat: 17.42829543052283, lng: 78.48636986290514 },
        { lat: 17.42833619543069, lng: 78.4863794491599 },
        { lat: 17.42841893566761, lng: 78.4864050727432 },
        { lat: 17.42846553380358, lng: 78.48642957305896 },
        { lat: 17.42850990586881, lng: 78.48645660286816 },
        { lat: 17.42861869760846, lng: 78.4864889263252 },
        { lat: 17.42871030129842, lng: 78.48650119783395 },
        { lat: 17.42881906520595, lng: 78.48653131627884 },
        { lat: 17.42891114750268, lng: 78.4865815084357 },
        { lat: 17.42898269989017, lng: 78.48661522460496 },
        { lat: 17.42911426986766, lng: 78.4866632595623 },
        { lat: 17.42925594528083, lng: 78.48670689394262 },
        { lat: 17.42931351235996, lng: 78.48670595871785 },
        { lat: 17.42936766334908, lng: 78.48670271805216 },
        { lat: 17.42941968101714, lng: 78.48670935584138 },
        { lat: 17.42960056026912, lng: 78.48672834207665 },
        { lat: 17.4297257683052, lng: 78.48671957049658 },
        { lat: 17.42982258003103, lng: 78.48669722121687 },
        { lat: 17.42995635653522, lng: 78.48665172583563 },
        { lat: 17.43012373736333, lng: 78.48658518897092 },
        { lat: 17.43028211739456, lng: 78.48652112561372 },
        { lat: 17.43038194069519, lng: 78.48646903833546 },
        { lat: 17.43047171421661, lng: 78.48642576183926 },
        { lat: 17.43053897848853, lng: 78.4863880871294 },
        { lat: 17.43061731551848, lng: 78.48633320601478 },
        { lat: 17.43068874240779, lng: 78.48626754086976 },
        { lat: 17.43074799181968, lng: 78.48622100722338 },
        { lat: 17.4308024773671, lng: 78.48615484018877 },
        { lat: 17.43085685338404, lng: 78.48607999954183 },
        { lat: 17.43097953880532, lng: 78.48596085316976 },
        { lat: 17.43109322156236, lng: 78.48584403545917 },
        { lat: 17.43116464824066, lng: 78.48577836994967 },
        { lat: 17.43123026569729, lng: 78.48569969984968 },
        { lat: 17.43127676585901, lng: 78.4856270236305 },
        { lat: 17.43129307794951, lng: 78.48557769832068 },
        { lat: 17.43130255779682, lng: 78.48552376025553 },
        { lat: 17.43133145370424, lng: 78.48548749152356 },
        { lat: 17.4313853577481, lng: 78.48546470186794 },
        { lat: 17.43141114009971, lng: 78.48545008636886 },
        { lat: 17.43142425320628, lng: 78.4854156522538 },
        { lat: 17.43142833404342, lng: 78.48538119514271 },
        { lat: 17.43147915808607, lng: 78.48529331854517 },
        { lat: 17.43153799879621, lng: 78.48521444746662 },
        { lat: 17.4315721859012, lng: 78.48515017266281 },
        { lat: 17.43157645605853, lng: 78.48513070900097 },
        { lat: 17.43156128223264, lng: 78.48509136905555 },
        { lat: 17.43157348554883, lng: 78.48507429568646 },
        { lat: 17.43162835677642, lng: 78.48503870013104 },
        { lat: 17.43172806999107, lng: 78.48497793988852 },
        { lat: 17.43177038141199, lng: 78.48493119551179 },
        { lat: 17.43181175528619, lng: 78.48489960871773 },
        { lat: 17.43186667846913, lng: 78.4848681297319 },
        { lat: 17.43192469096286, lng: 78.48481308582193 },
        { lat: 17.43201721904815, lng: 78.48471978581739 },
        { lat: 17.43200787295862, lng: 78.4846949198112 },
        { lat: 17.43204381446017, lng: 78.48468016675382 },
        { lat: 17.43210014679072, lng: 78.48467086800197 },
        { lat: 17.43217742495085, lng: 78.4846215872511 },
        { lat: 17.43221436339562, lng: 78.48459638211008 },
        { lat: 17.43229036416666, lng: 78.4845353575079 },
        { lat: 17.43235738278759, lng: 78.48447827795887 },
        { lat: 17.43244534159505, lng: 78.48438077602549 },
        { lat: 17.43254238646565, lng: 78.48428756037232 },
        { lat: 17.43263139409803, lng: 78.48418372286334 },
        { lat: 17.43266905263705, lng: 78.48412616312125 },
        { lat: 17.43273632692548, lng: 78.48399998343164 },
        { lat: 17.43279399732162, lng: 78.48391789261814 },
        { lat: 17.43283703413043, lng: 78.4838392354048 },
        { lat: 17.43290984817415, lng: 78.48370474659534 },
        { lat: 17.43295927128896, lng: 78.48359542410688 },
        { lat: 17.43300718651671, lng: 78.48345612989998 },
        { lat: 17.43304115928503, lng: 78.48337495100725 },
        { lat: 17.433064311374, lng: 78.4832415835096 },
        { lat: 17.43316109158558, lng: 78.48294886810143 },
        { lat: 17.4332742587712, lng: 78.4826128528175 },
        { lat: 17.43331292167494, lng: 78.48245618991344 },
        { lat: 17.43336399751613, lng: 78.48229906304418 },
        { lat: 17.43341704083925, lng: 78.48211897540133 },
        { lat: 17.43343457404803, lng: 78.48198774151673 },
        { lat: 17.4334527076716, lng: 78.48190398701558 },
        { lat: 17.43350409167311, lng: 78.48177126097474 },
        { lat: 17.43354222563262, lng: 78.48166209268908 },
        { lat: 17.4335985747548, lng: 78.48147563646184 },
        { lat: 17.43368168197807, lng: 78.48117325784663 },
        { lat: 17.43373284784261, lng: 78.48102333278032 },
        { lat: 17.43380239405858, lng: 78.48080920163447 },
        { lat: 17.43386736719355, lng: 78.48059057727035 },
        { lat: 17.43391904750411, lng: 78.48039212968173 },
        { lat: 17.43396249905564, lng: 78.48025715966602 },
        { lat: 17.4340051640329, lng: 78.48014925156463 },
        { lat: 17.43403042867333, lng: 78.480093772842 },
        { lat: 17.43408125559092, lng: 78.48000633402542 },
        { lat: 17.43418605243099, lng: 78.47963382370382 },
        { lat: 17.43420101445189, lng: 78.47956716538121 },
        { lat: 17.43423772053417, lng: 78.47943449320033 },
        { lat: 17.43428808653196, lng: 78.47922150718166 },
        { lat: 17.43432906184966, lng: 78.47906936899535 },
        { lat: 17.4343570648116, lng: 78.47896269132181 },
        { lat: 17.43437594240288, lng: 78.47884863997223 },
        { lat: 17.43438625867649, lng: 78.47877175559191 },
        { lat: 17.43437455932467, lng: 78.47873942484132 },
        { lat: 17.43434234434017, lng: 78.47869179269617 },
        { lat: 17.43433058914772, lng: 78.47865505361901 },
        { lat: 17.43433593341107, lng: 78.47863131061222 },
        { lat: 17.43434012280798, lng: 78.4786055247646 },
        { lat: 17.43432858725466, lng: 78.4785861293077 },
        { lat: 17.4343046293798, lng: 78.47856646424908 },
        { lat: 17.43426734192671, lng: 78.47856403735126 },
        { lat: 17.43423801186913, lng: 78.47856591018683 },
        { lat: 17.43419812986111, lng: 78.47853690813012 },
        { lat: 17.43411342992103, lng: 78.47844574649721 },
        { lat: 17.43409305203948, lng: 78.47844132204881 },
        { lat: 17.43407616851527, lng: 78.4784453760912 },
        { lat: 17.43406025181477, lng: 78.47843662612213 },
        { lat: 17.43406906622669, lng: 78.47841945192447 },
        { lat: 17.43409470827778, lng: 78.47839381158168 },
        { lat: 17.43412371809713, lng: 78.47836665523855 },
        { lat: 17.43413887891136, lng: 78.47831572616599 },
        { lat: 17.434130338741, lng: 78.47826541645036 },
        { lat: 17.43410624492967, lng: 78.478235021311 },
        { lat: 17.43406513354285, lng: 78.47819809685723 },
        { lat: 17.43402085175952, lng: 78.47817827091798 },
        { lat: 17.43399229676442, lng: 78.47815220133356 },
        { lat: 17.43393900321136, lng: 78.47813396711192 },
        { lat: 17.43389372854762, lng: 78.4781248868472 },
        { lat: 17.43385027578664, lng: 78.47808138006036 },
        { lat: 17.43381348777312, lng: 78.47802925328378 },
        { lat: 17.43377000706317, lng: 78.47798354143568 },
        { lat: 17.4337448663433, lng: 78.47795962858216 },
        { lat: 17.43371652917147, lng: 78.47795075585886 },
        { lat: 17.43367136435633, lng: 78.47795034741466 },
        { lat: 17.43363321996448, lng: 78.47796939638128 },
        { lat: 17.43358819107133, lng: 78.47797971804205 },
        { lat: 17.43353842170133, lng: 78.47797231608916 },
        { lat: 17.43349325688492, lng: 78.47797190763387 },
        { lat: 17.43342322322068, lng: 78.47796904844783 },
        { lat: 17.43337337751225, lng: 78.4779556201071 },
        { lat: 17.43334853659746, lng: 78.47795537447766 },
        { lat: 17.43330697788344, lng: 78.47797226485578 },
        { lat: 17.43326568540427, lng: 78.47801017326401 },
        { lat: 17.43323200405458, lng: 78.47802504529466 },
        { lat: 17.4332061702369, lng: 78.47803554337952 },
        { lat: 17.43314965231365, lng: 78.47803014610032 },
        { lat: 17.43310440558193, lng: 78.47802327096909 },
        { lat: 17.43305808403615, lng: 78.4780206729096 },
        { lat: 17.4330254160098, lng: 78.47802641362908 },
        { lat: 17.4329928615672, lng: 78.47804112147733 },
        { lat: 17.43292026259064, lng: 78.47810313138814 },
        { lat: 17.43286665761361, lng: 78.4781494437068 },
        { lat: 17.43283209319213, lng: 78.47818373298912 },
        { lat: 17.43283583517455, lng: 78.47821176185877 },
        { lat: 17.43283847626342, lng: 78.47824200945684 },
        { lat: 17.43286270783301, lng: 78.47828328311947 },
        { lat: 17.43287895216479, lng: 78.47831790148354 },
        { lat: 17.43290288213937, lng: 78.47833536316729 },
        { lat: 17.43287710415186, lng: 78.47835027137175 },
        { lat: 17.43284444170697, lng: 78.47835645417109 },
        { lat: 17.432815247546, lng: 78.47836905706349 },
        { lat: 17.43280552400321, lng: 78.47840359199898 },
        { lat: 17.4328012694582, lng: 78.47842423366538 },
        { lat: 17.43278025609653, lng: 78.47845877698364 },
        { lat: 17.43271372047821, lng: 78.47846468952523 },
        { lat: 17.43267136052847, lng: 78.4785074655371 },
        { lat: 17.43262982966624, lng: 78.4785265608032 },
        { lat: 17.43260498314121, lng: 78.47852587293623 },
        { lat: 17.43256846893197, lng: 78.47849535512371 },
        { lat: 17.43254788813872, lng: 78.47847490803619 },
        { lat: 17.43249957705019, lng: 78.47849350747323 },
        { lat: 17.43240187820119, lng: 78.47853483849237 },
        { lat: 17.43236474709569, lng: 78.47854475780349 },
        { lat: 17.43230198131218, lng: 78.47858090417063 },
        { lat: 17.43225139029057, lng: 78.47859777163283 },
        { lat: 17.4322267689892, lng: 78.47861486931036 },
        { lat: 17.43223392706773, lng: 78.47864520340957 },
        { lat: 17.43223315193541, lng: 78.47867314750269 },
        { lat: 17.43221648246357, lng: 78.47869410649014 },
        { lat: 17.43223278070035, lng: 78.47873298820392 },
        { lat: 17.4322320892981, lng: 78.47876754567523 },
        { lat: 17.43221432451644, lng: 78.47879116551762 },
        { lat: 17.43218144426751, lng: 78.47878014966267 },
        { lat: 17.43215734870527, lng: 78.47874960797719 },
        { lat: 17.4321092431723, lng: 78.47869528475795 },
        { lat: 17.43208883737258, lng: 78.47868865521392 },
        { lat: 17.43205956314783, lng: 78.47869493812658 },
        { lat: 17.43203832824342, lng: 78.47871199111627 },
        { lat: 17.43202152846832, lng: 78.4787226603132 },
        { lat: 17.4320046747064, lng: 78.478729066096 },
        { lat: 17.43192662032043, lng: 78.478716907797 },
        { lat: 17.4318850893953, lng: 78.47873600103576 },
        { lat: 17.43185592499521, lng: 78.47875095750136 },
        { lat: 17.43178524826648, lng: 78.4787864766032 },
        { lat: 17.43173471117134, lng: 78.47880760546813 },
        { lat: 17.43171325848377, lng: 78.4788074599154 },
        { lat: 17.43168946630104, lng: 78.47880087689978 },
        { lat: 17.43165107608367, lng: 78.47880052186846 },
        { lat: 17.43159931156139, lng: 78.47881387694896 },
        { lat: 17.43151581233531, lng: 78.47881752334106 },
        { lat: 17.43143325208356, lng: 78.47880616270294 },
        { lat: 17.43138346222921, lng: 78.4787971424672 },
        { lat: 17.43132680657366, lng: 78.47878086818427 },
        { lat: 17.43126905747571, lng: 78.47876740151109 },
        { lat: 17.43123623121356, lng: 78.47876064908796 },
        { lat: 17.4312032411675, lng: 78.47874096161337 },
        { lat: 17.43117124402719, lng: 78.47871052677561 },
        { lat: 17.43113830796221, lng: 78.47869510270789 },
        { lat: 17.43111341304664, lng: 78.47869059354747 },
        { lat: 17.43107695284635, lng: 78.47866433741417 },
        { lat: 17.43105635533855, lng: 78.47864256778139 },
        { lat: 17.43104049264386, lng: 78.4786380812908 },
        { lat: 17.43101091689842, lng: 78.4786205523926 },
        { lat: 17.4310162072287, lng: 78.47859254644041 },
        { lat: 17.43102047673246, lng: 78.47857308277636 },
        { lat: 17.43098839582948, lng: 78.47853603466635 },
        { lat: 17.43098564498979, lng: 78.47849711383033 },
        { lat: 17.43100773507056, lng: 78.47845843873593 },
        { lat: 17.4310421637161, lng: 78.47841341992114 },
        { lat: 17.43104982516216, lng: 78.47839434997525 },
        { lat: 17.43105861354283, lng: 78.47837511776095 },
        { lat: 17.43106363020956, lng: 78.4783255051097 },
        { lat: 17.43105201089645, lng: 78.47829949477855 },
        { lat: 17.43103149527253, lng: 78.47828419365383 },
        { lat: 17.43103661988049, lng: 78.47824310590515 },
        { lat: 17.43107027523746, lng: 78.478226177711 },
        { lat: 17.43109178377039, lng: 78.47823073334874 },
        { lat: 17.43111210767971, lng: 78.47823089623911 },
        { lat: 17.43115823749041, lng: 78.47821835427638 },
        { lat: 17.43116240454046, lng: 78.47819080407366 },
        { lat: 17.43118724548749, lng: 78.47819105165505 },
        { lat: 17.43120249877438, lng: 78.47823656383757 },
        { lat: 17.4312185513342, lng: 78.47825604178091 },
        { lat: 17.43122568340132, lng: 78.4782843192593 },
        { lat: 17.43121016879688, lng: 78.47830731907227 },
        { lat: 17.43118428097096, lng: 78.47831355545357 },
        { lat: 17.43117210807172, lng: 78.47833298097848 },
        { lat: 17.43117472120622, lng: 78.47836102511829 },
        { lat: 17.43119096736902, lng: 78.4783957918287 },
        { lat: 17.43121046403133, lng: 78.47841978203013 },
        { lat: 17.43124794321665, lng: 78.4784373490717 },
        { lat: 17.43126124677944, lng: 78.47841805478458 },
        { lat: 17.43129492819442, lng: 78.47840318303268 },
        { lat: 17.43133164793078, lng: 78.47836078032269 },
        { lat: 17.43137337053128, lng: 78.47835682533386 },
        { lat: 17.43137703240345, lng: 78.47837853227415 },
        { lat: 17.43137276108969, lng: 78.4783978511064 },
        { lat: 17.43135590733818, lng: 78.47840425688656 },
        { lat: 17.43135059097603, lng: 78.4784302045729 },
        { lat: 17.43136338372348, lng: 78.47845972530408 },
        { lat: 17.43138767103553, lng: 78.47850540696659 },
        { lat: 17.43138684380006, lng: 78.47852923616664 },
        { lat: 17.4313735402273, lng: 78.4785485304617 },
        { lat: 17.43134889099559, lng: 78.47856342297166 },
        { lat: 17.43131961677211, lng: 78.47856970586186 },
        { lat: 17.43128926773993, lng: 78.47858026765645 },
        { lat: 17.43126894385003, lng: 78.47858010661133 },
        { lat: 17.43124503997378, lng: 78.47856470333832 },
        { lat: 17.43123980549704, lng: 78.47859711947454 },
        { lat: 17.43126836225764, lng: 78.47862333555904 },
        { lat: 17.43128342374074, lng: 78.47865370767815 },
        { lat: 17.43129077350381, lng: 78.47869918176207 },
        { lat: 17.43133244027822, lng: 78.47869081670109 },
        { lat: 17.43135463836074, lng: 78.47866066833913 },
        { lat: 17.43138735667689, lng: 78.47865889583179 },
        { lat: 17.43141679469614, lng: 78.4786655480188 },
        { lat: 17.43144890165113, lng: 78.47870465455337 },
        { lat: 17.43146941725247, lng: 78.47871995575802 },
        { lat: 17.43149414837973, lng: 78.47871152985124 },
        { lat: 17.43150728817737, lng: 78.47867930047803 },
        { lat: 17.43153178105827, lng: 78.47865205990855 },
        { lat: 17.43153263622859, lng: 78.47863043576558 },
        { lat: 17.43150763150425, lng: 78.47861725493883 },
        { lat: 17.43148741742223, lng: 78.47862576556496 },
        { lat: 17.43147069209929, lng: 78.47864231430766 },
        { lat: 17.43143412208037, lng: 78.47860738647405 },
        { lat: 17.43145151086776, lng: 78.478554075336 },
        { lat: 17.43145749253482, lng: 78.4784915101129 },
        { lat: 17.43145826393993, lng: 78.47846327263287 },
        { lat: 17.43144351406065, lng: 78.47836835829635 },
        { lat: 17.43140405719774, lng: 78.47828377774447 },
        { lat: 17.43134782662402, lng: 78.47821192474552 },
        { lat: 17.43127565142857, lng: 78.4781291187582 },
        { lat: 17.43125172147964, lng: 78.47811165911067 },
        { lat: 17.43122679863313, lng: 78.47810494495775 },
        { lat: 17.43120093874508, lng: 78.47811338644027 },
        { lat: 17.43116367733835, lng: 78.47811301602493 },
        { lat: 17.43113977345857, lng: 78.47809761470627 },
        { lat: 17.43111914982675, lng: 78.47807378682168 },
        { lat: 17.43111147843428, lng: 78.47791379352287 },
        { lat: 17.43109314456221, lng: 78.47780334374289 },
        { lat: 17.43104465902079, lng: 78.47771903626985 },
        { lat: 17.43099988379768, lng: 78.4776602569582 },
        { lat: 17.430981160233, lng: 78.47760817811718 },
        { lat: 17.43095324055843, lng: 78.47754313977424 },
        { lat: 17.43089778292086, lng: 78.47744319845516 },
        { lat: 17.43084523828581, lng: 78.47739496433732 },
        { lat: 17.43079184046027, lng: 78.47736850104187 },
        { lat: 17.43074196681001, lng: 78.47735286789688 },
        { lat: 17.43070585843168, lng: 78.47735439366356 },
        { lat: 17.43065526564852, lng: 78.47737111260626 },
        { lat: 17.43063400292299, lng: 78.47738596051539 },
        { lat: 17.43057575252473, lng: 78.47742204475149 },
        { lat: 17.43052628666664, lng: 78.47743860138766 },
        { lat: 17.43045512235472, lng: 78.47743561105906 },
        { lat: 17.43040183439236, lng: 78.47741781940418 },
        { lat: 17.43036892431447, lng: 78.477404452055 },
        { lat: 17.43032591283871, lng: 78.47739578313269 },
        { lat: 17.43028859557825, lng: 78.47739100271933 },
        { lat: 17.43025567434524, lng: 78.47737675486172 },
        { lat: 17.43023068816006, lng: 78.47736504181633 },
        { lat: 17.43022916275085, lng: 78.47733375000271 },
        { lat: 17.4302184524093, lng: 78.47729038113808 },
        { lat: 17.43018623351943, lng: 78.47724245676802 },
        { lat: 17.43014963538196, lng: 78.47720532439855 },
        { lat: 17.43011391834659, lng: 78.47714862638989 },
        { lat: 17.43009494885133, lng: 78.47707714448066 },
        { lat: 17.43006724509496, lng: 78.47702915810274 },
        { lat: 17.43003408918451, lng: 78.47699638935377 },
        { lat: 17.429993111785, lng: 78.47697004904349 },
        { lat: 17.42995662162067, lng: 78.47694144160499 },
        { lat: 17.42992087846777, lng: 78.47688268729178 },
        { lat: 17.42988574257625, lng: 78.47678275897009 },
        { lat: 17.42985432457341, lng: 78.4767089493876 },
        { lat: 17.42983468992493, lng: 78.4766740829195 },
        { lat: 17.42982317847832, lng: 78.47665659959584 },
        { lat: 17.42979726278329, lng: 78.47666063107508 },
        { lat: 17.42976815069413, lng: 78.4766797023514 },
        { lat: 17.42971976528428, lng: 78.47669242234073 },
        { lat: 17.4296836830049, lng: 78.4766960064995 },
        { lat: 17.42965300254626, lng: 78.476680403225 },
        { lat: 17.42961920951478, lng: 78.476686454895 },
        { lat: 17.42959445055231, lng: 78.47669267589042 },
        { lat: 17.4295606295789, lng: 78.47669652250423 },
        { lat: 17.42951538098671, lng: 78.47668950096676 },
        { lat: 17.42951599012894, lng: 78.47664847565451 },
        { lat: 17.42954526612446, lng: 78.4766423393206 },
        { lat: 17.42959136972174, lng: 78.47662773883626 },
        { lat: 17.4296115855643, lng: 78.47661937487159 },
        { lat: 17.42963507044076, lng: 78.47660170387417 },
        { lat: 17.42967446275733, lng: 78.47659204874918 },
        { lat: 17.42968782200798, lng: 78.47657716275712 },
        { lat: 17.42971244313508, lng: 78.476560065115 },
        { lat: 17.42974615421431, lng: 78.47654754689323 },
        { lat: 17.42975951346043, lng: 78.47653266089185 },
        { lat: 17.42975576944577, lng: 78.47650448579866 },
        { lat: 17.42973180959384, lng: 78.47648467469533 },
        { lat: 17.42971134787186, lng: 78.47647363535269 },
        { lat: 17.42968198993934, lng: 78.47647330520122 },
        { lat: 17.42966069931509, lng: 78.47648594617763 },
        { lat: 17.42963585841644, lng: 78.47648570068216 },
        { lat: 17.42961545072209, lng: 78.47647892469281 },
        { lat: 17.42961165267516, lng: 78.47644648627457 },
        { lat: 17.42964189353329, lng: 78.47642739946033 },
        { lat: 17.42967995585424, lng: 78.4764018842042 },
        { lat: 17.42962997041527, lng: 78.4763774330634 },
        { lat: 17.42960967261308, lng: 78.47637932865514 },
        { lat: 17.42959634315832, lng: 78.47639656457395 },
        { lat: 17.42957072739327, lng: 78.47642426274032 },
        { lat: 17.42953690829105, lng: 78.47642825615429 },
        { lat: 17.42951655459986, lng: 78.47642574163895 },
        { lat: 17.42947480788198, lng: 78.47642778729991 },
        { lat: 17.42944544434673, lng: 78.4764270150123 },
        { lat: 17.42945192465231, lng: 78.47640384411649 },
        { lat: 17.42950108118228, lng: 78.47636288693765 },
        { lat: 17.42953583906623, lng: 78.47634388478062 },
        { lat: 17.42956952218392, lng: 78.47632916148761 },
        { lat: 17.42958723266005, lng: 78.47630127847634 },
        { lat: 17.42959378748519, lng: 78.47628398894778 },
        { lat: 17.42957773289075, lng: 78.47626436272301 },
        { lat: 17.4295496136539, lng: 78.47627268864254 },
        { lat: 17.42952394385296, lng: 78.47629612158799 },
        { lat: 17.42949469396035, lng: 78.47630431627117 },
        { lat: 17.42945737670239, lng: 78.47629953608167 },
        { lat: 17.4294368330225, lng: 78.47628203026211 },
        { lat: 17.42943862490773, lng: 78.47624525279745 },
        { lat: 17.42943488085933, lng: 78.47621707776426 },
        { lat: 17.42944455005963, lng: 78.47617828008195 },
        { lat: 17.42948476188939, lng: 78.4761442089526 },
        { lat: 17.42949801120012, lng: 78.47612065138846 },
        { lat: 17.42952010082531, lng: 78.4760819764114 },
        { lat: 17.42953786530052, lng: 78.47605835673524 },
        { lat: 17.42954659756628, lng: 78.47603471451086 },
        { lat: 17.4295429913446, lng: 78.47601741608183 },
        { lat: 17.42951801259549, lng: 78.47600629403733 },
        { lat: 17.42949327972989, lng: 78.47601457153107 },
        { lat: 17.42947279006547, lng: 78.47600132908833 },
        { lat: 17.42944874818946, lng: 78.4759750496916 },
        { lat: 17.42941650108714, lng: 78.47592492073197 },
        { lat: 17.42939135649942, lng: 78.47590071517537 },
        { lat: 17.42936301743271, lng: 78.47589169614749 },
        { lat: 17.42934167283603, lng: 78.47590007569964 },
        { lat: 17.42931148607288, lng: 78.47592342589581 },
        { lat: 17.4292608934382, lng: 78.47594014503555 },
        { lat: 17.42922720849435, lng: 78.47595472161113 },
        { lat: 17.42918107701472, lng: 78.47596711717127 },
        { lat: 17.42916083325737, lng: 78.47597327613319 },
        { lat: 17.42914521832491, lng: 78.47598833991881 },
        { lat: 17.4291283255581, lng: 78.47599166024646 },
        { lat: 17.4290954806218, lng: 78.47598343707539 },
        { lat: 17.42906270836941, lng: 78.4759809485243 },
        { lat: 17.42902431263473, lng: 78.47598015375632 },
        { lat: 17.42899032774517, lng: 78.47597106560353 },
        { lat: 17.42892191828128, lng: 78.47591819941073 },
        { lat: 17.42887992004406, lng: 78.47590039979167 },
        { lat: 17.42885505120475, lng: 78.47589794932115 },
        { lat: 17.42873546804139, lng: 78.47590503243906 },
        { lat: 17.42865989479142, lng: 78.47591048276212 },
        { lat: 17.42857655412309, lng: 78.47592662480825 },
        { lat: 17.42854625927121, lng: 78.47594144824025 },
        { lat: 17.42851026272011, lng: 78.4759517943512 },
        { lat: 17.42848087682334, lng: 78.4759492573409 },
        { lat: 17.42844361360099, lng: 78.47594874054258 },
        { lat: 17.42840632243115, lng: 78.47594601870799 },
        { lat: 17.42835650090947, lng: 78.47593450264489 },
        { lat: 17.42831813684109, lng: 78.47593620640625 },
        { lat: 17.42826385415721, lng: 78.47592901388472 },
        { lat: 17.42824333655006, lng: 78.47591356648853 },
        { lat: 17.42824307946576, lng: 78.47589328281548 },
        { lat: 17.42822719809696, lng: 78.47588732532986 },
        { lat: 17.42822563336864, lng: 78.47585294647824 },
        { lat: 17.42824134332924, lng: 78.47584538025839 },
        { lat: 17.42825722839515, lng: 78.47585162936178 },
        { lat: 17.42837113032109, lng: 78.47584168322862 },
        { lat: 17.42847484890029, lng: 78.47582996715853 },
        { lat: 17.42854491418013, lng: 78.47583532425061 },
        { lat: 17.42861599834143, lng: 78.47583199429879 },
        { lat: 17.42872420597465, lng: 78.4758181559131 },
        { lat: 17.42885384393195, lng: 78.47580270172595 },
        { lat: 17.42899353294156, lng: 78.47577858109587 },
        { lat: 17.42904079319879, lng: 78.475766169982 },
        { lat: 17.42906742774602, lng: 78.475729784761 },
        { lat: 17.42908849845325, lng: 78.47569979879398 },
        { lat: 17.42910271068234, lng: 78.4756631441059 },
        { lat: 17.42909885663606, lng: 78.47562629760753 },
        { lat: 17.4290750919873, lng: 78.47553282988193 },
        { lat: 17.42905708493772, lng: 78.47544825146134 },
        { lat: 17.42904472367834, lng: 78.4753637421655 },
        { lat: 17.42901536900184, lng: 78.47527461550042 },
        { lat: 17.42899925841447, lng: 78.47525057935019 },
        { lat: 17.42897879478563, lng: 78.47523939343571 },
        { lat: 17.42895031780724, lng: 78.4752194979554 },
        { lat: 17.42893365559441, lng: 78.47515195366184 },
        { lat: 17.42890237125182, lng: 78.4750887278668 },
        { lat: 17.42888257236045, lng: 78.47504092692628 },
        { lat: 17.42887970909034, lng: 78.47499318840484 },
        { lat: 17.42887257664094, lng: 78.47496491335063 },
        { lat: 17.42886866841517, lng: 78.47492380360399 },
        { lat: 17.42886952321865, lng: 78.47490217981637 },
        { lat: 17.42884454443056, lng: 78.47489105796062 },
        { lat: 17.42884187307775, lng: 78.4748584574614 },
        { lat: 17.42885947524858, lng: 78.47482204968662 },
        { lat: 17.42887599709783, lng: 78.47478948050984 },
        { lat: 17.42887566905679, lng: 78.47476361081112 },
        { lat: 17.4288731356052, lng: 78.47474188687276 },
        { lat: 17.42885159722562, lng: 78.47473497988388 },
        { lat: 17.42882670043096, lng: 78.47473032453493 },
        { lat: 17.42879963177323, lng: 78.47473246023806 },
        { lat: 17.4287826383848, lng: 78.47472784290782 },
        { lat: 17.42878563706861, lng: 78.47469722304383 },
        { lat: 17.42882025869984, lng: 78.47466749088022 },
        { lat: 17.42884592829274, lng: 78.47464405783738 },
        { lat: 17.42885471629531, lng: 78.47462482385868 },
        { lat: 17.42883513539811, lng: 78.47459422116496 },
        { lat: 17.42879762431132, lng: 78.47457415657783 },
        { lat: 17.42876190478075, lng: 78.47451731281664 },
        { lat: 17.42873040028795, lng: 78.47443674230406 },
        { lat: 17.42871616320372, lng: 78.4743823973448 },
        { lat: 17.428695481425, lng: 78.47435401339361 },
        { lat: 17.42867487981765, lng: 78.4743319510536 },
        { lat: 17.4286709379187, lng: 78.4742881960922 },
        { lat: 17.4286488290831, lng: 78.47423631170813 },
        { lat: 17.42861067105354, lng: 78.47416524167231 },
        { lat: 17.42856421062199, lng: 78.47406267807479 },
        { lat: 17.42855907646892, lng: 78.47401393973617 },
        { lat: 17.42858347922497, lng: 78.47397964565073 },
        { lat: 17.42858772030426, lng: 78.47395797529313 },
        { lat: 17.42854661211718, lng: 78.47392134823261 },
        { lat: 17.4285458465549, lng: 78.47377199435422 },
        { lat: 17.42855338144213, lng: 78.47365398542088 },
        { lat: 17.42855498265612, lng: 78.47360221508022 },
        { lat: 17.42856326709583, lng: 78.47354329614441 },
        { lat: 17.42857180698984, lng: 78.4735045141258 },
        { lat: 17.42861158194849, lng: 78.47343604827788 },
        { lat: 17.42864686594406, lng: 78.47336955421844 },
        { lat: 17.42866313761512, lng: 78.47331728642978 },
        { lat: 17.42869577979026, lng: 78.47322054370667 },
        { lat: 17.42872751320688, lng: 78.4731411613895 },
        { lat: 17.42874455552546, lng: 78.4730606584708 },
        { lat: 17.42874681908059, lng: 78.47297212636425 },
        { lat: 17.42873222346104, lng: 78.47288955826218 },
        { lat: 17.42872514668995, lng: 78.47286569342168 },
        { lat: 17.42870013795646, lng: 78.47285221819895 },
        { lat: 17.42867163280818, lng: 78.47283011811388 },
        { lat: 17.42863861063389, lng: 78.47280793346428 },
        { lat: 17.42862690489957, lng: 78.47277516393882 },
        { lat: 17.42863086419722, lng: 78.47273130025171 },
        { lat: 17.42865295499846, lng: 78.47269277190752 },
        { lat: 17.42868303313861, lng: 78.47266089658319 },
        { lat: 17.42869617196695, lng: 78.47262866743615 },
        { lat: 17.42869248153748, lng: 78.47260475597558 },
        { lat: 17.42867353666225, lng: 78.47253533358077 },
        { lat: 17.42867527189798, lng: 78.47249414626532 },
        { lat: 17.42867906507472, lng: 78.47243719912419 },
        { lat: 17.42870561874855, lng: 78.47239449386934 },
        { lat: 17.42874731869672, lng: 78.47238877478159 },
        { lat: 17.42877986144845, lng: 78.47237318404451 },
        { lat: 17.42879866096366, lng: 78.47234219976916 },
        { lat: 17.42881265611606, lng: 78.47228849358325 },
        { lat: 17.42884054563946, lng: 78.47226208847759 },
        { lat: 17.42887092596433, lng: 78.47225402630079 },
        { lat: 17.42889924085797, lng: 78.47226113319748 },
        { lat: 17.42893667003832, lng: 78.47227473081314 },
        { lat: 17.42896611372184, lng: 78.47228182216567 },
        { lat: 17.42898999369579, lng: 78.47229531286814 },
        { lat: 17.4290478605012, lng: 78.47231803777633 },
        { lat: 17.42912801020664, lng: 78.47231737596991 },
        { lat: 17.42920708707504, lng: 78.4723211379028 },
        { lat: 17.42928840846021, lng: 78.4723238395929 },
        { lat: 17.42932578538833, lng: 78.47233332066277 },
        { lat: 17.42937048360223, lng: 78.47238592498712 },
        { lat: 17.42940695003211, lng: 78.47241261981412 },
        { lat: 17.42945316699889, lng: 78.47240698524494 },
        { lat: 17.42950021235728, lng: 78.47237766854508 },
        { lat: 17.42952855337633, lng: 78.47238683376308 },
        { lat: 17.42954909923015, lng: 78.47240448773874 },
        { lat: 17.42960330539254, lng: 78.47240565107266 },
        { lat: 17.42966178045373, lng: 78.47238735083045 },
        { lat: 17.42969119617253, lng: 78.47239223905002 },
        { lat: 17.4297389411699, lng: 78.47241804278909 },
        { lat: 17.42978871241177, lng: 78.47242558994805 },
        { lat: 17.42986429098056, lng: 78.47242058024094 },
        { lat: 17.42991488690945, lng: 78.47240415359741 },
        { lat: 17.42995642450249, lng: 78.47238564440477 },
        { lat: 17.43003990645913, lng: 78.47238067257642 },
        { lat: 17.43009740570644, lng: 78.47237444032775 },
        { lat: 17.43019760867902, lng: 78.47235262586746 },
        { lat: 17.43028560951565, lng: 78.47234788530965 },
        { lat: 17.43031403264572, lng: 78.47236351894902 },
        { lat: 17.43034719107952, lng: 78.4723964335485 },
        { lat: 17.43038272090927, lng: 78.47243828402699 },
        { lat: 17.43044075004112, lng: 78.47247379727732 },
        { lat: 17.43050916402698, lng: 78.47252695592032 },
        { lat: 17.43055455443883, lng: 78.47254514844299 },
        { lat: 17.43061205369301, lng: 78.47253891620507 },
        { lat: 17.43066267761257, lng: 78.47252469455353 },
        { lat: 17.43077618537597, lng: 78.47248373035275 },
        { lat: 17.43081422468343, lng: 78.47245645123981 },
        { lat: 17.43084801933953, lng: 78.47245054549063 },
        { lat: 17.43087181721229, lng: 78.4724575678967 },
        { lat: 17.43088894682881, lng: 78.4724729149433 },
        { lat: 17.43092947878408, lng: 78.47246412382461 },
        { lat: 17.43100489315329, lng: 78.47244617905999 },
        { lat: 17.43103766911542, lng: 78.47244896233838 },
        { lat: 17.43108305953652, lng: 78.47246715487483 },
        { lat: 17.43112404114405, lng: 78.47249378772379 },
        { lat: 17.43116579703503, lng: 78.47249247674941 },
        { lat: 17.43117802715679, lng: 78.47247760779612 },
        { lat: 17.43119210436288, lng: 78.47243036932795 },
        { lat: 17.43123341058235, lng: 78.47239363433285 },
        { lat: 17.43126717912767, lng: 78.47238567211913 },
        { lat: 17.43131601188232, lng: 78.47240822625086 },
        { lat: 17.43135352318131, lng: 78.4724282924489 },
        { lat: 17.43139084415623, lng: 78.47243336533943 },
        { lat: 17.43141549654772, lng: 78.47241876557216 },
        { lat: 17.43145353394323, lng: 78.47239133769823 },
        { lat: 17.43149264786543, lng: 78.47235977763626 },
        { lat: 17.4315163785804, lng: 78.47236150938826 },
        { lat: 17.43152897625964, lng: 78.47237559600836 },
        { lat: 17.43153616323523, lng: 78.47240813468576 },
        { lat: 17.43156096675759, lng: 78.47240544075893 },
        { lat: 17.43159082833643, lng: 78.47235651505838 },
        { lat: 17.43163850980428, lng: 78.472288377319 },
        { lat: 17.43166426297617, lng: 78.47227155688986 },
        { lat: 17.43168453640682, lng: 78.47226774923442 },
        { lat: 17.43171397825774, lng: 78.4722746957579 },
        { lat: 17.43174154690635, lng: 78.47231195169523 },
        { lat: 17.43175771195602, lng: 78.47234024936694 },
        { lat: 17.43174889807707, lng: 78.47235742355124 },
        { lat: 17.43172308893734, lng: 78.47236983572196 },
        { lat: 17.43169846454606, lng: 78.47238664059448 },
        { lat: 17.43166822044538, lng: 78.47240543289394 },
        { lat: 17.43165061696063, lng: 78.47244169468084 },
        { lat: 17.43164085340353, lng: 78.47247299533278 },
        { lat: 17.43163553597993, lng: 78.4724987963705 },
        { lat: 17.43163842420005, lng: 78.47254844704182 },
        { lat: 17.43166255047557, lng: 78.47258134140554 },
        { lat: 17.43169124786149, lng: 78.47261858183856 },
        { lat: 17.43172316742749, lng: 78.47264284060823 },
        { lat: 17.43174817616949, lng: 78.47265631408332 },
        { lat: 17.4317643411981, lng: 78.47268461367469 },
        { lat: 17.43179736342287, lng: 78.47270679859945 },
        { lat: 17.43182223410674, lng: 78.4727093953687 },
        { lat: 17.43184686041579, lng: 78.47269273915737 },
        { lat: 17.43185562018555, lng: 78.47267129970524 },
        { lat: 17.4318696433238, lng: 78.47261979955623 },
        { lat: 17.43189087950368, lng: 78.47260289458764 },
        { lat: 17.43191907312616, lng: 78.4726004475344 },
        { lat: 17.43194474421863, lng: 78.47257715865163 },
        { lat: 17.43196504378559, lng: 78.47257540933741 },
        { lat: 17.43198997044913, lng: 78.47258241623314 },
        { lat: 17.43201508743038, lng: 78.47260441649804 },
        { lat: 17.4320469249198, lng: 78.47262220871507 },
        { lat: 17.43201690096351, lng: 78.4726583462182 },
        { lat: 17.43199136605698, lng: 78.47269236507655 },
        { lat: 17.43197121574513, lng: 78.47270587351191 },
        { lat: 17.43195901173936, lng: 78.47272280084272 },
        { lat: 17.43193336675301, lng: 78.47274814802795 },
        { lat: 17.43190384282999, lng: 78.4727347348423 },
        { lat: 17.43187450921297, lng: 78.47273631501824 },
        { lat: 17.43186588560272, lng: 78.47276848255743 },
        { lat: 17.43188207858254, lng: 78.47279898536797 },
        { lat: 17.43190259644325, lng: 78.47281443451261 },
        { lat: 17.43193080127227, lng: 78.47281286989637 },
        { lat: 17.43196005279111, lng: 78.4728048212667 },
        { lat: 17.43198591610003, lng: 78.4727966744062 },
        { lat: 17.4320188562176, lng: 78.47281239090782 },
        { lat: 17.43202251685148, lng: 78.47283395285456 },
        { lat: 17.43202066969475, lng: 78.47286632063904 },
        { lat: 17.43202879323535, lng: 78.47288370375753 },
        { lat: 17.43204943607689, lng: 78.47290900049698 },
        { lat: 17.43206645186627, lng: 78.47291538062298 },
        { lat: 17.43206453943576, lng: 78.47294260637892 },
        { lat: 17.43203548003883, lng: 78.47296579324048 },
        { lat: 17.43201325121385, lng: 78.47299344371302 },
        { lat: 17.43199223326772, lng: 78.47302754709848 },
        { lat: 17.43199592370202, lng: 78.47305145899588 },
        { lat: 17.43201200659183, lng: 78.47307329019782 },
        { lat: 17.43204847112572, lng: 78.47309983873144 },
        { lat: 17.43208050069952, lng: 78.47313276929502 },
        { lat: 17.43214205419753, lng: 78.47317911502125 },
        { lat: 17.4322105221625, lng: 78.47323653587559 },
        { lat: 17.43225591068461, lng: 78.47325458193865 },
        { lat: 17.4322934498898, lng: 78.47327685159388 },
        { lat: 17.43231743802003, lng: 78.47329886754085 },
        { lat: 17.43233699120906, lng: 78.47332726740082 },
        { lat: 17.43238667664079, lng: 78.47332805282893 },
        { lat: 17.43242835049421, lng: 78.47332027539265 },
        { lat: 17.43244168147803, lng: 78.4733031857467 },
        { lat: 17.43247991112927, lng: 78.47329089802385 },
        { lat: 17.43250037483689, lng: 78.47330208198281 },
        { lat: 17.43251183250195, lng: 78.47331530376172 },
        { lat: 17.432503070783, lng: 78.47333659463806 },
        { lat: 17.43246941411733, lng: 78.4733533770866 },
        { lat: 17.43245715595534, lng: 78.47336604102782 },
        { lat: 17.43243495505936, lng: 78.47339589660984 },
        { lat: 17.43243856153671, lng: 78.47341319522032 },
        { lat: 17.43245907933976, lng: 78.47342864259713 },
        { lat: 17.43248852117597, lng: 78.4734355893247 },
        { lat: 17.43250796428778, lng: 78.47345531565877 },
        { lat: 17.4325241030832, lng: 78.47348155523686 },
        { lat: 17.43262209301657, lng: 78.4735522429192 },
        { lat: 17.43267904734662, lng: 78.47359203583946 },
        { lat: 17.43274500774251, lng: 78.47362979285795 },
        { lat: 17.43278139015123, lng: 78.47364987310108 },
        { lat: 17.43281077788809, lng: 78.4736525564562 },
        { lat: 17.43284324424416, lng: 78.47363093912914 },
        { lat: 17.43283960980034, lng: 78.47361143538997 },
        { lat: 17.43282352697583, lng: 78.4735896059256 },
        { lat: 17.43282427339883, lng: 78.4735594567363 },
        { lat: 17.43283763235717, lng: 78.47354457026697 },
        { lat: 17.4328624489687, lng: 78.47354290561297 },
        { lat: 17.43288659935467, lng: 78.47357771002184 },
        { lat: 17.43290524379644, lng: 78.47362346895208 },
        { lat: 17.43293110528402, lng: 78.47361517538681 },
        { lat: 17.43295231543054, lng: 78.47359621207542 },
        { lat: 17.43295204123563, lng: 78.47357460336178 },
        { lat: 17.43294948149994, lng: 78.47355082253324 },
        { lat: 17.43293235193443, lng: 78.47353547522867 },
        { lat: 17.43292519308782, lng: 78.4735051413265 },
        { lat: 17.43296323249017, lng: 78.47347786014197 },
        { lat: 17.4329882113793, lng: 78.47348898384674 },
        { lat: 17.43301294590593, lng: 78.47348085067638 },
        { lat: 17.43303665237125, lng: 78.47348067098474 },
        { lat: 17.43304544021779, lng: 78.47346143837952 },
        { lat: 17.43305530088827, lng: 78.47343778005339 },
        { lat: 17.43307543632553, lng: 78.47342309567387 },
        { lat: 17.43310934108506, lng: 78.47342586356288 },
        { lat: 17.43314222523561, lng: 78.47343717195807 },
        { lat: 17.43316704184332, lng: 78.47343550728114 },
        { lat: 17.4332129585043, lng: 78.47340620564191 },
        { lat: 17.43324301056198, lng: 78.473372273068 },
        { lat: 17.43327624937185, lng: 78.47332256470828 },
        { lat: 17.43330712984634, lng: 78.4732649494781 },
        { lat: 17.43332029851504, lng: 78.47323507134588 },
        { lat: 17.43332640154454, lng: 78.47318220830837 },
        { lat: 17.43330509818074, lng: 78.47319382266275 },
        { lat: 17.43328289547038, lng: 78.47322353165949 },
        { lat: 17.43323772518301, lng: 78.47322268222112 },
        { lat: 17.43320043407843, lng: 78.47321996289347 },
        { lat: 17.43317652799804, lng: 78.47320441349574 },
        { lat: 17.43318870404772, lng: 78.47318528097928 },
        { lat: 17.43322236254703, lng: 78.4731686451725 },
        { lat: 17.43328981574366, lng: 78.47314610547475 },
        { lat: 17.43335170519347, lng: 78.47312996337344 },
        { lat: 17.43343140715389, lng: 78.47309402206884 },
        { lat: 17.4334975972198, lng: 78.47306091454539 },
        { lat: 17.43362434268742, lng: 78.47299551093883 },
        { lat: 17.4337161497198, lng: 78.47293485080682 },
        { lat: 17.4337541610453, lng: 78.47290536616114 },
        { lat: 17.43378690901953, lng: 78.4729059444005 },
        { lat: 17.43381971294858, lng: 78.47291093094822 },
        { lat: 17.43388275913968, lng: 78.47289697824486 },
        { lat: 17.43396926550707, lng: 78.47286344389921 },
        { lat: 17.43404104533936, lng: 78.47282599498338 },
        { lat: 17.43407010465518, lng: 78.47280280592207 },
        { lat: 17.43409494737142, lng: 78.47280319947656 },
        { lat: 17.4341075618357, lng: 78.47281860898758 },
        { lat: 17.43412794348735, lng: 78.47282332630473 },
        { lat: 17.43416961542722, lng: 78.47281540187122 },
        { lat: 17.43422357343753, lng: 78.47279701653994 },
        { lat: 17.43425187715837, lng: 78.47280324307988 },
        { lat: 17.43428032639962, lng: 78.47282093351026 },
        { lat: 17.43433170223064, lng: 78.47286594820321 },
        { lat: 17.43449207987907, lng: 78.47278184972417 },
        { lat: 17.43452221573557, lng: 78.47275453022523 },
        { lat: 17.43457701889348, lng: 78.47271378660488 },
        { lat: 17.43463086866099, lng: 78.47268687616256 },
        { lat: 17.4346559035757, lng: 78.4727024100325 },
        { lat: 17.43465848956918, lng: 78.47272824940192 },
        { lat: 17.43464168832273, lng: 78.47273877065105 },
        { lat: 17.43463739896594, lng: 78.47275662045011 },
        { lat: 17.43465344459081, lng: 78.47277551113659 },
        { lat: 17.43464914586827, lng: 78.47279262339279 },
        { lat: 17.43462576036871, lng: 78.47281808664918 },
        { lat: 17.43459955188936, lng: 78.47279904052412 },
        { lat: 17.43456680205641, lng: 78.47279831556565 },
        { lat: 17.43457280612295, lng: 78.47282660689035 },
        { lat: 17.43459447890061, lng: 78.47284409713933 },
        { lat: 17.43463892900147, lng: 78.4728771523877 },
        { lat: 17.43466388179493, lng: 78.47288621772636 },
        { lat: 17.43469304187066, lng: 78.47287096658499 },
        { lat: 17.43472559953937, lng: 78.47285655308691 },
        { lat: 17.43475845572585, lng: 78.47286565632801 },
        { lat: 17.43477176236975, lng: 78.47284665481929 },
        { lat: 17.43479299853214, lng: 78.47282974955938 },
        { lat: 17.43481701284243, lng: 78.47285382216465 },
        { lat: 17.43483836097174, lng: 78.47284573733 },
        { lat: 17.43485951502035, lng: 78.47282236349632 },
        { lat: 17.43489573333546, lng: 78.47282951036799 },
        { lat: 17.43490385688832, lng: 78.47284689185773 },
        { lat: 17.43487474159939, lng: 78.47286567082116 },
        { lat: 17.43484998099504, lng: 78.47287174583767 },
        { lat: 17.43483309579104, lng: 78.47287565364756 },
        { lat: 17.43481643076637, lng: 78.47289690691987 },
        { lat: 17.43481563036806, lng: 78.47292279296852 },
        { lat: 17.43483972677764, lng: 78.47295333415649 },
        { lat: 17.43486349479898, lng: 78.4729580048464 },
        { lat: 17.43488035201487, lng: 78.47295189193478 },
        { lat: 17.43491863758683, lng: 78.47294401412378 },
        { lat: 17.43495055716636, lng: 78.47296827330409 },
        { lat: 17.43493736061023, lng: 78.4729959485048 },
        { lat: 17.43490381222755, lng: 78.47302125633706 },
        { lat: 17.43488700910149, lng: 78.47303163082239 },
        { lat: 17.43486216640713, lng: 78.47303123913171 },
        { lat: 17.43482500961893, lng: 78.47303910137138 },
        { lat: 17.4347993105288, lng: 78.47306018551245 },
        { lat: 17.43478608780585, lng: 78.4730858004516 },
        { lat: 17.43478641430966, lng: 78.47311152419329 },
        { lat: 17.43480599553239, lng: 78.47314212760121 },
        { lat: 17.43483383462612, lng: 78.47320069778958 },
        { lat: 17.43486933271221, lng: 78.47324005072923 },
        { lat: 17.43488974234835, lng: 78.47324697321105 },
        { lat: 17.43492636921807, lng: 78.47328631062335 },
        { lat: 17.43495853503126, lng: 78.4733299737057 },
        { lat: 17.43501807534101, lng: 78.47339560451572 },
        { lat: 17.43504643316561, lng: 78.47340609462566 },
        { lat: 17.43510520860842, lng: 78.47341145933999 },
        { lat: 17.43513357574554, lng: 78.47342268323855 },
        { lat: 17.43514863990765, lng: 78.47345320217167 },
        { lat: 17.4351523004964, lng: 78.47347476261898 },
        { lat: 17.43514821998554, lng: 78.47350907366173 },
        { lat: 17.4351633102576, lng: 78.47354165096189 },
        { lat: 17.43521235936566, lng: 78.47358125775057 },
        { lat: 17.43526476874236, lng: 78.47361876144508 },
        { lat: 17.43530139555724, lng: 78.47365809901203 },
        { lat: 17.43532452723473, lng: 78.47370159122342 },
        { lat: 17.4353363113085, lng: 78.47374053515985 },
        { lat: 17.43536024349508, lng: 78.47375814313556 },
        { lat: 17.43538963120684, lng: 78.47376082460652 },
        { lat: 17.43541439185038, lng: 78.47375474967825 },
        { lat: 17.43543466345137, lng: 78.47375079528993 },
        { lat: 17.43547647160796, lng: 78.47375360115154 },
        { lat: 17.43549659957032, lng: 78.4737383276629 },
        { lat: 17.43602626894802, lng: 78.47433238031972 },
        { lat: 17.43608861702147, lng: 78.4742704412411 },
        { lat: 17.4363558578993, lng: 78.47399805573951 },
        { lat: 17.43670692442852, lng: 78.47360362924071 },
        { lat: 17.43677928186625, lng: 78.47346978404818 },
        { lat: 17.43691802450897, lng: 78.47331494313347 },
        { lat: 17.43713966761499, lng: 78.47299137040436 },
        { lat: 17.4373484941295, lng: 78.47255343499972 },
        { lat: 17.43747091848835, lng: 78.47220965085792 },
        { lat: 17.43756945907822, lng: 78.47172470323827 },
        { lat: 17.43760876566043, lng: 78.47141737142313 },
        { lat: 17.43761697093732, lng: 78.47115124045393 },
        { lat: 17.43760803309363, lng: 78.4707093725989 },
        { lat: 17.43754310550785, lng: 78.47030814592952 },
        { lat: 17.43724818055451, lng: 78.4688000736487 },
        { lat: 17.43705178829247, lng: 78.46798482450842 },
        { lat: 17.43688165710412, lng: 78.46756566092718 },
        { lat: 17.43669060822121, lng: 78.46720548518114 },
        { lat: 17.43645673963996, lng: 78.46689180130882 },
        { lat: 17.43620536343883, lng: 78.46662993717325 },
        { lat: 17.43584448628704, lng: 78.46632902545221 },
        { lat: 17.43544453589827, lng: 78.46605683674792 },
        { lat: 17.43496143550681, lng: 78.46578842677758 },
        { lat: 17.43418333676781, lng: 78.4653155842202 },
        { lat: 17.43362710385412, lng: 78.46491274772869 },
        { lat: 17.43291551681945, lng: 78.46449740522266 },
        { lat: 17.432668291344, lng: 78.4643339854853 },
        { lat: 17.43368786235141, lng: 78.4643607717471 },
        { lat: 17.43395095349064, lng: 78.46442364851391 },
        { lat: 17.4343660072487, lng: 78.46443801314449 },
        { lat: 17.43484075877238, lng: 78.46436387432546 },
        { lat: 17.43511290599228, lng: 78.46428392258596 },
        { lat: 17.43541846277175, lng: 78.46418354357694 },
        { lat: 17.43587708751344, lng: 78.46393335052029 },
        { lat: 17.43610420612891, lng: 78.46380086613595 },
        { lat: 17.43670733820506, lng: 78.46327399164669 },
        { lat: 17.43705592307014, lng: 78.4628529688216 },
        { lat: 17.43737133593115, lng: 78.46231308853244 },
        { lat: 17.43790902751994, lng: 78.46114856111416 },
        { lat: 17.43812246555711, lng: 78.4605364532165 },
        { lat: 17.4383879940865, lng: 78.45907657708041 },
        { lat: 17.4386859808202, lng: 78.45744290977979 },
        { lat: 17.43899481081204, lng: 78.45669483319502 },
        { lat: 17.43935347537208, lng: 78.45607170638182 },
        { lat: 17.43994172280218, lng: 78.45529461960528 },
        { lat: 17.44073807332421, lng: 78.4545699225471 },
      ],
    ],
  },
  {
    name: "SERILINGAMPALLY ZONE",
    color: "#2ecc71",
    polygons: [
      [
        { lat: 17.4838963389281, lng: 78.28404677762406 },
        { lat: 17.48452462264134, lng: 78.28106953272403 },
        { lat: 17.48081787397091, lng: 78.28118439387087 },
        { lat: 17.48087603127497, lng: 78.28393608094339 },
        { lat: 17.47978992297998, lng: 78.2839611011475 },
        { lat: 17.47990953917522, lng: 78.28800452993552 },
        { lat: 17.4789271354727, lng: 78.28804177162803 },
        { lat: 17.47894976014916, lng: 78.28864894552878 },
        { lat: 17.47894727296414, lng: 78.28916685947205 },
        { lat: 17.47896416505288, lng: 78.28970440604846 },
        { lat: 17.47992450956038, lng: 78.28969017700274 },
        { lat: 17.47995861342913, lng: 78.2896642384932 },
        { lat: 17.47995915216906, lng: 78.28968240836667 },
        { lat: 17.4800544356209, lng: 78.28966107964482 },
        { lat: 17.48033539910823, lng: 78.28923862642338 },
        { lat: 17.4838963389281, lng: 78.28404677762406 },
      ],
      [
        { lat: 17.49173447601087, lng: 78.28261038508876 },
        { lat: 17.49808943872252, lng: 78.28239985274313 },
        { lat: 17.49787442903794, lng: 78.28214776898058 },
        { lat: 17.49760487026166, lng: 78.28197772492575 },
        { lat: 17.49695967208724, lng: 78.28202213209985 },
        { lat: 17.4969337539411, lng: 78.28175563530444 },
        { lat: 17.4968758661204, lng: 78.28159404559092 },
        { lat: 17.49625261735986, lng: 78.28161492118926 },
        { lat: 17.49624689610446, lng: 78.28119727962236 },
        { lat: 17.49392087962469, lng: 78.28127829631133 },
        { lat: 17.49389162171519, lng: 78.28076818450067 },
        { lat: 17.49163573821782, lng: 78.28109182503617 },
        { lat: 17.49173447601087, lng: 78.28261038508876 },
      ],
      [
        { lat: 17.54769959564436, lng: 78.28167372309137 },
        { lat: 17.54863316142702, lng: 78.2819715848643 },
        { lat: 17.54956717531634, lng: 78.2823007763343 },
        { lat: 17.55056020451953, lng: 78.28256656200881 },
        { lat: 17.55106306575896, lng: 78.28215357518474 },
        { lat: 17.5517149235176, lng: 78.28164463681668 },
        { lat: 17.5522814880907, lng: 78.28141781520789 },
        { lat: 17.5537729255838, lng: 78.2809586380396 },
        { lat: 17.55397604155871, lng: 78.28045642824922 },
        { lat: 17.55402927144031, lng: 78.27998765650082 },
        { lat: 17.55386736291039, lng: 78.27917904900461 },
        { lat: 17.55370524630031, lng: 78.27827688041582 },
        { lat: 17.55329835662088, lng: 78.27709755576223 },
        { lat: 17.5526504988249, lng: 78.2758282989946 },
        { lat: 17.55170200159034, lng: 78.27440764000669 },
        { lat: 17.55163718934641, lng: 78.2740655515002 },
        { lat: 17.55152490066179, lng: 78.27253860238316 },
        { lat: 17.55123758365831, lng: 78.27126394530256 },
        { lat: 17.55104804057302, lng: 78.2705805270249 },
        { lat: 17.55100412386208, lng: 78.26964541751317 },
        { lat: 17.55041904626299, lng: 78.2685000111839 },
        { lat: 17.54964641083496, lng: 78.26688963589878 },
        { lat: 17.54777680263786, lng: 78.26604446810411 },
        { lat: 17.54752755106312, lng: 78.2654555342566 },
        { lat: 17.54733933191444, lng: 78.26486568113646 },
        { lat: 17.54771630943013, lng: 78.26395542170712 },
        { lat: 17.54810178533991, lng: 78.2636375816393 },
        { lat: 17.54878700430825, lng: 78.26340892172244 },
        { lat: 17.54917874775102, lng: 78.26352774982428 },
        { lat: 17.54996110421502, lng: 78.26376542513711 },
        { lat: 17.55062320474824, lng: 78.26397387884624 },
        { lat: 17.55110155611609, lng: 78.2639042754545 },
        { lat: 17.55196672605167, lng: 78.26361036914525 },
        { lat: 17.55225953702766, lng: 78.26313798191684 },
        { lat: 17.55237218549312, lng: 78.26263727887519 },
        { lat: 17.5523623315292, lng: 78.26195115192344 },
        { lat: 17.55217499579996, lng: 78.26142364892264 },
        { lat: 17.55201660020977, lng: 78.26086452481057 },
        { lat: 17.55194638454268, lng: 78.26014812589332 },
        { lat: 17.5516973472502, lng: 78.25949681075221 },
        { lat: 17.55151449212078, lng: 78.25928126768889 },
        { lat: 17.54990804121667, lng: 78.2580266159358 },
        { lat: 17.54977162884408, lng: 78.25687446689177 },
        { lat: 17.54957171453429, lng: 78.25547378765788 },
        { lat: 17.54940904677614, lng: 78.25454049655106 },
        { lat: 17.54966637518543, lng: 78.25372544114933 },
        { lat: 17.54989386661628, lng: 78.25287979510327 },
        { lat: 17.55081352477053, lng: 78.25221076767545 },
        { lat: 17.55140673577318, lng: 78.25179633281444 },
        { lat: 17.55142376170499, lng: 78.25086016376156 },
        { lat: 17.55120138504668, lng: 78.25002133976805 },
        { lat: 17.55107707485851, lng: 78.24971120966124 },
        { lat: 17.55038603187676, lng: 78.24953458307684 },
        { lat: 17.54948452556059, lng: 78.24942352841592 },
        { lat: 17.54906563946956, lng: 78.24946107806996 },
        { lat: 17.54847108509995, lng: 78.24978197213235 },
        { lat: 17.54805624763679, lng: 78.25010028543124 },
        { lat: 17.54797594992957, lng: 78.250725382874 },
        { lat: 17.54766388831091, lng: 78.25197787693352 },
        { lat: 17.54748641967052, lng: 78.2521365016824 },
        { lat: 17.54700717824001, lng: 78.25214377216255 },
        { lat: 17.54667623436328, lng: 78.25208641945143 },
        { lat: 17.54652523867874, lng: 78.25196396457014 },
        { lat: 17.54634552273526, lng: 78.25196669339864 },
        { lat: 17.54613798630017, lng: 78.25215695716591 },
        { lat: 17.5456901595574, lng: 78.25222612480215 },
        { lat: 17.54533342334122, lng: 78.25241865173425 },
        { lat: 17.54509425151501, lng: 78.25245346604495 },
        { lat: 17.54506148806686, lng: 78.25229803254027 },
        { lat: 17.5449100435976, lng: 78.252144399442 },
        { lat: 17.54454858310908, lng: 78.25208751083693 },
        { lat: 17.54394863041672, lng: 78.25203423907321 },
        { lat: 17.54367557727074, lng: 78.25175756098848 },
        { lat: 17.54340543718437, lng: 78.25176165906507 },
        { lat: 17.54313822630372, lng: 78.25189045435255 },
        { lat: 17.54289815473952, lng: 78.25186291234601 },
        { lat: 17.54297936064365, lng: 78.25130033559735 },
        { lat: 17.54216378023809, lng: 78.25087596296731 },
        { lat: 17.5412295204304, lng: 78.25045339567241 },
        { lat: 17.54095488745433, lng: 78.25014571140206 },
        { lat: 17.54116107252377, lng: 78.2498617658134 },
        { lat: 17.54011036885072, lng: 78.24975297104335 },
        { lat: 17.53923982844422, lng: 78.24967262836272 },
        { lat: 17.53884426540542, lng: 78.24921071030269 },
        { lat: 17.53884981267783, lng: 78.24755752885837 },
        { lat: 17.53893078527665, lng: 78.24690126773706 },
        { lat: 17.53935700215843, lng: 78.24533524767394 },
        { lat: 17.53978433030374, lng: 78.24376905721327 },
        { lat: 17.54018203069346, lng: 78.24226583012403 },
        { lat: 17.54055664790181, lng: 78.24119968740008 },
        { lat: 17.54065886413436, lng: 78.2399816176816 },
        { lat: 17.54079903669471, lng: 78.23935563313955 },
        { lat: 17.54121295345904, lng: 78.23897495638754 },
        { lat: 17.54025628273297, lng: 78.23911427374429 },
        { lat: 17.53818991042021, lng: 78.23920827229003 },
        { lat: 17.53795299919545, lng: 78.23939898861417 },
        { lat: 17.53648070745997, lng: 78.2391406094502 },
        { lat: 17.53576230142742, lng: 78.23918273513407 },
        { lat: 17.53501631466105, lng: 78.23935016691449 },
        { lat: 17.53373636955308, lng: 78.23996229966063 },
        { lat: 17.53299646403355, lng: 78.24062857283944 },
        { lat: 17.53216185396471, lng: 78.24092193031626 },
        { lat: 17.53067279823444, lng: 78.24153722119165 },
        { lat: 17.52868118884231, lng: 78.24265907488859 },
        { lat: 17.52857038742047, lng: 78.24328457022753 },
        { lat: 17.5290249636823, lng: 78.2436831876725 },
        { lat: 17.52942031540598, lng: 78.2440515229901 },
        { lat: 17.52948787340456, lng: 78.24458061159633 },
        { lat: 17.52931176071127, lng: 78.2448329018917 },
        { lat: 17.52862993713102, lng: 78.24537337595036 },
        { lat: 17.52714842735597, lng: 78.24439788023219 },
        { lat: 17.5269038537782, lng: 78.24405843793008 },
        { lat: 17.52626978502629, lng: 78.24375624640447 },
        { lat: 17.52555137451664, lng: 78.24379834835992 },
        { lat: 17.52476279628101, lng: 78.24524501941906 },
        { lat: 17.52563963411481, lng: 78.24576195426346 },
        { lat: 17.52650949290758, lng: 78.24587347453932 },
        { lat: 17.52645498676412, lng: 78.24624864329428 },
        { lat: 17.52523559411444, lng: 78.24682859155162 },
        { lat: 17.52533567829741, lng: 78.24757560177143 },
        { lat: 17.52567111726864, lng: 78.2479447030478 },
        { lat: 17.52591792959027, lng: 78.24844003111073 },
        { lat: 17.52585536801437, lng: 78.25037475196262 },
        { lat: 17.52575441805134, lng: 78.25168625402124 },
        { lat: 17.52542819564285, lng: 78.25187829234736 },
        { lat: 17.52528325597016, lng: 78.25225482930848 },
        { lat: 17.52429582940503, lng: 78.25230097083106 },
        { lat: 17.52360051534054, lng: 78.25190598618477 },
        { lat: 17.52184037095609, lng: 78.25246289549249 },
        { lat: 17.52097476548533, lng: 78.2527254613009 },
        { lat: 17.51954735683064, lng: 78.25134360514785 },
        { lat: 17.5188592250482, lng: 78.25144757523863 },
        { lat: 17.51810019859348, lng: 78.25283135325196 },
        { lat: 17.51734408723899, lng: 78.25237508031253 },
        { lat: 17.51655903349837, lng: 78.25195028343833 },
        { lat: 17.51654467142781, lng: 78.25095240743109 },
        { lat: 17.51585474554958, lng: 78.25093167706589 },
        { lat: 17.51580920229788, lng: 78.25193045690644 },
        { lat: 17.51486103366696, lng: 78.25266212294336 },
        { lat: 17.51435150312449, lng: 78.25260747552755 },
        { lat: 17.51398668698905, lng: 78.25223868061147 },
        { lat: 17.51371654691483, lng: 78.25224277250047 },
        { lat: 17.51320858024895, lng: 78.25237533085993 },
        { lat: 17.51252651041128, lng: 78.25282218289776 },
        { lat: 17.51213880084218, lng: 78.25298395445107 },
        { lat: 17.51201091866644, lng: 78.25242464266199 },
        { lat: 17.51167617134815, lng: 78.25202421773436 },
        { lat: 17.51104301010763, lng: 78.2517843600676 },
        { lat: 17.5099985845767, lng: 78.25211197424753 },
        { lat: 17.50929720638812, lng: 78.25333890257542 },
        { lat: 17.50859985273593, lng: 78.25484638367796 },
        { lat: 17.50777013491572, lng: 78.25548267164035 },
        { lat: 17.50700614028803, lng: 78.25652344323365 },
        { lat: 17.50680575401082, lng: 78.25721257303076 },
        { lat: 17.50642275078036, lng: 78.25762369256694 },
        { lat: 17.50734718032229, lng: 78.26153926912066 },
        { lat: 17.50887892289726, lng: 78.26176560432623 },
        { lat: 17.50990045491636, lng: 78.26196860482297 },
        { lat: 17.51104447923688, lng: 78.26235669600568 },
        { lat: 17.51212615385574, lng: 78.26249643056373 },
        { lat: 17.51269559013313, lng: 78.26255020612247 },
        { lat: 17.51423046101822, lng: 78.26299477120324 },
        { lat: 17.5167588185651, lng: 78.2637363205358 },
        { lat: 17.51745119548663, lng: 78.26400666188026 },
        { lat: 17.51872218058699, lng: 78.26489191838785 },
        { lat: 17.51867120766131, lng: 78.26551646865742 },
        { lat: 17.52260552991897, lng: 78.268201820741 },
        { lat: 17.52143506483225, lng: 78.27015319951724 },
        { lat: 17.519454385206, lng: 78.27205437325827 },
        { lat: 17.51882080639394, lng: 78.2738417191291 },
        { lat: 17.51785490514788, lng: 78.27753643787862 },
        { lat: 17.51691373872994, lng: 78.27876694702154 },
        { lat: 17.51595987734488, lng: 78.27918661236286 },
        { lat: 17.51470938583541, lng: 78.27973559398144 },
        { lat: 17.5142390174252, lng: 78.28036642078976 },
        { lat: 17.51382277625241, lng: 78.2805909285643 },
        { lat: 17.51427773199679, lng: 78.28102079812493 },
        { lat: 17.51426792057256, lng: 78.28168149224274 },
        { lat: 17.51424999996631, lng: 78.2823469888562 },
        { lat: 17.51424217783595, lng: 78.28234634953039 },
        { lat: 17.51422799691838, lng: 78.28292430121444 },
        { lat: 17.51357466514979, lng: 78.28372094705848 },
        { lat: 17.51308282749684, lng: 78.28339955283172 },
        { lat: 17.51285154981963, lng: 78.28326105204162 },
        { lat: 17.51256324573722, lng: 78.28314581008638 },
        { lat: 17.51245366776563, lng: 78.28309998688 },
        { lat: 17.51157581617462, lng: 78.28277667347466 },
        { lat: 17.50962230140005, lng: 78.28230687855584 },
        { lat: 17.50796985465842, lng: 78.2820196646135 },
        { lat: 17.5075707651885, lng: 78.28201960954813 },
        { lat: 17.50670176245209, lng: 78.28530653991244 },
        { lat: 17.5021324962902, lng: 78.2854197070227 },
        { lat: 17.50228140793084, lng: 78.29173159417499 },
        { lat: 17.50306610886618, lng: 78.29170810604522 },
        { lat: 17.50382983795597, lng: 78.29166050241489 },
        { lat: 17.50404111607744, lng: 78.29162263815785 },
        { lat: 17.50505620286279, lng: 78.29122800371289 },
        { lat: 17.50609942006896, lng: 78.29080765584756 },
        { lat: 17.50713491957412, lng: 78.29038940559535 },
        { lat: 17.50728514222779, lng: 78.29032749886213 },
        { lat: 17.5074188750873, lng: 78.29027328983389 },
        { lat: 17.50757639025387, lng: 78.29021490382208 },
        { lat: 17.50773681299369, lng: 78.29015543831254 },
        { lat: 17.50799959572708, lng: 78.29005803302498 },
        { lat: 17.50822416563157, lng: 78.28996525475918 },
        { lat: 17.50833449289432, lng: 78.28991967387563 },
        { lat: 17.50839416184921, lng: 78.28989502454425 },
        { lat: 17.50867709245461, lng: 78.2897458435451 },
        { lat: 17.50884644576863, lng: 78.28963637625114 },
        { lat: 17.50887018589709, lng: 78.28962091889352 },
        { lat: 17.50905225552894, lng: 78.28948906675575 },
        { lat: 17.50910607784948, lng: 78.28945027425804 },
        { lat: 17.50915966290133, lng: 78.2894196274035 },
        { lat: 17.50922040028187, lng: 78.28938567528074 },
        { lat: 17.50936145221166, lng: 78.28930682709982 },
        { lat: 17.50938665235225, lng: 78.28929274092121 },
        { lat: 17.50943453507998, lng: 78.28926035649485 },
        { lat: 17.5097229429451, lng: 78.28906201796738 },
        { lat: 17.50984490350244, lng: 78.28897522963057 },
        { lat: 17.51007871890358, lng: 78.28880884270491 },
        { lat: 17.5105586391713, lng: 78.2896128695114 },
        { lat: 17.51054306726395, lng: 78.28987208428767 },
        { lat: 17.51041690812383, lng: 78.29043176721112 },
        { lat: 17.51034373021258, lng: 78.29067191646547 },
        { lat: 17.51034726748936, lng: 78.29093084655045 },
        { lat: 17.5103480679156, lng: 78.29093252128061 },
        { lat: 17.51037399929734, lng: 78.29119290272541 },
        { lat: 17.51040908213598, lng: 78.29135635305252 },
        { lat: 17.51043826728946, lng: 78.2916321802837 },
        { lat: 17.51043721942808, lng: 78.29182141691746 },
        { lat: 17.51052982706674, lng: 78.292221189062 },
        { lat: 17.51057161328729, lng: 78.2926128258016 },
        { lat: 17.51056116472464, lng: 78.2929208370905 },
        { lat: 17.51045067598877, lng: 78.29327275561843 },
        { lat: 17.51023667318001, lng: 78.29372215946366 },
        { lat: 17.51001273755417, lng: 78.2942421508216 },
        { lat: 17.50982751640023, lng: 78.29450601837591 },
        { lat: 17.50952575161137, lng: 78.29495917336128 },
        { lat: 17.50925995290297, lng: 78.29537255715239 },
        { lat: 17.50900213273704, lng: 78.29575573577966 },
        { lat: 17.50857736558477, lng: 78.29632564988043 },
        { lat: 17.50843432942306, lng: 78.29652088196266 },
        { lat: 17.50843121137005, lng: 78.29652176389486 },
        { lat: 17.50829231300589, lng: 78.29669341715778 },
        { lat: 17.50807730296703, lng: 78.29700674874726 },
        { lat: 17.50807787874885, lng: 78.29700897364187 },
        { lat: 17.50804308218484, lng: 78.29705662012185 },
        { lat: 17.50783450751487, lng: 78.29737238929276 },
        { lat: 17.50775954878391, lng: 78.29752659063311 },
        { lat: 17.50770924160076, lng: 78.29763580771613 },
        { lat: 17.50767305366711, lng: 78.29771537013589 },
        { lat: 17.50762337022435, lng: 78.29786653462959 },
        { lat: 17.50753619089754, lng: 78.2980901023522 },
        { lat: 17.50746020804565, lng: 78.29819886799856 },
        { lat: 17.50736596194707, lng: 78.2983886406642 },
        { lat: 17.50731643500485, lng: 78.29854411022284 },
        { lat: 17.50728033940719, lng: 78.29863353260212 },
        { lat: 17.50726761406265, lng: 78.2986634356466 },
        { lat: 17.50724136794712, lng: 78.29872014008136 },
        { lat: 17.50723528047484, lng: 78.29874714304684 },
        { lat: 17.50719241015935, lng: 78.29882093758073 },
        { lat: 17.50720635382244, lng: 78.29980666577711 },
        { lat: 17.50709181093071, lng: 78.2997487171337 },
        { lat: 17.50540586489633, lng: 78.29889579908259 },
        { lat: 17.50349974778478, lng: 78.30346834179473 },
        { lat: 17.50374796699623, lng: 78.30364116568309 },
        { lat: 17.50283056695477, lng: 78.30575952311956 },
        { lat: 17.5025026807738, lng: 78.30561594750819 },
        { lat: 17.50173499686145, lng: 78.30625564105483 },
        { lat: 17.50165415558958, lng: 78.3066159982788 },
        { lat: 17.50232720927124, lng: 78.30736830143049 },
        { lat: 17.50240318788578, lng: 78.30736311944223 },
        { lat: 17.50266709287592, lng: 78.30734511948314 },
        { lat: 17.50317805363184, lng: 78.30736485560159 },
        { lat: 17.50336481669099, lng: 78.30735728467181 },
        { lat: 17.50377200902511, lng: 78.30734021769284 },
        { lat: 17.5049449651118, lng: 78.3072759479493 },
        { lat: 17.50510682393422, lng: 78.3073446368957 },
        { lat: 17.50506117116493, lng: 78.30742501199 },
        { lat: 17.50498189939943, lng: 78.30756535422708 },
        { lat: 17.50491862719382, lng: 78.30768644323369 },
        { lat: 17.50481233754483, lng: 78.30786464768089 },
        { lat: 17.50452437427655, lng: 78.30837087336246 },
        { lat: 17.50429609394554, lng: 78.30878412124096 },
        { lat: 17.50417638019858, lng: 78.30899432148622 },
        { lat: 17.50389246694443, lng: 78.30951428638078 },
        { lat: 17.50359713976999, lng: 78.31006002505445 },
        { lat: 17.50336151716127, lng: 78.31048888184046 },
        { lat: 17.50329430590813, lng: 78.31060014657773 },
        { lat: 17.50326048860606, lng: 78.31065382300366 },
        { lat: 17.50317295382629, lng: 78.31079078128143 },
        { lat: 17.50304964806297, lng: 78.31096282079399 },
        { lat: 17.50291090445953, lng: 78.31114563586533 },
        { lat: 17.50265226440887, lng: 78.31143991515546 },
        { lat: 17.50251038780844, lng: 78.31157157369056 },
        { lat: 17.50230022867773, lng: 78.31174396790813 },
        { lat: 17.50218304194114, lng: 78.31182434597052 },
        { lat: 17.50179003918312, lng: 78.31206805159948 },
        { lat: 17.50072792647034, lng: 78.3126533049591 },
        { lat: 17.50055986099688, lng: 78.3127502272422 },
        { lat: 17.49956297355977, lng: 78.31332707202864 },
        { lat: 17.49886848413299, lng: 78.31372636565065 },
        { lat: 17.49864997940047, lng: 78.313846109303 },
        { lat: 17.497850783513, lng: 78.31424290014117 },
        { lat: 17.49701949284901, lng: 78.31464567283918 },
        { lat: 17.49650968827213, lng: 78.31493398670649 },
        { lat: 17.49619827616829, lng: 78.31516956633914 },
        { lat: 17.4958121623564, lng: 78.31565689861785 },
        { lat: 17.4954997979737, lng: 78.31614842549162 },
        { lat: 17.49490964363293, lng: 78.31548872486115 },
        { lat: 17.49327961208843, lng: 78.3152668927103 },
        { lat: 17.4930169907884, lng: 78.31518301603171 },
        { lat: 17.49285230112773, lng: 78.31503934357995 },
        { lat: 17.49264917941268, lng: 78.31491116009676 },
        { lat: 17.491725382387, lng: 78.31454434886494 },
        { lat: 17.49127278977461, lng: 78.31435097128373 },
        { lat: 17.49055858509665, lng: 78.31412536786742 },
        { lat: 17.48910700399142, lng: 78.31382206413132 },
        { lat: 17.48803410369966, lng: 78.31359845513457 },
        { lat: 17.48660755729428, lng: 78.31328495197168 },
        { lat: 17.48615707285171, lng: 78.31309843421793 },
        { lat: 17.48611277036666, lng: 78.31307851518793 },
        { lat: 17.48601842431113, lng: 78.31303179379614 },
        { lat: 17.48566120026255, lng: 78.31285488985263 },
        { lat: 17.48554295883336, lng: 78.31278874976849 },
        { lat: 17.48563485688672, lng: 78.31263013091535 },
        { lat: 17.48565062705877, lng: 78.31258365199838 },
        { lat: 17.48565555724026, lng: 78.31256658564435 },
        { lat: 17.48570421999905, lng: 78.31231101937229 },
        { lat: 17.485709494804, lng: 78.3122985987265 },
        { lat: 17.48571275741313, lng: 78.3122633527556 },
        { lat: 17.4857132509709, lng: 78.31223536645759 },
        { lat: 17.48570841538187, lng: 78.31203879469139 },
        { lat: 17.48569574511695, lng: 78.31178824528017 },
        { lat: 17.48567754760531, lng: 78.31157758081116 },
        { lat: 17.48563510988706, lng: 78.31106946306487 },
        { lat: 17.48553676701438, lng: 78.31015959758163 },
        { lat: 17.48546042619391, lng: 78.30928675905402 },
        { lat: 17.4854114528129, lng: 78.30884676272846 },
        { lat: 17.48531945732955, lng: 78.30787705057057 },
        { lat: 17.48521826408599, lng: 78.3067580801443 },
        { lat: 17.48510039930563, lng: 78.30546755273787 },
        { lat: 17.4850312056386, lng: 78.30459461471982 },
        { lat: 17.48496434057185, lng: 78.30389344885937 },
        { lat: 17.48470392185829, lng: 78.30108121320515 },
        { lat: 17.48460563605889, lng: 78.30017883218876 },
        { lat: 17.48448783124191, lng: 78.29889578924852 },
        { lat: 17.48445556153835, lng: 78.29810448244231 },
        { lat: 17.48441381421048, lng: 78.29806468743718 },
        { lat: 17.48441359795458, lng: 78.2980461395697 },
        { lat: 17.48457155785437, lng: 78.29804095894042 },
        { lat: 17.48453048491528, lng: 78.2978048408362 },
        { lat: 17.48453443339336, lng: 78.29772024445002 },
        { lat: 17.48432683601131, lng: 78.2952227291421 },
        { lat: 17.48055402050941, lng: 78.29561902271864 },
        { lat: 17.4794941316317, lng: 78.29577301958379 },
        { lat: 17.47878063797469, lng: 78.29586869058797 },
        { lat: 17.47877317966911, lng: 78.29607096916591 },
        { lat: 17.47859361014059, lng: 78.29638219619355 },
        { lat: 17.4785470523628, lng: 78.29671273838115 },
        { lat: 17.47853097741913, lng: 78.29703218800549 },
        { lat: 17.47841396535519, lng: 78.29743825595472 },
        { lat: 17.4783745758856, lng: 78.29754524059132 },
        { lat: 17.47773674912417, lng: 78.29790398639666 },
        { lat: 17.4774818238881, lng: 78.29725038056915 },
        { lat: 17.4768212902803, lng: 78.2956558579774 },
        { lat: 17.47651916066951, lng: 78.29496882669653 },
        { lat: 17.47639844950643, lng: 78.29465601919114 },
        { lat: 17.47631870987322, lng: 78.29466634210151 },
        { lat: 17.47326312985018, lng: 78.29631391281346 },
        { lat: 17.46216076190889, lng: 78.2891412496975 },
        { lat: 17.45840693211458, lng: 78.28816873933685 },
        { lat: 17.45657656878207, lng: 78.28677183365637 },
        { lat: 17.45614397094669, lng: 78.28467976086237 },
        { lat: 17.45317767194282, lng: 78.28370467157733 },
        { lat: 17.4504540686769, lng: 78.28125993734953 },
        { lat: 17.4451719383359, lng: 78.27541764752922 },
        { lat: 17.44193651144341, lng: 78.27250722117626 },
        { lat: 17.43648927376535, lng: 78.27274950823733 },
        { lat: 17.43140433807771, lng: 78.2749867592928 },
        { lat: 17.42566841638946, lng: 78.28057166742737 },
        { lat: 17.42403493277938, lng: 78.28359598681318 },
        { lat: 17.4249320016161, lng: 78.28841307841236 },
        { lat: 17.42649233295938, lng: 78.29055557258468 },
        { lat: 17.43102794725698, lng: 78.29401963983508 },
        { lat: 17.43106097360842, lng: 78.29403875292503 },
        { lat: 17.42083072139195, lng: 78.31420732491081 },
        { lat: 17.41839643860187, lng: 78.31571044946905 },
        { lat: 17.41568171400987, lng: 78.32785388776942 },
        { lat: 17.4151359467419, lng: 78.3298078927772 },
        { lat: 17.4152180251506, lng: 78.33194154033968 },
        { lat: 17.4151719273808, lng: 78.33210655987301 },
        { lat: 17.41534235270271, lng: 78.33401801379534 },
        { lat: 17.4152407496526, lng: 78.33492898648646 },
        { lat: 17.41519659532665, lng: 78.33508919759839 },
        { lat: 17.41519872190263, lng: 78.33605703594665 },
        { lat: 17.41503224872869, lng: 78.3366054837791 },
        { lat: 17.41479588845156, lng: 78.33702255421993 },
        { lat: 17.41437265608319, lng: 78.33760122636374 },
        { lat: 17.41378477478323, lng: 78.33804821842989 },
        { lat: 17.41212050233448, lng: 78.34162390621587 },
        { lat: 17.41183390567937, lng: 78.34249775297305 },
        { lat: 17.41478982404342, lng: 78.34426086127036 },
        { lat: 17.41457450380776, lng: 78.34508579225556 },
        { lat: 17.41347573108411, lng: 78.34698625278267 },
        { lat: 17.41231810297593, lng: 78.34833890996934 },
        { lat: 17.412858606885, lng: 78.34919619955252 },
        { lat: 17.41347868696917, lng: 78.35084293831584 },
        { lat: 17.41342245292434, lng: 78.3520981428646 },
        { lat: 17.41641149461063, lng: 78.35384630434444 },
        { lat: 17.41602490263949, lng: 78.35519648611344 },
        { lat: 17.41561102602011, lng: 78.35573514690203 },
        { lat: 17.41575654692468, lng: 78.35580387612805 },
        { lat: 17.41435130438128, lng: 78.35904586667812 },
        { lat: 17.41388880922691, lng: 78.35991668279469 },
        { lat: 17.41343694106011, lng: 78.36054785829037 },
        { lat: 17.41310266476549, lng: 78.36082371348635 },
        { lat: 17.41186204898077, lng: 78.36561121229799 },
        { lat: 17.41179257087675, lng: 78.36567848099055 },
        { lat: 17.41193472942308, lng: 78.3659561570201 },
        { lat: 17.41213136273304, lng: 78.36603259269725 },
        { lat: 17.41243084981118, lng: 78.36599320609677 },
        { lat: 17.4128378026771, lng: 78.36605432214694 },
        { lat: 17.41322530273589, lng: 78.36607181796046 },
        { lat: 17.41325848637469, lng: 78.3668795549145 },
        { lat: 17.41321161734792, lng: 78.36721387324005 },
        { lat: 17.41310993279602, lng: 78.36752361678992 },
        { lat: 17.41337204637929, lng: 78.36752123070934 },
        { lat: 17.41366164638577, lng: 78.36753803204424 },
        { lat: 17.41371632036072, lng: 78.36763377368246 },
        { lat: 17.41345200305104, lng: 78.36790186070316 },
        { lat: 17.4131889980731, lng: 78.36823153779622 },
        { lat: 17.4129674850464, lng: 78.36856553203519 },
        { lat: 17.41297312158174, lng: 78.36875788122839 },
        { lat: 17.41315478156547, lng: 78.36899133559359 },
        { lat: 17.41317097863748, lng: 78.36901981858033 },
        { lat: 17.41320240911843, lng: 78.36905318215315 },
        { lat: 17.41296958382473, lng: 78.36949350514145 },
        { lat: 17.41253967099911, lng: 78.36997703102945 },
        { lat: 17.41220684364076, lng: 78.37060631399424 },
        { lat: 17.41210449979402, lng: 78.37096982395892 },
        { lat: 17.41220934496993, lng: 78.37181230830545 },
        { lat: 17.41244965680118, lng: 78.37214784146353 },
        { lat: 17.41291684765223, lng: 78.37252131920523 },
        { lat: 17.41326898936305, lng: 78.37276597338766 },
        { lat: 17.4135944788641, lng: 78.3729239874607 },
        { lat: 17.41389265687773, lng: 78.37321144168504 },
        { lat: 17.41393543373174, lng: 78.37323726943497 },
        { lat: 17.41396099636167, lng: 78.37326484011044 },
        { lat: 17.41408836602923, lng: 78.37352637561729 },
        { lat: 17.4143068159552, lng: 78.37392432466146 },
        { lat: 17.41444100205401, lng: 78.37412056824273 },
        { lat: 17.41449989214584, lng: 78.37417659242288 },
        { lat: 17.41453173438312, lng: 78.37419766894516 },
        { lat: 17.41456842314732, lng: 78.3742288447019 },
        { lat: 17.41460062458173, lng: 78.37425017669128 },
        { lat: 17.4147136319264, lng: 78.37426409462715 },
        { lat: 17.41472986024857, lng: 78.37426258037357 },
        { lat: 17.41479999719547, lng: 78.37426666235919 },
        { lat: 17.41486141987772, lng: 78.37427520483604 },
        { lat: 17.41491615079587, lng: 78.37428090315258 },
        { lat: 17.41508033698879, lng: 78.37419743315783 },
        { lat: 17.41523195966655, lng: 78.3739982122664 },
        { lat: 17.4153459982042, lng: 78.37406611995411 },
        { lat: 17.41535896430427, lng: 78.3740794013865 },
        { lat: 17.41538747059838, lng: 78.37426744854143 },
        { lat: 17.41541369395485, lng: 78.37429465639995 },
        { lat: 17.41546332933184, lng: 78.37433112424885 },
        { lat: 17.4156304137185, lng: 78.37430193997072 },
        { lat: 17.41566461972299, lng: 78.3743065187341 },
        { lat: 17.41574390814348, lng: 78.37431108229028 },
        { lat: 17.41577626288139, lng: 78.37432348635667 },
        { lat: 17.41594835920447, lng: 78.37451263736733 },
        { lat: 17.41603576738076, lng: 78.37525685774501 },
        { lat: 17.41605776022896, lng: 78.37531216736235 },
        { lat: 17.41608600861195, lng: 78.37537964655606 },
        { lat: 17.41621892060543, lng: 78.37585851317627 },
        { lat: 17.41598462992915, lng: 78.37612855258908 },
        { lat: 17.41516614356778, lng: 78.37701823001294 },
        { lat: 17.41559261937212, lng: 78.37739534128376 },
        { lat: 17.41648449658364, lng: 78.3777779388221 },
        { lat: 17.41762434578047, lng: 78.37810056631113 },
        { lat: 17.41736291798786, lng: 78.37942661454544 },
        { lat: 17.41786640814261, lng: 78.37949848911688 },
        { lat: 17.41777920871965, lng: 78.38054664959083 },
        { lat: 17.41766681758713, lng: 78.38107151706095 },
        { lat: 17.41749666981825, lng: 78.38147870038858 },
        { lat: 17.41730375622214, lng: 78.3817479801868 },
        { lat: 17.41718950330591, lng: 78.38185206312528 },
        { lat: 17.41704208880393, lng: 78.38218771624906 },
        { lat: 17.41680014843087, lng: 78.38253780130428 },
        { lat: 17.41649537457377, lng: 78.38295475368078 },
        { lat: 17.41628553442615, lng: 78.38344340205404 },
        { lat: 17.41628350882857, lng: 78.3837873869646 },
        { lat: 17.41599956817169, lng: 78.38439456398869 },
        { lat: 17.41573088774248, lng: 78.38465802205388 },
        { lat: 17.41556767274919, lng: 78.38485375858316 },
        { lat: 17.41533825305511, lng: 78.38517628429047 },
        { lat: 17.41518390004199, lng: 78.38558995626163 },
        { lat: 17.41485943463554, lng: 78.38597750261641 },
        { lat: 17.41465307493755, lng: 78.3862650148448 },
        { lat: 17.41445001095652, lng: 78.3865561578912 },
        { lat: 17.41443098981162, lng: 78.38684980790497 },
        { lat: 17.41448508036203, lng: 78.38716062042155 },
        { lat: 17.41435634755901, lng: 78.38735026084852 },
        { lat: 17.41434971030924, lng: 78.38737216191093 },
        { lat: 17.41415669181335, lng: 78.38767066678761 },
        { lat: 17.41402658080004, lng: 78.38809166066153 },
        { lat: 17.41323991411987, lng: 78.38790248342426 },
        { lat: 17.41262936513723, lng: 78.3877471821517 },
        { lat: 17.41223446401433, lng: 78.38767754357146 },
        { lat: 17.41182198928027, lng: 78.38760719460277 },
        { lat: 17.41135359956244, lng: 78.3877263567078 },
        { lat: 17.41084770991409, lng: 78.38770174160216 },
        { lat: 17.41057254721915, lng: 78.38788699214135 },
        { lat: 17.41041037765541, lng: 78.38815359690788 },
        { lat: 17.41020887910718, lng: 78.38881847834345 },
        { lat: 17.41022605293221, lng: 78.38909015764558 },
        { lat: 17.41013956100447, lng: 78.38952547458126 },
        { lat: 17.40999550789008, lng: 78.38997078020923 },
        { lat: 17.40978854009006, lng: 78.39053379515728 },
        { lat: 17.4097827291676, lng: 78.39055337999224 },
        { lat: 17.40985174939199, lng: 78.39056429424386 },
        { lat: 17.40994682765427, lng: 78.3905925655279 },
        { lat: 17.41004077164624, lng: 78.39062449922466 },
        { lat: 17.41008327072222, lng: 78.3906431834218 },
        { lat: 17.41013345428674, lng: 78.39066867004438 },
        { lat: 17.41017298276694, lng: 78.39068948111627 },
        { lat: 17.41018751988588, lng: 78.39069418150336 },
        { lat: 17.41042130194614, lng: 78.39076701342096 },
        { lat: 17.41047739609682, lng: 78.39080267393672 },
        { lat: 17.41065068471132, lng: 78.39100280295798 },
        { lat: 17.41078875254423, lng: 78.3911085545431 },
        { lat: 17.41088961456625, lng: 78.39119389289806 },
        { lat: 17.41086397432533, lng: 78.39127890360687 },
        { lat: 17.41077700505966, lng: 78.39167479372108 },
        { lat: 17.41073161378075, lng: 78.39187803433968 },
        { lat: 17.41068501022736, lng: 78.39207015941486 },
        { lat: 17.41067968121961, lng: 78.392152609735 },
        { lat: 17.41068509754714, lng: 78.39222544652958 },
        { lat: 17.41072137123797, lng: 78.39238634044027 },
        { lat: 17.41076959276288, lng: 78.39256264910095 },
        { lat: 17.41078574818245, lng: 78.39265481245043 },
        { lat: 17.41078450085634, lng: 78.39272439863926 },
        { lat: 17.41077595490414, lng: 78.39305067744203 },
        { lat: 17.41075090691644, lng: 78.39366645606061 },
        { lat: 17.41075105121144, lng: 78.39392248153051 },
        { lat: 17.4107661742997, lng: 78.39434261147562 },
        { lat: 17.4107718589105, lng: 78.39461414278183 },
        { lat: 17.41077459388245, lng: 78.39482337886189 },
        { lat: 17.41078153785768, lng: 78.39486446781663 },
        { lat: 17.41079787222379, lng: 78.39488872643334 },
        { lat: 17.41085050451305, lng: 78.39491246937193 },
        { lat: 17.41092223322775, lng: 78.39492649272722 },
        { lat: 17.41117437957444, lng: 78.39493089260407 },
        { lat: 17.41131239564402, lng: 78.39493158354591 },
        { lat: 17.4115828334289, lng: 78.3949162929125 },
        { lat: 17.41187038335514, lng: 78.39490779249824 },
        { lat: 17.4121232542135, lng: 78.39490509150664 },
        { lat: 17.4122689117639, lng: 78.39490743879584 },
        { lat: 17.41244981678469, lng: 78.39490663797287 },
        { lat: 17.41255067815845, lng: 78.3949149169656 },
        { lat: 17.41268484171334, lng: 78.39494478985144 },
        { lat: 17.41277390314703, lng: 78.39497978227114 },
        { lat: 17.41280952826652, lng: 78.39499377961559 },
        { lat: 17.41258738628422, lng: 78.39520137444565 },
        { lat: 17.4124051907456, lng: 78.39539491483573 },
        { lat: 17.41216722122339, lng: 78.39568369846265 },
        { lat: 17.41198870131542, lng: 78.39588356031405 },
        { lat: 17.41164380189739, lng: 78.39629193683204 },
        { lat: 17.41146051551661, lng: 78.39651780984275 },
        { lat: 17.41099501076328, lng: 78.39709332050285 },
        { lat: 17.41091491456726, lng: 78.39719459352233 },
        { lat: 17.41132978332937, lng: 78.39756163252709 },
        { lat: 17.41161145728978, lng: 78.39772191958532 },
        { lat: 17.41203015718824, lng: 78.39794498188732 },
        { lat: 17.41279687390774, lng: 78.39828508014638 },
        { lat: 17.41335948564092, lng: 78.39854799836058 },
        { lat: 17.41385765307528, lng: 78.39876698101772 },
        { lat: 17.41404160091264, lng: 78.39885582690933 },
        { lat: 17.41407003125352, lng: 78.39885327745918 },
        { lat: 17.41422183619682, lng: 78.3988420134596 },
        { lat: 17.41444992271839, lng: 78.39882555135706 },
        { lat: 17.41460579294753, lng: 78.39881229830675 },
        { lat: 17.4149315922382, lng: 78.398732136945 },
        { lat: 17.41539854740818, lng: 78.39860868657641 },
        { lat: 17.41662403584053, lng: 78.39826889653406 },
        { lat: 17.41728534023238, lng: 78.39783006178554 },
        { lat: 17.41749274190678, lng: 78.39769384875915 },
        { lat: 17.41752271982352, lng: 78.39778822114792 },
        { lat: 17.41768606163025, lng: 78.39797268622844 },
        { lat: 17.41791804384727, lng: 78.39824128555028 },
        { lat: 17.41803374430795, lng: 78.39836343284863 },
        { lat: 17.41815863119312, lng: 78.39844917182695 },
        { lat: 17.41831547324018, lng: 78.3985512360505 },
        { lat: 17.4183760853347, lng: 78.39861480759077 },
        { lat: 17.41840587415382, lng: 78.39865993062216 },
        { lat: 17.41842753996878, lng: 78.3987092667871 },
        { lat: 17.41843715139225, lng: 78.39873611597439 },
        { lat: 17.41923913968104, lng: 78.3984510976979 },
        { lat: 17.41990941754896, lng: 78.398213998295 },
        { lat: 17.4203226621132, lng: 78.39831790508154 },
        { lat: 17.42066492165073, lng: 78.3984273188477 },
        { lat: 17.42089311042601, lng: 78.39833447570274 },
        { lat: 17.42098258078638, lng: 78.39804943911996 },
        { lat: 17.42194770474665, lng: 78.39808263833748 },
        { lat: 17.42226623094725, lng: 78.39808351824254 },
        { lat: 17.4230023414014, lng: 78.39788228681213 },
        { lat: 17.42314373958377, lng: 78.39773092975263 },
        { lat: 17.4236479936575, lng: 78.3979179401716 },
        { lat: 17.42488405520496, lng: 78.39760170822193 },
        { lat: 17.42522194966496, lng: 78.39742768355464 },
        { lat: 17.42568465459861, lng: 78.39722279722349 },
        { lat: 17.42580845852216, lng: 78.3969841540105 },
        { lat: 17.42623396630654, lng: 78.39636110615348 },
        { lat: 17.42652528958649, lng: 78.39559460569673 },
        { lat: 17.42682019793892, lng: 78.39468354678137 },
        { lat: 17.42695142545425, lng: 78.39460406133766 },
        { lat: 17.42698906840823, lng: 78.39468606713382 },
        { lat: 17.42723398427637, lng: 78.39477147920334 },
        { lat: 17.42738740869568, lng: 78.39485183968371 },
        { lat: 17.42764334853913, lng: 78.39484820640033 },
        { lat: 17.42785004019771, lng: 78.39480717812174 },
        { lat: 17.42800047495503, lng: 78.39465900914595 },
        { lat: 17.42826395281035, lng: 78.39429971051692 },
        { lat: 17.42918363737693, lng: 78.39465690657472 },
        { lat: 17.4296920838338, lng: 78.39355336356255 },
        { lat: 17.42969067759481, lng: 78.39353362693758 },
        { lat: 17.42970059685247, lng: 78.39350175260049 },
        { lat: 17.42976010936642, lng: 78.39342315562251 },
        { lat: 17.42982454790006, lng: 78.39335279243261 },
        { lat: 17.42986832337946, lng: 78.39331657966817 },
        { lat: 17.42992089423482, lng: 78.39329193182549 },
        { lat: 17.42998083434186, lng: 78.39328512196987 },
        { lat: 17.43003498073762, lng: 78.39327072000941 },
        { lat: 17.43008772990038, lng: 78.39326445354978 },
        { lat: 17.43013596658361, lng: 78.39326436757631 },
        { lat: 17.43016690940944, lng: 78.39327176609584 },
        { lat: 17.43022619321907, lng: 78.39329078024664 },
        { lat: 17.43028665169411, lng: 78.39331873826234 },
        { lat: 17.4302885512572, lng: 78.3933010272807 },
        { lat: 17.43030844168229, lng: 78.39330334141678 },
        { lat: 17.43030589353833, lng: 78.39332711402743 },
        { lat: 17.43040209778257, lng: 78.39337385614236 },
        { lat: 17.43043182613691, lng: 78.39340755992131 },
        { lat: 17.43045303595578, lng: 78.39344857085582 },
        { lat: 17.43049351895241, lng: 78.39362123157272 },
        { lat: 17.43051132700645, lng: 78.39382394123473 },
        { lat: 17.43058507985197, lng: 78.39428403988538 },
        { lat: 17.4306305078925, lng: 78.39458826192423 },
        { lat: 17.43059250471946, lng: 78.3946225156495 },
        { lat: 17.43053809257109, lng: 78.39495761404979 },
        { lat: 17.43051084958853, lng: 78.39526029759197 },
        { lat: 17.43050727653049, lng: 78.39541783562416 },
        { lat: 17.43053366645771, lng: 78.39589946699206 },
        { lat: 17.43062588886294, lng: 78.39647211389456 },
        { lat: 17.43073463844459, lng: 78.39703697591284 },
        { lat: 17.43082515151562, lng: 78.3973802728952 },
        { lat: 17.43090610973102, lng: 78.39761847051244 },
        { lat: 17.43101203206965, lng: 78.39795532600186 },
        { lat: 17.43105901847387, lng: 78.39821935607176 },
        { lat: 17.43108417570575, lng: 78.39836748448876 },
        { lat: 17.43110314151402, lng: 78.39849098567481 },
        { lat: 17.43117162618492, lng: 78.39847985348587 },
        { lat: 17.43130033557521, lng: 78.39850495645166 },
        { lat: 17.43147542731592, lng: 78.39854446380478 },
        { lat: 17.43157810315746, lng: 78.39857707511524 },
        { lat: 17.43169090920607, lng: 78.39858366571639 },
        { lat: 17.43189452285838, lng: 78.39855913627324 },
        { lat: 17.43205099105996, lng: 78.3985441935732 },
        { lat: 17.43218907727202, lng: 78.39855045294851 },
        { lat: 17.43236419590484, lng: 78.3986300356324 },
        { lat: 17.43278029816021, lng: 78.39886602818359 },
        { lat: 17.43280646739418, lng: 78.39888203930327 },
        { lat: 17.43284779472007, lng: 78.39891752007505 },
        { lat: 17.43286461775135, lng: 78.39893252998932 },
        { lat: 17.43288325143102, lng: 78.39894967067443 },
        { lat: 17.43308882806293, lng: 78.39859261306103 },
        { lat: 17.43352111226502, lng: 78.3978486811393 },
        { lat: 17.43378471818671, lng: 78.39733403300175 },
        { lat: 17.43385329541022, lng: 78.39720516061212 },
        { lat: 17.43450139322555, lng: 78.39790104160211 },
        { lat: 17.43455116707065, lng: 78.39790661204314 },
        { lat: 17.43474823750584, lng: 78.3982365230096 },
        { lat: 17.43478989734563, lng: 78.39828824512406 },
        { lat: 17.43492485621469, lng: 78.3981858945307 },
        { lat: 17.43515675923262, lng: 78.39802989317955 },
        { lat: 17.43538070161831, lng: 78.39789640638617 },
        { lat: 17.43555699014853, lng: 78.39778716028255 },
        { lat: 17.43555570169791, lng: 78.39778221171892 },
        { lat: 17.43555620146974, lng: 78.39777415362059 },
        { lat: 17.4355588980776, lng: 78.39776557228193 },
        { lat: 17.43560545838233, lng: 78.39771744963197 },
        { lat: 17.43582282794645, lng: 78.39753005319723 },
        { lat: 17.43604394638786, lng: 78.3973263665084 },
        { lat: 17.43622199960497, lng: 78.39716872982532 },
        { lat: 17.43648317683112, lng: 78.39662445660072 },
        { lat: 17.43713276749719, lng: 78.39515388223063 },
        { lat: 17.43852472225085, lng: 78.39578670114173 },
        { lat: 17.43895824844384, lng: 78.39598464432532 },
        { lat: 17.4391328407039, lng: 78.39607182590686 },
        { lat: 17.43926214138154, lng: 78.39614874021139 },
        { lat: 17.43936790357303, lng: 78.39621593545499 },
        { lat: 17.43927810779076, lng: 78.39630225338149 },
        { lat: 17.43911610677739, lng: 78.39649153942898 },
        { lat: 17.43890052863435, lng: 78.39691998142831 },
        { lat: 17.43860538616397, lng: 78.3978014270327 },
        { lat: 17.43842864729443, lng: 78.39838421974937 },
        { lat: 17.43841380077962, lng: 78.39867038548019 },
        { lat: 17.43852267684756, lng: 78.39882393549559 },
        { lat: 17.43883111918897, lng: 78.3992602931022 },
        { lat: 17.43885714885574, lng: 78.39923721379512 },
        { lat: 17.43895723640676, lng: 78.39915019252552 },
        { lat: 17.43907973740589, lng: 78.39902841680667 },
        { lat: 17.43916964252514, lng: 78.39894870271068 },
        { lat: 17.43918721597091, lng: 78.39893522834163 },
        { lat: 17.4394273433731, lng: 78.39927966149493 },
        { lat: 17.43979461498164, lng: 78.39982474698937 },
        { lat: 17.43985001618853, lng: 78.39993026899877 },
        { lat: 17.44012973799801, lng: 78.40027698873122 },
        { lat: 17.44030059510139, lng: 78.40055748390131 },
        { lat: 17.44032457432213, lng: 78.40061755503946 },
        { lat: 17.44046034962179, lng: 78.40080189183205 },
        { lat: 17.44056773151411, lng: 78.4009833843136 },
        { lat: 17.44085128219267, lng: 78.40156189941106 },
        { lat: 17.44111069776699, lng: 78.40193911145191 },
        { lat: 17.44161380107862, lng: 78.40286180210632 },
        { lat: 17.44158152020783, lng: 78.40313485661669 },
        { lat: 17.44158775565965, lng: 78.4036127477488 },
        { lat: 17.44175513182676, lng: 78.40435348748007 },
        { lat: 17.44206073076349, lng: 78.40524911046703 },
        { lat: 17.4422524426483, lng: 78.40648242903168 },
        { lat: 17.44229051758181, lng: 78.40665366547047 },
        { lat: 17.44243813144409, lng: 78.40670385636342 },
        { lat: 17.44398357655055, lng: 78.40647287759595 },
        { lat: 17.44422595541234, lng: 78.4063686227655 },
        { lat: 17.44547049410995, lng: 78.40587675907854 },
        { lat: 17.44623303644033, lng: 78.40564528079439 },
        { lat: 17.4462511789707, lng: 78.40633156285735 },
        { lat: 17.44622414265785, lng: 78.40705686210536 },
        { lat: 17.44628550426555, lng: 78.40852428161182 },
        { lat: 17.44628007222669, lng: 78.40869538089137 },
        { lat: 17.44627964487174, lng: 78.40881658530634 },
        { lat: 17.44627564458334, lng: 78.40894673672867 },
        { lat: 17.44627163565064, lng: 78.40904162315664 },
        { lat: 17.44626487981897, lng: 78.40914695415813 },
        { lat: 17.44626015741497, lng: 78.40926432196808 },
        { lat: 17.44624964807045, lng: 78.40938693256862 },
        { lat: 17.44624268587722, lng: 78.40951187453095 },
        { lat: 17.44622678026217, lng: 78.40973966894435 },
        { lat: 17.44621866511896, lng: 78.40986847277998 },
        { lat: 17.44620451416422, lng: 78.41003370439306 },
        { lat: 17.44619028953931, lng: 78.4101864179594 },
        { lat: 17.44617304758879, lng: 78.4103104221327 },
        { lat: 17.44615001085783, lng: 78.41047307218696 },
        { lat: 17.44612859676672, lng: 78.41062953149728 },
        { lat: 17.44610615729733, lng: 78.41076751692904 },
        { lat: 17.44608729262188, lng: 78.4109087808592 },
        { lat: 17.44607193306318, lng: 78.41100674070044 },
        { lat: 17.44605557668758, lng: 78.41112436782099 },
        { lat: 17.4460322942846, lng: 78.41131240658052 },
        { lat: 17.44597096454007, lng: 78.41143275950078 },
        { lat: 17.44574918369311, lng: 78.4114408961083 },
        { lat: 17.44574204246175, lng: 78.41150219496701 },
        { lat: 17.44616552790403, lng: 78.41163440952955 },
        { lat: 17.44621554947633, lng: 78.41165103422304 },
        { lat: 17.44620542398276, lng: 78.41167510602507 },
        { lat: 17.44616422613372, lng: 78.41177809587913 },
        { lat: 17.44612355902535, lng: 78.41188377396652 },
        { lat: 17.44606993417927, lng: 78.41201659074393 },
        { lat: 17.44605068601408, lng: 78.412071432719 },
        { lat: 17.44603863965663, lng: 78.41211308748704 },
        { lat: 17.44600914169862, lng: 78.41210384809698 },
        { lat: 17.44596451011102, lng: 78.41208721870183 },
        { lat: 17.4459096424789, lng: 78.41206616843024 },
        { lat: 17.44583362336551, lng: 78.41203619002506 },
        { lat: 17.44564703231783, lng: 78.41196630689674 },
        { lat: 17.44547962184808, lng: 78.41229162322583 },
        { lat: 17.44449727375754, lng: 78.41312316055445 },
        { lat: 17.44335925015606, lng: 78.414281320638 },
        { lat: 17.44290772235892, lng: 78.41499574696361 },
        { lat: 17.44226650169432, lng: 78.415199886759 },
        { lat: 17.44170299844738, lng: 78.41490750990468 },
        { lat: 17.44159056497452, lng: 78.41516118923684 },
        { lat: 17.44140227570614, lng: 78.41508273533852 },
        { lat: 17.44109263315696, lng: 78.4157052747242 },
        { lat: 17.44019578399773, lng: 78.41531512696884 },
        { lat: 17.43970902702483, lng: 78.41510321999024 },
        { lat: 17.43861562347709, lng: 78.41471578230528 },
        { lat: 17.4383754741326, lng: 78.415351453532 },
        { lat: 17.43807626082263, lng: 78.41597461740747 },
        { lat: 17.43711980681863, lng: 78.41568128953952 },
        { lat: 17.43614553402908, lng: 78.41539621830901 },
        { lat: 17.43613691144883, lng: 78.41529465118192 },
        { lat: 17.43602099108615, lng: 78.41526764332693 },
        { lat: 17.43583784624005, lng: 78.41522743102878 },
        { lat: 17.4357929026683, lng: 78.41521854265899 },
        { lat: 17.43573678911335, lng: 78.4152100911389 },
        { lat: 17.43571290216361, lng: 78.41520805296939 },
        { lat: 17.43568128458751, lng: 78.41520722739006 },
        { lat: 17.43568210285681, lng: 78.41526336095853 },
        { lat: 17.43567271119257, lng: 78.41543303884063 },
        { lat: 17.4356578182876, lng: 78.41556591834265 },
        { lat: 17.43564305885548, lng: 78.4156676227335 },
        { lat: 17.43563344260279, lng: 78.41572554797786 },
        { lat: 17.43532408814394, lng: 78.41562816081273 },
        { lat: 17.43506926936512, lng: 78.41554332645785 },
        { lat: 17.43490869958612, lng: 78.41550135445588 },
        { lat: 17.43474090338037, lng: 78.41545108325556 },
        { lat: 17.43458006026322, lng: 78.41540718831268 },
        { lat: 17.43453586308195, lng: 78.41539735511047 },
        { lat: 17.43449952854344, lng: 78.41539119061721 },
        { lat: 17.43441922265098, lng: 78.41537909154955 },
        { lat: 17.43439358995888, lng: 78.41548753078277 },
        { lat: 17.43436843530059, lng: 78.41559592562304 },
        { lat: 17.43434130822181, lng: 78.41571441933084 },
        { lat: 17.43430309634552, lng: 78.41584729422053 },
        { lat: 17.43426887318504, lng: 78.41595146801144 },
        { lat: 17.43423409170462, lng: 78.4160323922068 },
        { lat: 17.43419028732544, lng: 78.41611906706122 },
        { lat: 17.4341438356379, lng: 78.41619146755897 },
        { lat: 17.43408480718688, lng: 78.41626683955057 },
        { lat: 17.43399462286919, lng: 78.41638378802148 },
        { lat: 17.43380935063794, lng: 78.41655844683967 },
        { lat: 17.43363123739896, lng: 78.41671736440728 },
        { lat: 17.43350760482571, lng: 78.41682432841607 },
        { lat: 17.43333524694355, lng: 78.41697425156524 },
        { lat: 17.43327009034968, lng: 78.41701858721777 },
        { lat: 17.43317083804897, lng: 78.4170802114885 },
        { lat: 17.43310059745892, lng: 78.41711284462257 },
        { lat: 17.43301402899574, lng: 78.41714612911574 },
        { lat: 17.43290208574938, lng: 78.41718619316858 },
        { lat: 17.4328045029762, lng: 78.4172262092946 },
        { lat: 17.43271137155281, lng: 78.41726780357469 },
        { lat: 17.43263866852078, lng: 78.41730855322992 },
        { lat: 17.43261445579123, lng: 78.41733501250023 },
        { lat: 17.43258412557948, lng: 78.41737919627435 },
        { lat: 17.43255349014988, lng: 78.417433341502 },
        { lat: 17.43249343430167, lng: 78.4175686731246 },
        { lat: 17.432445989889, lng: 78.4176698713641 },
        { lat: 17.43233843291608, lng: 78.41790407219469 },
        { lat: 17.43227249276422, lng: 78.41805466624089 },
        { lat: 17.43222131230925, lng: 78.4181753428395 },
        { lat: 17.43218208927151, lng: 78.41825392530457 },
        { lat: 17.43215378382674, lng: 78.41831504410874 },
        { lat: 17.43212207835761, lng: 78.41839102933224 },
        { lat: 17.43208281768883, lng: 78.41847911590216 },
        { lat: 17.43205500720067, lng: 78.4185421931432 },
        { lat: 17.43201591340324, lng: 78.4186298510963 },
        { lat: 17.43197530856707, lng: 78.41871987678631 },
        { lat: 17.43194040278083, lng: 78.41879507612481 },
        { lat: 17.43190828626671, lng: 78.41886528631994 },
        { lat: 17.43188411967028, lng: 78.4189215191662 },
        { lat: 17.43186851349779, lng: 78.41896565251527 },
        { lat: 17.43186032414509, lng: 78.4190012927935 },
        { lat: 17.43185242835651, lng: 78.41904216201442 },
        { lat: 17.43184765355171, lng: 78.41909060078484 },
        { lat: 17.43184025283001, lng: 78.41916116417126 },
        { lat: 17.43182990540119, lng: 78.41936797855465 },
        { lat: 17.43181932016473, lng: 78.41954029298766 },
        { lat: 17.43181241030215, lng: 78.41964066068141 },
        { lat: 17.43180588403366, lng: 78.41971752682616 },
        { lat: 17.43180108838482, lng: 78.41978785692308 },
        { lat: 17.43180213655766, lng: 78.41985849717699 },
        { lat: 17.43180419343363, lng: 78.41997757013579 },
        { lat: 17.43181258766813, lng: 78.42018753351807 },
        { lat: 17.43182033462126, lng: 78.42032434080083 },
        { lat: 17.43182049814558, lng: 78.42035229811854 },
        { lat: 17.43181849670874, lng: 78.42042123880879 },
        { lat: 17.43181477945225, lng: 78.42044174542924 },
        { lat: 17.43180821054952, lng: 78.42045546147932 },
        { lat: 17.43179651924423, lng: 78.42047533692958 },
        { lat: 17.43176327222291, lng: 78.42051006117593 },
        { lat: 17.4317323217223, lng: 78.42053800713899 },
        { lat: 17.43170645833951, lng: 78.42055358450227 },
        { lat: 17.43167290738309, lng: 78.42057112343933 },
        { lat: 17.4316117682493, lng: 78.42058682979581 },
        { lat: 17.43158006050403, lng: 78.42058978767292 },
        { lat: 17.43153926937994, lng: 78.42058456544373 },
        { lat: 17.43151874499134, lng: 78.42058002737502 },
        { lat: 17.43149537865301, lng: 78.42057293248484 },
        { lat: 17.43146755587928, lng: 78.42056065965286 },
        { lat: 17.43142526724088, lng: 78.42054162782962 },
        { lat: 17.43138839923902, lng: 78.42051645125399 },
        { lat: 17.43135094174853, lng: 78.42048272114616 },
        { lat: 17.43131970768703, lng: 78.42044729938728 },
        { lat: 17.43129919040089, lng: 78.42042072252995 },
        { lat: 17.43128000556278, lng: 78.42039214643471 },
        { lat: 17.43125479998827, lng: 78.4203539989521 },
        { lat: 17.43121751498306, lng: 78.42030305062798 },
        { lat: 17.43112245441081, lng: 78.42016925536684 },
        { lat: 17.43101167957669, lng: 78.42001370370414 },
        { lat: 17.43091971394124, lng: 78.41989063993562 },
        { lat: 17.4308389661169, lng: 78.41978309792802 },
        { lat: 17.43078829162003, lng: 78.41972064704852 },
        { lat: 17.43069602496113, lng: 78.41981425766943 },
        { lat: 17.4305852273122, lng: 78.41993080716861 },
        { lat: 17.4304863322737, lng: 78.4200389190431 },
        { lat: 17.43044451634335, lng: 78.42009889381094 },
        { lat: 17.43041451342775, lng: 78.42014908691678 },
        { lat: 17.43040362450208, lng: 78.4201813984527 },
        { lat: 17.43039316720033, lng: 78.42021983829324 },
        { lat: 17.43038881973623, lng: 78.42025165328369 },
        { lat: 17.43038931898255, lng: 78.42029520786491 },
        { lat: 17.4303985353177, lng: 78.42033442485985 },
        { lat: 17.43041836214988, lng: 78.42039247915035 },
        { lat: 17.4304928943208, lng: 78.42055657974865 },
        { lat: 17.43056134934326, lng: 78.42069741856925 },
        { lat: 17.43059201611059, lng: 78.42075228914344 },
        { lat: 17.43060785394896, lng: 78.4207731388765 },
        { lat: 17.43064083371132, lng: 78.42079586740051 },
        { lat: 17.43068652237459, lng: 78.4208159879917 },
        { lat: 17.43085708637839, lng: 78.4208950225855 },
        { lat: 17.43098505258861, lng: 78.4209471933481 },
        { lat: 17.43115546523088, lng: 78.42101761201282 },
        { lat: 17.43130197525082, lng: 78.42108227563223 },
        { lat: 17.43127204535433, lng: 78.42122424594693 },
        { lat: 17.43123019369813, lng: 78.42145360529547 },
        { lat: 17.43121052179107, lng: 78.42157578150197 },
        { lat: 17.43120541829098, lng: 78.42162811048583 },
        { lat: 17.43120560110408, lng: 78.42165994380802 },
        { lat: 17.43121291894898, lng: 78.4216873884238 },
        { lat: 17.43121706654775, lng: 78.4216993374001 },
        { lat: 17.43123330933403, lng: 78.42174337569486 },
        { lat: 17.43127666477193, lng: 78.42183378156012 },
        { lat: 17.43134289762792, lng: 78.42195428217417 },
        { lat: 17.43137141088161, lng: 78.42200537957578 },
        { lat: 17.43137765088558, lng: 78.42202289353357 },
        { lat: 17.43138496627312, lng: 78.42204624548212 },
        { lat: 17.43138750639477, lng: 78.42206176505502 },
        { lat: 17.43139020937762, lng: 78.42209370037439 },
        { lat: 17.43138681328682, lng: 78.42212423859159 },
        { lat: 17.43137977767356, lng: 78.42216651344464 },
        { lat: 17.43134338251711, lng: 78.42227823367665 },
        { lat: 17.43130418333087, lng: 78.422402329838 },
        { lat: 17.43127036409876, lng: 78.42251525574174 },
        { lat: 17.43123857338337, lng: 78.42259846518445 },
        { lat: 17.43116129648034, lng: 78.4228147190088 },
        { lat: 17.43105889037223, lng: 78.4230878252297 },
        { lat: 17.43075852117587, lng: 78.42388663701414 },
        { lat: 17.43056389917538, lng: 78.42435373026342 },
        { lat: 17.43045113828748, lng: 78.42464272649838 },
        { lat: 17.43030696359858, lng: 78.4250042518064 },
        { lat: 17.43017611973779, lng: 78.42533511048765 },
        { lat: 17.43013119646922, lng: 78.42531534588188 },
        { lat: 17.42995071628573, lng: 78.42523695154162 },
        { lat: 17.42990264802837, lng: 78.425444469445 },
        { lat: 17.4298742096783, lng: 78.42561160035135 },
        { lat: 17.42984322332731, lng: 78.42580374010646 },
        { lat: 17.42982137555996, lng: 78.4259899154958 },
        { lat: 17.429799202481, lng: 78.42617196883205 },
        { lat: 17.42979560875749, lng: 78.42622017977077 },
        { lat: 17.42978929173854, lng: 78.42629653227223 },
        { lat: 17.42978807898883, lng: 78.42640255457793 },
        { lat: 17.42979091375773, lng: 78.42652741439379 },
        { lat: 17.42980588446351, lng: 78.42669401352475 },
        { lat: 17.42980726254284, lng: 78.42684664342454 },
        { lat: 17.42980603719109, lng: 78.42720775377637 },
        { lat: 17.42980773345145, lng: 78.42733205289947 },
        { lat: 17.42980727808237, lng: 78.4274760498689 },
        { lat: 17.4298027546288, lng: 78.42764520594025 },
        { lat: 17.42980151042963, lng: 78.42781708969946 },
        { lat: 17.42979560524578, lng: 78.4280010309712 },
        { lat: 17.42979158870364, lng: 78.42813940171514 },
        { lat: 17.4297937138494, lng: 78.42820793218263 },
        { lat: 17.42979493587915, lng: 78.4283053502178 },
        { lat: 17.42979485726622, lng: 78.42842353615347 },
        { lat: 17.42979362623943, lng: 78.4285441073266 },
        { lat: 17.42978475677323, lng: 78.42873145093421 },
        { lat: 17.42977985282441, lng: 78.42887492889669 },
        { lat: 17.42977437834676, lng: 78.4290237523431 },
        { lat: 17.42977261013383, lng: 78.42920005241984 },
        { lat: 17.4297727729223, lng: 78.42936342442067 },
        { lat: 17.42976949808952, lng: 78.42949495892611 },
        { lat: 17.42976204349783, lng: 78.429644349254 },
        { lat: 17.42975038741434, lng: 78.43002950215437 },
        { lat: 17.42974720936699, lng: 78.43014568617511 },
        { lat: 17.42975246370771, lng: 78.43033217628147 },
        { lat: 17.429752004126, lng: 78.43050289297204 },
        { lat: 17.42974855691293, lng: 78.43070652322358 },
        { lat: 17.42974442658134, lng: 78.43086100226343 },
        { lat: 17.42973732421012, lng: 78.43104113497172 },
        { lat: 17.42973081958531, lng: 78.4311621790458 },
        { lat: 17.42971458825919, lng: 78.43144485766173 },
        { lat: 17.4297019952383, lng: 78.43163495190016 },
        { lat: 17.42969263626254, lng: 78.43183358903094 },
        { lat: 17.42999209071828, lng: 78.43184862151044 },
        { lat: 17.43026171581166, lng: 78.4318610955228 },
        { lat: 17.43039584471112, lng: 78.43186660116098 },
        { lat: 17.43069032893936, lng: 78.431880785812 },
        { lat: 17.43075542284426, lng: 78.43188946871592 },
        { lat: 17.43091102004902, lng: 78.43192866072415 },
        { lat: 17.43110255995565, lng: 78.43198909407052 },
        { lat: 17.43138123183866, lng: 78.43208523517731 },
        { lat: 17.43168861530667, lng: 78.43217345807923 },
        { lat: 17.43194905193767, lng: 78.4322611028913 },
        { lat: 17.43198762790821, lng: 78.43227650417502 },
        { lat: 17.43220835504953, lng: 78.432379980962 },
        { lat: 17.43236081084817, lng: 78.4324496961343 },
        { lat: 17.43248922278957, lng: 78.43250724462241 },
        { lat: 17.43262937259493, lng: 78.43257280229118 },
        { lat: 17.43267103387844, lng: 78.43260383076928 },
        { lat: 17.43270774181812, lng: 78.43263840228808 },
        { lat: 17.43274727069817, lng: 78.4326788148131 },
        { lat: 17.43278677360017, lng: 78.43271139963716 },
        { lat: 17.43282964849291, lng: 78.43273596619157 },
        { lat: 17.43292803310372, lng: 78.43277924904449 },
        { lat: 17.4330459897022, lng: 78.43283159626 },
        { lat: 17.43319953818577, lng: 78.43289745421534 },
        { lat: 17.43330262674372, lng: 78.43293900698352 },
        { lat: 17.43346419981938, lng: 78.43300815502734 },
        { lat: 17.43360564826617, lng: 78.4330633436151 },
        { lat: 17.43379408497896, lng: 78.4331403966569 },
        { lat: 17.43381039196539, lng: 78.43314322258368 },
        { lat: 17.43381755947391, lng: 78.43314266032142 },
        { lat: 17.4338410556616, lng: 78.4331364491683 },
        { lat: 17.43385173809054, lng: 78.43313131773138 },
        { lat: 17.43388273330848, lng: 78.4331846525676 },
        { lat: 17.43393644101663, lng: 78.43326002779897 },
        { lat: 17.43401956654801, lng: 78.43335585083219 },
        { lat: 17.43411519589243, lng: 78.43344771196199 },
        { lat: 17.4341218865898, lng: 78.43345373973497 },
        { lat: 17.43419248844894, lng: 78.43350932630118 },
        { lat: 17.43424218483934, lng: 78.43354453700181 },
        { lat: 17.43430375278966, lng: 78.43358958228482 },
        { lat: 17.43439335411401, lng: 78.4336431032393 },
        { lat: 17.43444996511545, lng: 78.4336783123048 },
        { lat: 17.43451123659729, lng: 78.43372481266968 },
        { lat: 17.43457456304214, lng: 78.43378730852974 },
        { lat: 17.434771168386, lng: 78.43400307045572 },
        { lat: 17.43494797874305, lng: 78.4341828770991 },
        { lat: 17.43509235542708, lng: 78.43433437948397 },
        { lat: 17.43521726515165, lng: 78.43445848001278 },
        { lat: 17.43531028610181, lng: 78.43454798421432 },
        { lat: 17.43534644188363, lng: 78.43458079732203 },
        { lat: 17.43539242877689, lng: 78.43462476456659 },
        { lat: 17.43546639167831, lng: 78.43469770858411 },
        { lat: 17.43543959333041, lng: 78.4347233951892 },
        { lat: 17.43535524974389, lng: 78.43482254393223 },
        { lat: 17.43525174728338, lng: 78.43493992395618 },
        { lat: 17.43517471446304, lng: 78.43503141305216 },
        { lat: 17.43508242942068, lng: 78.43515568042896 },
        { lat: 17.4349909995375, lng: 78.43526164674408 },
        { lat: 17.43494257359009, lng: 78.43531430505357 },
        { lat: 17.43484613684978, lng: 78.43542892680688 },
        { lat: 17.43477418925968, lng: 78.43551759325236 },
        { lat: 17.4346885917842, lng: 78.43562089400163 },
        { lat: 17.43456761549057, lng: 78.43576796150889 },
        { lat: 17.43445848835576, lng: 78.43588850052222 },
        { lat: 17.43436037702061, lng: 78.43600440680879 },
        { lat: 17.43430260656244, lng: 78.43608069207029 },
        { lat: 17.43426284318333, lng: 78.43614222940043 },
        { lat: 17.43421173620854, lng: 78.43623078561797 },
        { lat: 17.43414985702349, lng: 78.43635117849814 },
        { lat: 17.43410001677123, lng: 78.43646664407433 },
        { lat: 17.43411118550274, lng: 78.43647409034332 },
        { lat: 17.43411657185581, lng: 78.43647997087038 },
        { lat: 17.43412050645011, lng: 78.43648989114313 },
        { lat: 17.43412100854107, lng: 78.4364991443108 },
        { lat: 17.43411956171996, lng: 78.4365126859784 },
        { lat: 17.43411271428176, lng: 78.43653922992468 },
        { lat: 17.43410612679809, lng: 78.43656281586001 },
        { lat: 17.43409111340217, lng: 78.43660069207534 },
        { lat: 17.43405308063046, lng: 78.43669564407544 },
        { lat: 17.43401869037658, lng: 78.43677117140253 },
        { lat: 17.43396244782179, lng: 78.43688730960845 },
        { lat: 17.43391012483303, lng: 78.43700007166869 },
        { lat: 17.43389401457375, lng: 78.43703729134948 },
        { lat: 17.43388313095044, lng: 78.43706398761061 },
        { lat: 17.4338749809291, lng: 78.43708659235237 },
        { lat: 17.43386279190702, lng: 78.43711859649238 },
        { lat: 17.43383860927955, lng: 78.43718389480495 },
        { lat: 17.43380951708007, lng: 78.43727719463027 },
        { lat: 17.43379365135378, lng: 78.43733973096329 },
        { lat: 17.43377973652114, lng: 78.43742774361525 },
        { lat: 17.43376389316296, lng: 78.43757250810283 },
        { lat: 17.43375467520691, lng: 78.43769487546217 },
        { lat: 17.43375046660901, lng: 78.43778576805289 },
        { lat: 17.43374359329266, lng: 78.43788940825343 },
        { lat: 17.43374151789113, lng: 78.43791446943878 },
        { lat: 17.43373772970716, lng: 78.43794364268261 },
        { lat: 17.43373298494024, lng: 78.43797638582406 },
        { lat: 17.43372342661153, lng: 78.43801547188029 },
        { lat: 17.43371531772736, lng: 78.43804507240597 },
        { lat: 17.43369831300313, lng: 78.43811821892083 },
        { lat: 17.43369073768055, lng: 78.43815685858026 },
        { lat: 17.43366979909218, lng: 78.43825972605862 },
        { lat: 17.43366198052637, lng: 78.43832396583139 },
        { lat: 17.43364199279992, lng: 78.43843398671436 },
        { lat: 17.43362200848699, lng: 78.43853929370904 },
        { lat: 17.43360493449939, lng: 78.43865530023315 },
        { lat: 17.43359213718594, lng: 78.43872681477588 },
        { lat: 17.43358136984675, lng: 78.43877485510757 },
        { lat: 17.43395215670465, lng: 78.438886715036 },
        { lat: 17.43412625006448, lng: 78.43893614706563 },
        { lat: 17.43427504619757, lng: 78.43898232403642 },
        { lat: 17.43455084984036, lng: 78.43906249016496 },
        { lat: 17.43468157351128, lng: 78.43910150445545 },
        { lat: 17.43481293438967, lng: 78.43913732592358 },
        { lat: 17.43494905815658, lng: 78.43917704585058 },
        { lat: 17.43505234341227, lng: 78.4392117699115 },
        { lat: 17.43517651437791, lng: 78.4392504881977 },
        { lat: 17.43531033809395, lng: 78.4392842656957 },
        { lat: 17.43542285665675, lng: 78.4393144415893 },
        { lat: 17.43554732810786, lng: 78.43935173504664 },
        { lat: 17.43571001079115, lng: 78.43939667431691 },
        { lat: 17.43582835628692, lng: 78.43942345513865 },
        { lat: 17.43596387598577, lng: 78.43945146215363 },
        { lat: 17.43612180782753, lng: 78.43948059025672 },
        { lat: 17.43626089599693, lng: 78.43950136846884 },
        { lat: 17.43632343941641, lng: 78.4395054934295 },
        { lat: 17.43643640746456, lng: 78.43950566461257 },
        { lat: 17.43646241514949, lng: 78.43956654179594 },
        { lat: 17.4365010552321, lng: 78.43963372074697 },
        { lat: 17.43652697341243, lng: 78.43967001636315 },
        { lat: 17.43656224556274, lng: 78.43970847627212 },
        { lat: 17.43659948827156, lng: 78.43977403010648 },
        { lat: 17.43664298814515, lng: 78.43980461372756 },
        { lat: 17.43675147646258, lng: 78.43985197351176 },
        { lat: 17.43686340199034, lng: 78.43989046536609 },
        { lat: 17.43699862463491, lng: 78.43993006789407 },
        { lat: 17.43710363264088, lng: 78.43996861968714 },
        { lat: 17.43726639871966, lng: 78.44001119876188 },
        { lat: 17.43749458323184, lng: 78.44008207798795 },
        { lat: 17.43756565054266, lng: 78.44013007706478 },
        { lat: 17.43762752183765, lng: 78.44022317036057 },
        { lat: 17.43767049913848, lng: 78.44030990156192 },
        { lat: 17.43783772443559, lng: 78.4403157008666 },
        { lat: 17.43863772165336, lng: 78.44040926333898 },
        { lat: 17.43879002671819, lng: 78.44046325450697 },
        { lat: 17.43893366095486, lng: 78.44050843657055 },
        { lat: 17.43923230795886, lng: 78.44057860343797 },
        { lat: 17.43988178153771, lng: 78.44074252084235 },
        { lat: 17.4398807746791, lng: 78.44078390511518 },
        { lat: 17.43985790697585, lng: 78.44097564055126 },
        { lat: 17.43983838960068, lng: 78.44124041773708 },
        { lat: 17.43985437588504, lng: 78.44133042389169 },
        { lat: 17.4398621364756, lng: 78.44145748899585 },
        { lat: 17.43984946475577, lng: 78.44152920558483 },
        { lat: 17.43983780556073, lng: 78.44158350484237 },
        { lat: 17.43984278801262, lng: 78.44168268889413 },
        { lat: 17.43984891844312, lng: 78.442216236067 },
        { lat: 17.43987200519604, lng: 78.44231813250595 },
        { lat: 17.43994486075253, lng: 78.44250131515882 },
        { lat: 17.44025238476236, lng: 78.4423623185689 },
        { lat: 17.44283726266325, lng: 78.44086852549316 },
        { lat: 17.44362752857904, lng: 78.44046099763827 },
        { lat: 17.44389984021785, lng: 78.44028534884261 },
        { lat: 17.44419972044921, lng: 78.44013486854894 },
        { lat: 17.44431845334693, lng: 78.4400733951824 },
        { lat: 17.44441508212089, lng: 78.44000827844013 },
        { lat: 17.44450236078967, lng: 78.43994481086906 },
        { lat: 17.44461864707978, lng: 78.4398661522128 },
        { lat: 17.44468133935743, lng: 78.43982695409048 },
        { lat: 17.44488350959778, lng: 78.43971346282656 },
        { lat: 17.4455881534584, lng: 78.43933837680818 },
        { lat: 17.446496069342, lng: 78.43878173874202 },
        { lat: 17.44748762825104, lng: 78.43827715641609 },
        { lat: 17.44750000994051, lng: 78.4382708549349 },
        { lat: 17.44797079324781, lng: 78.43797552192709 },
        { lat: 17.44808304619658, lng: 78.43790510301824 },
        { lat: 17.44873160160647, lng: 78.43755609250763 },
        { lat: 17.44981625407351, lng: 78.43707343694837 },
        { lat: 17.45031012807746, lng: 78.43684758770576 },
        { lat: 17.45115282226505, lng: 78.43637933198833 },
        { lat: 17.4527861796732, lng: 78.43558600646453 },
        { lat: 17.45392202418265, lng: 78.43494264530904 },
        { lat: 17.45434387729247, lng: 78.43475430077737 },
        { lat: 17.4554545481714, lng: 78.43426955925577 },
        { lat: 17.45609351908369, lng: 78.43399732733897 },
        { lat: 17.45611162296523, lng: 78.4339898318579 },
        { lat: 17.45645316595857, lng: 78.43384592890882 },
        { lat: 17.45686915964288, lng: 78.43365144437772 },
        { lat: 17.45723300555145, lng: 78.43348967035116 },
        { lat: 17.45765456366147, lng: 78.4332913833922 },
        { lat: 17.45870982545445, lng: 78.43280361174595 },
        { lat: 17.45954485904745, lng: 78.43242085725655 },
        { lat: 17.46010644680923, lng: 78.43217062982615 },
        { lat: 17.46100282531656, lng: 78.43175630304715 },
        { lat: 17.46186971697181, lng: 78.43137134717169 },
        { lat: 17.46187253829843, lng: 78.43131695028106 },
        { lat: 17.46194665100091, lng: 78.43032865214117 },
        { lat: 17.46195716888009, lng: 78.42975585111635 },
        { lat: 17.46195032932438, lng: 78.42922686610088 },
        { lat: 17.46191975780136, lng: 78.42871066236738 },
        { lat: 17.46184986903025, lng: 78.42838797054341 },
        { lat: 17.46178732172629, lng: 78.42817099193977 },
        { lat: 17.45979548997048, lng: 78.42844171400156 },
        { lat: 17.45973081997809, lng: 78.42815297965677 },
        { lat: 17.45919915315285, lng: 78.4279239178941 },
        { lat: 17.45919719075121, lng: 78.42754169852596 },
        { lat: 17.45692949797382, lng: 78.42693208861348 },
        { lat: 17.45708962635716, lng: 78.42642348066585 },
        { lat: 17.45540556830008, lng: 78.4260526397977 },
        { lat: 17.45585642750169, lng: 78.42502500322038 },
        { lat: 17.45462442276259, lng: 78.42459766035805 },
        { lat: 17.45452676623356, lng: 78.42458255649301 },
        { lat: 17.45452243587565, lng: 78.42505040036627 },
        { lat: 17.45316864840448, lng: 78.42480846618281 },
        { lat: 17.45311366428478, lng: 78.42482209172775 },
        { lat: 17.45291611284292, lng: 78.4265038226766 },
        { lat: 17.45030341279003, lng: 78.4262485041462 },
        { lat: 17.45050964740858, lng: 78.42472718390079 },
        { lat: 17.45063198848611, lng: 78.42430381770146 },
        { lat: 17.45112192524506, lng: 78.42432629151612 },
        { lat: 17.45130842944168, lng: 78.42433889683623 },
        { lat: 17.45175061754476, lng: 78.42434537058195 },
        { lat: 17.45188624613025, lng: 78.42356718145422 },
        { lat: 17.45193783600642, lng: 78.42309667872273 },
        { lat: 17.452212232645, lng: 78.4231863664037 },
        { lat: 17.45436069820378, lng: 78.42337029523162 },
        { lat: 17.45412259543677, lng: 78.4217627866905 },
        { lat: 17.45410949821461, lng: 78.42165726902084 },
        { lat: 17.45407006739494, lng: 78.421436448488 },
        { lat: 17.45401384986653, lng: 78.42110742704952 },
        { lat: 17.45398775837141, lng: 78.42089275559564 },
        { lat: 17.45395319811628, lng: 78.42027179090347 },
        { lat: 17.45395650013555, lng: 78.41989255064468 },
        { lat: 17.45395561225342, lng: 78.41983545717466 },
        { lat: 17.45393752404435, lng: 78.41936343787339 },
        { lat: 17.45392584360604, lng: 78.41905866130206 },
        { lat: 17.45396061130933, lng: 78.41851521726277 },
        { lat: 17.45402323257104, lng: 78.41774999549847 },
        { lat: 17.45410859111352, lng: 78.41658701237475 },
        { lat: 17.45436848362871, lng: 78.41549768906772 },
        { lat: 17.45444514893111, lng: 78.41527607196332 },
        { lat: 17.45473763056653, lng: 78.41456195571126 },
        { lat: 17.45494802689355, lng: 78.41409203190437 },
        { lat: 17.45498928003384, lng: 78.41400220444824 },
        { lat: 17.45505802087344, lng: 78.4138502353633 },
        { lat: 17.45512099908816, lng: 78.41369087615507 },
        { lat: 17.45513100531099, lng: 78.41366818058206 },
        { lat: 17.4551646629818, lng: 78.41359031840216 },
        { lat: 17.4551931397512, lng: 78.41351881601959 },
        { lat: 17.455204838085, lng: 78.41348081410281 },
        { lat: 17.45521627605885, lng: 78.41340335120222 },
        { lat: 17.45525001702879, lng: 78.41323899580549 },
        { lat: 17.45526365791957, lng: 78.4131613418111 },
        { lat: 17.45527428998319, lng: 78.41310802825441 },
        { lat: 17.45527854018034, lng: 78.41308337669496 },
        { lat: 17.45545087105651, lng: 78.411750247744 },
        { lat: 17.45552785519486, lng: 78.41149366257713 },
        { lat: 17.45554404272337, lng: 78.41128823919698 },
        { lat: 17.45554506902134, lng: 78.41128833290766 },
        { lat: 17.45557675807747, lng: 78.41120730717921 },
        { lat: 17.45566465582083, lng: 78.410911300373 },
        { lat: 17.4557162549631, lng: 78.41071639336012 },
        { lat: 17.45573609072552, lng: 78.41061580172868 },
        { lat: 17.45577083177285, lng: 78.41047731785616 },
        { lat: 17.45564743757695, lng: 78.41041918374322 },
        { lat: 17.45543274441744, lng: 78.41035513705299 },
        { lat: 17.45477762940957, lng: 78.41007513585494 },
        { lat: 17.45413726300881, lng: 78.40982671293843 },
        { lat: 17.45425013903429, lng: 78.40950178146134 },
        { lat: 17.45376470659767, lng: 78.40932738130915 },
        { lat: 17.45309717469745, lng: 78.40857982253276 },
        { lat: 17.45204851369985, lng: 78.40719497831336 },
        { lat: 17.45058626379653, lng: 78.40535311601862 },
        { lat: 17.45060472784945, lng: 78.40504356805707 },
        { lat: 17.450651221132, lng: 78.40426407502194 },
        { lat: 17.45148907375022, lng: 78.40225013458821 },
        { lat: 17.45203682020045, lng: 78.40168931534747 },
        { lat: 17.45388335754302, lng: 78.3993806138406 },
        { lat: 17.45407341872673, lng: 78.39754215117196 },
        { lat: 17.45467330358728, lng: 78.39764823512449 },
        { lat: 17.45491183335831, lng: 78.3972183694565 },
        { lat: 17.45506631960725, lng: 78.39724354276723 },
        { lat: 17.45620906291098, lng: 78.39296890048273 },
        { lat: 17.46214055367205, lng: 78.38753198180133 },
        { lat: 17.4626053749725, lng: 78.38754989284051 },
        { lat: 17.4652005331924, lng: 78.38572614935242 },
        { lat: 17.4668041453812, lng: 78.38481975339374 },
        { lat: 17.4673242137431, lng: 78.38441531950482 },
        { lat: 17.46823539607133, lng: 78.38393504067386 },
        { lat: 17.46924732504256, lng: 78.38307012039999 },
        { lat: 17.46952377041524, lng: 78.382903354231 },
        { lat: 17.46992887495022, lng: 78.38252619171544 },
        { lat: 17.47167007194791, lng: 78.38019406384525 },
        { lat: 17.47277483550921, lng: 78.37755873262176 },
        { lat: 17.47345790880801, lng: 78.37701924363614 },
        { lat: 17.47680002567144, lng: 78.37838937668579 },
        { lat: 17.47704330250705, lng: 78.3780768067976 },
        { lat: 17.48393546432293, lng: 78.38066723101936 },
        { lat: 17.48708093385997, lng: 78.38181740395738 },
        { lat: 17.48804149554624, lng: 78.38217716074472 },
        { lat: 17.4882057563339, lng: 78.3822154402748 },
        { lat: 17.48817509445788, lng: 78.38228335169559 },
        { lat: 17.49031655669605, lng: 78.38307841458915 },
        { lat: 17.49162978480589, lng: 78.38176873414669 },
        { lat: 17.49240321930146, lng: 78.38011615906379 },
        { lat: 17.49003282018645, lng: 78.3785061926096 },
        { lat: 17.48756379516828, lng: 78.37692636375225 },
        { lat: 17.48618184887669, lng: 78.37695928973604 },
        { lat: 17.48437222984538, lng: 78.37694088578674 },
        { lat: 17.48360620049542, lng: 78.37678706414104 },
        { lat: 17.47920842643133, lng: 78.37558147315919 },
        { lat: 17.48073752724562, lng: 78.37392688070132 },
        { lat: 17.4818778753034, lng: 78.37199705133762 },
        { lat: 17.48213679279272, lng: 78.37046055815179 },
        { lat: 17.48221152255491, lng: 78.3690871347425 },
        { lat: 17.4824853021988, lng: 78.36596920767803 },
        { lat: 17.48458352127687, lng: 78.36612765299151 },
        { lat: 17.48450732525816, lng: 78.36707220327906 },
        { lat: 17.49008452706867, lng: 78.36960944893299 },
        { lat: 17.49284536216774, lng: 78.37102618383398 },
        { lat: 17.49316933393836, lng: 78.37136384994255 },
        { lat: 17.49682503774628, lng: 78.37508358442429 },
        { lat: 17.49690107475735, lng: 78.37516067051493 },
        { lat: 17.49652810468158, lng: 78.3740472753715 },
        { lat: 17.49932352449428, lng: 78.37432649794911 },
        { lat: 17.50166289409109, lng: 78.37467071577629 },
        { lat: 17.50428281132048, lng: 78.3748437628246 },
        { lat: 17.50704549450872, lng: 78.37574294106696 },
        { lat: 17.50719420432007, lng: 78.3735603136154 },
        { lat: 17.51303892529047, lng: 78.37361877182543 },
        { lat: 17.51302544963618, lng: 78.37324873431172 },
        { lat: 17.51412764418469, lng: 78.37275471464211 },
        { lat: 17.51492694002908, lng: 78.37248420641205 },
        { lat: 17.51480551411041, lng: 78.37142500727431 },
        { lat: 17.51561958203802, lng: 78.37137844426918 },
        { lat: 17.51609528258815, lng: 78.37121220593242 },
        { lat: 17.51725850473496, lng: 78.37099621556611 },
        { lat: 17.51872779110742, lng: 78.37079573505943 },
        { lat: 17.51898725615221, lng: 78.36873984286355 },
        { lat: 17.51890022841613, lng: 78.3679441461112 },
        { lat: 17.51896001202924, lng: 78.3666880847385 },
        { lat: 17.51898606239272, lng: 78.36577121463338 },
        { lat: 17.51934416839451, lng: 78.3653874934217 },
        { lat: 17.51996640579078, lng: 78.36474094565493 },
        { lat: 17.52056396460452, lng: 78.36367634842006 },
        { lat: 17.52127539469591, lng: 78.36255032597433 },
        { lat: 17.52020486045884, lng: 78.3611113578878 },
        { lat: 17.5197236046386, lng: 78.36085930838195 },
        { lat: 17.51958610507388, lng: 78.36058236407459 },
        { lat: 17.51984227109484, lng: 78.35972193626692 },
        { lat: 17.52012497724283, lng: 78.35798447434557 },
        { lat: 17.52048464805398, lng: 78.35628574203817 },
        { lat: 17.52055522738838, lng: 78.35441188124815 },
        { lat: 17.52095628246835, lng: 78.35295162668903 },
        { lat: 17.52135519738514, lng: 78.35133200793418 },
        { lat: 17.52080860801881, lng: 78.35048321932057 },
        { lat: 17.5208518296845, lng: 78.34942663254766 },
        { lat: 17.52129334884623, lng: 78.34242697785092 },
        { lat: 17.51895045935446, lng: 78.34162431408245 },
        { lat: 17.51804315818279, lng: 78.34173418097943 },
        { lat: 17.51804606503529, lng: 78.34172742746296 },
        { lat: 17.51790560154618, lng: 78.34123138985488 },
        { lat: 17.51802896642354, lng: 78.3404525820857 },
        { lat: 17.51810634891056, lng: 78.33909666799318 },
        { lat: 17.51838057805564, lng: 78.33674171541179 },
        { lat: 17.51809416646365, lng: 78.33676581777846 },
        { lat: 17.51755983352621, lng: 78.3368333858077 },
        { lat: 17.51767862847618, lng: 78.33571594970287 },
        { lat: 17.51723717957096, lng: 78.33558293278801 },
        { lat: 17.51727175299351, lng: 78.3338889585293 },
        { lat: 17.51645181491249, lng: 78.33404039670872 },
        { lat: 17.51651584628802, lng: 78.33453753880218 },
        { lat: 17.51623050654133, lng: 78.33464132254055 },
        { lat: 17.51626246930948, lng: 78.33559716209012 },
        { lat: 17.51576796753383, lng: 78.3357836875578 },
        { lat: 17.51599960652146, lng: 78.33737415232581 },
        { lat: 17.51440046803669, lng: 78.33644118170656 },
        { lat: 17.51447370591116, lng: 78.33620103696978 },
        { lat: 17.51260351658144, lng: 78.33501304426812 },
        { lat: 17.51230371838243, lng: 78.33404121170328 },
        { lat: 17.51194594603004, lng: 78.3344448867758 },
        { lat: 17.5110492913861, lng: 78.33457751269682 },
        { lat: 17.51005145246857, lng: 78.33429324455544 },
        { lat: 17.50913702305411, lng: 78.33452573976042 },
        { lat: 17.50912353285276, lng: 78.33494430564433 },
        { lat: 17.50801503753971, lng: 78.33496048382513 },
        { lat: 17.50717009711814, lng: 78.33467398237637 },
        { lat: 17.50596797493859, lng: 78.33212641096438 },
        { lat: 17.50552384738766, lng: 78.33159100315032 },
        { lat: 17.50664957522845, lng: 78.32976170841552 },
        { lat: 17.50813076300893, lng: 78.32758493625448 },
        { lat: 17.50846719572473, lng: 78.3248905293383 },
        { lat: 17.50863480994373, lng: 78.32243765908935 },
        { lat: 17.5063190998626, lng: 78.32259198945768 },
        { lat: 17.5061034981002, lng: 78.31791750965083 },
        { lat: 17.50638644980409, lng: 78.31683020205237 },
        { lat: 17.50794897359291, lng: 78.31698720536428 },
        { lat: 17.5082176908489, lng: 78.31697040610756 },
        { lat: 17.50855180236158, lng: 78.31624389679425 },
        { lat: 17.5086332168818, lng: 78.315712223584 },
        { lat: 17.50877835855956, lng: 78.31516061884409 },
        { lat: 17.50878659684424, lng: 78.31470209764443 },
        { lat: 17.50861897866121, lng: 78.3146509381504 },
        { lat: 17.50847394498197, lng: 78.31424296069065 },
        { lat: 17.50823003311289, lng: 78.31419202875941 },
        { lat: 17.50808461601929, lng: 78.31387849440608 },
        { lat: 17.50807865420417, lng: 78.31357886687074 },
        { lat: 17.50805749915213, lng: 78.31263736218669 },
        { lat: 17.50805620920755, lng: 78.31203447082687 },
        { lat: 17.50778287504454, lng: 78.3114641303112 },
        { lat: 17.50805565230428, lng: 78.31041829851048 },
        { lat: 17.50801890923649, lng: 78.30781175824698 },
        { lat: 17.50801871511262, lng: 78.30781156157764 },
        { lat: 17.50808495954159, lng: 78.30782375964802 },
        { lat: 17.50813519011588, lng: 78.30781663973421 },
        { lat: 17.50830411478027, lng: 78.30779192593029 },
        { lat: 17.50841589450238, lng: 78.30777297699657 },
        { lat: 17.50853457373016, lng: 78.30773612655433 },
        { lat: 17.50898199778382, lng: 78.30767822724732 },
        { lat: 17.5093754262064, lng: 78.30758859512976 },
        { lat: 17.50939576471849, lng: 78.3075837464443 },
        { lat: 17.50968959193214, lng: 78.30750916962296 },
        { lat: 17.51002437872042, lng: 78.30736043967588 },
        { lat: 17.51019514216337, lng: 78.30715270665237 },
        { lat: 17.51049395531186, lng: 78.3068350839547 },
        { lat: 17.51070229040164, lng: 78.30653229178566 },
        { lat: 17.51081402914972, lng: 78.30636593162889 },
        { lat: 17.51081759661131, lng: 78.30624707520852 },
        { lat: 17.51081768134461, lng: 78.30608192178175 },
        { lat: 17.51081791883125, lng: 78.30605632519789 },
        { lat: 17.51082497353021, lng: 78.3058365377675 },
        { lat: 17.51079055255413, lng: 78.30559133453377 },
        { lat: 17.51079031588053, lng: 78.30538342542663 },
        { lat: 17.51088530034306, lng: 78.30512820485576 },
        { lat: 17.51088327037123, lng: 78.30497882707657 },
        { lat: 17.51088300193511, lng: 78.30493648087125 },
        { lat: 17.51088363593649, lng: 78.30481501267585 },
        { lat: 17.51079959275218, lng: 78.30454083529251 },
        { lat: 17.51069129990815, lng: 78.30438852668128 },
        { lat: 17.51048876430577, lng: 78.30416470564766 },
        { lat: 17.51034576707853, lng: 78.30393730001063 },
        { lat: 17.51027019426837, lng: 78.30371430621682 },
        { lat: 17.5102213660886, lng: 78.3035530176435 },
        { lat: 17.51019405200786, lng: 78.30325910403403 },
        { lat: 17.51021049541923, lng: 78.30313465462919 },
        { lat: 17.51025631180407, lng: 78.30307457254129 },
        { lat: 17.51036523767114, lng: 78.30289205657633 },
        { lat: 17.51044775734286, lng: 78.30278046647612 },
        { lat: 17.5105073421245, lng: 78.3026516053468 },
        { lat: 17.51055223645098, lng: 78.30255388980069 },
        { lat: 17.51061630525767, lng: 78.30242167092591 },
        { lat: 17.51072723542497, lng: 78.30222044566705 },
        { lat: 17.51081594259966, lng: 78.30210301574867 },
        { lat: 17.51086653164815, lng: 78.30203120220935 },
        { lat: 17.51090745677575, lng: 78.30197020837839 },
        { lat: 17.51097123408346, lng: 78.30194496889165 },
        { lat: 17.51105581502963, lng: 78.30184195386737 },
        { lat: 17.51120028927103, lng: 78.30164237043631 },
        { lat: 17.51130824311047, lng: 78.30152153257026 },
        { lat: 17.51133826663249, lng: 78.3014894513544 },
        { lat: 17.51143507629553, lng: 78.30140119575381 },
        { lat: 17.51143545132372, lng: 78.30139464417074 },
        { lat: 17.51146528511616, lng: 78.30137855198448 },
        { lat: 17.51158329636961, lng: 78.30130104571923 },
        { lat: 17.51168674533329, lng: 78.30129951653173 },
        { lat: 17.51199627790546, lng: 78.301127864435 },
        { lat: 17.51203535225373, lng: 78.30110754413232 },
        { lat: 17.51216745191215, lng: 78.3009825666348 },
        { lat: 17.51228046828855, lng: 78.30085936949504 },
        { lat: 17.51235416408218, lng: 78.3007965237717 },
        { lat: 17.51242559137621, lng: 78.30070780960942 },
        { lat: 17.51250410039958, lng: 78.30057715508289 },
        { lat: 17.51257673489648, lng: 78.30043662561302 },
        { lat: 17.51262302129928, lng: 78.30032636799054 },
        { lat: 17.51269489574167, lng: 78.30007139814201 },
        { lat: 17.51274087616797, lng: 78.29983310339107 },
        { lat: 17.51278761419379, lng: 78.29968667024838 },
        { lat: 17.51280774213667, lng: 78.29961571813459 },
        { lat: 17.51283450389147, lng: 78.29951013694193 },
        { lat: 17.51285057481518, lng: 78.29945441327736 },
        { lat: 17.51289226769201, lng: 78.2993448293946 },
        { lat: 17.51292873305931, lng: 78.29916877958439 },
        { lat: 17.51302074603362, lng: 78.29888660104302 },
        { lat: 17.51304096962914, lng: 78.2986594834614 },
        { lat: 17.51302136647505, lng: 78.29855176644774 },
        { lat: 17.51297101291239, lng: 78.29846880645515 },
        { lat: 17.51293849525695, lng: 78.29836398001824 },
        { lat: 17.51279707197682, lng: 78.2981766076445 },
        { lat: 17.5127777451273, lng: 78.29812934970931 },
        { lat: 17.51269922570649, lng: 78.29791659322345 },
        { lat: 17.5126917776574, lng: 78.29779933447018 },
        { lat: 17.51269117720508, lng: 78.29779901017226 },
        { lat: 17.5126924405132, lng: 78.29779058652713 },
        { lat: 17.51269115681705, lng: 78.29778956173426 },
        { lat: 17.51268603310725, lng: 78.29770887386898 },
        { lat: 17.5127224175114, lng: 78.29758689369508 },
        { lat: 17.51272306421229, lng: 78.29758663564404 },
        { lat: 17.51272513899407, lng: 78.29757281630157 },
        { lat: 17.51272715192417, lng: 78.29757102457056 },
        { lat: 17.51276531531634, lng: 78.29744308184512 },
        { lat: 17.5127986356642, lng: 78.29722657387819 },
        { lat: 17.51278248124477, lng: 78.29699189905658 },
        { lat: 17.51273476856436, lng: 78.2967225885268 },
        { lat: 17.51271574427459, lng: 78.29627733882171 },
        { lat: 17.51272500884049, lng: 78.29622003955848 },
        { lat: 17.51274550113576, lng: 78.29609894494129 },
        { lat: 17.51277428672288, lng: 78.2959576807909 },
        { lat: 17.51280084757018, lng: 78.29580586197635 },
        { lat: 17.51280990940786, lng: 78.29575304392509 },
        { lat: 17.51291744284597, lng: 78.29551653703504 },
        { lat: 17.51299168777532, lng: 78.29540405227127 },
        { lat: 17.51302347297813, lng: 78.29531245215347 },
        { lat: 17.51302586588066, lng: 78.29520306110126 },
        { lat: 17.51301646421161, lng: 78.29508371747175 },
        { lat: 17.51298736133589, lng: 78.29494441299113 },
        { lat: 17.51298598847193, lng: 78.29494360507577 },
        { lat: 17.51298703611009, lng: 78.29493315066941 },
        { lat: 17.51298367815508, lng: 78.29481688657015 },
        { lat: 17.51294944502273, lng: 78.2945865262685 },
        { lat: 17.51299422058278, lng: 78.29445018172518 },
        { lat: 17.5130747912449, lng: 78.29437405653455 },
        { lat: 17.51313170723114, lng: 78.29435753910195 },
        { lat: 17.51317976229977, lng: 78.2943451314573 },
        { lat: 17.51325207871941, lng: 78.2943226095715 },
        { lat: 17.51333220408184, lng: 78.2942993620194 },
        { lat: 17.51350558359689, lng: 78.29418945713226 },
        { lat: 17.51355359774902, lng: 78.29414824347772 },
        { lat: 17.51358343743829, lng: 78.29405666987816 },
        { lat: 17.51359768120091, lng: 78.29396127838235 },
        { lat: 17.51357678996033, lng: 78.29385425489649 },
        { lat: 17.51356569495256, lng: 78.29375316451461 },
        { lat: 17.51360747752367, lng: 78.29353990702056 },
        { lat: 17.51370598196809, lng: 78.293354157522 },
        { lat: 17.51378852457543, lng: 78.29328002779332 },
        { lat: 17.51389317954729, lng: 78.29326025044043 },
        { lat: 17.51403385573688, lng: 78.29331689391321 },
        { lat: 17.51408043890473, lng: 78.29332759084744 },
        { lat: 17.51416454396004, lng: 78.29335343170278 },
        { lat: 17.51422676357291, lng: 78.29335656195641 },
        { lat: 17.51424876118541, lng: 78.29334468714808 },
        { lat: 17.51429034931056, lng: 78.29331713778946 },
        { lat: 17.51430311774038, lng: 78.29325619719674 },
        { lat: 17.51424397243018, lng: 78.29297089043354 },
        { lat: 17.51422685908377, lng: 78.29289971594173 },
        { lat: 17.51422155632279, lng: 78.29289879784483 },
        { lat: 17.51421974435586, lng: 78.29287601548118 },
        { lat: 17.51407772700289, lng: 78.2924029033544 },
        { lat: 17.51402502047407, lng: 78.29231354107993 },
        { lat: 17.5140225871896, lng: 78.29213536252641 },
        { lat: 17.51406637181374, lng: 78.2919267985585 },
        { lat: 17.51411640817391, lng: 78.29179644828503 },
        { lat: 17.51426876259585, lng: 78.2915700731878 },
        { lat: 17.51444294805952, lng: 78.2914243760361 },
        { lat: 17.51455614401294, lng: 78.29136599415692 },
        { lat: 17.51460063455979, lng: 78.29132246752825 },
        { lat: 17.51462303641299, lng: 78.2913206272795 },
        { lat: 17.514863438252, lng: 78.29107799145198 },
        { lat: 17.51499203175337, lng: 78.29104619859575 },
        { lat: 17.51523570087063, lng: 78.29104258219222 },
        { lat: 17.51562280628205, lng: 78.29104430822329 },
        { lat: 17.51595431296465, lng: 78.2911738651371 },
        { lat: 17.51612129002243, lng: 78.29132827742747 },
        { lat: 17.51649497957957, lng: 78.29139743886854 },
        { lat: 17.51678175198261, lng: 78.29140065525525 },
        { lat: 17.51704590025102, lng: 78.29132202364072 },
        { lat: 17.51754030182123, lng: 78.29130721715907 },
        { lat: 17.51766254461095, lng: 78.29133528668893 },
        { lat: 17.51785257517608, lng: 78.29107845101947 },
        { lat: 17.5179639779752, lng: 78.29083772592686 },
        { lat: 17.51882469757626, lng: 78.29087724469382 },
        { lat: 17.51916686381169, lng: 78.29073768542257 },
        { lat: 17.51947780877465, lng: 78.29041181539598 },
        { lat: 17.5195185635392, lng: 78.29024684539252 },
        { lat: 17.51953116014529, lng: 78.2901196510693 },
        { lat: 17.51952944225314, lng: 78.28946969457768 },
        { lat: 17.52031778098327, lng: 78.28945798422131 },
        { lat: 17.52061500273292, lng: 78.28917713749077 },
        { lat: 17.52090904210187, lng: 78.28918771307393 },
        { lat: 17.52182331602732, lng: 78.28894999356808 },
        { lat: 17.52204846273552, lng: 78.28864033088823 },
        { lat: 17.52260797660737, lng: 78.28866937212638 },
        { lat: 17.52301606977199, lng: 78.28863342255038 },
        { lat: 17.5230184233361, lng: 78.28861521484183 },
        { lat: 17.52302552899012, lng: 78.2886147063827 },
        { lat: 17.52322642846196, lng: 78.28859066762547 },
        { lat: 17.52420945688964, lng: 78.28823280992671 },
        { lat: 17.52483638932416, lng: 78.2880363348933 },
        { lat: 17.52552677327379, lng: 78.28808837688594 },
        { lat: 17.52630468118352, lng: 78.28801437708671 },
        { lat: 17.52654785485048, lng: 78.28826020903398 },
        { lat: 17.5270905673182, lng: 78.28850171196758 },
        { lat: 17.52733285487598, lng: 78.28868519090155 },
        { lat: 17.52811608206089, lng: 78.2889853221769 },
        { lat: 17.52823944089381, lng: 78.28923309571243 },
        { lat: 17.5284518980419, lng: 78.28938584011347 },
        { lat: 17.52929325765992, lng: 78.28956036618833 },
        { lat: 17.5295618325916, lng: 78.2895251680485 },
        { lat: 17.53009991292074, lng: 78.28936120189297 },
        { lat: 17.53036538414063, lng: 78.2891077576923 },
        { lat: 17.5307785298771, lng: 78.28866484918862 },
        { lat: 17.53152438889552, lng: 78.28840421795114 },
        { lat: 17.53178586870691, lng: 78.28787002220047 },
        { lat: 17.53250322125613, lng: 78.28767203443543 },
        { lat: 17.53288451547104, lng: 78.2871361876481 },
        { lat: 17.5335673575004, lng: 78.28665804854484 },
        { lat: 17.53449490839226, lng: 78.28661297758197 },
        { lat: 17.53566321748149, lng: 78.28656430305661 },
        { lat: 17.53601999789529, lng: 78.2863718483124 },
        { lat: 17.53622358086749, lng: 78.28590087463 },
        { lat: 17.53630488661384, lng: 78.28533817369953 },
        { lat: 17.53638598819936, lng: 78.28468191984435 },
        { lat: 17.53689463208578, lng: 78.2846742970205 },
        { lat: 17.53701222625016, lng: 78.2845166080031 },
        { lat: 17.53736189706713, lng: 78.28382514196755 },
        { lat: 17.5379191375512, lng: 78.2829434471021 },
        { lat: 17.53814943437386, lng: 78.28228494958238 },
        { lat: 17.53829087430233, lng: 78.28165896951666 },
        { lat: 17.53975535827003, lng: 78.2814497379132 },
        { lat: 17.54008674339986, lng: 78.28153832296144 },
        { lat: 17.54047715004558, lng: 78.28156379986787 },
        { lat: 17.54116239972345, lng: 78.28133506858538 },
        { lat: 17.54170333768302, lng: 78.28145169542148 },
        { lat: 17.54260372142303, lng: 78.28156307903599 },
        { lat: 17.5441624281725, lng: 78.28153968791939 },
        { lat: 17.5458721135801, lng: 78.28163877803475 },
        { lat: 17.54769959564436, lng: 78.28167372309137 },
      ],
      [
        { lat: 17.53352887918665, lng: 78.28252604536664 },
        { lat: 17.53345219953772, lng: 78.28293512839714 },
        { lat: 17.53345389541311, lng: 78.2829867391463 },
        { lat: 17.53344711425841, lng: 78.28304013479577 },
        { lat: 17.53336148316174, lng: 78.28322052818866 },
        { lat: 17.53329202459536, lng: 78.28336685105356 },
        { lat: 17.53324773875043, lng: 78.28346014617732 },
        { lat: 17.53318882192669, lng: 78.28356165182663 },
        { lat: 17.53317100319972, lng: 78.28364138375188 },
        { lat: 17.53316602033645, lng: 78.28370199206508 },
        { lat: 17.53316377788078, lng: 78.28373221108964 },
        { lat: 17.53315579683952, lng: 78.28384498386319 },
        { lat: 17.5331538122241, lng: 78.28390046354627 },
        { lat: 17.53315108560242, lng: 78.28397664877167 },
        { lat: 17.53314733118902, lng: 78.28408154673367 },
        { lat: 17.53313279223996, lng: 78.28424045713498 },
        { lat: 17.53313045721002, lng: 78.28430042263115 },
        { lat: 17.53213137230586, lng: 78.28434246153675 },
        { lat: 17.53135724930766, lng: 78.28444378617809 },
        { lat: 17.5312195944259, lng: 78.28390718082424 },
        { lat: 17.53069920692701, lng: 78.28364579245266 },
        { lat: 17.52979254030826, lng: 78.28356950141783 },
        { lat: 17.52948130668956, lng: 78.28299063929089 },
        { lat: 17.52858039290504, lng: 78.28331833269988 },
        { lat: 17.52746344100787, lng: 78.28355953010882 },
        { lat: 17.52574240650344, lng: 78.28385463790504 },
        { lat: 17.52385019847368, lng: 78.284197160242 },
        { lat: 17.52358816098694, lng: 78.28397662457368 },
        { lat: 17.52263663043103, lng: 78.28376656213885 },
        { lat: 17.52245857738477, lng: 78.28341003590708 },
        { lat: 17.52163462338978, lng: 78.2831081944878 },
        { lat: 17.52136683591, lng: 78.2824838450673 },
        { lat: 17.52165648681585, lng: 78.28162668786571 },
        { lat: 17.52177432953245, lng: 78.28077224899583 },
        { lat: 17.5202128084639, lng: 78.28012229270188 },
        { lat: 17.51955542486901, lng: 78.28246611909724 },
        { lat: 17.51691288086042, lng: 78.281563179964 },
        { lat: 17.51902811344967, lng: 78.27870375669724 },
        { lat: 17.52170713483064, lng: 78.2760604073989 },
        { lat: 17.52370172337869, lng: 78.27679340651287 },
        { lat: 17.52388957864945, lng: 78.27490548660732 },
        { lat: 17.52539662460125, lng: 78.27474825435034 },
        { lat: 17.52712212047366, lng: 78.27476718547575 },
        { lat: 17.52753161335725, lng: 78.273279811583 },
        { lat: 17.5299087756935, lng: 78.27364798517007 },
        { lat: 17.53094542475232, lng: 78.27372227151189 },
        { lat: 17.5313036354754, lng: 78.27465947109195 },
        { lat: 17.53173428301427, lng: 78.27465299874079 },
        { lat: 17.5319623512454, lng: 78.27550228522875 },
        { lat: 17.53206619952391, lng: 78.27675766116137 },
        { lat: 17.53278243887662, lng: 78.27854236786496 },
        { lat: 17.53300360043672, lng: 78.2789878410375 },
        { lat: 17.53335011755177, lng: 78.27902750364305 },
        { lat: 17.53328420450195, lng: 78.28050976709201 },
        { lat: 17.53321749188485, lng: 78.28185744648465 },
        { lat: 17.53352887918665, lng: 78.28252604536664 },
      ],
      [
        { lat: 17.50731566464792, lng: 78.28963919904325 },
        { lat: 17.50731688262519, lng: 78.28963521393321 },
        { lat: 17.50731106880623, lng: 78.28965749866404 },
        { lat: 17.50731566464792, lng: 78.28963919904325 },
      ],
      [
        { lat: 17.50729222983401, lng: 78.28973251565456 },
        { lat: 17.50729417236468, lng: 78.28972478428734 },
        { lat: 17.50727118039024, lng: 78.28982044158775 },
        { lat: 17.50729222983401, lng: 78.28973251565456 },
      ],
      [
        { lat: 17.48334019484388, lng: 78.31160416026519 },
        { lat: 17.48349279256939, lng: 78.31167478764773 },
        { lat: 17.48323274587835, lng: 78.31155645459063 },
        { lat: 17.48334019484388, lng: 78.31160416026519 },
      ],
    ],
  },
  {
    name: "KUKATPALLY ZONE",
    color: "#f39c12",
    polygons: [
      [
        { lat: 17.54002108717026, lng: 78.55266474314524 },
        { lat: 17.54241306182026, lng: 78.54994224985278 },
        { lat: 17.54172384287631, lng: 78.54831986245314 },
        { lat: 17.53666573234009, lng: 78.54528659285126 },
        { lat: 17.53650065014096, lng: 78.54401841002468 },
        { lat: 17.53634849487395, lng: 78.54368112832792 },
        { lat: 17.53636830153494, lng: 78.54369153592636 },
        { lat: 17.5363641633138, lng: 78.54368078353856 },
        { lat: 17.5367156350243, lng: 78.54267633484287 },
        { lat: 17.53671467788481, lng: 78.54259918241023 },
        { lat: 17.53738067940383, lng: 78.54104389114295 },
        { lat: 17.53791200209749, lng: 78.5391834139485 },
        { lat: 17.53908342755525, lng: 78.53652711600053 },
        { lat: 17.53835896572863, lng: 78.53285021813403 },
        { lat: 17.53767691069575, lng: 78.53258045844389 },
        { lat: 17.53566550405676, lng: 78.53225894518077 },
        { lat: 17.53390370861846, lng: 78.53202373026147 },
        { lat: 17.53220910221303, lng: 78.53219446225518 },
        { lat: 17.52820117451499, lng: 78.5327468648113 },
        { lat: 17.52560199223338, lng: 78.53321371090924 },
        { lat: 17.52507321735937, lng: 78.53393074416302 },
        { lat: 17.5247684537092, lng: 78.5343182774347 },
        { lat: 17.5243214588092, lng: 78.53504635963867 },
        { lat: 17.5238264749242, lng: 78.5355202083972 },
        { lat: 17.52353430614156, lng: 78.53591795475555 },
        { lat: 17.52353910942497, lng: 78.53622922473612 },
        { lat: 17.52387842430715, lng: 78.53627665929754 },
        { lat: 17.52382795616877, lng: 78.53649685327076 },
        { lat: 17.52412991153396, lng: 78.53661662504905 },
        { lat: 17.52416407012067, lng: 78.53733464696255 },
        { lat: 17.52442570990071, lng: 78.53783414202071 },
        { lat: 17.5179426793344, lng: 78.53656683387395 },
        { lat: 17.51793250862692, lng: 78.53823889853263 },
        { lat: 17.51778558077118, lng: 78.53822136456563 },
        { lat: 17.51772180363118, lng: 78.53855784326555 },
        { lat: 17.51627931595175, lng: 78.5382667914959 },
        { lat: 17.51621138891571, lng: 78.53969098647092 },
        { lat: 17.51612835507931, lng: 78.54009365873232 },
        { lat: 17.5162367798456, lng: 78.54010066426841 },
        { lat: 17.51644213495783, lng: 78.53995378057068 },
        { lat: 17.51714521128057, lng: 78.53998343787046 },
        { lat: 17.5177084198405, lng: 78.53994173536199 },
        { lat: 17.51956333562727, lng: 78.54043195769756 },
        { lat: 17.51926172693001, lng: 78.54192552254906 },
        { lat: 17.51927600503686, lng: 78.5425385418529 },
        { lat: 17.51919039488186, lng: 78.54285735787998 },
        { lat: 17.51917315256556, lng: 78.54301770853938 },
        { lat: 17.51910329628864, lng: 78.54324984022139 },
        { lat: 17.51907313995248, lng: 78.5433921619892 },
        { lat: 17.51909435827296, lng: 78.54355557591938 },
        { lat: 17.52165658048161, lng: 78.54600227990163 },
        { lat: 17.52208240069987, lng: 78.54580897028445 },
        { lat: 17.52404704328889, lng: 78.54751629294951 },
        { lat: 17.5273363992237, lng: 78.54742818656983 },
        { lat: 17.52760792516237, lng: 78.54872631171817 },
        { lat: 17.52869248568951, lng: 78.54946647821404 },
        { lat: 17.52984826337688, lng: 78.55016833326934 },
        { lat: 17.53008462866095, lng: 78.55015021103584 },
        { lat: 17.53022097243062, lng: 78.54958045234473 },
        { lat: 17.53067974768855, lng: 78.54841600811834 },
        { lat: 17.53148679075904, lng: 78.54816602928221 },
        { lat: 17.53186911660514, lng: 78.54739040058185 },
        { lat: 17.53453124118828, lng: 78.54740774823016 },
        { lat: 17.54002108717026, lng: 78.55266474314524 },
      ],
      [
        { lat: 17.54688366811056, lng: 78.44352881675256 },
        { lat: 17.55299778714414, lng: 78.44241941910828 },
        { lat: 17.55404767655985, lng: 78.43361321251521 },
        { lat: 17.55423777699312, lng: 78.43207691336436 },
        { lat: 17.55566910968514, lng: 78.43031237258654 },
        { lat: 17.556325368125, lng: 78.42826396825284 },
        { lat: 17.55785893681843, lng: 78.42665896083282 },
        { lat: 17.5586975179889, lng: 78.4249930082111 },
        { lat: 17.55912285750275, lng: 78.42389090046947 },
        { lat: 17.55964427402818, lng: 78.42282728655209 },
        { lat: 17.56030077571886, lng: 78.421861398479 },
        { lat: 17.56093685942145, lng: 78.42079614708776 },
        { lat: 17.56100129848186, lng: 78.4198204896653 },
        { lat: 17.56082284650945, lng: 78.4185221130679 },
        { lat: 17.56041093856122, lng: 78.41772082969611 },
        { lat: 17.55977084129872, lng: 78.41701246805202 },
        { lat: 17.55912879054479, lng: 78.41615467317806 },
        { lat: 17.5550083357524, lng: 78.41462884159897 },
        { lat: 17.55227690724425, lng: 78.41406977695625 },
        { lat: 17.54970968671642, lng: 78.41291055832538 },
        { lat: 17.54671020621597, lng: 78.40939611346805 },
        { lat: 17.54637763008439, lng: 78.40808563799375 },
        { lat: 17.54624608646757, lng: 78.407880851621 },
        { lat: 17.54626403628548, lng: 78.40772571237662 },
        { lat: 17.54561503973752, lng: 78.40196602019927 },
        { lat: 17.54400886594038, lng: 78.40084411718605 },
        { lat: 17.5426489537263, lng: 78.39705350958451 },
        { lat: 17.54258349535636, lng: 78.39643671482754 },
        { lat: 17.54275026349951, lng: 78.39530846960857 },
        { lat: 17.54233789621221, lng: 78.39520476661706 },
        { lat: 17.54248501990218, lng: 78.3940369506032 },
        { lat: 17.54078017695904, lng: 78.39377239434819 },
        { lat: 17.53552414966353, lng: 78.39384754321746 },
        { lat: 17.53192282108012, lng: 78.39400860838886 },
        { lat: 17.52636085518531, lng: 78.39480537951093 },
        { lat: 17.52534774290595, lng: 78.39480988614206 },
        { lat: 17.52229910446218, lng: 78.39629794725539 },
        { lat: 17.51976625301, lng: 78.3963042022344 },
        { lat: 17.51975334426814, lng: 78.39750482318539 },
        { lat: 17.51865899896555, lng: 78.39751046775575 },
        { lat: 17.51865899265192, lng: 78.39787408327082 },
        { lat: 17.51828177428025, lng: 78.39789938612807 },
        { lat: 17.51828196322325, lng: 78.39827794125954 },
        { lat: 17.51724947293265, lng: 78.39826277384498 },
        { lat: 17.51722424936426, lng: 78.3992543532341 },
        { lat: 17.51711424255483, lng: 78.39932060715631 },
        { lat: 17.51724006344197, lng: 78.3997312417239 },
        { lat: 17.51738267901466, lng: 78.4005480884737 },
        { lat: 17.51701083783305, lng: 78.40061913351511 },
        { lat: 17.51620309401029, lng: 78.4034440970601 },
        { lat: 17.51550862812493, lng: 78.40559380333356 },
        { lat: 17.51525315526278, lng: 78.40623101378179 },
        { lat: 17.51498105456449, lng: 78.40647396609789 },
        { lat: 17.51489462604614, lng: 78.40688164095005 },
        { lat: 17.51487980472114, lng: 78.40715162131742 },
        { lat: 17.51457543485413, lng: 78.4075584055709 },
        { lat: 17.51414272500119, lng: 78.40926205887637 },
        { lat: 17.51397386339883, lng: 78.40944910525324 },
        { lat: 17.51430518544569, lng: 78.40665707475075 },
        { lat: 17.51394064918974, lng: 78.40560580114717 },
        { lat: 17.51359398358942, lng: 78.40331313547141 },
        { lat: 17.51217556589196, lng: 78.4029273429994 },
        { lat: 17.51077667480637, lng: 78.40197009222511 },
        { lat: 17.50879405809976, lng: 78.40126023180373 },
        { lat: 17.50729392984704, lng: 78.4004476926333 },
        { lat: 17.50753479057279, lng: 78.3996254100844 },
        { lat: 17.50773535513137, lng: 78.3989406813596 },
        { lat: 17.50817606859023, lng: 78.39685834839908 },
        { lat: 17.50831156041064, lng: 78.39619678100085 },
        { lat: 17.50894032842423, lng: 78.39306803557898 },
        { lat: 17.50995259368581, lng: 78.39155821282904 },
        { lat: 17.51043839907739, lng: 78.39105368828261 },
        { lat: 17.51068034009529, lng: 78.3907197625975 },
        { lat: 17.51201163849681, lng: 78.38907282962293 },
        { lat: 17.51180233650685, lng: 78.38890501873821 },
        { lat: 17.51215312867776, lng: 78.38835984323438 },
        { lat: 17.51200510043434, lng: 78.3879036441493 },
        { lat: 17.51097230736918, lng: 78.38817328270594 },
        { lat: 17.51086247620495, lng: 78.38792868010569 },
        { lat: 17.5105980347361, lng: 78.38778516527657 },
        { lat: 17.51077733638927, lng: 78.38726031277953 },
        { lat: 17.51036636842572, lng: 78.38708712970929 },
        { lat: 17.50899487771798, lng: 78.38683137106491 },
        { lat: 17.50839750363644, lng: 78.38561205856037 },
        { lat: 17.50785938243833, lng: 78.38543810168888 },
        { lat: 17.50974759610363, lng: 78.3791722058574 },
        { lat: 17.50785553937898, lng: 78.3791323570556 },
        { lat: 17.50803606124691, lng: 78.37686892778662 },
        { lat: 17.50699763491133, lng: 78.37634563133308 },
        { lat: 17.50704549450872, lng: 78.37574294106696 },
        { lat: 17.50428281132048, lng: 78.3748437628246 },
        { lat: 17.50166289409109, lng: 78.37467071577629 },
        { lat: 17.49932352449428, lng: 78.37432649794911 },
        { lat: 17.49652810468158, lng: 78.3740472753715 },
        { lat: 17.49690107475735, lng: 78.37516067051493 },
        { lat: 17.49682503774628, lng: 78.37508358442429 },
        { lat: 17.49316933393836, lng: 78.37136384994255 },
        { lat: 17.49284536216774, lng: 78.37102618383398 },
        { lat: 17.49008452706867, lng: 78.36960944893299 },
        { lat: 17.48450732525816, lng: 78.36707220327906 },
        { lat: 17.48458352127687, lng: 78.36612765299151 },
        { lat: 17.4824853021988, lng: 78.36596920767803 },
        { lat: 17.48221152255491, lng: 78.3690871347425 },
        { lat: 17.48213679279272, lng: 78.37046055815179 },
        { lat: 17.4818778753034, lng: 78.37199705133762 },
        { lat: 17.48073752724562, lng: 78.37392688070132 },
        { lat: 17.47920842643133, lng: 78.37558147315919 },
        { lat: 17.48360620049542, lng: 78.37678706414104 },
        { lat: 17.48437222984538, lng: 78.37694088578674 },
        { lat: 17.48618184887669, lng: 78.37695928973604 },
        { lat: 17.48756379516828, lng: 78.37692636375225 },
        { lat: 17.49003282018645, lng: 78.3785061926096 },
        { lat: 17.49240321930146, lng: 78.38011615906379 },
        { lat: 17.49162978480589, lng: 78.38176873414669 },
        { lat: 17.49031655669605, lng: 78.38307841458915 },
        { lat: 17.48817509445788, lng: 78.38228335169559 },
        { lat: 17.4882057563339, lng: 78.3822154402748 },
        { lat: 17.48804149554624, lng: 78.38217716074472 },
        { lat: 17.48708093385997, lng: 78.38181740395738 },
        { lat: 17.48393546432293, lng: 78.38066723101936 },
        { lat: 17.47704330250705, lng: 78.3780768067976 },
        { lat: 17.47680002567144, lng: 78.37838937668579 },
        { lat: 17.47345790880801, lng: 78.37701924363614 },
        { lat: 17.47277483550921, lng: 78.37755873262176 },
        { lat: 17.47167007194791, lng: 78.38019406384525 },
        { lat: 17.46992887495022, lng: 78.38252619171544 },
        { lat: 17.46952377041524, lng: 78.382903354231 },
        { lat: 17.46924732504256, lng: 78.38307012039999 },
        { lat: 17.46823539607133, lng: 78.38393504067386 },
        { lat: 17.4673242137431, lng: 78.38441531950482 },
        { lat: 17.4668041453812, lng: 78.38481975339374 },
        { lat: 17.4652005331924, lng: 78.38572614935242 },
        { lat: 17.4626053749725, lng: 78.38754989284051 },
        { lat: 17.46214055367205, lng: 78.38753198180133 },
        { lat: 17.45620906291098, lng: 78.39296890048273 },
        { lat: 17.45506631960725, lng: 78.39724354276723 },
        { lat: 17.45491183335831, lng: 78.3972183694565 },
        { lat: 17.45467330358728, lng: 78.39764823512449 },
        { lat: 17.45407341872673, lng: 78.39754215117196 },
        { lat: 17.45388335754302, lng: 78.3993806138406 },
        { lat: 17.45203682020045, lng: 78.40168931534747 },
        { lat: 17.45148907375022, lng: 78.40225013458821 },
        { lat: 17.450651221132, lng: 78.40426407502194 },
        { lat: 17.45060472784945, lng: 78.40504356805707 },
        { lat: 17.45058626379653, lng: 78.40535311601862 },
        { lat: 17.45204851369985, lng: 78.40719497831336 },
        { lat: 17.45309717469745, lng: 78.40857982253276 },
        { lat: 17.45376470659767, lng: 78.40932738130915 },
        { lat: 17.45425013903429, lng: 78.40950178146134 },
        { lat: 17.45413726300881, lng: 78.40982671293843 },
        { lat: 17.45477762940957, lng: 78.41007513585494 },
        { lat: 17.45543274441744, lng: 78.41035513705299 },
        { lat: 17.45564743757695, lng: 78.41041918374322 },
        { lat: 17.45577083177285, lng: 78.41047731785616 },
        { lat: 17.45573609072552, lng: 78.41061580172868 },
        { lat: 17.4557162549631, lng: 78.41071639336012 },
        { lat: 17.45566465582083, lng: 78.410911300373 },
        { lat: 17.45557675807747, lng: 78.41120730717921 },
        { lat: 17.45554506902134, lng: 78.41128833290766 },
        { lat: 17.45554404272337, lng: 78.41128823919698 },
        { lat: 17.45552785519486, lng: 78.41149366257713 },
        { lat: 17.45545087105651, lng: 78.411750247744 },
        { lat: 17.45527854018034, lng: 78.41308337669496 },
        { lat: 17.45527428998319, lng: 78.41310802825441 },
        { lat: 17.45526365791957, lng: 78.4131613418111 },
        { lat: 17.45525001702879, lng: 78.41323899580549 },
        { lat: 17.45521627605885, lng: 78.41340335120222 },
        { lat: 17.455204838085, lng: 78.41348081410281 },
        { lat: 17.4551931397512, lng: 78.41351881601959 },
        { lat: 17.4551646629818, lng: 78.41359031840216 },
        { lat: 17.45513100531099, lng: 78.41366818058206 },
        { lat: 17.45512099908816, lng: 78.41369087615507 },
        { lat: 17.45505802087344, lng: 78.4138502353633 },
        { lat: 17.45498928003384, lng: 78.41400220444824 },
        { lat: 17.45494802689355, lng: 78.41409203190437 },
        { lat: 17.45473763056653, lng: 78.41456195571126 },
        { lat: 17.45444514893111, lng: 78.41527607196332 },
        { lat: 17.45436848362871, lng: 78.41549768906772 },
        { lat: 17.45410859111352, lng: 78.41658701237475 },
        { lat: 17.45402323257104, lng: 78.41774999549847 },
        { lat: 17.45396061130933, lng: 78.41851521726277 },
        { lat: 17.45392584360604, lng: 78.41905866130206 },
        { lat: 17.45393752404435, lng: 78.41936343787339 },
        { lat: 17.45395561225342, lng: 78.41983545717466 },
        { lat: 17.45395650013555, lng: 78.41989255064468 },
        { lat: 17.45395319811628, lng: 78.42027179090347 },
        { lat: 17.45398775837141, lng: 78.42089275559564 },
        { lat: 17.45401384986653, lng: 78.42110742704952 },
        { lat: 17.45407006739494, lng: 78.421436448488 },
        { lat: 17.45410949821461, lng: 78.42165726902084 },
        { lat: 17.45412259543677, lng: 78.4217627866905 },
        { lat: 17.45436069820378, lng: 78.42337029523162 },
        { lat: 17.452212232645, lng: 78.4231863664037 },
        { lat: 17.45193783600642, lng: 78.42309667872273 },
        { lat: 17.45188624613025, lng: 78.42356718145422 },
        { lat: 17.45175061754476, lng: 78.42434537058195 },
        { lat: 17.45130842944168, lng: 78.42433889683623 },
        { lat: 17.45112192524506, lng: 78.42432629151612 },
        { lat: 17.45063198848611, lng: 78.42430381770146 },
        { lat: 17.45050964740858, lng: 78.42472718390079 },
        { lat: 17.45030341279003, lng: 78.4262485041462 },
        { lat: 17.45291611284292, lng: 78.4265038226766 },
        { lat: 17.45311366428478, lng: 78.42482209172775 },
        { lat: 17.45316864840448, lng: 78.42480846618281 },
        { lat: 17.45452243587565, lng: 78.42505040036627 },
        { lat: 17.45452676623356, lng: 78.42458255649301 },
        { lat: 17.45462442276259, lng: 78.42459766035805 },
        { lat: 17.45585642750169, lng: 78.42502500322038 },
        { lat: 17.45540556830008, lng: 78.4260526397977 },
        { lat: 17.45708962635716, lng: 78.42642348066585 },
        { lat: 17.45692949797382, lng: 78.42693208861348 },
        { lat: 17.45919719075121, lng: 78.42754169852596 },
        { lat: 17.45919915315285, lng: 78.4279239178941 },
        { lat: 17.45973081997809, lng: 78.42815297965677 },
        { lat: 17.45979548997048, lng: 78.42844171400156 },
        { lat: 17.46178732172629, lng: 78.42817099193977 },
        { lat: 17.46184986903025, lng: 78.42838797054341 },
        { lat: 17.46191975780136, lng: 78.42871066236738 },
        { lat: 17.46195032932438, lng: 78.42922686610088 },
        { lat: 17.46195716888009, lng: 78.42975585111635 },
        { lat: 17.46194665100091, lng: 78.43032865214117 },
        { lat: 17.46187253829843, lng: 78.43131695028106 },
        { lat: 17.46186971697181, lng: 78.43137134717169 },
        { lat: 17.46153026589929, lng: 78.43791376884434 },
        { lat: 17.46139134893316, lng: 78.43967190051417 },
        { lat: 17.46128139812683, lng: 78.44147756556427 },
        { lat: 17.46103641238139, lng: 78.44395162079792 },
        { lat: 17.46082565448533, lng: 78.44662936241721 },
        { lat: 17.46016769942922, lng: 78.44813660760968 },
        { lat: 17.45986655690703, lng: 78.44849686427555 },
        { lat: 17.45937545722957, lng: 78.44897983053717 },
        { lat: 17.4587534362391, lng: 78.44938526291934 },
        { lat: 17.45825474223719, lng: 78.44962560170961 },
        { lat: 17.45763450498752, lng: 78.44982095115483 },
        { lat: 17.4566288638924, lng: 78.45000765962595 },
        { lat: 17.4556902922669, lng: 78.4501840970666 },
        { lat: 17.45428228617404, lng: 78.45043708041621 },
        { lat: 17.45235592785814, lng: 78.45079529441081 },
        { lat: 17.45067993415401, lng: 78.45111267227013 },
        { lat: 17.44997895803451, lng: 78.451235651917 },
        { lat: 17.44906175228137, lng: 78.45139656405038 },
        { lat: 17.44753327690489, lng: 78.45168853977869 },
        { lat: 17.44721100590769, lng: 78.45175303089563 },
        { lat: 17.44764443350145, lng: 78.4523539840501 },
        { lat: 17.44804289388997, lng: 78.45230612201814 },
        { lat: 17.4486472449752, lng: 78.45247448625666 },
        { lat: 17.44894320365429, lng: 78.45253170314622 },
        { lat: 17.4491660963771, lng: 78.45262342395085 },
        { lat: 17.44954449384372, lng: 78.45285228724174 },
        { lat: 17.45006096964807, lng: 78.45349251035738 },
        { lat: 17.45035391152929, lng: 78.45379999122139 },
        { lat: 17.45092918912239, lng: 78.45393549995781 },
        { lat: 17.45158388173695, lng: 78.45397705053743 },
        { lat: 17.45341316982412, lng: 78.45393974311729 },
        { lat: 17.45396398896134, lng: 78.45376118336624 },
        { lat: 17.45449793526454, lng: 78.45354521590274 },
        { lat: 17.45488623669524, lng: 78.45364674316798 },
        { lat: 17.455529986371, lng: 78.45408611433695 },
        { lat: 17.45575754436857, lng: 78.45425309263148 },
        { lat: 17.45591942826557, lng: 78.4543607038621 },
        { lat: 17.45634652877904, lng: 78.45468341675858 },
        { lat: 17.45679574455768, lng: 78.45494158847461 },
        { lat: 17.4570428220392, lng: 78.45497486855339 },
        { lat: 17.45736496611556, lng: 78.45497468780988 },
        { lat: 17.45742973333115, lng: 78.45496116426744 },
        { lat: 17.4578606751466, lng: 78.45479981498693 },
        { lat: 17.45826522030583, lng: 78.45459252121873 },
        { lat: 17.45849242696947, lng: 78.45453259686505 },
        { lat: 17.4590598034914, lng: 78.4545008101868 },
        { lat: 17.45960414872868, lng: 78.45457391471459 },
        { lat: 17.45985759977712, lng: 78.45466002533182 },
        { lat: 17.4599636817114, lng: 78.4547705927845 },
        { lat: 17.46010889102283, lng: 78.45502552293985 },
        { lat: 17.46010170119906, lng: 78.45503818276225 },
        { lat: 17.4593931900482, lng: 78.4566812639545 },
        { lat: 17.45935748205332, lng: 78.45677334800793 },
        { lat: 17.45912543450496, lng: 78.45731436792836 },
        { lat: 17.45901406065713, lng: 78.45757485307402 },
        { lat: 17.45885270473187, lng: 78.45785097038952 },
        { lat: 17.45858434040762, lng: 78.45816840947953 },
        { lat: 17.45824174747542, lng: 78.45866116232789 },
        { lat: 17.45804566315879, lng: 78.45902490262726 },
        { lat: 17.4578848723765, lng: 78.45953255983969 },
        { lat: 17.45774899865715, lng: 78.45996785923734 },
        { lat: 17.46071480775344, lng: 78.46099775196107 },
        { lat: 17.46145855779634, lng: 78.46124362230012 },
        { lat: 17.46288821781885, lng: 78.46174342877839 },
        { lat: 17.46235502753564, lng: 78.46327198331089 },
        { lat: 17.46442559703777, lng: 78.46341133685108 },
        { lat: 17.46635226840528, lng: 78.46328901011957 },
        { lat: 17.46821665166186, lng: 78.4632962878579 },
        { lat: 17.47076591986161, lng: 78.46348320316993 },
        { lat: 17.47210859408572, lng: 78.46355804089818 },
        { lat: 17.47472857957551, lng: 78.46355775963661 },
        { lat: 17.47713396936086, lng: 78.46361731251172 },
        { lat: 17.47929366027432, lng: 78.46340180259037 },
        { lat: 17.48165639042476, lng: 78.46350098426299 },
        { lat: 17.48158949497752, lng: 78.46464068583975 },
        { lat: 17.48404713452722, lng: 78.46487092209325 },
        { lat: 17.48504080181973, lng: 78.4650308537956 },
        { lat: 17.48598946942191, lng: 78.46483636653733 },
        { lat: 17.48686948613367, lng: 78.46417439250095 },
        { lat: 17.48715861163687, lng: 78.46346205148478 },
        { lat: 17.48674822611405, lng: 78.46225387299828 },
        { lat: 17.48675863101386, lng: 78.46106177150821 },
        { lat: 17.48715281332891, lng: 78.46104839625066 },
        { lat: 17.48720136456406, lng: 78.46103278099342 },
        { lat: 17.48720839670954, lng: 78.46113428295472 },
        { lat: 17.48715663726213, lng: 78.46112304778407 },
        { lat: 17.48716095377004, lng: 78.46146065802193 },
        { lat: 17.48713216833379, lng: 78.46145209391732 },
        { lat: 17.4871396585878, lng: 78.46158944726454 },
        { lat: 17.48768153875767, lng: 78.46158192467881 },
        { lat: 17.48863508397813, lng: 78.46394352100282 },
        { lat: 17.48912260031431, lng: 78.46469378653406 },
        { lat: 17.4908857620297, lng: 78.46597904524808 },
        { lat: 17.49327826721244, lng: 78.46769903862548 },
        { lat: 17.49441844435502, lng: 78.46865944045773 },
        { lat: 17.49584989917145, lng: 78.46997442687278 },
        { lat: 17.49585421539682, lng: 78.47031305111534 },
        { lat: 17.4957924805538, lng: 78.47146941594134 },
        { lat: 17.49579857026371, lng: 78.47194747418297 },
        { lat: 17.49576237212235, lng: 78.47210735604662 },
        { lat: 17.49584212652303, lng: 78.4723652467007 },
        { lat: 17.49605390371126, lng: 78.47248185425677 },
        { lat: 17.49615124926862, lng: 78.47261996563411 },
        { lat: 17.49594115210304, lng: 78.47413699196366 },
        { lat: 17.49582027888974, lng: 78.47515471816688 },
        { lat: 17.49509914285602, lng: 78.47707724852823 },
        { lat: 17.49456330960156, lng: 78.47853899024207 },
        { lat: 17.49454824347356, lng: 78.47885795960498 },
        { lat: 17.49831764379041, lng: 78.48061894956466 },
        { lat: 17.50052870790491, lng: 78.48172161155486 },
        { lat: 17.50072047258276, lng: 78.4819196995194 },
        { lat: 17.50110372062284, lng: 78.48274372535009 },
        { lat: 17.50207469507674, lng: 78.48468782489304 },
        { lat: 17.5029669955542, lng: 78.48664797190278 },
        { lat: 17.50345327318447, lng: 78.48753261549216 },
        { lat: 17.50350309384055, lng: 78.48762694705358 },
        { lat: 17.50383862631625, lng: 78.48830945538307 },
        { lat: 17.50432022689163, lng: 78.48935381046324 },
        { lat: 17.50456348356161, lng: 78.4900702145206 },
        { lat: 17.50467503834664, lng: 78.49057673874998 },
        { lat: 17.50474421360895, lng: 78.49113365563312 },
        { lat: 17.50477823780321, lng: 78.49155656925114 },
        { lat: 17.50476386108327, lng: 78.4917568314093 },
        { lat: 17.50374300724863, lng: 78.49196653095328 },
        { lat: 17.50165527095482, lng: 78.4924135865704 },
        { lat: 17.50089252130202, lng: 78.4925685005648 },
        { lat: 17.50016340956349, lng: 78.4927378927768 },
        { lat: 17.4993246419394, lng: 78.49292871229237 },
        { lat: 17.49809230820869, lng: 78.4932157441712 },
        { lat: 17.49736593066987, lng: 78.49322321791648 },
        { lat: 17.49662801378017, lng: 78.49326322439697 },
        { lat: 17.49617357546335, lng: 78.49323210273369 },
        { lat: 17.49522980176833, lng: 78.49305578054066 },
        { lat: 17.49425619551292, lng: 78.49291099796127 },
        { lat: 17.49415805187242, lng: 78.49286004765834 },
        { lat: 17.49392837668917, lng: 78.49272573097197 },
        { lat: 17.49359914261679, lng: 78.49254197866811 },
        { lat: 17.49359520366767, lng: 78.4925430426367 },
        { lat: 17.49344676584357, lng: 78.4924012476751 },
        { lat: 17.49323456414868, lng: 78.49226689464574 },
        { lat: 17.49282886182613, lng: 78.49201002849328 },
        { lat: 17.49219681035117, lng: 78.49163394771685 },
        { lat: 17.49159720382128, lng: 78.49127236584346 },
        { lat: 17.49059628847307, lng: 78.4909237643334 },
        { lat: 17.48967624973813, lng: 78.4907346788091 },
        { lat: 17.48828657289854, lng: 78.4905408343361 },
        { lat: 17.48689878319339, lng: 78.49049637918212 },
        { lat: 17.48606344131239, lng: 78.4904854313053 },
        { lat: 17.48629506815402, lng: 78.48980989143054 },
        { lat: 17.48669503941538, lng: 78.48884068289806 },
        { lat: 17.48715211110776, lng: 78.4878520082415 },
        { lat: 17.48762818427073, lng: 78.48694898166981 },
        { lat: 17.48784610994216, lng: 78.48665301435278 },
        { lat: 17.48789158020793, lng: 78.48667562359788 },
        { lat: 17.48906569245846, lng: 78.48544115147554 },
        { lat: 17.49017853933324, lng: 78.48434557323219 },
        { lat: 17.49020620927262, lng: 78.48408767676987 },
        { lat: 17.48968672990009, lng: 78.48120264954018 },
        { lat: 17.48942598713501, lng: 78.47978412018186 },
        { lat: 17.48745442390776, lng: 78.47971402939953 },
        { lat: 17.48731978404673, lng: 78.47893187298514 },
        { lat: 17.48621432942265, lng: 78.47931069562429 },
        { lat: 17.48571677208272, lng: 78.47945293181823 },
        { lat: 17.4856477892259, lng: 78.47869423538387 },
        { lat: 17.48566185191529, lng: 78.47809513596394 },
        { lat: 17.48593059914475, lng: 78.47735887000415 },
        { lat: 17.48613253160969, lng: 78.47651419895568 },
        { lat: 17.48538135002961, lng: 78.47649771301231 },
        { lat: 17.48530461977138, lng: 78.47616781428569 },
        { lat: 17.4833840174411, lng: 78.47535872379024 },
        { lat: 17.48300168739536, lng: 78.47527013751039 },
        { lat: 17.48184218719014, lng: 78.47522434523479 },
        { lat: 17.48014372673898, lng: 78.47520022325104 },
        { lat: 17.47977361958606, lng: 78.47520536047406 },
        { lat: 17.47975725649819, lng: 78.47531969234757 },
        { lat: 17.47948958368407, lng: 78.47533088729207 },
        { lat: 17.47949516379666, lng: 78.4751705931812 },
        { lat: 17.4780395139752, lng: 78.47467171928889 },
        { lat: 17.47773822507283, lng: 78.4750896033658 },
        { lat: 17.47760678414384, lng: 78.47511817177117 },
        { lat: 17.47760671830875, lng: 78.47512962060527 },
        { lat: 17.4775010648002, lng: 78.47537029440043 },
        { lat: 17.47679307470687, lng: 78.47511168489108 },
        { lat: 17.47655186722309, lng: 78.47524363710153 },
        { lat: 17.47671563585076, lng: 78.4758359175785 },
        { lat: 17.47680372306925, lng: 78.47648993461753 },
        { lat: 17.47599171677731, lng: 78.47649102005408 },
        { lat: 17.47594340565464, lng: 78.47671974794947 },
        { lat: 17.47568587009342, lng: 78.47662877481734 },
        { lat: 17.47525222949733, lng: 78.47644696824231 },
        { lat: 17.47483337428639, lng: 78.47725053714498 },
        { lat: 17.47452324049411, lng: 78.47763879970044 },
        { lat: 17.47386198486629, lng: 78.47887281839742 },
        { lat: 17.47383979330696, lng: 78.47931175410446 },
        { lat: 17.4734916771249, lng: 78.47984924721678 },
        { lat: 17.47354708921137, lng: 78.48018435067382 },
        { lat: 17.47337504066916, lng: 78.48035367677139 },
        { lat: 17.47319813099949, lng: 78.48079961247264 },
        { lat: 17.47314566706067, lng: 78.48133558468548 },
        { lat: 17.47296775745119, lng: 78.4813242015924 },
        { lat: 17.47287269552569, lng: 78.48156284110476 },
        { lat: 17.47226287496597, lng: 78.48147513695001 },
        { lat: 17.47218076554474, lng: 78.48254983836779 },
        { lat: 17.47195238029883, lng: 78.4833402949352 },
        { lat: 17.47174419253054, lng: 78.48429419754932 },
        { lat: 17.4715717192515, lng: 78.4842226151117 },
        { lat: 17.47151533307993, lng: 78.48463466843664 },
        { lat: 17.47144119692112, lng: 78.48512540573378 },
        { lat: 17.47139303844351, lng: 78.48539353907414 },
        { lat: 17.4716385791771, lng: 78.48547120721582 },
        { lat: 17.47158746764722, lng: 78.48570128725983 },
        { lat: 17.47154449020296, lng: 78.48611229432979 },
        { lat: 17.47155517559029, lng: 78.48619544777483 },
        { lat: 17.47155504823547, lng: 78.48658017225178 },
        { lat: 17.47156926405018, lng: 78.4867743759486 },
        { lat: 17.47164411774479, lng: 78.48705801915261 },
        { lat: 17.4716629012842, lng: 78.48726199397049 },
        { lat: 17.47162261416862, lng: 78.48769702563804 },
        { lat: 17.47163581551791, lng: 78.48822569283773 },
        { lat: 17.47156225365631, lng: 78.48900774901935 },
        { lat: 17.47156733492185, lng: 78.48900952670627 },
        { lat: 17.47145665535994, lng: 78.48910744941276 },
        { lat: 17.47129088150867, lng: 78.4891696184387 },
        { lat: 17.4712823166196, lng: 78.48939667270648 },
        { lat: 17.47036634922945, lng: 78.48941980203 },
        { lat: 17.4705194838929, lng: 78.49026310469786 },
        { lat: 17.47056230766624, lng: 78.4907132472903 },
        { lat: 17.47047915764281, lng: 78.49072756451348 },
        { lat: 17.4697115078624, lng: 78.49071786154724 },
        { lat: 17.47002526926406, lng: 78.49151254764983 },
        { lat: 17.47006958333512, lng: 78.49212095335943 },
        { lat: 17.47002961650051, lng: 78.49261841170896 },
        { lat: 17.47004561651641, lng: 78.49311147086007 },
        { lat: 17.46998547731356, lng: 78.49364634420927 },
        { lat: 17.46999022560559, lng: 78.49381373255635 },
        { lat: 17.47013376265678, lng: 78.49407363808085 },
        { lat: 17.47131252252887, lng: 78.49429338012507 },
        { lat: 17.47135523945146, lng: 78.49420191791339 },
        { lat: 17.47247315735506, lng: 78.4943117293903 },
        { lat: 17.47337441350845, lng: 78.49438160655515 },
        { lat: 17.47527707603489, lng: 78.495282895468 },
        { lat: 17.47485795993418, lng: 78.495357279059 },
        { lat: 17.47439685215792, lng: 78.49563781295711 },
        { lat: 17.47403449671001, lng: 78.49580738494907 },
        { lat: 17.47379278433505, lng: 78.49646064622101 },
        { lat: 17.47362120624565, lng: 78.49675229206235 },
        { lat: 17.47340404516516, lng: 78.497089345085 },
        { lat: 17.47318824232823, lng: 78.49735250162291 },
        { lat: 17.47294651488947, lng: 78.49785123111062 },
        { lat: 17.47255495693654, lng: 78.49773450704909 },
        { lat: 17.47223648679321, lng: 78.49898784302339 },
        { lat: 17.47239613197026, lng: 78.49905563555451 },
        { lat: 17.4723753894012, lng: 78.49916359994235 },
        { lat: 17.47226046308148, lng: 78.49951003093273 },
        { lat: 17.4723726348364, lng: 78.49964076802709 },
        { lat: 17.4723141733078, lng: 78.49982590179123 },
        { lat: 17.47208935918271, lng: 78.50018085777893 },
        { lat: 17.47209841520748, lng: 78.5003306720992 },
        { lat: 17.47224131702329, lng: 78.50042098207591 },
        { lat: 17.47253639931849, lng: 78.50019550171969 },
        { lat: 17.47327425026463, lng: 78.49951114295726 },
        { lat: 17.4735453138949, lng: 78.49936724281119 },
        { lat: 17.47400583474706, lng: 78.499092516181 },
        { lat: 17.47432836364063, lng: 78.49896385784409 },
        { lat: 17.47468741062168, lng: 78.49889302832169 },
        { lat: 17.47502094576353, lng: 78.49872642268645 },
        { lat: 17.47524102046541, lng: 78.49862351886668 },
        { lat: 17.47579453730343, lng: 78.4984572091469 },
        { lat: 17.47622775133562, lng: 78.4984158029456 },
        { lat: 17.47662484745802, lng: 78.49844772506765 },
        { lat: 17.47702566684319, lng: 78.4984877023672 },
        { lat: 17.47704603494189, lng: 78.49830479611869 },
        { lat: 17.47706185104376, lng: 78.49823236599723 },
        { lat: 17.47708419185307, lng: 78.49810880001438 },
        { lat: 17.47711552919309, lng: 78.49784566469923 },
        { lat: 17.47717026016192, lng: 78.49744774362081 },
        { lat: 17.47742324207981, lng: 78.4975164964827 },
        { lat: 17.47766887015129, lng: 78.49758955322422 },
        { lat: 17.47777671871605, lng: 78.49761422413867 },
        { lat: 17.47786194907678, lng: 78.4976318484228 },
        { lat: 17.47789843814247, lng: 78.49756184757095 },
        { lat: 17.47790312109567, lng: 78.49739420485822 },
        { lat: 17.47790340353941, lng: 78.49738766002712 },
        { lat: 17.47952156967076, lng: 78.49766569215005 },
        { lat: 17.47955386292442, lng: 78.49810568756276 },
        { lat: 17.47986028817472, lng: 78.49824343560779 },
        { lat: 17.48036067018367, lng: 78.49841214899466 },
        { lat: 17.48037841972054, lng: 78.49899633556642 },
        { lat: 17.48052588468608, lng: 78.49906141200658 },
        { lat: 17.48193294676141, lng: 78.4983586202476 },
        { lat: 17.48212142943968, lng: 78.4985241295645 },
        { lat: 17.48224973786182, lng: 78.49875022636454 },
        { lat: 17.48224246548861, lng: 78.4990267370034 },
        { lat: 17.48243273549226, lng: 78.49933416274855 },
        { lat: 17.48254675336893, lng: 78.49956419145678 },
        { lat: 17.48264860982005, lng: 78.49968232885475 },
        { lat: 17.4829528598041, lng: 78.4999321690916 },
        { lat: 17.4831815958272, lng: 78.49956427509241 },
        { lat: 17.48317937982784, lng: 78.4995722027861 },
        { lat: 17.4835198372641, lng: 78.49993918429772 },
        { lat: 17.48412810497759, lng: 78.5005627611291 },
        { lat: 17.48434981107544, lng: 78.50085233142921 },
        { lat: 17.48440029989187, lng: 78.5010664230226 },
        { lat: 17.48454400083113, lng: 78.50132904488356 },
        { lat: 17.48462809478988, lng: 78.50141256388477 },
        { lat: 17.48461069390801, lng: 78.50144273218945 },
        { lat: 17.48469747284205, lng: 78.50153571114083 },
        { lat: 17.48485817448216, lng: 78.50177257762029 },
        { lat: 17.48486958023921, lng: 78.50191934456203 },
        { lat: 17.48480489302617, lng: 78.50228629163865 },
        { lat: 17.48476406752651, lng: 78.50265042138138 },
        { lat: 17.48479433608951, lng: 78.50277700969573 },
        { lat: 17.48556187199675, lng: 78.50281135313854 },
        { lat: 17.48598202797595, lng: 78.50372700472312 },
        { lat: 17.48615579028237, lng: 78.50413330155712 },
        { lat: 17.48665211163617, lng: 78.50446078276957 },
        { lat: 17.4870402702558, lng: 78.50468914352493 },
        { lat: 17.48706987845044, lng: 78.50463209725078 },
        { lat: 17.48737254750139, lng: 78.5042078032002 },
        { lat: 17.48842158491886, lng: 78.5048654012398 },
        { lat: 17.48874422062922, lng: 78.50515236126289 },
        { lat: 17.4890334557686, lng: 78.5056340208639 },
        { lat: 17.48961489663277, lng: 78.50654874253603 },
        { lat: 17.48982406154267, lng: 78.50693437673407 },
        { lat: 17.4897351652183, lng: 78.5069916202862 },
        { lat: 17.48983465331808, lng: 78.50720691980618 },
        { lat: 17.49016061439663, lng: 78.50775905859305 },
        { lat: 17.4894819323392, lng: 78.50823524085196 },
        { lat: 17.48942183104994, lng: 78.5088216898743 },
        { lat: 17.49093331824375, lng: 78.50977231825232 },
        { lat: 17.49138839101707, lng: 78.50996949143881 },
        { lat: 17.49139947217381, lng: 78.50997429322348 },
        { lat: 17.4913692019694, lng: 78.5102324558006 },
        { lat: 17.49129380907726, lng: 78.51085207902918 },
        { lat: 17.49123687403103, lng: 78.51134295018362 },
        { lat: 17.49115838569547, lng: 78.5119446856884 },
        { lat: 17.49108598548986, lng: 78.51257472629942 },
        { lat: 17.49106838579702, lng: 78.51277220007032 },
        { lat: 17.49132190581216, lng: 78.51276969680308 },
        { lat: 17.49178995024779, lng: 78.51274216154266 },
        { lat: 17.49221523078922, lng: 78.51263925157295 },
        { lat: 17.49267257928971, lng: 78.51252096256948 },
        { lat: 17.49291101376606, lng: 78.51247787276107 },
        { lat: 17.49354531070277, lng: 78.51255889364298 },
        { lat: 17.49406808926457, lng: 78.51270369156047 },
        { lat: 17.49464296479274, lng: 78.51281042612909 },
        { lat: 17.4946561512469, lng: 78.51280643089434 },
        { lat: 17.49489620701644, lng: 78.5128507045273 },
        { lat: 17.49608013978552, lng: 78.5130457784166 },
        { lat: 17.49627676662932, lng: 78.51307333194768 },
        { lat: 17.49629393239342, lng: 78.51308301443487 },
        { lat: 17.49726228960935, lng: 78.51325108881052 },
        { lat: 17.498681247557, lng: 78.51349327438167 },
        { lat: 17.49927024067405, lng: 78.51358238689816 },
        { lat: 17.50072871596048, lng: 78.51383150972568 },
        { lat: 17.50167341458641, lng: 78.51398676126882 },
        { lat: 17.50243803508505, lng: 78.51416940434038 },
        { lat: 17.50243652695267, lng: 78.51415875259471 },
        { lat: 17.50252921497449, lng: 78.51419925896226 },
        { lat: 17.5026951555675, lng: 78.51428292335038 },
        { lat: 17.50289414779011, lng: 78.51442964481855 },
        { lat: 17.50324139415155, lng: 78.51467895011947 },
        { lat: 17.50370274536784, lng: 78.5150264723373 },
        { lat: 17.50375656372049, lng: 78.51500236705223 },
        { lat: 17.50422866249864, lng: 78.51478717360884 },
        { lat: 17.50470313719136, lng: 78.51458077216432 },
        { lat: 17.50540340685368, lng: 78.5143474481153 },
        { lat: 17.50575650242142, lng: 78.51428436145846 },
        { lat: 17.50614171390139, lng: 78.51425613809357 },
        { lat: 17.50656989735636, lng: 78.51422820882871 },
        { lat: 17.50703919391103, lng: 78.51423148977052 },
        { lat: 17.50743308756755, lng: 78.51426198688586 },
        { lat: 17.50789184758266, lng: 78.51432425146254 },
        { lat: 17.50839884142814, lng: 78.51444337116328 },
        { lat: 17.50879105371174, lng: 78.51456176612601 },
        { lat: 17.50919030050331, lng: 78.5146989307124 },
        { lat: 17.50961178481652, lng: 78.51485070273267 },
        { lat: 17.51017404743451, lng: 78.51504600097971 },
        { lat: 17.51058871937455, lng: 78.51519566152018 },
        { lat: 17.51118961825663, lng: 78.515405584575 },
        { lat: 17.51194956486594, lng: 78.51567261473652 },
        { lat: 17.51284889570751, lng: 78.51596274565296 },
        { lat: 17.5131539883023, lng: 78.5160337370416 },
        { lat: 17.51360961324931, lng: 78.51611576048244 },
        { lat: 17.51399922565478, lng: 78.51616470732078 },
        { lat: 17.51443832790837, lng: 78.51619370685233 },
        { lat: 17.51495400149759, lng: 78.51619811953285 },
        { lat: 17.51520829823317, lng: 78.51618904717814 },
        { lat: 17.51534271284148, lng: 78.51617808810938 },
        { lat: 17.51554033197424, lng: 78.51615831646079 },
        { lat: 17.51585195733709, lng: 78.51612330333484 },
        { lat: 17.51627049679862, lng: 78.51604960830255 },
        { lat: 17.51670111031608, lng: 78.51594794454556 },
        { lat: 17.51727441263255, lng: 78.5157763625352 },
        { lat: 17.51794676205832, lng: 78.51556973487709 },
        { lat: 17.51811117390106, lng: 78.51551805451669 },
        { lat: 17.51854814692764, lng: 78.51538393619626 },
        { lat: 17.51909770879913, lng: 78.51521282189243 },
        { lat: 17.51971372845811, lng: 78.51502211329668 },
        { lat: 17.52023288809693, lng: 78.51486068103989 },
        { lat: 17.52101899179644, lng: 78.51461982728433 },
        { lat: 17.52137371829366, lng: 78.51450845698906 },
        { lat: 17.52151000685279, lng: 78.51446804728151 },
        { lat: 17.52156292130594, lng: 78.51445040424548 },
        { lat: 17.52187377722369, lng: 78.51435655119086 },
        { lat: 17.52245152725843, lng: 78.51417945259355 },
        { lat: 17.522709475909, lng: 78.51410383093838 },
        { lat: 17.52296170318115, lng: 78.51402299166075 },
        { lat: 17.52320156913786, lng: 78.51394806019862 },
        { lat: 17.52354847542861, lng: 78.51384400246008 },
        { lat: 17.52373650221178, lng: 78.5137824319673 },
        { lat: 17.52390657908996, lng: 78.51373169849155 },
        { lat: 17.52405981091265, lng: 78.51368973102228 },
        { lat: 17.52423564408907, lng: 78.51364686237959 },
        { lat: 17.52442161413994, lng: 78.51360091456223 },
        { lat: 17.52456820596853, lng: 78.51357006953403 },
        { lat: 17.52473400914436, lng: 78.51353837329738 },
        { lat: 17.52496644339755, lng: 78.51350046595508 },
        { lat: 17.52514815635898, lng: 78.51347487607794 },
        { lat: 17.52533675816771, lng: 78.51345728545576 },
        { lat: 17.52549828213712, lng: 78.51344418153353 },
        { lat: 17.5256575965474, lng: 78.51343508416993 },
        { lat: 17.52585534836702, lng: 78.51342545626551 },
        { lat: 17.52602609434472, lng: 78.51342590888693 },
        { lat: 17.5262409917504, lng: 78.51343046481861 },
        { lat: 17.52645145142677, lng: 78.51344140558678 },
        { lat: 17.52658046767899, lng: 78.51345008154576 },
        { lat: 17.52680806186258, lng: 78.51347432243357 },
        { lat: 17.52697787171043, lng: 78.51348950008867 },
        { lat: 17.52706394187949, lng: 78.51349994104073 },
        { lat: 17.52717274152803, lng: 78.51351904381401 },
        { lat: 17.5273824449375, lng: 78.51355868442167 },
        { lat: 17.52759943717701, lng: 78.51360652805481 },
        { lat: 17.52759836315774, lng: 78.51368405015289 },
        { lat: 17.52755443720944, lng: 78.51399251625138 },
        { lat: 17.52747417530196, lng: 78.51437620202987 },
        { lat: 17.52741512012454, lng: 78.5146978240821 },
        { lat: 17.52736363008061, lng: 78.51493664832357 },
        { lat: 17.52729161084605, lng: 78.51521560397009 },
        { lat: 17.52718289928015, lng: 78.51561761029846 },
        { lat: 17.52711820323785, lng: 78.51587056283934 },
        { lat: 17.52709376864241, lng: 78.51600320815842 },
        { lat: 17.52708495131974, lng: 78.5161004715446 },
        { lat: 17.527071429549, lng: 78.51627999363141 },
        { lat: 17.52705381452727, lng: 78.51641737454625 },
        { lat: 17.52800477055251, lng: 78.51652087637932 },
        { lat: 17.52793550220744, lng: 78.51697225709009 },
        { lat: 17.5283381641638, lng: 78.51706690689264 },
        { lat: 17.52833204086362, lng: 78.51716699809029 },
        { lat: 17.52882730785587, lng: 78.51726734594939 },
        { lat: 17.52885201077305, lng: 78.51739092241647 },
        { lat: 17.52944080703844, lng: 78.51762250536699 },
        { lat: 17.52941337703323, lng: 78.5176973773892 },
        { lat: 17.52997786597332, lng: 78.51792881722145 },
        { lat: 17.53028110459345, lng: 78.51809905155407 },
        { lat: 17.53098834354328, lng: 78.51847053129119 },
        { lat: 17.53088626830661, lng: 78.51871602619552 },
        { lat: 17.5313124450712, lng: 78.51891750163884 },
        { lat: 17.53134316134855, lng: 78.51894230950982 },
        { lat: 17.5317129782199, lng: 78.5191334360918 },
        { lat: 17.53231743039267, lng: 78.51945525665883 },
        { lat: 17.53251889838757, lng: 78.51951354322104 },
        { lat: 17.53301964373233, lng: 78.51961633279709 },
        { lat: 17.53300339093689, lng: 78.5196888728011 },
        { lat: 17.53300495759485, lng: 78.51968920076736 },
        { lat: 17.53304231522955, lng: 78.5197946051456 },
        { lat: 17.53327145936908, lng: 78.52007844020778 },
        { lat: 17.53360273639434, lng: 78.52042665102222 },
        { lat: 17.534213202911, lng: 78.52108591656862 },
        { lat: 17.53460254466408, lng: 78.52149112906203 },
        { lat: 17.53484829467516, lng: 78.52172691992713 },
        { lat: 17.53503656379495, lng: 78.52180008504659 },
        { lat: 17.53539932894634, lng: 78.52191471944849 },
        { lat: 17.53565504622568, lng: 78.52203056059155 },
        { lat: 17.53606372811271, lng: 78.52222428331409 },
        { lat: 17.53687859587213, lng: 78.52241248392157 },
        { lat: 17.53773221566258, lng: 78.52151722075179 },
        { lat: 17.53776987860918, lng: 78.52135373740447 },
        { lat: 17.53776796178319, lng: 78.52120056841945 },
        { lat: 17.53784644963831, lng: 78.52059793000635 },
        { lat: 17.53785528399925, lng: 78.52044461480168 },
        { lat: 17.53770676051028, lng: 78.51974791533335 },
        { lat: 17.53764038660645, lng: 78.51902768294437 },
        { lat: 17.53797170403264, lng: 78.51899975951699 },
        { lat: 17.5380007874741, lng: 78.51892131961664 },
        { lat: 17.53802107789961, lng: 78.51886225525612 },
        { lat: 17.53804715959987, lng: 78.51873137393476 },
        { lat: 17.53806430582611, lng: 78.51826881389394 },
        { lat: 17.53808533438584, lng: 78.51796363263989 },
        { lat: 17.53807189896252, lng: 78.51788310903544 },
        { lat: 17.53805783266064, lng: 78.51782849856805 },
        { lat: 17.53801256340644, lng: 78.51780121735302 },
        { lat: 17.53794546179985, lng: 78.51778618726097 },
        { lat: 17.53786423737585, lng: 78.51778828932058 },
        { lat: 17.53780879184625, lng: 78.51778804821332 },
        { lat: 17.53778185597433, lng: 78.5177744661915 },
        { lat: 17.53776202070961, lng: 78.51774571647098 },
        { lat: 17.53771427194582, lng: 78.51732041004203 },
        { lat: 17.53770606236029, lng: 78.51718974545375 },
        { lat: 17.53772011647268, lng: 78.51716713676548 },
        { lat: 17.53773950830458, lng: 78.51714133911817 },
        { lat: 17.53776924321324, lng: 78.51713034827259 },
        { lat: 17.53780921789455, lng: 78.5171260671347 },
        { lat: 17.53786248989329, lng: 78.5171340586225 },
        { lat: 17.53803488058033, lng: 78.51716035766854 },
        { lat: 17.53856884141463, lng: 78.51724400669696 },
        { lat: 17.5388908767741, lng: 78.51729317531691 },
        { lat: 17.53896373757368, lng: 78.51729093832574 },
        { lat: 17.53903839103673, lng: 78.51724134712305 },
        { lat: 17.53906670573043, lng: 78.51721231428664 },
        { lat: 17.53919515186936, lng: 78.51697392223788 },
        { lat: 17.53932716804978, lng: 78.51673423284291 },
        { lat: 17.53937038608614, lng: 78.51665517772764 },
        { lat: 17.53942251378452, lng: 78.51661959434166 },
        { lat: 17.53951158003654, lng: 78.51657443937142 },
        { lat: 17.53988740748114, lng: 78.51643480425193 },
        { lat: 17.54022215114371, lng: 78.51629672625945 },
        { lat: 17.54047036076303, lng: 78.5161946993848 },
        { lat: 17.54052393105099, lng: 78.51619795559711 },
        { lat: 17.5406683460043, lng: 78.51620395912708 },
        { lat: 17.54109345430806, lng: 78.5162589481426 },
        { lat: 17.54124502135815, lng: 78.51630171994164 },
        { lat: 17.5412597705471, lng: 78.51633440125856 },
        { lat: 17.54126453590569, lng: 78.5164857883367 },
        { lat: 17.54127000854637, lng: 78.51661723926243 },
        { lat: 17.54129775656934, lng: 78.51669557972318 },
        { lat: 17.54135476958849, lng: 78.51674462163008 },
        { lat: 17.5414077717261, lng: 78.51677877494585 },
        { lat: 17.54167565821355, lng: 78.51687376747489 },
        { lat: 17.54163162169759, lng: 78.51705920214691 },
        { lat: 17.54157809357721, lng: 78.51728810929994 },
        { lat: 17.54170476215806, lng: 78.51732723589365 },
        { lat: 17.54169695648826, lng: 78.51734004760348 },
        { lat: 17.54158927901628, lng: 78.5177101848964 },
        { lat: 17.54175540706482, lng: 78.51799937415268 },
        { lat: 17.54181523408322, lng: 78.51800603199834 },
        { lat: 17.54203316171238, lng: 78.51804291929932 },
        { lat: 17.54201801363295, lng: 78.51816864316913 },
        { lat: 17.5421465729355, lng: 78.51818048854452 },
        { lat: 17.54218047615345, lng: 78.51802558185992 },
        { lat: 17.54233944645752, lng: 78.51802964485523 },
        { lat: 17.54241689025676, lng: 78.51772592777972 },
        { lat: 17.54248907895058, lng: 78.51747957847256 },
        { lat: 17.54251842952852, lng: 78.51743807687308 },
        { lat: 17.54254692972925, lng: 78.51742398804046 },
        { lat: 17.54266653692782, lng: 78.51743356813013 },
        { lat: 17.54283190148913, lng: 78.51747117173377 },
        { lat: 17.54297114521523, lng: 78.51742692742633 },
        { lat: 17.54328994257828, lng: 78.51750354380104 },
        { lat: 17.54329175440365, lng: 78.51745743569872 },
        { lat: 17.54335040137623, lng: 78.51746535408475 },
        { lat: 17.5434559701685, lng: 78.51749879182812 },
        { lat: 17.54374513231273, lng: 78.51759449334202 },
        { lat: 17.5442389036264, lng: 78.51780822605883 },
        { lat: 17.54435416607463, lng: 78.51784487062592 },
        { lat: 17.5449200981848, lng: 78.51722047697035 },
        { lat: 17.54499837564394, lng: 78.51679281454311 },
        { lat: 17.54519795414683, lng: 78.51650984989149 },
        { lat: 17.54578137905594, lng: 78.51523456190652 },
        { lat: 17.54491778436958, lng: 78.51497232136188 },
        { lat: 17.54510269217273, lng: 78.51304545085715 },
        { lat: 17.54501215303356, lng: 78.51297195385928 },
        { lat: 17.54552275687334, lng: 78.51224257441456 },
        { lat: 17.54627032460163, lng: 78.50992812078628 },
        { lat: 17.54649703713085, lng: 78.508953500777 },
        { lat: 17.54703154872677, lng: 78.50597031372888 },
        { lat: 17.5440319962978, lng: 78.50634638474058 },
        { lat: 17.53987139474124, lng: 78.50614923134223 },
        { lat: 17.53946644752202, lng: 78.5060441744629 },
        { lat: 17.53881926358199, lng: 78.50588862467504 },
        { lat: 17.53737897726576, lng: 78.50594569418153 },
        { lat: 17.53485580356291, lng: 78.50483688177697 },
        { lat: 17.53298746195899, lng: 78.5033529721558 },
        { lat: 17.5313148056726, lng: 78.50260619735673 },
        { lat: 17.5294042296882, lng: 78.50171348463374 },
        { lat: 17.52940164583184, lng: 78.50170970352956 },
        { lat: 17.52926394705689, lng: 78.50159203004476 },
        { lat: 17.52910479387848, lng: 78.50147838709975 },
        { lat: 17.52898817614588, lng: 78.50132679979386 },
        { lat: 17.52876427391451, lng: 78.50119536198038 },
        { lat: 17.52856112293603, lng: 78.50100385966171 },
        { lat: 17.52839088632676, lng: 78.50086421713223 },
        { lat: 17.52832170785851, lng: 78.50077923033697 },
        { lat: 17.52825144573589, lng: 78.50060832856752 },
        { lat: 17.5282133912118, lng: 78.5004332472519 },
        { lat: 17.52822664231353, lng: 78.50034713109372 },
        { lat: 17.52792676895091, lng: 78.50044464646268 },
        { lat: 17.52782480660533, lng: 78.49991190354314 },
        { lat: 17.52784457541584, lng: 78.49926277711242 },
        { lat: 17.52798007588133, lng: 78.4988275186111 },
        { lat: 17.527981388723, lng: 78.49877975720146 },
        { lat: 17.52806444156938, lng: 78.49815301338216 },
        { lat: 17.52800466343695, lng: 78.49807117316799 },
        { lat: 17.52800888767203, lng: 78.49799276861727 },
        { lat: 17.52793929202974, lng: 78.4979315537839 },
        { lat: 17.5278440202381, lng: 78.49765389040714 },
        { lat: 17.52780860715414, lng: 78.49727178855218 },
        { lat: 17.52782731690192, lng: 78.49693676755155 },
        { lat: 17.52788179410917, lng: 78.49664204200396 },
        { lat: 17.52783322832304, lng: 78.49640482799431 },
        { lat: 17.52788623701829, lng: 78.4962738703477 },
        { lat: 17.52799144742025, lng: 78.49491742924765 },
        { lat: 17.52792201902031, lng: 78.49426479660951 },
        { lat: 17.52777492237119, lng: 78.49351758552454 },
        { lat: 17.52773909726156, lng: 78.4931036088328 },
        { lat: 17.52808737264505, lng: 78.49282782335872 },
        { lat: 17.52878916667176, lng: 78.49269064722847 },
        { lat: 17.52976418998448, lng: 78.49239030031205 },
        { lat: 17.530525333009, lng: 78.4921088326037 },
        { lat: 17.53227799787063, lng: 78.49162242651538 },
        { lat: 17.53241158522445, lng: 78.49130175950054 },
        { lat: 17.53247916095249, lng: 78.49059940443685 },
        { lat: 17.53264751274815, lng: 78.48940147514287 },
        { lat: 17.5326665807905, lng: 78.48849254784359 },
        { lat: 17.53264926821483, lng: 78.48833337212925 },
        { lat: 17.53228106285389, lng: 78.48824279422925 },
        { lat: 17.53225567887596, lng: 78.48823668477178 },
        { lat: 17.53225808319153, lng: 78.48818874175235 },
        { lat: 17.53115789807494, lng: 78.487674961773 },
        { lat: 17.52559365487294, lng: 78.48399515690198 },
        { lat: 17.5255815110183, lng: 78.48395506606401 },
        { lat: 17.52575785457725, lng: 78.4837745388278 },
        { lat: 17.52565902336886, lng: 78.48321797327294 },
        { lat: 17.52557163501788, lng: 78.48235837540116 },
        { lat: 17.52530054486855, lng: 78.48148537444138 },
        { lat: 17.5253917828216, lng: 78.48024073471251 },
        { lat: 17.52584513717731, lng: 78.47860851244927 },
        { lat: 17.52666516005442, lng: 78.47544587346506 },
        { lat: 17.52757466515612, lng: 78.47555782434468 },
        { lat: 17.52800187556146, lng: 78.47532774183082 },
        { lat: 17.52834503110105, lng: 78.47412742027572 },
        { lat: 17.52865214234006, lng: 78.47384918094319 },
        { lat: 17.52861338661443, lng: 78.47081097171753 },
        { lat: 17.52830119476549, lng: 78.47069076221457 },
        { lat: 17.52804793932129, lng: 78.47035286126496 },
        { lat: 17.52958944098891, lng: 78.46583899731412 },
        { lat: 17.52970500454193, lng: 78.46495155293277 },
        { lat: 17.52924404383275, lng: 78.46480844905341 },
        { lat: 17.52923935463906, lng: 78.46480711626604 },
        { lat: 17.52964461569803, lng: 78.46353276439946 },
        { lat: 17.52973202250653, lng: 78.46289390974462 },
        { lat: 17.52973741928535, lng: 78.46284907233911 },
        { lat: 17.52971196221086, lng: 78.46276068413192 },
        { lat: 17.52967785415894, lng: 78.46218728346214 },
        { lat: 17.52959181424815, lng: 78.46203704169987 },
        { lat: 17.52961025930084, lng: 78.46168608432222 },
        { lat: 17.52953186397492, lng: 78.46153573649678 },
        { lat: 17.5295651913813, lng: 78.4611526909553 },
        { lat: 17.5297311467876, lng: 78.46097502944993 },
        { lat: 17.53020626302198, lng: 78.45986051676145 },
        { lat: 17.53069828406507, lng: 78.4582807183413 },
        { lat: 17.53221329730092, lng: 78.46073845032969 },
        { lat: 17.53318396806356, lng: 78.45885183770461 },
        { lat: 17.53247419383248, lng: 78.45717196727456 },
        { lat: 17.53286136660902, lng: 78.45516595075489 },
        { lat: 17.53368141073812, lng: 78.44923084354045 },
        { lat: 17.53499077284302, lng: 78.44478913468849 },
        { lat: 17.53477440167213, lng: 78.44437616700769 },
        { lat: 17.54688366811056, lng: 78.44352881675256 },
      ],
      [
        { lat: 17.48052558764217, lng: 78.48859361839102 },
        { lat: 17.48073916320509, lng: 78.48814630922645 },
        { lat: 17.48086364625211, lng: 78.4881276816756 },
        { lat: 17.48131690394776, lng: 78.48824010010284 },
        { lat: 17.4814997311692, lng: 78.48788506894195 },
        { lat: 17.48150026041933, lng: 78.48788613835983 },
        { lat: 17.48151535765324, lng: 78.48823617507618 },
        { lat: 17.48230345214785, lng: 78.48847935058849 },
        { lat: 17.48300487100425, lng: 78.4886714237376 },
        { lat: 17.48295239168178, lng: 78.48905687660282 },
        { lat: 17.48285714953835, lng: 78.49031323275418 },
        { lat: 17.48278788375048, lng: 78.49164020394716 },
        { lat: 17.48264683600671, lng: 78.49267680638772 },
        { lat: 17.48131025903823, lng: 78.49242992622597 },
        { lat: 17.48134081704513, lng: 78.4917272816717 },
        { lat: 17.48132082041733, lng: 78.49099544970673 },
        { lat: 17.48015849619379, lng: 78.49077399223847 },
        { lat: 17.48052558764217, lng: 78.48859361839102 },
      ],
    ],
  },
  {
    name: "SECUNDERABAD ZONE",
    color: "#9b59b6",
    polygons: [
      [
        { lat: 17.49348230507685, lng: 78.53498858846895 },
        { lat: 17.49391547760956, lng: 78.53462411138752 },
        { lat: 17.49399273737557, lng: 78.53455910470481 },
        { lat: 17.4944880725621, lng: 78.53403441948748 },
        { lat: 17.49420906967675, lng: 78.53398650793046 },
        { lat: 17.49378881653467, lng: 78.53398285932602 },
        { lat: 17.49374203662546, lng: 78.53399679218215 },
        { lat: 17.49358015168158, lng: 78.53397295346403 },
        { lat: 17.49334102759942, lng: 78.53396123528884 },
        { lat: 17.49318407248347, lng: 78.53402312286326 },
        { lat: 17.49237234847234, lng: 78.53447237880529 },
        { lat: 17.49219595425281, lng: 78.5342788826078 },
        { lat: 17.49175527211529, lng: 78.53378959058237 },
        { lat: 17.49148477850698, lng: 78.53347689903761 },
        { lat: 17.49149459501272, lng: 78.5334783779918 },
        { lat: 17.4912189558323, lng: 78.53314340808353 },
        { lat: 17.49121209023666, lng: 78.53313808391158 },
        { lat: 17.49121249486978, lng: 78.53313808315777 },
        { lat: 17.49098865044266, lng: 78.53283706216088 },
        { lat: 17.49042497683862, lng: 78.53209308314491 },
        { lat: 17.48936267136225, lng: 78.53079153069967 },
        { lat: 17.48601571543779, lng: 78.52762395194105 },
        { lat: 17.48600980169929, lng: 78.52761644953641 },
        { lat: 17.48586143313808, lng: 78.52762205270345 },
        { lat: 17.48539848636443, lng: 78.52757975004891 },
        { lat: 17.48523213120346, lng: 78.52746246639597 },
        { lat: 17.48518307567959, lng: 78.52726515444041 },
        { lat: 17.4851850879098, lng: 78.52710367822532 },
        { lat: 17.48518425124965, lng: 78.52705737960174 },
        { lat: 17.48520001559133, lng: 78.52683888957489 },
        { lat: 17.48523412540369, lng: 78.5266611219279 },
        { lat: 17.48527560927969, lng: 78.52646133955916 },
        { lat: 17.4852915228506, lng: 78.52620412828378 },
        { lat: 17.4852874284636, lng: 78.52587546813444 },
        { lat: 17.48525717784867, lng: 78.52572119097927 },
        { lat: 17.4852025653225, lng: 78.52565344620265 },
        { lat: 17.48500831192404, lng: 78.52564673579731 },
        { lat: 17.48461410733264, lng: 78.52565518358244 },
        { lat: 17.4842350666173, lng: 78.52568210127072 },
        { lat: 17.48413324744744, lng: 78.52566168914343 },
        { lat: 17.48374024461434, lng: 78.52552692909306 },
        { lat: 17.48330139461801, lng: 78.5253087443019 },
        { lat: 17.48296785337251, lng: 78.52515139140182 },
        { lat: 17.48264331195673, lng: 78.52499703067751 },
        { lat: 17.48226698822001, lng: 78.52476243957895 },
        { lat: 17.48200132733807, lng: 78.52453880267052 },
        { lat: 17.48174059172811, lng: 78.52423105405542 },
        { lat: 17.48164354275549, lng: 78.52411408176566 },
        { lat: 17.4813778425368, lng: 78.52388733364083 },
        { lat: 17.48121787987928, lng: 78.52375564913487 },
        { lat: 17.48094213312364, lng: 78.52368156338841 },
        { lat: 17.48049319875346, lng: 78.5236129366201 },
        { lat: 17.47956557392891, lng: 78.5234854191052 },
        { lat: 17.47821050454417, lng: 78.52344290897463 },
        { lat: 17.47793124227049, lng: 78.52391499623775 },
        { lat: 17.47711645049954, lng: 78.52525712939457 },
        { lat: 17.47661290145303, lng: 78.52609966517018 },
        { lat: 17.47655649280741, lng: 78.52628383662949 },
        { lat: 17.4765343709866, lng: 78.52658314016942 },
        { lat: 17.47653807231924, lng: 78.52686841778039 },
        { lat: 17.47662709423063, lng: 78.52719327192328 },
        { lat: 17.47698709814139, lng: 78.52783624532384 },
        { lat: 17.47717833697105, lng: 78.5281958935361 },
        { lat: 17.47731156890387, lng: 78.52852956225932 },
        { lat: 17.47737616619854, lng: 78.52868196454551 },
        { lat: 17.47713359556367, lng: 78.52875671354795 },
        { lat: 17.47632821195371, lng: 78.52899577619975 },
        { lat: 17.47340743792013, lng: 78.52986378413166 },
        { lat: 17.47115780537606, lng: 78.5305390748258 },
        { lat: 17.47025248484833, lng: 78.53081082487076 },
        { lat: 17.4676674902463, lng: 78.53158861297335 },
        { lat: 17.46558409664085, lng: 78.53224456368366 },
        { lat: 17.46373757367664, lng: 78.53276816170835 },
        { lat: 17.46270898961675, lng: 78.53297373435251 },
        { lat: 17.46231474210593, lng: 78.53299053404089 },
        { lat: 17.46223320621591, lng: 78.53299400862993 },
        { lat: 17.46163826083847, lng: 78.53245646733467 },
        { lat: 17.46121379618208, lng: 78.53224824546844 },
        { lat: 17.46094038616224, lng: 78.53200400384058 },
        { lat: 17.45958418629183, lng: 78.5303983876745 },
        { lat: 17.45637399395666, lng: 78.52664604777259 },
        { lat: 17.45612498585547, lng: 78.52636560722699 },
        { lat: 17.45588202640043, lng: 78.52602846751063 },
        { lat: 17.4553532088404, lng: 78.52544683286759 },
        { lat: 17.45466029376403, lng: 78.5249992914108 },
        { lat: 17.45464542191621, lng: 78.52499563308469 },
        { lat: 17.45453295704947, lng: 78.52491690018778 },
        { lat: 17.45406151243231, lng: 78.52476142950732 },
        { lat: 17.45314348957587, lng: 78.52464361209448 },
        { lat: 17.45295377858383, lng: 78.5245795261224 },
        { lat: 17.45234989550023, lng: 78.52443098526206 },
        { lat: 17.45227273760714, lng: 78.5243747725059 },
        { lat: 17.45214652176191, lng: 78.52431423227692 },
        { lat: 17.45175126874244, lng: 78.52423865397559 },
        { lat: 17.45155167543987, lng: 78.52423464374144 },
        { lat: 17.45061686716557, lng: 78.52400470616513 },
        { lat: 17.44927787463896, lng: 78.52364715373548 },
        { lat: 17.44885643160009, lng: 78.52342578156491 },
        { lat: 17.44908729368284, lng: 78.5229455515543 },
        { lat: 17.44909185615355, lng: 78.52288761665324 },
        { lat: 17.44912201471568, lng: 78.52252973890941 },
        { lat: 17.44897603756017, lng: 78.52246046334265 },
        { lat: 17.44858180053425, lng: 78.52227457904716 },
        { lat: 17.4484531105335, lng: 78.52222652327866 },
        { lat: 17.44834472821814, lng: 78.52212043110414 },
        { lat: 17.44827171905983, lng: 78.52209154107184 },
        { lat: 17.44818987865316, lng: 78.52201271824019 },
        { lat: 17.44793947331423, lng: 78.52161148481878 },
        { lat: 17.44782634924848, lng: 78.5214317606835 },
        { lat: 17.44773881898007, lng: 78.52131144450203 },
        { lat: 17.44763921909376, lng: 78.52175696250305 },
        { lat: 17.44759823270586, lng: 78.5218431640602 },
        { lat: 17.44756980845131, lng: 78.5218634665854 },
        { lat: 17.44729803133194, lng: 78.52179717911315 },
        { lat: 17.44686839327261, lng: 78.52168547158273 },
        { lat: 17.44659934763271, lng: 78.52160788568325 },
        { lat: 17.44651670381634, lng: 78.52152084083195 },
        { lat: 17.44668687993234, lng: 78.52087444644039 },
        { lat: 17.44682235553851, lng: 78.5203707253307 },
        { lat: 17.4469181486654, lng: 78.52000343880142 },
        { lat: 17.4464435039919, lng: 78.51988537371695 },
        { lat: 17.44627069379138, lng: 78.51982546853239 },
        { lat: 17.44620627474186, lng: 78.5198338097138 },
        { lat: 17.44618083558542, lng: 78.51988322213666 },
        { lat: 17.44618073473672, lng: 78.51988208771859 },
        { lat: 17.44599677942744, lng: 78.51980737343172 },
        { lat: 17.44595672623003, lng: 78.51991229237835 },
        { lat: 17.44566241402483, lng: 78.51977096860634 },
        { lat: 17.44581036938907, lng: 78.51939750002136 },
        { lat: 17.4459120060533, lng: 78.51915412353001 },
        { lat: 17.4459967751797, lng: 78.51893786495155 },
        { lat: 17.4461136226264, lng: 78.51864946723138 },
        { lat: 17.44619412711107, lng: 78.5184362536266 },
        { lat: 17.44597065015229, lng: 78.5183376975335 },
        { lat: 17.44568055641809, lng: 78.51818626669407 },
        { lat: 17.44567890567415, lng: 78.51818564163875 },
        { lat: 17.4456798530864, lng: 78.51818317470392 },
        { lat: 17.44584438996365, lng: 78.51775488328079 },
        { lat: 17.44602624370069, lng: 78.5171312660458 },
        { lat: 17.44630709308525, lng: 78.51646865272762 },
        { lat: 17.44647419421884, lng: 78.51601507701763 },
        { lat: 17.44653428692902, lng: 78.51585382578457 },
        { lat: 17.44676978703858, lng: 78.51518241665981 },
        { lat: 17.44680433231168, lng: 78.5150565116559 },
        { lat: 17.44695101985737, lng: 78.51451174656366 },
        { lat: 17.44714141646881, lng: 78.51385036202419 },
        { lat: 17.44732264354298, lng: 78.5131796898297 },
        { lat: 17.44755825686763, lng: 78.51251768568241 },
        { lat: 17.44778531420626, lng: 78.51189344089815 },
        { lat: 17.44783774057194, lng: 78.51175155573155 },
        { lat: 17.44786837012773, lng: 78.51167246574295 },
        { lat: 17.44802153662186, lng: 78.51127848127537 },
        { lat: 17.4481606007694, lng: 78.51084366290908 },
        { lat: 17.44820275428074, lng: 78.51060780532968 },
        { lat: 17.44839375091197, lng: 78.50999346121489 },
        { lat: 17.4484383581822, lng: 78.5099457947759 },
        { lat: 17.44843989787997, lng: 78.50993877280379 },
        { lat: 17.44857126278989, lng: 78.5098328577576 },
        { lat: 17.44864961737269, lng: 78.50952505638851 },
        { lat: 17.44874724310244, lng: 78.50884912848188 },
        { lat: 17.448823661018, lng: 78.5088124926331 },
        { lat: 17.44916162221931, lng: 78.5085494633793 },
        { lat: 17.449482754781, lng: 78.50831653885133 },
        { lat: 17.44993851436917, lng: 78.50807132556481 },
        { lat: 17.45031712108014, lng: 78.50784807498816 },
        { lat: 17.45063581565437, lng: 78.50764953990257 },
        { lat: 17.45107177634947, lng: 78.50731197309418 },
        { lat: 17.45144502785536, lng: 78.50699750142668 },
        { lat: 17.45152005881374, lng: 78.50694846819218 },
        { lat: 17.45175626253458, lng: 78.506333491104 },
        { lat: 17.45198465057284, lng: 78.50581273489775 },
        { lat: 17.45198329757366, lng: 78.50570922724067 },
        { lat: 17.45161464127237, lng: 78.50518723769228 },
        { lat: 17.4510228297749, lng: 78.50489418168253 },
        { lat: 17.45080404671858, lng: 78.50476541976008 },
        { lat: 17.45074049047875, lng: 78.504747467714 },
        { lat: 17.45035866465202, lng: 78.5046021181752 },
        { lat: 17.4498403145559, lng: 78.50439276052316 },
        { lat: 17.44981796418605, lng: 78.5043778873785 },
        { lat: 17.44974996564203, lng: 78.50450715045228 },
        { lat: 17.44956118028045, lng: 78.50431701450582 },
        { lat: 17.44935793948764, lng: 78.50411748979796 },
        { lat: 17.44911393091279, lng: 78.50390669516136 },
        { lat: 17.44885335382834, lng: 78.50370857522378 },
        { lat: 17.44809498182424, lng: 78.50307157536686 },
        { lat: 17.44780821549767, lng: 78.50288128402708 },
        { lat: 17.44742478099932, lng: 78.50260516964696 },
        { lat: 17.44695989083174, lng: 78.50231273911307 },
        { lat: 17.44648305392858, lng: 78.50202047181249 },
        { lat: 17.44635246788095, lng: 78.50189776629195 },
        { lat: 17.44623863844184, lng: 78.50177732243262 },
        { lat: 17.44611603244018, lng: 78.50171924073999 },
        { lat: 17.44595792994967, lng: 78.50168902928563 },
        { lat: 17.44529471140094, lng: 78.50158852142033 },
        { lat: 17.44489972265471, lng: 78.5015341521984 },
        { lat: 17.4442558056163, lng: 78.50144831989462 },
        { lat: 17.4437722555256, lng: 78.50138270976832 },
        { lat: 17.44318115422628, lng: 78.50131607571758 },
        { lat: 17.4428102459234, lng: 78.50127631584672 },
        { lat: 17.44286019713156, lng: 78.50093503948985 },
        { lat: 17.44288508447703, lng: 78.50028129875302 },
        { lat: 17.4429573904647, lng: 78.49861847293353 },
        { lat: 17.44296432535516, lng: 78.49842447417917 },
        { lat: 17.44299451665104, lng: 78.49757978345052 },
        { lat: 17.44306167727749, lng: 78.49550997151135 },
        { lat: 17.44313220303463, lng: 78.49370899643598 },
        { lat: 17.4431864469879, lng: 78.49175513103432 },
        { lat: 17.44320104977595, lng: 78.49035450979639 },
        { lat: 17.44316361389194, lng: 78.48994423252272 },
        { lat: 17.44317046704675, lng: 78.48878272349098 },
        { lat: 17.4431842483818, lng: 78.48703481184268 },
        { lat: 17.44323437227104, lng: 78.48532748292253 },
        { lat: 17.44331484381827, lng: 78.48318654304049 },
        { lat: 17.44334085277638, lng: 78.48212560411262 },
        { lat: 17.44335962496031, lng: 78.4804933970996 },
        { lat: 17.44340054812548, lng: 78.47891316927664 },
        { lat: 17.44348074312003, lng: 78.47734549445808 },
        { lat: 17.44351748391278, lng: 78.47638368746121 },
        { lat: 17.44356270243042, lng: 78.47542705116248 },
        { lat: 17.44362831686568, lng: 78.47494814077133 },
        { lat: 17.44385828093617, lng: 78.4738619881759 },
        { lat: 17.4440076852194, lng: 78.4726425047961 },
        { lat: 17.44406230617643, lng: 78.47163743829068 },
        { lat: 17.44408522067661, lng: 78.47118401210845 },
        { lat: 17.44406319731198, lng: 78.47057933839787 },
        { lat: 17.44429212471535, lng: 78.47054132501943 },
        { lat: 17.44492869922673, lng: 78.4704254880105 },
        { lat: 17.44537209074768, lng: 78.47033970144706 },
        { lat: 17.44582029173664, lng: 78.47025633774457 },
        { lat: 17.4464798411132, lng: 78.47006798142014 },
        { lat: 17.44706299576331, lng: 78.46988565657668 },
        { lat: 17.44717942798163, lng: 78.46984727629395 },
        { lat: 17.44720347916015, lng: 78.46970553601261 },
        { lat: 17.44731807939937, lng: 78.46887066495282 },
        { lat: 17.44734820574747, lng: 78.46836712542586 },
        { lat: 17.44742117819725, lng: 78.46836261527115 },
        { lat: 17.44803541998233, lng: 78.46829761180915 },
        { lat: 17.44872226427358, lng: 78.46825042149334 },
        { lat: 17.4493729314086, lng: 78.46820373209697 },
        { lat: 17.45000613490474, lng: 78.46820434103302 },
        { lat: 17.45070277020029, lng: 78.4682134794715 },
        { lat: 17.4513443942261, lng: 78.4681669143285 },
        { lat: 17.45189245838628, lng: 78.46788636992903 },
        { lat: 17.45239392999924, lng: 78.46750294752879 },
        { lat: 17.45290444438555, lng: 78.46711939792657 },
        { lat: 17.4534506345409, lng: 78.46669770334493 },
        { lat: 17.45396114674676, lng: 78.46631414908654 },
        { lat: 17.45440891411528, lng: 78.465991518249 },
        { lat: 17.45523773062989, lng: 78.46444919205233 },
        { lat: 17.45559293090945, lng: 78.4638193447501 },
        { lat: 17.45601586095741, lng: 78.46306655964597 },
        { lat: 17.45643442183159, lng: 78.46234619800829 },
        { lat: 17.45710188675384, lng: 78.46128128422893 },
        { lat: 17.45744863030356, lng: 78.4607386854037 },
        { lat: 17.45765070912095, lng: 78.46028274357401 },
        { lat: 17.45774899865715, lng: 78.45996785923734 },
        { lat: 17.4578848723765, lng: 78.45953255983969 },
        { lat: 17.45804566315879, lng: 78.45902490262726 },
        { lat: 17.45824174747542, lng: 78.45866116232789 },
        { lat: 17.45858434040762, lng: 78.45816840947953 },
        { lat: 17.45885270473187, lng: 78.45785097038952 },
        { lat: 17.45901406065713, lng: 78.45757485307402 },
        { lat: 17.45912543450496, lng: 78.45731436792836 },
        { lat: 17.45935748205332, lng: 78.45677334800793 },
        { lat: 17.4593931900482, lng: 78.4566812639545 },
        { lat: 17.46010170119906, lng: 78.45503818276225 },
        { lat: 17.46010889102283, lng: 78.45502552293985 },
        { lat: 17.4599636817114, lng: 78.4547705927845 },
        { lat: 17.45985759977712, lng: 78.45466002533182 },
        { lat: 17.45960414872868, lng: 78.45457391471459 },
        { lat: 17.4590598034914, lng: 78.4545008101868 },
        { lat: 17.45849242696947, lng: 78.45453259686505 },
        { lat: 17.45826522030583, lng: 78.45459252121873 },
        { lat: 17.4578606751466, lng: 78.45479981498693 },
        { lat: 17.45742973333115, lng: 78.45496116426744 },
        { lat: 17.45736496611556, lng: 78.45497468780988 },
        { lat: 17.4570428220392, lng: 78.45497486855339 },
        { lat: 17.45679574455768, lng: 78.45494158847461 },
        { lat: 17.45634652877904, lng: 78.45468341675858 },
        { lat: 17.45591942826557, lng: 78.4543607038621 },
        { lat: 17.45575754436857, lng: 78.45425309263148 },
        { lat: 17.455529986371, lng: 78.45408611433695 },
        { lat: 17.45488623669524, lng: 78.45364674316798 },
        { lat: 17.45449793526454, lng: 78.45354521590274 },
        { lat: 17.45396398896134, lng: 78.45376118336624 },
        { lat: 17.45341316982412, lng: 78.45393974311729 },
        { lat: 17.45158388173695, lng: 78.45397705053743 },
        { lat: 17.45092918912239, lng: 78.45393549995781 },
        { lat: 17.45035391152929, lng: 78.45379999122139 },
        { lat: 17.45006096964807, lng: 78.45349251035738 },
        { lat: 17.44954449384372, lng: 78.45285228724174 },
        { lat: 17.4491660963771, lng: 78.45262342395085 },
        { lat: 17.44894320365429, lng: 78.45253170314622 },
        { lat: 17.4486472449752, lng: 78.45247448625666 },
        { lat: 17.44804289388997, lng: 78.45230612201814 },
        { lat: 17.44764443350145, lng: 78.4523539840501 },
        { lat: 17.44721100590769, lng: 78.45175303089563 },
        { lat: 17.44716041856665, lng: 78.45176315318051 },
        { lat: 17.44669337784892, lng: 78.45189567030623 },
        { lat: 17.44145451054156, lng: 78.45413748525058 },
        { lat: 17.44073807332421, lng: 78.4545699225471 },
        { lat: 17.43994172280218, lng: 78.45529461960528 },
        { lat: 17.43935347537208, lng: 78.45607170638182 },
        { lat: 17.43899481081204, lng: 78.45669483319502 },
        { lat: 17.4386859808202, lng: 78.45744290977979 },
        { lat: 17.4383879940865, lng: 78.45907657708041 },
        { lat: 17.43812246555711, lng: 78.4605364532165 },
        { lat: 17.43790902751994, lng: 78.46114856111416 },
        { lat: 17.43737133593115, lng: 78.46231308853244 },
        { lat: 17.43705592307014, lng: 78.4628529688216 },
        { lat: 17.43670733820506, lng: 78.46327399164669 },
        { lat: 17.43610420612891, lng: 78.46380086613595 },
        { lat: 17.43587708751344, lng: 78.46393335052029 },
        { lat: 17.43541846277175, lng: 78.46418354357694 },
        { lat: 17.43511290599228, lng: 78.46428392258596 },
        { lat: 17.43484075877238, lng: 78.46436387432546 },
        { lat: 17.4343660072487, lng: 78.46443801314449 },
        { lat: 17.43395095349064, lng: 78.46442364851391 },
        { lat: 17.43368786235141, lng: 78.4643607717471 },
        { lat: 17.432668291344, lng: 78.4643339854853 },
        { lat: 17.43291551681945, lng: 78.46449740522266 },
        { lat: 17.43362710385412, lng: 78.46491274772869 },
        { lat: 17.43418333676781, lng: 78.4653155842202 },
        { lat: 17.43496143550681, lng: 78.46578842677758 },
        { lat: 17.43544453589827, lng: 78.46605683674792 },
        { lat: 17.43584448628704, lng: 78.46632902545221 },
        { lat: 17.43620536343883, lng: 78.46662993717325 },
        { lat: 17.43645673963996, lng: 78.46689180130882 },
        { lat: 17.43669060822121, lng: 78.46720548518114 },
        { lat: 17.43688165710412, lng: 78.46756566092718 },
        { lat: 17.43705178829247, lng: 78.46798482450842 },
        { lat: 17.43724818055451, lng: 78.4688000736487 },
        { lat: 17.43754310550785, lng: 78.47030814592952 },
        { lat: 17.43760803309363, lng: 78.4707093725989 },
        { lat: 17.43761697093732, lng: 78.47115124045393 },
        { lat: 17.43760876566043, lng: 78.47141737142313 },
        { lat: 17.43756945907822, lng: 78.47172470323827 },
        { lat: 17.43747091848835, lng: 78.47220965085792 },
        { lat: 17.4373484941295, lng: 78.47255343499972 },
        { lat: 17.43713966761499, lng: 78.47299137040436 },
        { lat: 17.43691802450897, lng: 78.47331494313347 },
        { lat: 17.43677928186625, lng: 78.47346978404818 },
        { lat: 17.43670692442852, lng: 78.47360362924071 },
        { lat: 17.4363558578993, lng: 78.47399805573951 },
        { lat: 17.43608861702147, lng: 78.4742704412411 },
        { lat: 17.43602626894802, lng: 78.47433238031972 },
        { lat: 17.43549659957032, lng: 78.4737383276629 },
        { lat: 17.43547647160796, lng: 78.47375360115154 },
        { lat: 17.43543466345137, lng: 78.47375079528993 },
        { lat: 17.43541439185038, lng: 78.47375474967825 },
        { lat: 17.43538963120684, lng: 78.47376082460652 },
        { lat: 17.43536024349508, lng: 78.47375814313556 },
        { lat: 17.4353363113085, lng: 78.47374053515985 },
        { lat: 17.43532452723473, lng: 78.47370159122342 },
        { lat: 17.43530139555724, lng: 78.47365809901203 },
        { lat: 17.43526476874236, lng: 78.47361876144508 },
        { lat: 17.43521235936566, lng: 78.47358125775057 },
        { lat: 17.4351633102576, lng: 78.47354165096189 },
        { lat: 17.43514821998554, lng: 78.47350907366173 },
        { lat: 17.4351523004964, lng: 78.47347476261898 },
        { lat: 17.43514863990765, lng: 78.47345320217167 },
        { lat: 17.43513357574554, lng: 78.47342268323855 },
        { lat: 17.43510520860842, lng: 78.47341145933999 },
        { lat: 17.43504643316561, lng: 78.47340609462566 },
        { lat: 17.43501807534101, lng: 78.47339560451572 },
        { lat: 17.43495853503126, lng: 78.4733299737057 },
        { lat: 17.43492636921807, lng: 78.47328631062335 },
        { lat: 17.43488974234835, lng: 78.47324697321105 },
        { lat: 17.43486933271221, lng: 78.47324005072923 },
        { lat: 17.43483383462612, lng: 78.47320069778958 },
        { lat: 17.43480599553239, lng: 78.47314212760121 },
        { lat: 17.43478641430966, lng: 78.47311152419329 },
        { lat: 17.43478608780585, lng: 78.4730858004516 },
        { lat: 17.4347993105288, lng: 78.47306018551245 },
        { lat: 17.43482500961893, lng: 78.47303910137138 },
        { lat: 17.43486216640713, lng: 78.47303123913171 },
        { lat: 17.43488700910149, lng: 78.47303163082239 },
        { lat: 17.43490381222755, lng: 78.47302125633706 },
        { lat: 17.43493736061023, lng: 78.4729959485048 },
        { lat: 17.43495055716636, lng: 78.47296827330409 },
        { lat: 17.43491863758683, lng: 78.47294401412378 },
        { lat: 17.43488035201487, lng: 78.47295189193478 },
        { lat: 17.43486349479898, lng: 78.4729580048464 },
        { lat: 17.43483972677764, lng: 78.47295333415649 },
        { lat: 17.43481563036806, lng: 78.47292279296852 },
        { lat: 17.43481643076637, lng: 78.47289690691987 },
        { lat: 17.43483309579104, lng: 78.47287565364756 },
        { lat: 17.43484998099504, lng: 78.47287174583767 },
        { lat: 17.43487474159939, lng: 78.47286567082116 },
        { lat: 17.43490385688832, lng: 78.47284689185773 },
        { lat: 17.43489573333546, lng: 78.47282951036799 },
        { lat: 17.43485951502035, lng: 78.47282236349632 },
        { lat: 17.43483836097174, lng: 78.47284573733 },
        { lat: 17.43481701284243, lng: 78.47285382216465 },
        { lat: 17.43479299853214, lng: 78.47282974955938 },
        { lat: 17.43477176236975, lng: 78.47284665481929 },
        { lat: 17.43475845572585, lng: 78.47286565632801 },
        { lat: 17.43472559953937, lng: 78.47285655308691 },
        { lat: 17.43469304187066, lng: 78.47287096658499 },
        { lat: 17.43466388179493, lng: 78.47288621772636 },
        { lat: 17.43463892900147, lng: 78.4728771523877 },
        { lat: 17.43459447890061, lng: 78.47284409713933 },
        { lat: 17.43457280612295, lng: 78.47282660689035 },
        { lat: 17.43456680205641, lng: 78.47279831556565 },
        { lat: 17.43459955188936, lng: 78.47279904052412 },
        { lat: 17.43462576036871, lng: 78.47281808664918 },
        { lat: 17.43464914586827, lng: 78.47279262339279 },
        { lat: 17.43465344459081, lng: 78.47277551113659 },
        { lat: 17.43463739896594, lng: 78.47275662045011 },
        { lat: 17.43464168832273, lng: 78.47273877065105 },
        { lat: 17.43465848956918, lng: 78.47272824940192 },
        { lat: 17.4346559035757, lng: 78.4727024100325 },
        { lat: 17.43463086866099, lng: 78.47268687616256 },
        { lat: 17.43457701889348, lng: 78.47271378660488 },
        { lat: 17.43452221573557, lng: 78.47275453022523 },
        { lat: 17.43449207987907, lng: 78.47278184972417 },
        { lat: 17.43433170223064, lng: 78.47286594820321 },
        { lat: 17.43428032639962, lng: 78.47282093351026 },
        { lat: 17.43425187715837, lng: 78.47280324307988 },
        { lat: 17.43422357343753, lng: 78.47279701653994 },
        { lat: 17.43416961542722, lng: 78.47281540187122 },
        { lat: 17.43412794348735, lng: 78.47282332630473 },
        { lat: 17.4341075618357, lng: 78.47281860898758 },
        { lat: 17.43409494737142, lng: 78.47280319947656 },
        { lat: 17.43407010465518, lng: 78.47280280592207 },
        { lat: 17.43404104533936, lng: 78.47282599498338 },
        { lat: 17.43396926550707, lng: 78.47286344389921 },
        { lat: 17.43388275913968, lng: 78.47289697824486 },
        { lat: 17.43381971294858, lng: 78.47291093094822 },
        { lat: 17.43378690901953, lng: 78.4729059444005 },
        { lat: 17.4337541610453, lng: 78.47290536616114 },
        { lat: 17.4337161497198, lng: 78.47293485080682 },
        { lat: 17.43362434268742, lng: 78.47299551093883 },
        { lat: 17.4334975972198, lng: 78.47306091454539 },
        { lat: 17.43343140715389, lng: 78.47309402206884 },
        { lat: 17.43335170519347, lng: 78.47312996337344 },
        { lat: 17.43328981574366, lng: 78.47314610547475 },
        { lat: 17.43322236254703, lng: 78.4731686451725 },
        { lat: 17.43318870404772, lng: 78.47318528097928 },
        { lat: 17.43317652799804, lng: 78.47320441349574 },
        { lat: 17.43320043407843, lng: 78.47321996289347 },
        { lat: 17.43323772518301, lng: 78.47322268222112 },
        { lat: 17.43328289547038, lng: 78.47322353165949 },
        { lat: 17.43330509818074, lng: 78.47319382266275 },
        { lat: 17.43332640154454, lng: 78.47318220830837 },
        { lat: 17.43332029851504, lng: 78.47323507134588 },
        { lat: 17.43330712984634, lng: 78.4732649494781 },
        { lat: 17.43327624937185, lng: 78.47332256470828 },
        { lat: 17.43324301056198, lng: 78.473372273068 },
        { lat: 17.4332129585043, lng: 78.47340620564191 },
        { lat: 17.43316704184332, lng: 78.47343550728114 },
        { lat: 17.43314222523561, lng: 78.47343717195807 },
        { lat: 17.43310934108506, lng: 78.47342586356288 },
        { lat: 17.43307543632553, lng: 78.47342309567387 },
        { lat: 17.43305530088827, lng: 78.47343778005339 },
        { lat: 17.43304544021779, lng: 78.47346143837952 },
        { lat: 17.43303665237125, lng: 78.47348067098474 },
        { lat: 17.43301294590593, lng: 78.47348085067638 },
        { lat: 17.4329882113793, lng: 78.47348898384674 },
        { lat: 17.43296323249017, lng: 78.47347786014197 },
        { lat: 17.43292519308782, lng: 78.4735051413265 },
        { lat: 17.43293235193443, lng: 78.47353547522867 },
        { lat: 17.43294948149994, lng: 78.47355082253324 },
        { lat: 17.43295204123563, lng: 78.47357460336178 },
        { lat: 17.43295231543054, lng: 78.47359621207542 },
        { lat: 17.43293110528402, lng: 78.47361517538681 },
        { lat: 17.43290524379644, lng: 78.47362346895208 },
        { lat: 17.43288659935467, lng: 78.47357771002184 },
        { lat: 17.4328624489687, lng: 78.47354290561297 },
        { lat: 17.43283763235717, lng: 78.47354457026697 },
        { lat: 17.43282427339883, lng: 78.4735594567363 },
        { lat: 17.43282352697583, lng: 78.4735896059256 },
        { lat: 17.43283960980034, lng: 78.47361143538997 },
        { lat: 17.43284324424416, lng: 78.47363093912914 },
        { lat: 17.43281077788809, lng: 78.4736525564562 },
        { lat: 17.43278139015123, lng: 78.47364987310108 },
        { lat: 17.43274500774251, lng: 78.47362979285795 },
        { lat: 17.43267904734662, lng: 78.47359203583946 },
        { lat: 17.43262209301657, lng: 78.4735522429192 },
        { lat: 17.4325241030832, lng: 78.47348155523686 },
        { lat: 17.43250796428778, lng: 78.47345531565877 },
        { lat: 17.43248852117597, lng: 78.4734355893247 },
        { lat: 17.43245907933976, lng: 78.47342864259713 },
        { lat: 17.43243856153671, lng: 78.47341319522032 },
        { lat: 17.43243495505936, lng: 78.47339589660984 },
        { lat: 17.43245715595534, lng: 78.47336604102782 },
        { lat: 17.43246941411733, lng: 78.4733533770866 },
        { lat: 17.432503070783, lng: 78.47333659463806 },
        { lat: 17.43251183250195, lng: 78.47331530376172 },
        { lat: 17.43250037483689, lng: 78.47330208198281 },
        { lat: 17.43247991112927, lng: 78.47329089802385 },
        { lat: 17.43244168147803, lng: 78.4733031857467 },
        { lat: 17.43242835049421, lng: 78.47332027539265 },
        { lat: 17.43238667664079, lng: 78.47332805282893 },
        { lat: 17.43233699120906, lng: 78.47332726740082 },
        { lat: 17.43231743802003, lng: 78.47329886754085 },
        { lat: 17.4322934498898, lng: 78.47327685159388 },
        { lat: 17.43225591068461, lng: 78.47325458193865 },
        { lat: 17.4322105221625, lng: 78.47323653587559 },
        { lat: 17.43214205419753, lng: 78.47317911502125 },
        { lat: 17.43208050069952, lng: 78.47313276929502 },
        { lat: 17.43204847112572, lng: 78.47309983873144 },
        { lat: 17.43201200659183, lng: 78.47307329019782 },
        { lat: 17.43199592370202, lng: 78.47305145899588 },
        { lat: 17.43199223326772, lng: 78.47302754709848 },
        { lat: 17.43201325121385, lng: 78.47299344371302 },
        { lat: 17.43203548003883, lng: 78.47296579324048 },
        { lat: 17.43206453943576, lng: 78.47294260637892 },
        { lat: 17.43206645186627, lng: 78.47291538062298 },
        { lat: 17.43204943607689, lng: 78.47290900049698 },
        { lat: 17.43202879323535, lng: 78.47288370375753 },
        { lat: 17.43202066969475, lng: 78.47286632063904 },
        { lat: 17.43202251685148, lng: 78.47283395285456 },
        { lat: 17.4320188562176, lng: 78.47281239090782 },
        { lat: 17.43198591610003, lng: 78.4727966744062 },
        { lat: 17.43196005279111, lng: 78.4728048212667 },
        { lat: 17.43193080127227, lng: 78.47281286989637 },
        { lat: 17.43190259644325, lng: 78.47281443451261 },
        { lat: 17.43188207858254, lng: 78.47279898536797 },
        { lat: 17.43186588560272, lng: 78.47276848255743 },
        { lat: 17.43187450921297, lng: 78.47273631501824 },
        { lat: 17.43190384282999, lng: 78.4727347348423 },
        { lat: 17.43193336675301, lng: 78.47274814802795 },
        { lat: 17.43195901173936, lng: 78.47272280084272 },
        { lat: 17.43197121574513, lng: 78.47270587351191 },
        { lat: 17.43199136605698, lng: 78.47269236507655 },
        { lat: 17.43201690096351, lng: 78.4726583462182 },
        { lat: 17.4320469249198, lng: 78.47262220871507 },
        { lat: 17.43201508743038, lng: 78.47260441649804 },
        { lat: 17.43198997044913, lng: 78.47258241623314 },
        { lat: 17.43196504378559, lng: 78.47257540933741 },
        { lat: 17.43194474421863, lng: 78.47257715865163 },
        { lat: 17.43191907312616, lng: 78.4726004475344 },
        { lat: 17.43189087950368, lng: 78.47260289458764 },
        { lat: 17.4318696433238, lng: 78.47261979955623 },
        { lat: 17.43185562018555, lng: 78.47267129970524 },
        { lat: 17.43184686041579, lng: 78.47269273915737 },
        { lat: 17.43182223410674, lng: 78.4727093953687 },
        { lat: 17.43179736342287, lng: 78.47270679859945 },
        { lat: 17.4317643411981, lng: 78.47268461367469 },
        { lat: 17.43174817616949, lng: 78.47265631408332 },
        { lat: 17.43172316742749, lng: 78.47264284060823 },
        { lat: 17.43169124786149, lng: 78.47261858183856 },
        { lat: 17.43166255047557, lng: 78.47258134140554 },
        { lat: 17.43163842420005, lng: 78.47254844704182 },
        { lat: 17.43163553597993, lng: 78.4724987963705 },
        { lat: 17.43164085340353, lng: 78.47247299533278 },
        { lat: 17.43165061696063, lng: 78.47244169468084 },
        { lat: 17.43166822044538, lng: 78.47240543289394 },
        { lat: 17.43169846454606, lng: 78.47238664059448 },
        { lat: 17.43172308893734, lng: 78.47236983572196 },
        { lat: 17.43174889807707, lng: 78.47235742355124 },
        { lat: 17.43175771195602, lng: 78.47234024936694 },
        { lat: 17.43174154690635, lng: 78.47231195169523 },
        { lat: 17.43171397825774, lng: 78.4722746957579 },
        { lat: 17.43168453640682, lng: 78.47226774923442 },
        { lat: 17.43166426297617, lng: 78.47227155688986 },
        { lat: 17.43163850980428, lng: 78.472288377319 },
        { lat: 17.43159082833643, lng: 78.47235651505838 },
        { lat: 17.43156096675759, lng: 78.47240544075893 },
        { lat: 17.43153616323523, lng: 78.47240813468576 },
        { lat: 17.43152897625964, lng: 78.47237559600836 },
        { lat: 17.4315163785804, lng: 78.47236150938826 },
        { lat: 17.43149264786543, lng: 78.47235977763626 },
        { lat: 17.43145353394323, lng: 78.47239133769823 },
        { lat: 17.43141549654772, lng: 78.47241876557216 },
        { lat: 17.43139084415623, lng: 78.47243336533943 },
        { lat: 17.43135352318131, lng: 78.4724282924489 },
        { lat: 17.43131601188232, lng: 78.47240822625086 },
        { lat: 17.43126717912767, lng: 78.47238567211913 },
        { lat: 17.43123341058235, lng: 78.47239363433285 },
        { lat: 17.43119210436288, lng: 78.47243036932795 },
        { lat: 17.43117802715679, lng: 78.47247760779612 },
        { lat: 17.43116579703503, lng: 78.47249247674941 },
        { lat: 17.43112404114405, lng: 78.47249378772379 },
        { lat: 17.43108305953652, lng: 78.47246715487483 },
        { lat: 17.43103766911542, lng: 78.47244896233838 },
        { lat: 17.43100489315329, lng: 78.47244617905999 },
        { lat: 17.43092947878408, lng: 78.47246412382461 },
        { lat: 17.43088894682881, lng: 78.4724729149433 },
        { lat: 17.43087181721229, lng: 78.4724575678967 },
        { lat: 17.43084801933953, lng: 78.47245054549063 },
        { lat: 17.43081422468343, lng: 78.47245645123981 },
        { lat: 17.43077618537597, lng: 78.47248373035275 },
        { lat: 17.43066267761257, lng: 78.47252469455353 },
        { lat: 17.43061205369301, lng: 78.47253891620507 },
        { lat: 17.43055455443883, lng: 78.47254514844299 },
        { lat: 17.43050916402698, lng: 78.47252695592032 },
        { lat: 17.43044075004112, lng: 78.47247379727732 },
        { lat: 17.43038272090927, lng: 78.47243828402699 },
        { lat: 17.43034719107952, lng: 78.4723964335485 },
        { lat: 17.43031403264572, lng: 78.47236351894902 },
        { lat: 17.43028560951565, lng: 78.47234788530965 },
        { lat: 17.43019760867902, lng: 78.47235262586746 },
        { lat: 17.43009740570644, lng: 78.47237444032775 },
        { lat: 17.43003990645913, lng: 78.47238067257642 },
        { lat: 17.42995642450249, lng: 78.47238564440477 },
        { lat: 17.42991488690945, lng: 78.47240415359741 },
        { lat: 17.42986429098056, lng: 78.47242058024094 },
        { lat: 17.42978871241177, lng: 78.47242558994805 },
        { lat: 17.4297389411699, lng: 78.47241804278909 },
        { lat: 17.42969119617253, lng: 78.47239223905002 },
        { lat: 17.42966178045373, lng: 78.47238735083045 },
        { lat: 17.42960330539254, lng: 78.47240565107266 },
        { lat: 17.42954909923015, lng: 78.47240448773874 },
        { lat: 17.42952855337633, lng: 78.47238683376308 },
        { lat: 17.42950021235728, lng: 78.47237766854508 },
        { lat: 17.42945316699889, lng: 78.47240698524494 },
        { lat: 17.42940695003211, lng: 78.47241261981412 },
        { lat: 17.42937048360223, lng: 78.47238592498712 },
        { lat: 17.42932578538833, lng: 78.47233332066277 },
        { lat: 17.42928840846021, lng: 78.4723238395929 },
        { lat: 17.42920708707504, lng: 78.4723211379028 },
        { lat: 17.42912801020664, lng: 78.47231737596991 },
        { lat: 17.4290478605012, lng: 78.47231803777633 },
        { lat: 17.42898999369579, lng: 78.47229531286814 },
        { lat: 17.42896611372184, lng: 78.47228182216567 },
        { lat: 17.42893667003832, lng: 78.47227473081314 },
        { lat: 17.42889924085797, lng: 78.47226113319748 },
        { lat: 17.42887092596433, lng: 78.47225402630079 },
        { lat: 17.42884054563946, lng: 78.47226208847759 },
        { lat: 17.42881265611606, lng: 78.47228849358325 },
        { lat: 17.42879866096366, lng: 78.47234219976916 },
        { lat: 17.42877986144845, lng: 78.47237318404451 },
        { lat: 17.42874731869672, lng: 78.47238877478159 },
        { lat: 17.42870561874855, lng: 78.47239449386934 },
        { lat: 17.42867906507472, lng: 78.47243719912419 },
        { lat: 17.42867527189798, lng: 78.47249414626532 },
        { lat: 17.42867353666225, lng: 78.47253533358077 },
        { lat: 17.42869248153748, lng: 78.47260475597558 },
        { lat: 17.42869617196695, lng: 78.47262866743615 },
        { lat: 17.42868303313861, lng: 78.47266089658319 },
        { lat: 17.42865295499846, lng: 78.47269277190752 },
        { lat: 17.42863086419722, lng: 78.47273130025171 },
        { lat: 17.42862690489957, lng: 78.47277516393882 },
        { lat: 17.42863861063389, lng: 78.47280793346428 },
        { lat: 17.42867163280818, lng: 78.47283011811388 },
        { lat: 17.42870013795646, lng: 78.47285221819895 },
        { lat: 17.42872514668995, lng: 78.47286569342168 },
        { lat: 17.42873222346104, lng: 78.47288955826218 },
        { lat: 17.42874681908059, lng: 78.47297212636425 },
        { lat: 17.42874455552546, lng: 78.4730606584708 },
        { lat: 17.42872751320688, lng: 78.4731411613895 },
        { lat: 17.42869577979026, lng: 78.47322054370667 },
        { lat: 17.42866313761512, lng: 78.47331728642978 },
        { lat: 17.42864686594406, lng: 78.47336955421844 },
        { lat: 17.42861158194849, lng: 78.47343604827788 },
        { lat: 17.42857180698984, lng: 78.4735045141258 },
        { lat: 17.42856326709583, lng: 78.47354329614441 },
        { lat: 17.42855498265612, lng: 78.47360221508022 },
        { lat: 17.42855338144213, lng: 78.47365398542088 },
        { lat: 17.4285458465549, lng: 78.47377199435422 },
        { lat: 17.42854661211718, lng: 78.47392134823261 },
        { lat: 17.42858772030426, lng: 78.47395797529313 },
        { lat: 17.42858347922497, lng: 78.47397964565073 },
        { lat: 17.42855907646892, lng: 78.47401393973617 },
        { lat: 17.42856421062199, lng: 78.47406267807479 },
        { lat: 17.42861067105354, lng: 78.47416524167231 },
        { lat: 17.4286488290831, lng: 78.47423631170813 },
        { lat: 17.4286709379187, lng: 78.4742881960922 },
        { lat: 17.42867487981765, lng: 78.4743319510536 },
        { lat: 17.428695481425, lng: 78.47435401339361 },
        { lat: 17.42871616320372, lng: 78.4743823973448 },
        { lat: 17.42873040028795, lng: 78.47443674230406 },
        { lat: 17.42876190478075, lng: 78.47451731281664 },
        { lat: 17.42879762431132, lng: 78.47457415657783 },
        { lat: 17.42883513539811, lng: 78.47459422116496 },
        { lat: 17.42885471629531, lng: 78.47462482385868 },
        { lat: 17.42884592829274, lng: 78.47464405783738 },
        { lat: 17.42882025869984, lng: 78.47466749088022 },
        { lat: 17.42878563706861, lng: 78.47469722304383 },
        { lat: 17.4287826383848, lng: 78.47472784290782 },
        { lat: 17.42879963177323, lng: 78.47473246023806 },
        { lat: 17.42882670043096, lng: 78.47473032453493 },
        { lat: 17.42885159722562, lng: 78.47473497988388 },
        { lat: 17.4288731356052, lng: 78.47474188687276 },
        { lat: 17.42887566905679, lng: 78.47476361081112 },
        { lat: 17.42887599709783, lng: 78.47478948050984 },
        { lat: 17.42885947524858, lng: 78.47482204968662 },
        { lat: 17.42884187307775, lng: 78.4748584574614 },
        { lat: 17.42884454443056, lng: 78.47489105796062 },
        { lat: 17.42886952321865, lng: 78.47490217981637 },
        { lat: 17.42886866841517, lng: 78.47492380360399 },
        { lat: 17.42887257664094, lng: 78.47496491335063 },
        { lat: 17.42887970909034, lng: 78.47499318840484 },
        { lat: 17.42888257236045, lng: 78.47504092692628 },
        { lat: 17.42890237125182, lng: 78.4750887278668 },
        { lat: 17.42893365559441, lng: 78.47515195366184 },
        { lat: 17.42895031780724, lng: 78.4752194979554 },
        { lat: 17.42897879478563, lng: 78.47523939343571 },
        { lat: 17.42899925841447, lng: 78.47525057935019 },
        { lat: 17.42901536900184, lng: 78.47527461550042 },
        { lat: 17.42904472367834, lng: 78.4753637421655 },
        { lat: 17.42905708493772, lng: 78.47544825146134 },
        { lat: 17.4290750919873, lng: 78.47553282988193 },
        { lat: 17.42909885663606, lng: 78.47562629760753 },
        { lat: 17.42910271068234, lng: 78.4756631441059 },
        { lat: 17.42908849845325, lng: 78.47569979879398 },
        { lat: 17.42906742774602, lng: 78.475729784761 },
        { lat: 17.42904079319879, lng: 78.475766169982 },
        { lat: 17.42899353294156, lng: 78.47577858109587 },
        { lat: 17.42885384393195, lng: 78.47580270172595 },
        { lat: 17.42872420597465, lng: 78.4758181559131 },
        { lat: 17.42861599834143, lng: 78.47583199429879 },
        { lat: 17.42854491418013, lng: 78.47583532425061 },
        { lat: 17.42847484890029, lng: 78.47582996715853 },
        { lat: 17.42837113032109, lng: 78.47584168322862 },
        { lat: 17.42825722839515, lng: 78.47585162936178 },
        { lat: 17.42824134332924, lng: 78.47584538025839 },
        { lat: 17.42822563336864, lng: 78.47585294647824 },
        { lat: 17.42822719809696, lng: 78.47588732532986 },
        { lat: 17.42824307946576, lng: 78.47589328281548 },
        { lat: 17.42824333655006, lng: 78.47591356648853 },
        { lat: 17.42826385415721, lng: 78.47592901388472 },
        { lat: 17.42831813684109, lng: 78.47593620640625 },
        { lat: 17.42835650090947, lng: 78.47593450264489 },
        { lat: 17.42840632243115, lng: 78.47594601870799 },
        { lat: 17.42844361360099, lng: 78.47594874054258 },
        { lat: 17.42848087682334, lng: 78.4759492573409 },
        { lat: 17.42851026272011, lng: 78.4759517943512 },
        { lat: 17.42854625927121, lng: 78.47594144824025 },
        { lat: 17.42857655412309, lng: 78.47592662480825 },
        { lat: 17.42865989479142, lng: 78.47591048276212 },
        { lat: 17.42873546804139, lng: 78.47590503243906 },
        { lat: 17.42885505120475, lng: 78.47589794932115 },
        { lat: 17.42887992004406, lng: 78.47590039979167 },
        { lat: 17.42892191828128, lng: 78.47591819941073 },
        { lat: 17.42899032774517, lng: 78.47597106560353 },
        { lat: 17.42902431263473, lng: 78.47598015375632 },
        { lat: 17.42906270836941, lng: 78.4759809485243 },
        { lat: 17.4290954806218, lng: 78.47598343707539 },
        { lat: 17.4291283255581, lng: 78.47599166024646 },
        { lat: 17.42914521832491, lng: 78.47598833991881 },
        { lat: 17.42916083325737, lng: 78.47597327613319 },
        { lat: 17.42918107701472, lng: 78.47596711717127 },
        { lat: 17.42922720849435, lng: 78.47595472161113 },
        { lat: 17.4292608934382, lng: 78.47594014503555 },
        { lat: 17.42931148607288, lng: 78.47592342589581 },
        { lat: 17.42934167283603, lng: 78.47590007569964 },
        { lat: 17.42936301743271, lng: 78.47589169614749 },
        { lat: 17.42939135649942, lng: 78.47590071517537 },
        { lat: 17.42941650108714, lng: 78.47592492073197 },
        { lat: 17.42944874818946, lng: 78.4759750496916 },
        { lat: 17.42947279006547, lng: 78.47600132908833 },
        { lat: 17.42949327972989, lng: 78.47601457153107 },
        { lat: 17.42951801259549, lng: 78.47600629403733 },
        { lat: 17.4295429913446, lng: 78.47601741608183 },
        { lat: 17.42954659756628, lng: 78.47603471451086 },
        { lat: 17.42953786530052, lng: 78.47605835673524 },
        { lat: 17.42952010082531, lng: 78.4760819764114 },
        { lat: 17.42949801120012, lng: 78.47612065138846 },
        { lat: 17.42948476188939, lng: 78.4761442089526 },
        { lat: 17.42944455005963, lng: 78.47617828008195 },
        { lat: 17.42943488085933, lng: 78.47621707776426 },
        { lat: 17.42943862490773, lng: 78.47624525279745 },
        { lat: 17.4294368330225, lng: 78.47628203026211 },
        { lat: 17.42945737670239, lng: 78.47629953608167 },
        { lat: 17.42949469396035, lng: 78.47630431627117 },
        { lat: 17.42952394385296, lng: 78.47629612158799 },
        { lat: 17.4295496136539, lng: 78.47627268864254 },
        { lat: 17.42957773289075, lng: 78.47626436272301 },
        { lat: 17.42959378748519, lng: 78.47628398894778 },
        { lat: 17.42958723266005, lng: 78.47630127847634 },
        { lat: 17.42956952218392, lng: 78.47632916148761 },
        { lat: 17.42953583906623, lng: 78.47634388478062 },
        { lat: 17.42950108118228, lng: 78.47636288693765 },
        { lat: 17.42945192465231, lng: 78.47640384411649 },
        { lat: 17.42944544434673, lng: 78.4764270150123 },
        { lat: 17.42947480788198, lng: 78.47642778729991 },
        { lat: 17.42951655459986, lng: 78.47642574163895 },
        { lat: 17.42953690829105, lng: 78.47642825615429 },
        { lat: 17.42957072739327, lng: 78.47642426274032 },
        { lat: 17.42959634315832, lng: 78.47639656457395 },
        { lat: 17.42960967261308, lng: 78.47637932865514 },
        { lat: 17.42962997041527, lng: 78.4763774330634 },
        { lat: 17.42967995585424, lng: 78.4764018842042 },
        { lat: 17.42964189353329, lng: 78.47642739946033 },
        { lat: 17.42961165267516, lng: 78.47644648627457 },
        { lat: 17.42961545072209, lng: 78.47647892469281 },
        { lat: 17.42963585841644, lng: 78.47648570068216 },
        { lat: 17.42966069931509, lng: 78.47648594617763 },
        { lat: 17.42968198993934, lng: 78.47647330520122 },
        { lat: 17.42971134787186, lng: 78.47647363535269 },
        { lat: 17.42973180959384, lng: 78.47648467469533 },
        { lat: 17.42975576944577, lng: 78.47650448579866 },
        { lat: 17.42975951346043, lng: 78.47653266089185 },
        { lat: 17.42974615421431, lng: 78.47654754689323 },
        { lat: 17.42971244313508, lng: 78.476560065115 },
        { lat: 17.42968782200798, lng: 78.47657716275712 },
        { lat: 17.42967446275733, lng: 78.47659204874918 },
        { lat: 17.42963507044076, lng: 78.47660170387417 },
        { lat: 17.4296115855643, lng: 78.47661937487159 },
        { lat: 17.42959136972174, lng: 78.47662773883626 },
        { lat: 17.42954526612446, lng: 78.4766423393206 },
        { lat: 17.42951599012894, lng: 78.47664847565451 },
        { lat: 17.42951538098671, lng: 78.47668950096676 },
        { lat: 17.4295606295789, lng: 78.47669652250423 },
        { lat: 17.42959445055231, lng: 78.47669267589042 },
        { lat: 17.42961920951478, lng: 78.476686454895 },
        { lat: 17.42965300254626, lng: 78.476680403225 },
        { lat: 17.4296836830049, lng: 78.4766960064995 },
        { lat: 17.42971976528428, lng: 78.47669242234073 },
        { lat: 17.42976815069413, lng: 78.4766797023514 },
        { lat: 17.42979726278329, lng: 78.47666063107508 },
        { lat: 17.42982317847832, lng: 78.47665659959584 },
        { lat: 17.42983468992493, lng: 78.4766740829195 },
        { lat: 17.42985432457341, lng: 78.4767089493876 },
        { lat: 17.42988574257625, lng: 78.47678275897009 },
        { lat: 17.42992087846777, lng: 78.47688268729178 },
        { lat: 17.42995662162067, lng: 78.47694144160499 },
        { lat: 17.429993111785, lng: 78.47697004904349 },
        { lat: 17.43003408918451, lng: 78.47699638935377 },
        { lat: 17.43006724509496, lng: 78.47702915810274 },
        { lat: 17.43009494885133, lng: 78.47707714448066 },
        { lat: 17.43011391834659, lng: 78.47714862638989 },
        { lat: 17.43014963538196, lng: 78.47720532439855 },
        { lat: 17.43018623351943, lng: 78.47724245676802 },
        { lat: 17.4302184524093, lng: 78.47729038113808 },
        { lat: 17.43022916275085, lng: 78.47733375000271 },
        { lat: 17.43023068816006, lng: 78.47736504181633 },
        { lat: 17.43025567434524, lng: 78.47737675486172 },
        { lat: 17.43028859557825, lng: 78.47739100271933 },
        { lat: 17.43032591283871, lng: 78.47739578313269 },
        { lat: 17.43036892431447, lng: 78.477404452055 },
        { lat: 17.43040183439236, lng: 78.47741781940418 },
        { lat: 17.43045512235472, lng: 78.47743561105906 },
        { lat: 17.43052628666664, lng: 78.47743860138766 },
        { lat: 17.43057575252473, lng: 78.47742204475149 },
        { lat: 17.43063400292299, lng: 78.47738596051539 },
        { lat: 17.43065526564852, lng: 78.47737111260626 },
        { lat: 17.43070585843168, lng: 78.47735439366356 },
        { lat: 17.43074196681001, lng: 78.47735286789688 },
        { lat: 17.43079184046027, lng: 78.47736850104187 },
        { lat: 17.43084523828581, lng: 78.47739496433732 },
        { lat: 17.43089778292086, lng: 78.47744319845516 },
        { lat: 17.43095324055843, lng: 78.47754313977424 },
        { lat: 17.430981160233, lng: 78.47760817811718 },
        { lat: 17.43099988379768, lng: 78.4776602569582 },
        { lat: 17.43104465902079, lng: 78.47771903626985 },
        { lat: 17.43109314456221, lng: 78.47780334374289 },
        { lat: 17.43111147843428, lng: 78.47791379352287 },
        { lat: 17.43111914982675, lng: 78.47807378682168 },
        { lat: 17.43113977345857, lng: 78.47809761470627 },
        { lat: 17.43116367733835, lng: 78.47811301602493 },
        { lat: 17.43120093874508, lng: 78.47811338644027 },
        { lat: 17.43122679863313, lng: 78.47810494495775 },
        { lat: 17.43125172147964, lng: 78.47811165911067 },
        { lat: 17.43127565142857, lng: 78.4781291187582 },
        { lat: 17.43134782662402, lng: 78.47821192474552 },
        { lat: 17.43140405719774, lng: 78.47828377774447 },
        { lat: 17.43144351406065, lng: 78.47836835829635 },
        { lat: 17.43145826393993, lng: 78.47846327263287 },
        { lat: 17.43145749253482, lng: 78.4784915101129 },
        { lat: 17.43145151086776, lng: 78.478554075336 },
        { lat: 17.43143412208037, lng: 78.47860738647405 },
        { lat: 17.43147069209929, lng: 78.47864231430766 },
        { lat: 17.43148741742223, lng: 78.47862576556496 },
        { lat: 17.43150763150425, lng: 78.47861725493883 },
        { lat: 17.43153263622859, lng: 78.47863043576558 },
        { lat: 17.43153178105827, lng: 78.47865205990855 },
        { lat: 17.43150728817737, lng: 78.47867930047803 },
        { lat: 17.43149414837973, lng: 78.47871152985124 },
        { lat: 17.43146941725247, lng: 78.47871995575802 },
        { lat: 17.43144890165113, lng: 78.47870465455337 },
        { lat: 17.43141679469614, lng: 78.4786655480188 },
        { lat: 17.43138735667689, lng: 78.47865889583179 },
        { lat: 17.43135463836074, lng: 78.47866066833913 },
        { lat: 17.43133244027822, lng: 78.47869081670109 },
        { lat: 17.43129077350381, lng: 78.47869918176207 },
        { lat: 17.43128342374074, lng: 78.47865370767815 },
        { lat: 17.43126836225764, lng: 78.47862333555904 },
        { lat: 17.43123980549704, lng: 78.47859711947454 },
        { lat: 17.43124503997378, lng: 78.47856470333832 },
        { lat: 17.43126894385003, lng: 78.47858010661133 },
        { lat: 17.43128926773993, lng: 78.47858026765645 },
        { lat: 17.43131961677211, lng: 78.47856970586186 },
        { lat: 17.43134889099559, lng: 78.47856342297166 },
        { lat: 17.4313735402273, lng: 78.4785485304617 },
        { lat: 17.43138684380006, lng: 78.47852923616664 },
        { lat: 17.43138767103553, lng: 78.47850540696659 },
        { lat: 17.43136338372348, lng: 78.47845972530408 },
        { lat: 17.43135059097603, lng: 78.4784302045729 },
        { lat: 17.43135590733818, lng: 78.47840425688656 },
        { lat: 17.43137276108969, lng: 78.4783978511064 },
        { lat: 17.43137703240345, lng: 78.47837853227415 },
        { lat: 17.43137337053128, lng: 78.47835682533386 },
        { lat: 17.43133164793078, lng: 78.47836078032269 },
        { lat: 17.43129492819442, lng: 78.47840318303268 },
        { lat: 17.43126124677944, lng: 78.47841805478458 },
        { lat: 17.43124794321665, lng: 78.4784373490717 },
        { lat: 17.43121046403133, lng: 78.47841978203013 },
        { lat: 17.43119096736902, lng: 78.4783957918287 },
        { lat: 17.43117472120622, lng: 78.47836102511829 },
        { lat: 17.43117210807172, lng: 78.47833298097848 },
        { lat: 17.43118428097096, lng: 78.47831355545357 },
        { lat: 17.43121016879688, lng: 78.47830731907227 },
        { lat: 17.43122568340132, lng: 78.4782843192593 },
        { lat: 17.4312185513342, lng: 78.47825604178091 },
        { lat: 17.43120249877438, lng: 78.47823656383757 },
        { lat: 17.43118724548749, lng: 78.47819105165505 },
        { lat: 17.43116240454046, lng: 78.47819080407366 },
        { lat: 17.43115823749041, lng: 78.47821835427638 },
        { lat: 17.43111210767971, lng: 78.47823089623911 },
        { lat: 17.43109178377039, lng: 78.47823073334874 },
        { lat: 17.43107027523746, lng: 78.478226177711 },
        { lat: 17.43103661988049, lng: 78.47824310590515 },
        { lat: 17.43103149527253, lng: 78.47828419365383 },
        { lat: 17.43105201089645, lng: 78.47829949477855 },
        { lat: 17.43106363020956, lng: 78.4783255051097 },
        { lat: 17.43105861354283, lng: 78.47837511776095 },
        { lat: 17.43104982516216, lng: 78.47839434997525 },
        { lat: 17.4310421637161, lng: 78.47841341992114 },
        { lat: 17.43100773507056, lng: 78.47845843873593 },
        { lat: 17.43098564498979, lng: 78.47849711383033 },
        { lat: 17.43098839582948, lng: 78.47853603466635 },
        { lat: 17.43102047673246, lng: 78.47857308277636 },
        { lat: 17.4310162072287, lng: 78.47859254644041 },
        { lat: 17.43101091689842, lng: 78.4786205523926 },
        { lat: 17.43104049264386, lng: 78.4786380812908 },
        { lat: 17.43105635533855, lng: 78.47864256778139 },
        { lat: 17.43107695284635, lng: 78.47866433741417 },
        { lat: 17.43111341304664, lng: 78.47869059354747 },
        { lat: 17.43113830796221, lng: 78.47869510270789 },
        { lat: 17.43117124402719, lng: 78.47871052677561 },
        { lat: 17.4312032411675, lng: 78.47874096161337 },
        { lat: 17.43123623121356, lng: 78.47876064908796 },
        { lat: 17.43126905747571, lng: 78.47876740151109 },
        { lat: 17.43132680657366, lng: 78.47878086818427 },
        { lat: 17.43138346222921, lng: 78.4787971424672 },
        { lat: 17.43143325208356, lng: 78.47880616270294 },
        { lat: 17.43151581233531, lng: 78.47881752334106 },
        { lat: 17.43159931156139, lng: 78.47881387694896 },
        { lat: 17.43165107608367, lng: 78.47880052186846 },
        { lat: 17.43168946630104, lng: 78.47880087689978 },
        { lat: 17.43171325848377, lng: 78.4788074599154 },
        { lat: 17.43173471117134, lng: 78.47880760546813 },
        { lat: 17.43178524826648, lng: 78.4787864766032 },
        { lat: 17.43185592499521, lng: 78.47875095750136 },
        { lat: 17.4318850893953, lng: 78.47873600103576 },
        { lat: 17.43192662032043, lng: 78.478716907797 },
        { lat: 17.4320046747064, lng: 78.478729066096 },
        { lat: 17.43202152846832, lng: 78.4787226603132 },
        { lat: 17.43203832824342, lng: 78.47871199111627 },
        { lat: 17.43205956314783, lng: 78.47869493812658 },
        { lat: 17.43208883737258, lng: 78.47868865521392 },
        { lat: 17.4321092431723, lng: 78.47869528475795 },
        { lat: 17.43215734870527, lng: 78.47874960797719 },
        { lat: 17.43218144426751, lng: 78.47878014966267 },
        { lat: 17.43221432451644, lng: 78.47879116551762 },
        { lat: 17.4322320892981, lng: 78.47876754567523 },
        { lat: 17.43223278070035, lng: 78.47873298820392 },
        { lat: 17.43221648246357, lng: 78.47869410649014 },
        { lat: 17.43223315193541, lng: 78.47867314750269 },
        { lat: 17.43223392706773, lng: 78.47864520340957 },
        { lat: 17.4322267689892, lng: 78.47861486931036 },
        { lat: 17.43225139029057, lng: 78.47859777163283 },
        { lat: 17.43230198131218, lng: 78.47858090417063 },
        { lat: 17.43236474709569, lng: 78.47854475780349 },
        { lat: 17.43240187820119, lng: 78.47853483849237 },
        { lat: 17.43249957705019, lng: 78.47849350747323 },
        { lat: 17.43254788813872, lng: 78.47847490803619 },
        { lat: 17.43256846893197, lng: 78.47849535512371 },
        { lat: 17.43260498314121, lng: 78.47852587293623 },
        { lat: 17.43262982966624, lng: 78.4785265608032 },
        { lat: 17.43267136052847, lng: 78.4785074655371 },
        { lat: 17.43271372047821, lng: 78.47846468952523 },
        { lat: 17.43278025609653, lng: 78.47845877698364 },
        { lat: 17.4328012694582, lng: 78.47842423366538 },
        { lat: 17.43280552400321, lng: 78.47840359199898 },
        { lat: 17.432815247546, lng: 78.47836905706349 },
        { lat: 17.43284444170697, lng: 78.47835645417109 },
        { lat: 17.43287710415186, lng: 78.47835027137175 },
        { lat: 17.43290288213937, lng: 78.47833536316729 },
        { lat: 17.43287895216479, lng: 78.47831790148354 },
        { lat: 17.43286270783301, lng: 78.47828328311947 },
        { lat: 17.43283847626342, lng: 78.47824200945684 },
        { lat: 17.43283583517455, lng: 78.47821176185877 },
        { lat: 17.43283209319213, lng: 78.47818373298912 },
        { lat: 17.43286665761361, lng: 78.4781494437068 },
        { lat: 17.43292026259064, lng: 78.47810313138814 },
        { lat: 17.4329928615672, lng: 78.47804112147733 },
        { lat: 17.4330254160098, lng: 78.47802641362908 },
        { lat: 17.43305808403615, lng: 78.4780206729096 },
        { lat: 17.43310440558193, lng: 78.47802327096909 },
        { lat: 17.43314965231365, lng: 78.47803014610032 },
        { lat: 17.4332061702369, lng: 78.47803554337952 },
        { lat: 17.43323200405458, lng: 78.47802504529466 },
        { lat: 17.43326568540427, lng: 78.47801017326401 },
        { lat: 17.43330697788344, lng: 78.47797226485578 },
        { lat: 17.43334853659746, lng: 78.47795537447766 },
        { lat: 17.43337337751225, lng: 78.4779556201071 },
        { lat: 17.43342322322068, lng: 78.47796904844783 },
        { lat: 17.43349325688492, lng: 78.47797190763387 },
        { lat: 17.43353842170133, lng: 78.47797231608916 },
        { lat: 17.43358819107133, lng: 78.47797971804205 },
        { lat: 17.43363321996448, lng: 78.47796939638128 },
        { lat: 17.43367136435633, lng: 78.47795034741466 },
        { lat: 17.43371652917147, lng: 78.47795075585886 },
        { lat: 17.4337448663433, lng: 78.47795962858216 },
        { lat: 17.43377000706317, lng: 78.47798354143568 },
        { lat: 17.43381348777312, lng: 78.47802925328378 },
        { lat: 17.43385027578664, lng: 78.47808138006036 },
        { lat: 17.43389372854762, lng: 78.4781248868472 },
        { lat: 17.43393900321136, lng: 78.47813396711192 },
        { lat: 17.43399229676442, lng: 78.47815220133356 },
        { lat: 17.43402085175952, lng: 78.47817827091798 },
        { lat: 17.43406513354285, lng: 78.47819809685723 },
        { lat: 17.43410624492967, lng: 78.478235021311 },
        { lat: 17.434130338741, lng: 78.47826541645036 },
        { lat: 17.43413887891136, lng: 78.47831572616599 },
        { lat: 17.43412371809713, lng: 78.47836665523855 },
        { lat: 17.43409470827778, lng: 78.47839381158168 },
        { lat: 17.43406906622669, lng: 78.47841945192447 },
        { lat: 17.43406025181477, lng: 78.47843662612213 },
        { lat: 17.43407616851527, lng: 78.4784453760912 },
        { lat: 17.43409305203948, lng: 78.47844132204881 },
        { lat: 17.43411342992103, lng: 78.47844574649721 },
        { lat: 17.43419812986111, lng: 78.47853690813012 },
        { lat: 17.43423801186913, lng: 78.47856591018683 },
        { lat: 17.43426734192671, lng: 78.47856403735126 },
        { lat: 17.4343046293798, lng: 78.47856646424908 },
        { lat: 17.43432858725466, lng: 78.4785861293077 },
        { lat: 17.43434012280798, lng: 78.4786055247646 },
        { lat: 17.43433593341107, lng: 78.47863131061222 },
        { lat: 17.43433058914772, lng: 78.47865505361901 },
        { lat: 17.43434234434017, lng: 78.47869179269617 },
        { lat: 17.43437455932467, lng: 78.47873942484132 },
        { lat: 17.43438625867649, lng: 78.47877175559191 },
        { lat: 17.43437594240288, lng: 78.47884863997223 },
        { lat: 17.4343570648116, lng: 78.47896269132181 },
        { lat: 17.43432906184966, lng: 78.47906936899535 },
        { lat: 17.43428808653196, lng: 78.47922150718166 },
        { lat: 17.43423772053417, lng: 78.47943449320033 },
        { lat: 17.43420101445189, lng: 78.47956716538121 },
        { lat: 17.43418605243099, lng: 78.47963382370382 },
        { lat: 17.43408125559092, lng: 78.48000633402542 },
        { lat: 17.43403042867333, lng: 78.480093772842 },
        { lat: 17.4340051640329, lng: 78.48014925156463 },
        { lat: 17.43396249905564, lng: 78.48025715966602 },
        { lat: 17.43391904750411, lng: 78.48039212968173 },
        { lat: 17.43386736719355, lng: 78.48059057727035 },
        { lat: 17.43380239405858, lng: 78.48080920163447 },
        { lat: 17.43373284784261, lng: 78.48102333278032 },
        { lat: 17.43368168197807, lng: 78.48117325784663 },
        { lat: 17.4335985747548, lng: 78.48147563646184 },
        { lat: 17.43354222563262, lng: 78.48166209268908 },
        { lat: 17.43350409167311, lng: 78.48177126097474 },
        { lat: 17.4334527076716, lng: 78.48190398701558 },
        { lat: 17.43343457404803, lng: 78.48198774151673 },
        { lat: 17.43341704083925, lng: 78.48211897540133 },
        { lat: 17.43336399751613, lng: 78.48229906304418 },
        { lat: 17.43331292167494, lng: 78.48245618991344 },
        { lat: 17.4332742587712, lng: 78.4826128528175 },
        { lat: 17.43316109158558, lng: 78.48294886810143 },
        { lat: 17.433064311374, lng: 78.4832415835096 },
        { lat: 17.43304115928503, lng: 78.48337495100725 },
        { lat: 17.43300718651671, lng: 78.48345612989998 },
        { lat: 17.43295927128896, lng: 78.48359542410688 },
        { lat: 17.43290984817415, lng: 78.48370474659534 },
        { lat: 17.43283703413043, lng: 78.4838392354048 },
        { lat: 17.43279399732162, lng: 78.48391789261814 },
        { lat: 17.43273632692548, lng: 78.48399998343164 },
        { lat: 17.43266905263705, lng: 78.48412616312125 },
        { lat: 17.43263139409803, lng: 78.48418372286334 },
        { lat: 17.43254238646565, lng: 78.48428756037232 },
        { lat: 17.43244534159505, lng: 78.48438077602549 },
        { lat: 17.43235738278759, lng: 78.48447827795887 },
        { lat: 17.43229036416666, lng: 78.4845353575079 },
        { lat: 17.43221436339562, lng: 78.48459638211008 },
        { lat: 17.43217742495085, lng: 78.4846215872511 },
        { lat: 17.43210014679072, lng: 78.48467086800197 },
        { lat: 17.43204381446017, lng: 78.48468016675382 },
        { lat: 17.43200787295862, lng: 78.4846949198112 },
        { lat: 17.43201721904815, lng: 78.48471978581739 },
        { lat: 17.43192469096286, lng: 78.48481308582193 },
        { lat: 17.43186667846913, lng: 78.4848681297319 },
        { lat: 17.43181175528619, lng: 78.48489960871773 },
        { lat: 17.43177038141199, lng: 78.48493119551179 },
        { lat: 17.43172806999107, lng: 78.48497793988852 },
        { lat: 17.43162835677642, lng: 78.48503870013104 },
        { lat: 17.43157348554883, lng: 78.48507429568646 },
        { lat: 17.43156128223264, lng: 78.48509136905555 },
        { lat: 17.43157645605853, lng: 78.48513070900097 },
        { lat: 17.4315721859012, lng: 78.48515017266281 },
        { lat: 17.43153799879621, lng: 78.48521444746662 },
        { lat: 17.43147915808607, lng: 78.48529331854517 },
        { lat: 17.43142833404342, lng: 78.48538119514271 },
        { lat: 17.43142425320628, lng: 78.4854156522538 },
        { lat: 17.43141114009971, lng: 78.48545008636886 },
        { lat: 17.4313853577481, lng: 78.48546470186794 },
        { lat: 17.43133145370424, lng: 78.48548749152356 },
        { lat: 17.43130255779682, lng: 78.48552376025553 },
        { lat: 17.43129307794951, lng: 78.48557769832068 },
        { lat: 17.43127676585901, lng: 78.4856270236305 },
        { lat: 17.43123026569729, lng: 78.48569969984968 },
        { lat: 17.43116464824066, lng: 78.48577836994967 },
        { lat: 17.43109322156236, lng: 78.48584403545917 },
        { lat: 17.43097953880532, lng: 78.48596085316976 },
        { lat: 17.43085685338404, lng: 78.48607999954183 },
        { lat: 17.4308024773671, lng: 78.48615484018877 },
        { lat: 17.43074799181968, lng: 78.48622100722338 },
        { lat: 17.43068874240779, lng: 78.48626754086976 },
        { lat: 17.43061731551848, lng: 78.48633320601478 },
        { lat: 17.43053897848853, lng: 78.4863880871294 },
        { lat: 17.43047171421661, lng: 78.48642576183926 },
        { lat: 17.43038194069519, lng: 78.48646903833546 },
        { lat: 17.43028211739456, lng: 78.48652112561372 },
        { lat: 17.43012373736333, lng: 78.48658518897092 },
        { lat: 17.42995635653522, lng: 78.48665172583563 },
        { lat: 17.42982258003103, lng: 78.48669722121687 },
        { lat: 17.4297257683052, lng: 78.48671957049658 },
        { lat: 17.42960056026912, lng: 78.48672834207665 },
        { lat: 17.42941968101714, lng: 78.48670935584138 },
        { lat: 17.42936766334908, lng: 78.48670271805216 },
        { lat: 17.42931351235996, lng: 78.48670595871785 },
        { lat: 17.42925594528083, lng: 78.48670689394262 },
        { lat: 17.42911426986766, lng: 78.4866632595623 },
        { lat: 17.42898269989017, lng: 78.48661522460496 },
        { lat: 17.42891114750268, lng: 78.4865815084357 },
        { lat: 17.42881906520595, lng: 78.48653131627884 },
        { lat: 17.42871030129842, lng: 78.48650119783395 },
        { lat: 17.42861869760846, lng: 78.4864889263252 },
        { lat: 17.42850990586881, lng: 78.48645660286816 },
        { lat: 17.42846553380358, lng: 78.48642957305896 },
        { lat: 17.42841893566761, lng: 78.4864050727432 },
        { lat: 17.42833619543069, lng: 78.4863794491599 },
        { lat: 17.42829543052283, lng: 78.48636986290514 },
        { lat: 17.42826141803028, lng: 78.4863585677255 },
        { lat: 17.42821897888483, lng: 78.48630578396285 },
        { lat: 17.42816832453896, lng: 78.48622826589819 },
        { lat: 17.42810294009499, lng: 78.48614654067465 },
        { lat: 17.42801243066058, lng: 78.48604207795115 },
        { lat: 17.42785924329474, lng: 78.48589142987174 },
        { lat: 17.42775546277936, lng: 78.48580890804622 },
        { lat: 17.42769710338523, lng: 78.48574708063404 },
        { lat: 17.42765785379845, lng: 78.48567866873209 },
        { lat: 17.42761185922014, lng: 78.48561255469619 },
        { lat: 17.42755495519691, lng: 78.48557658165954 },
        { lat: 17.42752297018069, lng: 78.48554703027325 },
        { lat: 17.42748760429084, lng: 78.48551796366874 },
        { lat: 17.42747719456166, lng: 78.48549826125927 },
        { lat: 17.42747470311848, lng: 78.48547977135634 },
        { lat: 17.42749077402642, lng: 78.48541133738463 },
        { lat: 17.42751136567449, lng: 78.48534328179186 },
        { lat: 17.42752168117698, lng: 78.48526610685617 },
        { lat: 17.42751958909778, lng: 78.48518983582191 },
        { lat: 17.42752489159017, lng: 78.48516271287006 },
        { lat: 17.42752460388329, lng: 78.4851399287059 },
        { lat: 17.42752091309146, lng: 78.48511587018065 },
        { lat: 17.42751260870792, lng: 78.48508408251392 },
        { lat: 17.42751668770577, lng: 78.48504947751769 },
        { lat: 17.42753558221932, lng: 78.48502584525953 },
        { lat: 17.42755111627065, lng: 78.48500431392965 },
        { lat: 17.42755081371935, lng: 78.48498035575027 },
        { lat: 17.42752886345702, lng: 78.48494081595179 },
        { lat: 17.42751849264067, lng: 78.48492419912986 },
        { lat: 17.42752704599472, lng: 78.48488629995116 },
        { lat: 17.42756743964929, lng: 78.48486648656328 },
        { lat: 17.4276167152282, lng: 78.48483479232179 },
        { lat: 17.42765929780702, lng: 78.48480951062375 },
        { lat: 17.42765783858104, lng: 78.48478336286287 },
        { lat: 17.42764274463246, lng: 78.48475034537144 },
        { lat: 17.42761620671836, lng: 78.48470513474238 },
        { lat: 17.42758529096243, lng: 78.48467086258081 },
        { lat: 17.42755210091865, lng: 78.48463530060728 },
        { lat: 17.4275360006702, lng: 78.48461199929034 },
        { lat: 17.42753222811798, lng: 78.4845814724161 },
        { lat: 17.42752041470079, lng: 78.48454002864936 },
        { lat: 17.42750637896333, lng: 78.48450140976088 },
        { lat: 17.42747467601033, lng: 78.48449420060072 },
        { lat: 17.42743761495586, lng: 78.48450970431166 },
        { lat: 17.427389193459, lng: 78.48451962813053 },
        { lat: 17.42734856591857, lng: 78.48452092075686 },
        { lat: 17.42732254964992, lng: 78.48451701328626 },
        { lat: 17.42728514699135, lng: 78.48450547141226 },
        { lat: 17.42723547048446, lng: 78.48450541841547 },
        { lat: 17.42716783710405, lng: 78.48451384233668 },
        { lat: 17.42711587512022, lng: 78.4845116133606 },
        { lat: 17.42705242836696, lng: 78.48449396087538 },
        { lat: 17.42695592702934, lng: 78.48445147258212 },
        { lat: 17.42693642551532, lng: 78.48442704187713 },
        { lat: 17.42692938909676, lng: 78.48440626404275 },
        { lat: 17.42690315374666, lng: 78.48438501171934 },
        { lat: 17.42683382346404, lng: 78.48434847376211 },
        { lat: 17.42679157142089, lng: 78.48431053722987 },
        { lat: 17.42676412372946, lng: 78.48428268719924 },
        { lat: 17.42675247366051, lng: 78.48425417842162 },
        { lat: 17.42673173193857, lng: 78.48422094500194 },
        { lat: 17.42671912945035, lng: 78.48420641563814 },
        { lat: 17.4266795490123, lng: 78.48420122449986 },
        { lat: 17.42666248519755, lng: 78.4841910222216 },
        { lat: 17.42663624983173, lng: 78.48416976995779 },
        { lat: 17.42663017877646, lng: 78.48413604002981 },
        { lat: 17.42663207432134, lng: 78.48410734748128 },
        { lat: 17.42661704897603, lng: 78.48407976754662 },
        { lat: 17.42658968297036, lng: 78.48405838590917 },
        { lat: 17.42654886419026, lng: 78.48404453880184 },
        { lat: 17.42653069754687, lng: 78.48403640841322 },
        { lat: 17.42652476201669, lng: 78.48401340826122 },
        { lat: 17.42652656468619, lng: 78.48397736501498 },
        { lat: 17.42652725342723, lng: 78.48394251501367 },
        { lat: 17.42650452886814, lng: 78.48393106562024 },
        { lat: 17.4264524406415, lng: 78.48391884268314 },
        { lat: 17.42638663781799, lng: 78.48389342854844 },
        { lat: 17.42636946256704, lng: 78.48387440621569 },
        { lat: 17.42638380271677, lng: 78.48384774662836 },
        { lat: 17.42637874344745, lng: 78.48380474281997 },
        { lat: 17.42633916115613, lng: 78.4837994050185 },
        { lat: 17.42631445753992, lng: 78.48381003495838 },
        { lat: 17.42631024315555, lng: 78.48383390810442 },
        { lat: 17.42631164862163, lng: 78.48385579235287 },
        { lat: 17.42629484660426, lng: 78.48386631395945 },
        { lat: 17.42627542675264, lng: 78.48384835172413 },
        { lat: 17.42625819763958, lng: 78.48382506611088 },
        { lat: 17.42624650480561, lng: 78.4837931765361 },
        { lat: 17.42623435516704, lng: 78.48372512986313 },
        { lat: 17.42622065173304, lng: 78.48371282295267 },
        { lat: 17.4261959165321, lng: 78.4837209524897 },
        { lat: 17.42618983268267, lng: 78.48377557824885 },
        { lat: 17.42619284791204, lng: 78.48383551750553 },
        { lat: 17.42622752710286, lng: 78.48389958027408 },
        { lat: 17.42626120372734, lng: 78.48397365264191 },
        { lat: 17.42628101907508, lng: 78.48402292359226 },
        { lat: 17.42628931059514, lng: 78.48405368184496 },
        { lat: 17.42628283860289, lng: 78.48407758781462 },
        { lat: 17.42626959007242, lng: 78.48410129124048 },
        { lat: 17.4262859669893, lng: 78.48414649208412 },
        { lat: 17.42628669853501, lng: 78.48420440594737 },
        { lat: 17.42628064052898, lng: 78.48426108812833 },
        { lat: 17.42625748896948, lng: 78.48430521437913 },
        { lat: 17.42623409234688, lng: 78.48432993942217 },
        { lat: 17.42615911803912, lng: 78.48438286180577 },
        { lat: 17.42610648210262, lng: 78.4844166605375 },
        { lat: 17.42605264865933, lng: 78.48444503554079 },
        { lat: 17.42601231073082, lng: 78.48446925884768 },
        { lat: 17.42594053341495, lng: 78.48450714168149 },
        { lat: 17.42589450874631, lng: 78.48452805952303 },
        { lat: 17.42585407425999, lng: 78.48454463859457 },
        { lat: 17.42579893192501, lng: 78.484558771618 },
        { lat: 17.42577076759337, lng: 78.48456356840784 },
        { lat: 17.42575150186795, lng: 78.48455780522721 },
        { lat: 17.42574097880308, lng: 78.48452913435446 },
        { lat: 17.42571165782312, lng: 78.4845317415985 },
        { lat: 17.42572019800827, lng: 78.48458219632211 },
        { lat: 17.42569907193555, lng: 78.48460791944673 },
        { lat: 17.4256507617991, lng: 78.48462666315045 },
        { lat: 17.42559550994175, lng: 78.48463212469163 },
        { lat: 17.42556153268902, lng: 78.48462362384286 },
        { lat: 17.42554223911802, lng: 78.48461565564341 },
        { lat: 17.42554404192238, lng: 78.48457961258237 },
        { lat: 17.42553816031007, lng: 78.48456087580442 },
        { lat: 17.42551874049615, lng: 78.48454291166826 },
        { lat: 17.42549261471408, lng: 78.48453033276857 },
        { lat: 17.4254664072648, lng: 78.48451128745947 },
        { lat: 17.42544464632471, lng: 78.48448674111381 },
        { lat: 17.42540126365729, lng: 78.4844486716277 },
        { lat: 17.42537835905928, lng: 78.48442296488697 },
        { lat: 17.42536798822652, lng: 78.48440634827831 },
        { lat: 17.42533716528866, lng: 78.48437942533042 },
        { lat: 17.42530980117894, lng: 78.4843581905163 },
        { lat: 17.42527220172387, lng: 78.48433106691091 },
        { lat: 17.42522784062922, lng: 78.48430492040532 },
        { lat: 17.4251800782542, lng: 78.48427764256344 },
        { lat: 17.42513238457624, lng: 78.48425580388526 },
        { lat: 17.42506892109563, lng: 78.48423682707602 },
        { lat: 17.42502245274319, lng: 78.4842226152215 },
        { lat: 17.42499415104648, lng: 78.48421653561331 },
        { lat: 17.42496141582054, lng: 78.48421698428562 },
        { lat: 17.42491417882167, lng: 78.48423130249819 },
        { lat: 17.42488039649119, lng: 78.48423823490887 },
        { lat: 17.42483324118511, lng: 78.48425902137731 },
        { lat: 17.42480754423823, lng: 78.48428039626535 },
        { lat: 17.42480107216821, lng: 78.48430430014892 },
        { lat: 17.42481838660999, lng: 78.48433434741851 },
        { lat: 17.42484448454754, lng: 78.48434472124876 },
        { lat: 17.42486696031628, lng: 78.48433647418793 },
        { lat: 17.42492748488033, lng: 78.48430153828805 },
        { lat: 17.42493972720316, lng: 78.48428755294286 },
        { lat: 17.42496105931531, lng: 78.48427814546153 },
        { lat: 17.42498364460172, lng: 78.48427856978853 },
        { lat: 17.42501192032516, lng: 78.48428259302875 },
        { lat: 17.42505738054051, lng: 78.48430637415623 },
        { lat: 17.42508819046042, lng: 78.48433226604453 },
        { lat: 17.42512688901087, lng: 78.48435702239732 },
        { lat: 17.42514877432977, lng: 78.48439141597976 },
        { lat: 17.42516026098852, lng: 78.48440698984975 },
        { lat: 17.42518083743478, lng: 78.48442714159928 },
        { lat: 17.4252024610127, lng: 78.48444081148014 },
        { lat: 17.42524092564749, lng: 78.48444704727501 },
        { lat: 17.42530112337532, lng: 78.48447562438048 },
        { lat: 17.42534890055851, lng: 78.48450407629157 },
        { lat: 17.42539229621295, lng: 78.48454317491503 },
        { lat: 17.42541759763618, lng: 78.48457987580629 },
        { lat: 17.42542473426062, lng: 78.48460859116202 },
        { lat: 17.42543182820841, lng: 78.48463392750512 },
        { lat: 17.42544685531465, lng: 78.48466165408131 },
        { lat: 17.42546635678011, lng: 78.48468608463894 },
        { lat: 17.42549967485567, lng: 78.48473178896592 },
        { lat: 17.42550452415938, lng: 78.4847581835145 },
        { lat: 17.42548908661094, lng: 78.48478735689442 },
        { lat: 17.42546788067611, lng: 78.48480675841762 },
        { lat: 17.4254489174927, lng: 78.48482495311738 },
        { lat: 17.42544022860296, lng: 78.48485212216102 },
        { lat: 17.42543639086936, lng: 78.48490583437975 },
        { lat: 17.42543127025598, lng: 78.48494736110787 },
        { lat: 17.42539301351973, lng: 78.48495758943906 },
        { lat: 17.4253761575902, lng: 78.4849638476097 },
        { lat: 17.42534836813972, lng: 78.48499833487071 },
        { lat: 17.42531872195875, lng: 78.48506460186765 },
        { lat: 17.42529881181618, lng: 78.48509721607593 },
        { lat: 17.42527398003333, lng: 78.48509770308542 },
        { lat: 17.42523182278868, lng: 78.48506726217154 },
        { lat: 17.42519558977119, lng: 78.48505893704854 },
        { lat: 17.4251730174687, lng: 78.4850595417594 },
        { lat: 17.42514376697459, lng: 78.48506773292176 },
        { lat: 17.42511710629953, lng: 78.48510220465478 },
        { lat: 17.4250917563082, lng: 78.48515106686028 },
        { lat: 17.42507095117893, lng: 78.48520221707109 },
        { lat: 17.4250655688202, lng: 78.48522301811606 },
        { lat: 17.42506837016909, lng: 78.48526605451505 },
        { lat: 17.42506897884598, lng: 78.48531426561837 },
        { lat: 17.42505697214238, lng: 78.48534692013625 },
        { lat: 17.42504213200113, lng: 78.48542342212181 },
        { lat: 17.42503166970705, lng: 78.48548898393858 },
        { lat: 17.42502513070211, lng: 78.4855075973086 },
        { lat: 17.42502217292978, lng: 78.48554159748339 },
        { lat: 17.42501908896496, lng: 78.48556560173289 },
        { lat: 17.42502623845948, lng: 78.4855953480987 },
        { lat: 17.42503810166049, lng: 78.48564075743313 },
        { lat: 17.42503861933273, lng: 78.48568176650811 },
        { lat: 17.42503682557658, lng: 78.48571854323573 },
        { lat: 17.42501608894832, lng: 78.48577513253994 },
        { lat: 17.42499745962892, lng: 78.4858197853543 },
        { lat: 17.42496993346014, lng: 78.48587514477545 },
        { lat: 17.42493553612283, lng: 78.48592280603445 },
        { lat: 17.42490412445248, lng: 78.48593867213125 },
        { lat: 17.4248782473433, lng: 78.4859457895095 },
        { lat: 17.42485792146718, lng: 78.48594547892199 },
        { lat: 17.42483632765602, lng: 78.48593416062857 },
        { lat: 17.42482238687732, lng: 78.48590303954028 },
        { lat: 17.42481413646101, lng: 78.48587551365834 },
        { lat: 17.42480237164606, lng: 78.4858378943202 },
        { lat: 17.42479299243108, lng: 78.48581038484754 },
        { lat: 17.42478153371918, lng: 78.4857970168516 },
        { lat: 17.4247372692439, lng: 78.48577851228988 },
        { lat: 17.42466173594344, lng: 78.48578718954502 },
        { lat: 17.42458982841359, lng: 78.48581478402372 },
        { lat: 17.42452347210757, lng: 78.48583495052628 },
        { lat: 17.42447279846613, lng: 78.48584534867234 },
        { lat: 17.42441992841445, lng: 78.48586062610822 },
        { lat: 17.42435248596864, lng: 78.4858841889084 },
        { lat: 17.42430143571055, lng: 78.48586474893132 },
        { lat: 17.42424471916514, lng: 78.48584362151277 },
        { lat: 17.42371042989905, lng: 78.48564306750754 },
        { lat: 17.41967780985093, lng: 78.48261587285992 },
        { lat: 17.41961740958952, lng: 78.48257127639194 },
        { lat: 17.41621164818093, lng: 78.48001410099778 },
        { lat: 17.41585223838765, lng: 78.47971547347045 },
        { lat: 17.41558283985333, lng: 78.47948176042416 },
        { lat: 17.41521556138424, lng: 78.47918588846143 },
        { lat: 17.41510602921734, lng: 78.47909507461581 },
        { lat: 17.41499080282993, lng: 78.4790003697504 },
        { lat: 17.41499169177719, lng: 78.47898139454944 },
        { lat: 17.41492079153272, lng: 78.4789100428797 },
        { lat: 17.41475386911728, lng: 78.47883412928587 },
        { lat: 17.41473257072032, lng: 78.47884618177369 },
        { lat: 17.41464169793175, lng: 78.47880244528562 },
        { lat: 17.41461470350929, lng: 78.47881046179596 },
        { lat: 17.41421010706216, lng: 78.4785990399742 },
        { lat: 17.41382676612856, lng: 78.47837218868523 },
        { lat: 17.41347048641461, lng: 78.4781426147197 },
        { lat: 17.41151610315842, lng: 78.47679691744855 },
        { lat: 17.41144680192139, lng: 78.47676273637703 },
        { lat: 17.41128964003778, lng: 78.47665523265484 },
        { lat: 17.4110299375354, lng: 78.47647416985377 },
        { lat: 17.41087391740186, lng: 78.47636768201372 },
        { lat: 17.41060860053136, lng: 78.47618904907954 },
        { lat: 17.41042886256799, lng: 78.47608185831734 },
        { lat: 17.41017072402403, lng: 78.47593517256972 },
        { lat: 17.40982156154594, lng: 78.47573285147553 },
        { lat: 17.40958602482296, lng: 78.47558791449488 },
        { lat: 17.40958783383343, lng: 78.47555246261756 },
        { lat: 17.4095225674396, lng: 78.47548030207875 },
        { lat: 17.40949278133482, lng: 78.47544616587383 },
        { lat: 17.40947892806716, lng: 78.47538746709216 },
        { lat: 17.40937468988603, lng: 78.47541415752647 },
        { lat: 17.40922885071428, lng: 78.4753171255969 },
        { lat: 17.40905373370694, lng: 78.47521325590742 },
        { lat: 17.40903915339288, lng: 78.47520519246653 },
        { lat: 17.40889508574444, lng: 78.47513536262696 },
        { lat: 17.40884968925096, lng: 78.47511552267184 },
        { lat: 17.40857290207883, lng: 78.47569611073331 },
        { lat: 17.40841031534334, lng: 78.47585637035692 },
        { lat: 17.40822760971637, lng: 78.47605828323172 },
        { lat: 17.40779956152576, lng: 78.4763922124803 },
        { lat: 17.40732268621126, lng: 78.47677183589518 },
        { lat: 17.40698621065149, lng: 78.47696611818493 },
        { lat: 17.40690593866351, lng: 78.47700453783904 },
        { lat: 17.40662362298329, lng: 78.47710440622082 },
        { lat: 17.40637761129101, lng: 78.47709444373892 },
        { lat: 17.40618272722969, lng: 78.47705618665205 },
        { lat: 17.40554893703434, lng: 78.47686614170263 },
        { lat: 17.40493424648891, lng: 78.47660322214706 },
        { lat: 17.40465169254929, lng: 78.4765094117026 },
        { lat: 17.40445628522629, lng: 78.47643973282264 },
        { lat: 17.404156549919, lng: 78.47636063221445 },
        { lat: 17.40386024098424, lng: 78.47627786567433 },
        { lat: 17.40357138186545, lng: 78.47623479646438 },
        { lat: 17.40295952986948, lng: 78.47619616344214 },
        { lat: 17.40264608538455, lng: 78.47613172423925 },
        { lat: 17.40251902284573, lng: 78.476102158138 },
        { lat: 17.40242660761595, lng: 78.47607886238946 },
        { lat: 17.40195861266604, lng: 78.47590978169947 },
        { lat: 17.40145947863774, lng: 78.47569214217991 },
        { lat: 17.40128463692068, lng: 78.47562952498474 },
        { lat: 17.40107227427225, lng: 78.47556359060353 },
        { lat: 17.40094371524038, lng: 78.47582479459749 },
        { lat: 17.40076421301124, lng: 78.4760005807832 },
        { lat: 17.40051375042937, lng: 78.47621627791118 },
        { lat: 17.40017612741224, lng: 78.47686411938031 },
        { lat: 17.39986806993284, lng: 78.4774086386423 },
        { lat: 17.39951768587613, lng: 78.47802449116668 },
        { lat: 17.39926259229133, lng: 78.4783624560358 },
        { lat: 17.39897556981673, lng: 78.47861724209831 },
        { lat: 17.39859552473417, lng: 78.47884114326746 },
        { lat: 17.39826982942127, lng: 78.47896781736277 },
        { lat: 17.3975501161663, lng: 78.47918994118803 },
        { lat: 17.39731646549168, lng: 78.4792703289068 },
        { lat: 17.39691164157297, lng: 78.47948813334503 },
        { lat: 17.39639738463036, lng: 78.47984250855397 },
        { lat: 17.39637826614817, lng: 78.47985848055794 },
        { lat: 17.39616438526353, lng: 78.47997434109487 },
        { lat: 17.39602903737223, lng: 78.48001478604236 },
        { lat: 17.39571761300945, lng: 78.47998630681289 },
        { lat: 17.39535530269908, lng: 78.47996613344611 },
        { lat: 17.39480010055001, lng: 78.48001233177669 },
        { lat: 17.39444864959079, lng: 78.4800557394556 },
        { lat: 17.39388751603484, lng: 78.48012131577985 },
        { lat: 17.39381984203503, lng: 78.48014153878283 },
        { lat: 17.3937773517559, lng: 78.4802000081171 },
        { lat: 17.39360544390163, lng: 78.48076836557112 },
        { lat: 17.39352501175458, lng: 78.4812454233937 },
        { lat: 17.39359731359399, lng: 78.48159175395753 },
        { lat: 17.39372144447155, lng: 78.4821303305816 },
        { lat: 17.39380308467342, lng: 78.4827273750825 },
        { lat: 17.39381843512497, lng: 78.48296514457265 },
        { lat: 17.3938219238477, lng: 78.48324166609193 },
        { lat: 17.39379876883793, lng: 78.483364188132 },
        { lat: 17.39369599484382, lng: 78.48353925621116 },
        { lat: 17.39356763016474, lng: 78.48364392198843 },
        { lat: 17.3933655798697, lng: 78.4837817546821 },
        { lat: 17.39296708621503, lng: 78.48401232230148 },
        { lat: 17.39235817501666, lng: 78.48420717397134 },
        { lat: 17.3916572166359, lng: 78.48444830658453 },
        { lat: 17.39137538575823, lng: 78.48462582070951 },
        { lat: 17.39095267859708, lng: 78.48489530366543 },
        { lat: 17.3905736769186, lng: 78.48520277860904 },
        { lat: 17.39042037134258, lng: 78.48528848679864 },
        { lat: 17.39034676462414, lng: 78.4853280839172 },
        { lat: 17.39029208816654, lng: 78.48539958059204 },
        { lat: 17.39026884865335, lng: 78.48551567071439 },
        { lat: 17.39027111766078, lng: 78.48569572701896 },
        { lat: 17.39031027099774, lng: 78.48586241811284 },
        { lat: 17.39038053877607, lng: 78.48604797946905 },
        { lat: 17.39053870596951, lng: 78.48634811050657 },
        { lat: 17.39065332717972, lng: 78.48662310921141 },
        { lat: 17.39079045920058, lng: 78.4869538791566 },
        { lat: 17.3908669858298, lng: 78.4872796932522 },
        { lat: 17.3908740463338, lng: 78.48734188853531 },
        { lat: 17.39090289796055, lng: 78.48760717810251 },
        { lat: 17.39093026047456, lng: 78.48784920221044 },
        { lat: 17.39092234685563, lng: 78.48804829328931 },
        { lat: 17.39088165899981, lng: 78.48840340192572 },
        { lat: 17.39080957581608, lng: 78.48874808351505 },
        { lat: 17.39075989190797, lng: 78.48894050990053 },
        { lat: 17.39069385802335, lng: 78.48893779346945 },
        { lat: 17.39042520140897, lng: 78.48884377870999 },
        { lat: 17.39005116661305, lng: 78.48865713764353 },
        { lat: 17.38991560197483, lng: 78.48857444406107 },
        { lat: 17.38987803240586, lng: 78.48866723289117 },
        { lat: 17.38982684590023, lng: 78.4887774438164 },
        { lat: 17.38983356699344, lng: 78.48877984112252 },
        { lat: 17.38978333192394, lng: 78.48888972763973 },
        { lat: 17.3897481841646, lng: 78.48896891857287 },
        { lat: 17.3897515046861, lng: 78.4889716736736 },
        { lat: 17.38971023699097, lng: 78.48906308205176 },
        { lat: 17.38966549982664, lng: 78.48903733559408 },
        { lat: 17.38959333149235, lng: 78.4889983104588 },
        { lat: 17.38956340011223, lng: 78.48898351282793 },
        { lat: 17.38957127008152, lng: 78.4890265340218 },
        { lat: 17.38948032837213, lng: 78.48920403186428 },
        { lat: 17.38940639495434, lng: 78.4891713747696 },
        { lat: 17.38934841483039, lng: 78.4891959993799 },
        { lat: 17.38934242681425, lng: 78.48918180431899 },
        { lat: 17.38918735727366, lng: 78.48910776018711 },
        { lat: 17.38901907769391, lng: 78.48902842169672 },
        { lat: 17.38898731330474, lng: 78.48901093524049 },
        { lat: 17.38898142864568, lng: 78.48899906887723 },
        { lat: 17.38891812174019, lng: 78.4890624038184 },
        { lat: 17.38880010565535, lng: 78.48900756333545 },
        { lat: 17.38873944503438, lng: 78.48898217544341 },
        { lat: 17.38871608567111, lng: 78.48903831722893 },
        { lat: 17.38869220806622, lng: 78.48902133458512 },
        { lat: 17.38864763884151, lng: 78.48900369369554 },
        { lat: 17.3885935446552, lng: 78.48898994555404 },
        { lat: 17.38849504302733, lng: 78.48897859085912 },
        { lat: 17.38847131454368, lng: 78.48897345879097 },
        { lat: 17.38844786923351, lng: 78.48905542995202 },
        { lat: 17.38841405659277, lng: 78.48913895361825 },
        { lat: 17.38840123786568, lng: 78.4891897372257 },
        { lat: 17.3883907916859, lng: 78.48929269625417 },
        { lat: 17.38838914910372, lng: 78.48937032487449 },
        { lat: 17.38836613820134, lng: 78.48945812226235 },
        { lat: 17.38832904174487, lng: 78.4895749907585 },
        { lat: 17.38825899515012, lng: 78.48953043837653 },
        { lat: 17.38820756690845, lng: 78.48948722922418 },
        { lat: 17.38808261512333, lng: 78.48941830908967 },
        { lat: 17.38798040929479, lng: 78.48938777346028 },
        { lat: 17.38796934043679, lng: 78.4893872622783 },
        { lat: 17.38796015472421, lng: 78.48939974251428 },
        { lat: 17.38794219323629, lng: 78.48941062294894 },
        { lat: 17.38787513017982, lng: 78.4893948806052 },
        { lat: 17.38781376007288, lng: 78.48936693899802 },
        { lat: 17.38780155038057, lng: 78.48935443186468 },
        { lat: 17.38778928845472, lng: 78.48931645188108 },
        { lat: 17.38777123918744, lng: 78.48921396675419 },
        { lat: 17.38776869221435, lng: 78.48920363430244 },
        { lat: 17.38770328465933, lng: 78.48923548090738 },
        { lat: 17.38733622785073, lng: 78.48932731747203 },
        { lat: 17.38700056737189, lng: 78.48942957957847 },
        { lat: 17.38685227062626, lng: 78.48951481142238 },
        { lat: 17.38666956113787, lng: 78.48962583933732 },
        { lat: 17.3864420658298, lng: 78.48976641876118 },
        { lat: 17.38623518165852, lng: 78.4898886294057 },
        { lat: 17.38611444305737, lng: 78.48995539730579 },
        { lat: 17.38603154300723, lng: 78.48999270451941 },
        { lat: 17.38593100620085, lng: 78.49000854729351 },
        { lat: 17.38576059567813, lng: 78.48999278294811 },
        { lat: 17.38542645156036, lng: 78.4899394582577 },
        { lat: 17.38485549811347, lng: 78.48983871320071 },
        { lat: 17.38456664105914, lng: 78.48979562250233 },
        { lat: 17.38444788228939, lng: 78.49054991291726 },
        { lat: 17.38448630660156, lng: 78.49067722674474 },
        { lat: 17.38482255873143, lng: 78.49087509558764 },
        { lat: 17.38494673275131, lng: 78.4908973478725 },
        { lat: 17.38474045633918, lng: 78.49174971359459 },
        { lat: 17.38472814405995, lng: 78.49180571641675 },
        { lat: 17.38428463195692, lng: 78.49172184779015 },
        { lat: 17.38344540691648, lng: 78.49184834076496 },
        { lat: 17.38280723426263, lng: 78.49185703872779 },
        { lat: 17.38216785523699, lng: 78.49176987598531 },
        { lat: 17.38140527173533, lng: 78.49164604252864 },
        { lat: 17.3809820283896, lng: 78.49166459426313 },
        { lat: 17.38097644628305, lng: 78.49165774155173 },
        { lat: 17.38090689738487, lng: 78.49166389587991 },
        { lat: 17.3808042764774, lng: 78.49167297575696 },
        { lat: 17.38075265360445, lng: 78.4917027893934 },
        { lat: 17.38066959847248, lng: 78.49175008429216 },
        { lat: 17.38039760994901, lng: 78.49178953341927 },
        { lat: 17.3802627275839, lng: 78.49202378325201 },
        { lat: 17.38022365054291, lng: 78.49223452077588 },
        { lat: 17.38026903405391, lng: 78.49233267917577 },
        { lat: 17.38023529995158, lng: 78.49243339233014 },
        { lat: 17.38022620951887, lng: 78.49264274302219 },
        { lat: 17.38024341698614, lng: 78.49279444854862 },
        { lat: 17.38031604535444, lng: 78.49307362566257 },
        { lat: 17.38038318282193, lng: 78.49327879093346 },
        { lat: 17.38041550546989, lng: 78.49341578991083 },
        { lat: 17.38042428962934, lng: 78.49356869030369 },
        { lat: 17.38049252962911, lng: 78.49377178467586 },
        { lat: 17.3805678923697, lng: 78.49400080045045 },
        { lat: 17.38062107002662, lng: 78.49426260457301 },
        { lat: 17.38069197600336, lng: 78.49441024605835 },
        { lat: 17.3807665123196, lng: 78.49448963018024 },
        { lat: 17.38085829182801, lng: 78.494677115694 },
        { lat: 17.38087012185385, lng: 78.49493914937278 },
        { lat: 17.3808730463405, lng: 78.49494900234265 },
        { lat: 17.38103133757398, lng: 78.49493653461593 },
        { lat: 17.38103169551125, lng: 78.49496390633036 },
        { lat: 17.3811371326547, lng: 78.49498524619607 },
        { lat: 17.38118408970942, lng: 78.49511748861168 },
        { lat: 17.38121552857094, lng: 78.49518688125819 },
        { lat: 17.38127267140422, lng: 78.495233282711 },
        { lat: 17.381391674192, lng: 78.49525443812193 },
        { lat: 17.38148775492578, lng: 78.49525194528627 },
        { lat: 17.38152496965565, lng: 78.49524438017295 },
        { lat: 17.38156462989172, lng: 78.49525089340062 },
        { lat: 17.38159214254905, lng: 78.49527962078889 },
        { lat: 17.38158364666473, lng: 78.49532163296067 },
        { lat: 17.38156378372296, lng: 78.49535909469432 },
        { lat: 17.38155684036611, lng: 78.49543342338967 },
        { lat: 17.38155183392309, lng: 78.49548288128084 },
        { lat: 17.38158766994827, lng: 78.49554280779864 },
        { lat: 17.38165433613066, lng: 78.49553924796102 },
        { lat: 17.38167751754532, lng: 78.4955461360053 },
        { lat: 17.38171840411746, lng: 78.49559964163355 },
        { lat: 17.38191827579842, lng: 78.4956589756368 },
        { lat: 17.3819241507307, lng: 78.49567931536278 },
        { lat: 17.38193393262161, lng: 78.4957356270143 },
        { lat: 17.38194408478323, lng: 78.4958201588408 },
        { lat: 17.38194506851001, lng: 78.49589540702861 },
        { lat: 17.38195373817211, lng: 78.49595320501881 },
        { lat: 17.38201252176381, lng: 78.49603854074685 },
        { lat: 17.38201169730884, lng: 78.49614850484264 },
        { lat: 17.38201231251486, lng: 78.49619553474734 },
        { lat: 17.38204018424721, lng: 78.49625160224677 },
        { lat: 17.38206884583646, lng: 78.49628178353699 },
        { lat: 17.38209981469895, lng: 78.49631531603634 },
        { lat: 17.38217732328694, lng: 78.49636261681698 },
        { lat: 17.38226874932141, lng: 78.49643662912733 },
        { lat: 17.38245258475232, lng: 78.49665989863884 },
        { lat: 17.38260983926465, lng: 78.49683928733049 },
        { lat: 17.38267296459708, lng: 78.49691089311095 },
        { lat: 17.3827648821183, lng: 78.4970225273607 },
        { lat: 17.38299199198846, lng: 78.49718273478457 },
        { lat: 17.3830673128321, lng: 78.49723565151973 },
        { lat: 17.38315747358658, lng: 78.49729939099939 },
        { lat: 17.3832122296387, lng: 78.49733627270055 },
        { lat: 17.38330005545931, lng: 78.4973943116462 },
        { lat: 17.38334069334896, lng: 78.49747563217178 },
        { lat: 17.38339008716225, lng: 78.49753478458548 },
        { lat: 17.38343673360937, lng: 78.49755663580362 },
        { lat: 17.38347795526391, lng: 78.49759605521395 },
        { lat: 17.38355104612816, lng: 78.49765150284678 },
        { lat: 17.38362438365806, lng: 78.49772576228474 },
        { lat: 17.38367926300502, lng: 78.49777205102338 },
        { lat: 17.38374318730867, lng: 78.49781821491835 },
        { lat: 17.38379806664097, lng: 78.49786450371256 },
        { lat: 17.38384402612542, lng: 78.49792032232949 },
        { lat: 17.38390397837576, lng: 78.49800873095573 },
        { lat: 17.3839272682474, lng: 78.49806030129231 },
        { lat: 17.38394597123915, lng: 78.4981070858264 },
        { lat: 17.38395562920765, lng: 78.49815399146495 },
        { lat: 17.38395624402884, lng: 78.49820102381976 },
        { lat: 17.38399487765626, lng: 78.49838865395405 },
        { lat: 17.38401358055374, lng: 78.4984354366675 },
        { lat: 17.38403796415851, lng: 78.49848420034077 },
        { lat: 17.38406003133532, lng: 78.4985288810508 },
        { lat: 17.38408765588385, lng: 78.49856613399203 },
        { lat: 17.38413361339839, lng: 78.49862195291418 },
        { lat: 17.38416092161111, lng: 78.49863338892811 },
        { lat: 17.38426362406604, lng: 78.49870996367687 },
        { lat: 17.38471725751381, lng: 78.49898570234096 },
        { lat: 17.384747246425, lng: 78.49901126470219 },
        { lat: 17.38479974131871, lng: 78.49906442046554 },
        { lat: 17.38483628569183, lng: 78.4990921438316 },
        { lat: 17.38486378870241, lng: 78.49911999197421 },
        { lat: 17.38490033307023, lng: 78.49914771536028 },
        { lat: 17.38500080333982, lng: 78.49922160529665 },
        { lat: 17.38507414043088, lng: 78.49929586594767 },
        { lat: 17.38513806451024, lng: 78.49934203258556 },
        { lat: 17.38519294356172, lng: 78.49938832029628 },
        { lat: 17.38526603409769, lng: 78.49944377101465 },
        { lat: 17.38533863329446, lng: 78.49946159218032 },
        { lat: 17.38537542599174, lng: 78.49950812952352 },
        { lat: 17.3854079151508, lng: 78.49957162924503 },
        { lat: 17.38544691390218, lng: 78.4996140202689 },
        { lat: 17.3854767480769, lng: 78.49964742261344 },
        { lat: 17.38554055615221, lng: 78.49968462266779 },
        { lat: 17.38553274014334, lng: 78.4997788093254 },
        { lat: 17.38554239780398, lng: 78.49982571738093 },
        { lat: 17.38557002217011, lng: 78.49986297082023 },
        { lat: 17.38558985727624, lng: 78.49990988734899 },
        { lat: 17.3856439128324, lng: 78.49997970713032 },
        { lat: 17.38567221051096, lng: 78.5000685511802 },
        { lat: 17.3856818681098, lng: 78.50011545929503 },
        { lat: 17.38570296806332, lng: 78.50017264779189 },
        { lat: 17.38569720887037, lng: 78.500251076649 },
        { lat: 17.38570253703081, lng: 78.50031274257503 },
        { lat: 17.38572185213198, lng: 78.50040656074877 },
        { lat: 17.38573138820286, lng: 78.50044406004974 },
        { lat: 17.38574104571775, lng: 78.50049096821127 },
        { lat: 17.38575520362744, lng: 78.50053605053866 },
        { lat: 17.38577051057526, lng: 78.5005825884803 },
        { lat: 17.38578469237634, lng: 78.50062958006919 },
        { lat: 17.38580239296709, lng: 78.5006862278688 },
        { lat: 17.38581892613059, lng: 78.50074009773442 },
        { lat: 17.38583541698285, lng: 78.5007907341456 },
        { lat: 17.38585411942859, lng: 78.50083751950541 },
        { lat: 17.38586390187854, lng: 78.5008938346657 },
        { lat: 17.3858735592713, lng: 78.50094074101742 },
        { lat: 17.38587429670932, lng: 78.50099718092356 },
        { lat: 17.38586586589215, lng: 78.50104433483736 },
        { lat: 17.38586721566082, lng: 78.50114780583867 },
        { lat: 17.38585915257685, lng: 78.50122317877641 },
        { lat: 17.38588812818053, lng: 78.50136390352542 },
        { lat: 17.38589107365452, lng: 78.50158965578234 },
        { lat: 17.38588301042583, lng: 78.50166503061486 },
        { lat: 17.38586361511105, lng: 78.50173835436722 },
        { lat: 17.38586362062714, lng: 78.50182552482671 },
        { lat: 17.38586461698229, lng: 78.50190180386384 },
        { lat: 17.38588796488525, lng: 78.50195808169192 },
        { lat: 17.38591016003938, lng: 78.50201260859659 },
        { lat: 17.38595123024551, lng: 78.50204041803933 },
        { lat: 17.38598777429915, lng: 78.50206814219656 },
        { lat: 17.38599731012235, lng: 78.50210564544165 },
        { lat: 17.38600709042212, lng: 78.50216196078661 },
        { lat: 17.38603471440761, lng: 78.5021992147223 },
        { lat: 17.38609045315712, lng: 78.5023113505772 },
        { lat: 17.3861103446999, lng: 78.50236267481591 },
        { lat: 17.38612797867239, lng: 78.50241432508523 },
        { lat: 17.38620327765924, lng: 78.50263909008154 },
        { lat: 17.38622222592409, lng: 78.50270468599754 },
        { lat: 17.38624104928095, lng: 78.50276087872422 },
        { lat: 17.38625058493779, lng: 78.50279837831116 },
        { lat: 17.38624276751149, lng: 78.50289256729008 },
        { lat: 17.38625254758021, lng: 78.50294888090019 },
        { lat: 17.38628029458184, lng: 78.50299554389608 },
        { lat: 17.386307918434, lng: 78.50303279802837 },
        { lat: 17.38633578668077, lng: 78.50308886431431 },
        { lat: 17.3863544886326, lng: 78.50313565010329 },
        { lat: 17.38637331366117, lng: 78.50319184102398 },
        { lat: 17.38640808326579, lng: 78.50325692888835 },
        { lat: 17.38643566298277, lng: 78.50329080288613 },
        { lat: 17.38645475989846, lng: 78.50336786384393 },
        { lat: 17.38647149266279, lng: 78.50343702132618 },
        { lat: 17.38648576938895, lng: 78.50349136257675 },
        { lat: 17.3865229269282, lng: 78.50356612032081 },
        { lat: 17.38653246249307, lng: 78.50360362378814 },
        { lat: 17.38655116431337, lng: 78.50365040781253 },
        { lat: 17.38656094418503, lng: 78.50370672158493 },
        { lat: 17.38657047970182, lng: 78.50374422318967 },
        { lat: 17.38657403612968, lng: 78.50401700992992 },
        { lat: 17.38656560460397, lng: 78.50406416398849 },
        { lat: 17.38655754046169, lng: 78.50413953912327 },
        { lat: 17.38654923199318, lng: 78.50419610207517 },
        { lat: 17.38655119359005, lng: 78.50434660318889 },
        { lat: 17.38656097509944, lng: 78.50440291888223 },
        { lat: 17.38657063173586, lng: 78.50444982758695 },
        { lat: 17.38658933339327, lng: 78.50449661361525 },
        { lat: 17.38659898998569, lng: 78.50454352045396 },
        { lat: 17.38660852535158, lng: 78.50458102213146 },
        { lat: 17.38660962908794, lng: 78.50466568163819 },
        { lat: 17.38661773691833, lng: 78.50476729506762 },
        { lat: 17.38661498589373, lng: 78.5048164302981 },
        { lat: 17.38661232487934, lng: 78.50487262129943 },
        { lat: 17.3866223504748, lng: 78.50494774925788 },
        { lat: 17.3866322530175, lng: 78.50501347019991 },
        { lat: 17.38663294160556, lng: 78.50506638172523 },
        { lat: 17.38662794030072, lng: 78.50511643171957 },
        { lat: 17.38662504778188, lng: 78.50515468895374 },
        { lat: 17.38661710623952, lng: 78.50523947115195 },
        { lat: 17.38662664147956, lng: 78.50527697288732 },
        { lat: 17.38666138290653, lng: 78.50533985673914 },
        { lat: 17.38671843214245, lng: 78.50537920894443 },
        { lat: 17.38672808856071, lng: 78.5054261177714 },
        { lat: 17.38672931492507, lng: 78.50552018254398 },
        { lat: 17.38670328495964, lng: 78.50560521003084 },
        { lat: 17.3866584305863, lng: 78.5056340461351 },
        { lat: 17.38661701765277, lng: 78.5056666566175 },
        { lat: 17.38659254949095, lng: 78.50569786339322 },
        { lat: 17.38660575741202, lng: 78.5057570695766 },
        { lat: 17.38661979307733, lng: 78.50579289424716 },
        { lat: 17.38663387093161, lng: 78.50583195053538 },
        { lat: 17.38662543899149, lng: 78.50587910646708 },
        { lat: 17.38660551898462, lng: 78.5059123060153 },
        { lat: 17.38658676817798, lng: 78.50594857702528 },
        { lat: 17.38654150446009, lng: 78.50603269303274 },
        { lat: 17.38652880137269, lng: 78.50609916258507 },
        { lat: 17.38656439419382, lng: 78.50614057245652 },
        { lat: 17.3865416347223, lng: 78.50621629540866 },
        { lat: 17.38657082366518, lng: 78.5062870454342 },
        { lat: 17.38659538909375, lng: 78.50634992067341 },
        { lat: 17.38660153959671, lng: 78.50638805722976 },
        { lat: 17.38660779469907, lng: 78.50643427659514 },
        { lat: 17.38661081939647, lng: 78.50649288902324 },
        { lat: 17.38660487975078, lng: 78.50655765083597 },
        { lat: 17.38660888457543, lng: 78.50660478306898 },
        { lat: 17.38658374068697, lng: 78.50667098286706 },
        { lat: 17.3865695104221, lng: 78.50670704580557 },
        { lat: 17.38655531316454, lng: 78.50674560674368 },
        { lat: 17.38653771481751, lng: 78.5067834781516 },
        { lat: 17.38652928264349, lng: 78.50683063404561 },
        { lat: 17.38651168430206, lng: 78.50686850732299 },
        { lat: 17.38648527578056, lng: 78.5069245817626 },
        { lat: 17.38645412267282, lng: 78.5069635210506 },
        { lat: 17.38641733841748, lng: 78.50700429946377 },
        { lat: 17.38639406853064, lng: 78.5070407802064 },
        { lat: 17.3863816696325, lng: 78.50713061772719 },
        { lat: 17.38638898364766, lng: 78.50717123885231 },
        { lat: 17.38637211906641, lng: 78.50726554866813 },
        { lat: 17.38635703874856, lng: 78.50732323238182 },
        { lat: 17.3863377788962, lng: 78.50740713870569 },
        { lat: 17.38632971345898, lng: 78.50748251377445 },
        { lat: 17.38633750246227, lng: 78.50755958176708 },
        { lat: 17.38634059470887, lng: 78.50762348552897 },
        { lat: 17.38634157424257, lng: 78.50769873807712 },
        { lat: 17.38635159875527, lng: 78.50777386434794 },
        { lat: 17.38634377893427, lng: 78.50786805161297 },
        { lat: 17.38634586064799, lng: 78.50802796189936 },
        { lat: 17.38635539356901, lng: 78.50806546382326 },
        { lat: 17.38636841004336, lng: 78.50810982694023 },
        { lat: 17.38637921296731, lng: 78.5081578981108 },
        { lat: 17.38639340775567, lng: 78.50820606633532 },
        { lat: 17.38641322636034, lng: 78.50825180858101 },
        { lat: 17.38643068649115, lng: 78.50829023040383 },
        { lat: 17.3864581866375, lng: 78.50831808221533 },
        { lat: 17.38688400493589, lng: 78.508368726408 },
        { lat: 17.38691588000256, lng: 78.50829831905949 },
        { lat: 17.38694609162106, lng: 78.50827379825874 },
        { lat: 17.38702237585235, lng: 78.50831421359916 },
        { lat: 17.38702040338055, lng: 78.50842331656051 },
        { lat: 17.38701987787719, lng: 78.50846977472987 },
        { lat: 17.3870195292238, lng: 78.5086167822732 },
        { lat: 17.3869925968279, lng: 78.50872506148325 },
        { lat: 17.3869499032821, lng: 78.5089143796536 },
        { lat: 17.38693912314652, lng: 78.50895480576474 },
        { lat: 17.38689379811685, lng: 78.50912124156214 },
        { lat: 17.3868936978027, lng: 78.50920047684563 },
        { lat: 17.38689460386119, lng: 78.50935702096969 },
        { lat: 17.38683232114828, lng: 78.50961071276977 },
        { lat: 17.38681288623838, lng: 78.50968139177075 },
        { lat: 17.38678583190345, lng: 78.50977466378963 },
        { lat: 17.38678940463728, lng: 78.50987546535093 },
        { lat: 17.38679005246579, lng: 78.50992528562053 },
        { lat: 17.3867871938957, lng: 78.50996633818573 },
        { lat: 17.38676963520063, lng: 78.51000729432303 },
        { lat: 17.38675227997207, lng: 78.5100639797179 },
        { lat: 17.38673353751168, lng: 78.5101008391851 },
        { lat: 17.3867081596765, lng: 78.51014925350995 },
        { lat: 17.38669975417239, lng: 78.51019846725156 },
        { lat: 17.38670146571679, lng: 78.51024313227003 },
        { lat: 17.38670340813984, lng: 78.51030558063879 },
        { lat: 17.38669278898782, lng: 78.51035850052834 },
        { lat: 17.38667577446363, lng: 78.51044134736036 },
        { lat: 17.38664986507264, lng: 78.51053578148469 },
        { lat: 17.38663238691933, lng: 78.51058305974328 },
        { lat: 17.38659718869293, lng: 78.5106588039348 },
        { lat: 17.38657971231324, lng: 78.51070608214707 },
        { lat: 17.38654426854984, lng: 78.51076301404846 },
        { lat: 17.38650870199211, lng: 78.51081053698418 },
        { lat: 17.38649110284529, lng: 78.51084840998077 },
        { lat: 17.38645442029153, lng: 78.51089697897494 },
        { lat: 17.38642877110536, lng: 78.51092452302794 },
        { lat: 17.38643188792628, lng: 78.5109903381506 },
        { lat: 17.38643488193847, lng: 78.51104659758914 },
        { lat: 17.38643834494846, lng: 78.51113901623008 },
        { lat: 17.38641434065971, lng: 78.51129310516336 },
        { lat: 17.38640701970333, lng: 78.51133877657198 },
        { lat: 17.38638954134146, lng: 78.51138605471493 },
        { lat: 17.3863664592376, lng: 78.51143708483713 },
        { lat: 17.38634242779404, lng: 78.51150209129939 },
        { lat: 17.38631951049699, lng: 78.51156576195807 },
        { lat: 17.38629337525423, lng: 78.51164285264652 },
        { lat: 17.38626707883106, lng: 78.51170759808278 },
        { lat: 17.38623059383861, lng: 78.51177145218172 },
        { lat: 17.38618131949454, lng: 78.51189530854855 },
        { lat: 17.38614765134092, lng: 78.51191487852222 },
        { lat: 17.38612797196533, lng: 78.51196674298919 },
        { lat: 17.38610306790295, lng: 78.51205160764394 },
        { lat: 17.38608228165423, lng: 78.5121052517754 },
        { lat: 17.38606162360795, lng: 78.51216889173989 },
        { lat: 17.3860564922584, lng: 78.51220909065204 },
        { lat: 17.38603901547359, lng: 78.5122563686216 },
        { lat: 17.38601237093546, lng: 78.51229436371027 },
        { lat: 17.38597680580863, lng: 78.51234188998606 },
        { lat: 17.38595016122738, lng: 78.5123798831694 },
        { lat: 17.38592179915685, lng: 78.51245965080473 },
        { lat: 17.38589872771573, lng: 78.51251156102238 },
        { lat: 17.38587677592331, lng: 78.51256257561316 },
        { lat: 17.38585484427815, lng: 78.51261520789376 },
        { lat: 17.38579115227754, lng: 78.51267369885525 },
        { lat: 17.38576460099747, lng: 78.51271889443484 },
        { lat: 17.38572466879632, lng: 78.51277853161457 },
        { lat: 17.38569852937235, lng: 78.51285532849111 },
        { lat: 17.38568543036887, lng: 78.51289152236127 },
        { lat: 17.38567687403921, lng: 78.51292927091446 },
        { lat: 17.38562375117677, lng: 78.51301789937902 },
        { lat: 17.38555245393531, lng: 78.513100309079 },
        { lat: 17.38551664328482, lng: 78.5131290191531 },
        { lat: 17.38545154776728, lng: 78.51316665510402 },
        { lat: 17.38540004364534, lng: 78.5132058701701 },
        { lat: 17.3853453159835, lng: 78.51325806500769 },
        { lat: 17.3853104547849, lng: 78.51327294548173 },
        { lat: 17.3852304339596, lng: 78.5132929966771 },
        { lat: 17.38516611214935, lng: 78.51330313352528 },
        { lat: 17.38511196787229, lng: 78.51331327768503 },
        { lat: 17.38503069194811, lng: 78.51332379038173 },
        { lat: 17.38497679108319, lng: 78.5133527466737 },
        { lat: 17.38493456443892, lng: 78.51340977116112 },
        { lat: 17.38485680154506, lng: 78.513516668927 },
        { lat: 17.38482560306302, lng: 78.51355237343732 },
        { lat: 17.38478099244284, lng: 78.51360001951362 },
        { lat: 17.38471534986794, lng: 78.51368249705189 },
        { lat: 17.38466040612207, lng: 78.51371808399261 },
        { lat: 17.38461321581714, lng: 78.51374136369603 },
        { lat: 17.38453453966619, lng: 78.51377800874357 },
        { lat: 17.38445758694487, lng: 78.5138601986778 },
        { lat: 17.38436011440426, lng: 78.51392973148874 },
        { lat: 17.38406774596476, lng: 78.51414200494233 },
        { lat: 17.38398011789283, lng: 78.51418582754644 },
        { lat: 17.38391767300162, lng: 78.51425341372702 },
        { lat: 17.38380480672261, lng: 78.51435652533662 },
        { lat: 17.38367404040496, lng: 78.51447443266758 },
        { lat: 17.38355667702601, lng: 78.51457951618092 },
        { lat: 17.38344938323175, lng: 78.51467637755412 },
        { lat: 17.38341148476302, lng: 78.51471849337932 },
        { lat: 17.38338472807301, lng: 78.5147479628481 },
        { lat: 17.38333095125703, lng: 78.5147863253308 },
        { lat: 17.38328621773016, lng: 78.51482456566357 },
        { lat: 17.38321471649182, lng: 78.51489139319732 },
        { lat: 17.38308039505122, lng: 78.51499670516134 },
        { lat: 17.38297320339519, lng: 78.51510150200959 },
        { lat: 17.38287493793117, lng: 78.51519706501597 },
        { lat: 17.38276195762056, lng: 78.51529150213295 },
        { lat: 17.38273193690101, lng: 78.51533071940781 },
        { lat: 17.38267852563562, lng: 78.51539730041978 },
        { lat: 17.38247407904184, lng: 78.5156755554948 },
        { lat: 17.38242759222266, lng: 78.51575291882828 },
        { lat: 17.38234788093767, lng: 78.51588424320735 },
        { lat: 17.3822435276188, lng: 78.51603354132051 },
        { lat: 17.38220759574922, lng: 78.51605284525026 },
        { lat: 17.38213597150776, lng: 78.51611026503429 },
        { lat: 17.38210359060152, lng: 78.51614187005855 },
        { lat: 17.382046503781, lng: 78.51618674452901 },
        { lat: 17.38191266945776, lng: 78.51632968047211 },
        { lat: 17.38187685817767, lng: 78.51635838931483 },
        { lat: 17.38182332405367, lng: 78.51641556474767 },
        { lat: 17.38177664503574, lng: 78.5164782333008 },
        { lat: 17.38175218946168, lng: 78.51651060983045 },
        { lat: 17.38169865528285, lng: 78.51656778518121 },
        { lat: 17.38166305414003, lng: 78.51661280784568 },
        { lat: 17.38162751877219, lng: 78.51666282828735 },
        { lat: 17.38160531714049, lng: 78.51669458738101 },
        { lat: 17.38158198490511, lng: 78.51672651034701 },
        { lat: 17.38155533928078, lng: 78.5167645020139 },
        { lat: 17.38150628371758, lng: 78.51681823606361 },
        { lat: 17.38145610477273, lng: 78.51687257033302 },
        { lat: 17.38143536632597, lng: 78.51693003485418 },
        { lat: 17.38137732955762, lng: 78.51698888866989 },
        { lat: 17.38131174366459, lng: 78.51707577252861 },
        { lat: 17.38125738557764, lng: 78.51715662384763 },
        { lat: 17.38102335682383, lng: 78.5175083331076 },
        { lat: 17.38097513033925, lng: 78.51762599792713 },
        { lat: 17.38102440751446, lng: 78.51766582119977 },
        { lat: 17.3810073758608, lng: 78.51768989194271 },
        { lat: 17.38099496426926, lng: 78.5177074333321 },
        { lat: 17.38126316554838, lng: 78.5178674018041 },
        { lat: 17.38116441743784, lng: 78.51798086600581 },
        { lat: 17.38096576220079, lng: 78.51811604168195 },
        { lat: 17.38089673442523, lng: 78.51821105824857 },
        { lat: 17.38088214133022, lng: 78.51822437158597 },
        { lat: 17.38062417369228, lng: 78.51832260162364 },
        { lat: 17.38033228440247, lng: 78.51882628774167 },
        { lat: 17.38028240401854, lng: 78.5189671980237 },
        { lat: 17.38054627573616, lng: 78.5190859192 },
        { lat: 17.38046722634373, lng: 78.51926838502474 },
        { lat: 17.38020778459511, lng: 78.5199281030615 },
        { lat: 17.38001952036181, lng: 78.5204086889747 },
        { lat: 17.37938453754575, lng: 78.52228151389961 },
        { lat: 17.37930930284728, lng: 78.5230213391573 },
        { lat: 17.37927314711323, lng: 78.52337315075614 },
        { lat: 17.37926420513796, lng: 78.52346852739905 },
        { lat: 17.37933977848934, lng: 78.5238038343284 },
        { lat: 17.37939850554032, lng: 78.52406057699197 },
        { lat: 17.37945676227235, lng: 78.5240954423502 },
        { lat: 17.37946256607722, lng: 78.5241209811689 },
        { lat: 17.37977297828912, lng: 78.52430675657502 },
        { lat: 17.37984799173446, lng: 78.52454252352842 },
        { lat: 17.37985052494398, lng: 78.52491336284245 },
        { lat: 17.37994751787947, lng: 78.52515636091259 },
        { lat: 17.37998592002949, lng: 78.52515248265335 },
        { lat: 17.38001157815276, lng: 78.52521676567109 },
        { lat: 17.3801527387441, lng: 78.52520250836959 },
        { lat: 17.3802713515333, lng: 78.525106089294 },
        { lat: 17.38046546544089, lng: 78.52472714679544 },
        { lat: 17.38095847790557, lng: 78.52455260227794 },
        { lat: 17.38109392274153, lng: 78.52460061886285 },
        { lat: 17.38121771492194, lng: 78.52483444383377 },
        { lat: 17.381228947882, lng: 78.5250036351455 },
        { lat: 17.38122440167863, lng: 78.52535178962081 },
        { lat: 17.38115861174537, lng: 78.52551070224933 },
        { lat: 17.38108406789663, lng: 78.52569237239406 },
        { lat: 17.38087777544557, lng: 78.52617893502996 },
        { lat: 17.38083338159049, lng: 78.52624377344816 },
        { lat: 17.38078810432277, lng: 78.52659012876019 },
        { lat: 17.3807442689331, lng: 78.52658006011963 },
        { lat: 17.38072591479564, lng: 78.52662061516473 },
        { lat: 17.38060450260866, lng: 78.52685122114659 },
        { lat: 17.38039978476196, lng: 78.52730196341246 },
        { lat: 17.38025774477845, lng: 78.52779666193389 },
        { lat: 17.38025965530749, lng: 78.52795094440253 },
        { lat: 17.38034181943558, lng: 78.52802450598794 },
        { lat: 17.38056232112485, lng: 78.52807629871401 },
        { lat: 17.38060997319513, lng: 78.52808444547712 },
        { lat: 17.38072866526898, lng: 78.52811042605359 },
        { lat: 17.38094775649655, lng: 78.52814481579813 },
        { lat: 17.3815923477811, lng: 78.52827152939294 },
        { lat: 17.38166390610478, lng: 78.528260612309 },
        { lat: 17.38173906331478, lng: 78.52825680631906 },
        { lat: 17.38216083736508, lng: 78.52824896122341 },
        { lat: 17.38265126474897, lng: 78.52809801934607 },
        { lat: 17.38294631644217, lng: 78.527994500683 },
        { lat: 17.38324688678128, lng: 78.52795064146635 },
        { lat: 17.38341488309081, lng: 78.5280081178191 },
        { lat: 17.38343859263145, lng: 78.52799286605429 },
        { lat: 17.38354881224186, lng: 78.52801627489039 },
        { lat: 17.38358642661848, lng: 78.52796599167895 },
        { lat: 17.38377563640889, lng: 78.5274208721573 },
        { lat: 17.3839294823777, lng: 78.52749347154288 },
        { lat: 17.38406914603994, lng: 78.52719292765099 },
        { lat: 17.38435636625089, lng: 78.5272288908283 },
        { lat: 17.38466754164844, lng: 78.52726950930784 },
        { lat: 17.3847681732783, lng: 78.5269047779289 },
        { lat: 17.38494560459353, lng: 78.52695217054685 },
        { lat: 17.38620886652127, lng: 78.5270695939411 },
        { lat: 17.38648304456581, lng: 78.52721026583254 },
        { lat: 17.38651273425459, lng: 78.52690621833948 },
        { lat: 17.3878988443588, lng: 78.52726008010423 },
        { lat: 17.38810930888528, lng: 78.52730787705262 },
        { lat: 17.38812401976863, lng: 78.52729439755242 },
        { lat: 17.38831239591097, lng: 78.52739132241523 },
        { lat: 17.38843305935754, lng: 78.52740742538919 },
        { lat: 17.38899540615096, lng: 78.52752189463713 },
        { lat: 17.3892121266794, lng: 78.52759172961525 },
        { lat: 17.38933184280476, lng: 78.5276100326003 },
        { lat: 17.38946773601741, lng: 78.52765715787714 },
        { lat: 17.3895496606614, lng: 78.52767650784764 },
        { lat: 17.38969160784132, lng: 78.52771471198842 },
        { lat: 17.38984475299536, lng: 78.52775129628579 },
        { lat: 17.38993635224773, lng: 78.52775928795573 },
        { lat: 17.38998226579329, lng: 78.52776117882802 },
        { lat: 17.39008254201378, lng: 78.52775208719002 },
        { lat: 17.39022698196183, lng: 78.52774413570738 },
        { lat: 17.39051843813237, lng: 78.52772191405649 },
        { lat: 17.39058662293529, lng: 78.52777552617974 },
        { lat: 17.39148698174115, lng: 78.5277636111052 },
        { lat: 17.39149418067521, lng: 78.52737892365143 },
        { lat: 17.39165478292566, lng: 78.52738788773064 },
        { lat: 17.39213569060184, lng: 78.52747487883146 },
        { lat: 17.39273328949539, lng: 78.5276037865978 },
        { lat: 17.39388063840793, lng: 78.52787504386293 },
        { lat: 17.39410819302688, lng: 78.52792992568145 },
        { lat: 17.3942041238195, lng: 78.52795152232737 },
        { lat: 17.39427273387353, lng: 78.52794797070385 },
        { lat: 17.39436561155774, lng: 78.52793908250712 },
        { lat: 17.39452933628445, lng: 78.52795803408227 },
        { lat: 17.3946748640226, lng: 78.52796716722716 },
        { lat: 17.39495983528498, lng: 78.52796020663268 },
        { lat: 17.39509645309396, lng: 78.52794801445458 },
        { lat: 17.39513703292301, lng: 78.52811032021881 },
        { lat: 17.39559291236698, lng: 78.52811903892825 },
        { lat: 17.39569311277756, lng: 78.52849104979845 },
        { lat: 17.39595514187167, lng: 78.52844287277559 },
        { lat: 17.39608016376195, lng: 78.52875615810895 },
        { lat: 17.39618507805067, lng: 78.52900538599889 },
        { lat: 17.39626894622342, lng: 78.52903536658643 },
        { lat: 17.39632039294807, lng: 78.5290489980931 },
        { lat: 17.39648639075266, lng: 78.5288501354683 },
        { lat: 17.39652841025735, lng: 78.52878318229337 },
        { lat: 17.39662673246989, lng: 78.5283414061165 },
        { lat: 17.39686804856173, lng: 78.52785241479494 },
        { lat: 17.39690460049102, lng: 78.52777861277377 },
        { lat: 17.39693306584892, lng: 78.52772113606531 },
        { lat: 17.39713519407043, lng: 78.52699552922368 },
        { lat: 17.39717416836485, lng: 78.52683476921507 },
        { lat: 17.39720976174057, lng: 78.52664523574128 },
        { lat: 17.39637886454189, lng: 78.52622383103542 },
        { lat: 17.39667419647524, lng: 78.52571514223905 },
        { lat: 17.39600259358832, lng: 78.52537038337698 },
        { lat: 17.39600671932279, lng: 78.52525227795684 },
        { lat: 17.39624037830569, lng: 78.52478382409926 },
        { lat: 17.39644178625664, lng: 78.52479417983294 },
        { lat: 17.39664760326737, lng: 78.52462100562742 },
        { lat: 17.39690456980421, lng: 78.52459319220154 },
        { lat: 17.39727970310109, lng: 78.52456523744797 },
        { lat: 17.39729558853276, lng: 78.52443544122704 },
        { lat: 17.39726638566247, lng: 78.52408717271999 },
        { lat: 17.39744353608754, lng: 78.52340006379178 },
        { lat: 17.39756107667697, lng: 78.52296719637941 },
        { lat: 17.39766731223182, lng: 78.52259430398547 },
        { lat: 17.39781193873365, lng: 78.5225858744262 },
        { lat: 17.39785584325998, lng: 78.52239622137172 },
        { lat: 17.39778282585486, lng: 78.52235309171118 },
        { lat: 17.39796339292377, lng: 78.52154130895126 },
        { lat: 17.39806407446148, lng: 78.52118760612761 },
        { lat: 17.39817542359455, lng: 78.52116799732929 },
        { lat: 17.39823941379249, lng: 78.52110598767986 },
        { lat: 17.39825017359452, lng: 78.52107159270035 },
        { lat: 17.39838824296852, lng: 78.52114212285939 },
        { lat: 17.39847311000182, lng: 78.52119165315418 },
        { lat: 17.39865234485054, lng: 78.52128590365234 },
        { lat: 17.39893968179213, lng: 78.52139965032258 },
        { lat: 17.39906288818994, lng: 78.52143991119848 },
        { lat: 17.39922047382834, lng: 78.52148983680976 },
        { lat: 17.39924675586089, lng: 78.5214999502795 },
        { lat: 17.39936111654005, lng: 78.52156553902991 },
        { lat: 17.39944795412946, lng: 78.52162762673595 },
        { lat: 17.39958609919337, lng: 78.52173282263958 },
        { lat: 17.39971917386524, lng: 78.52184429605 },
        { lat: 17.39977919936204, lng: 78.52189504896033 },
        { lat: 17.39987194046437, lng: 78.521972485828 },
        { lat: 17.39999092058257, lng: 78.52206769942214 },
        { lat: 17.40013048972041, lng: 78.52217055777142 },
        { lat: 17.40026121556765, lng: 78.5222660150117 },
        { lat: 17.40042869946831, lng: 78.52237868023465 },
        { lat: 17.40044024459841, lng: 78.52239148928267 },
        { lat: 17.40050675253619, lng: 78.52247351552455 },
        { lat: 17.40067545260832, lng: 78.52255684859632 },
        { lat: 17.40084514031264, lng: 78.52270507374321 },
        { lat: 17.40099580254094, lng: 78.52274372396231 },
        { lat: 17.40114174844824, lng: 78.52282886178838 },
        { lat: 17.40125925305847, lng: 78.52255970160282 },
        { lat: 17.40130229962372, lng: 78.52251724037704 },
        { lat: 17.4014499267698, lng: 78.52213712603826 },
        { lat: 17.40153224467204, lng: 78.52194037428966 },
        { lat: 17.40160350483582, lng: 78.5217663470796 },
        { lat: 17.40172662036164, lng: 78.52180387495945 },
        { lat: 17.40187237106471, lng: 78.52183700819123 },
        { lat: 17.40200603445427, lng: 78.52185862381394 },
        { lat: 17.40216169105245, lng: 78.52187571700294 },
        { lat: 17.40241957110587, lng: 78.52191044880966 },
        { lat: 17.40253346478253, lng: 78.52192501181408 },
        { lat: 17.40289321305576, lng: 78.52196246079743 },
        { lat: 17.40322241616287, lng: 78.5220012125582 },
        { lat: 17.40329962653634, lng: 78.52201127559472 },
        { lat: 17.40331968431505, lng: 78.5220045138124 },
        { lat: 17.40334394846523, lng: 78.5219594555437 },
        { lat: 17.40346851565462, lng: 78.52164910123446 },
        { lat: 17.40361826323835, lng: 78.52126122457929 },
        { lat: 17.40377754376636, lng: 78.52086494463111 },
        { lat: 17.40385340756819, lng: 78.52065716158418 },
        { lat: 17.40392113197224, lng: 78.52047093043973 },
        { lat: 17.40399452884989, lng: 78.52027827143958 },
        { lat: 17.40406892287455, lng: 78.52009223699243 },
        { lat: 17.40411873560085, lng: 78.51997155801108 },
        { lat: 17.4042285040308, lng: 78.51970740617513 },
        { lat: 17.40435240145961, lng: 78.51938273201888 },
        { lat: 17.40440079735252, lng: 78.51926008395476 },
        { lat: 17.40452151464767, lng: 78.51895696787035 },
        { lat: 17.40464336507758, lng: 78.51865008617716 },
        { lat: 17.40473724786181, lng: 78.51840351901738 },
        { lat: 17.40488174155773, lng: 78.51801287404433 },
        { lat: 17.40495779679762, lng: 78.51781688558822 },
        { lat: 17.40502996425738, lng: 78.51763815360829 },
        { lat: 17.40512905298833, lng: 78.5174058988556 },
        { lat: 17.40525106427017, lng: 78.51710235390706 },
        { lat: 17.40535049402816, lng: 78.51684829417806 },
        { lat: 17.4055056652742, lng: 78.51644513418515 },
        { lat: 17.4056272776548, lng: 78.51620228359005 },
        { lat: 17.40561251848322, lng: 78.51616931849831 },
        { lat: 17.40565129988861, lng: 78.51608666751058 },
        { lat: 17.40578179002328, lng: 78.51579775510828 },
        { lat: 17.40583018524697, lng: 78.51568351223929 },
        { lat: 17.40607961735656, lng: 78.51539053290985 },
        { lat: 17.40632416835643, lng: 78.51500026317724 },
        { lat: 17.406330296493, lng: 78.51500742249794 },
        { lat: 17.40708196066758, lng: 78.51588558702998 },
        { lat: 17.40775404793002, lng: 78.51644070154825 },
        { lat: 17.40813589658974, lng: 78.51684966117689 },
        { lat: 17.40935618291109, lng: 78.51763154995588 },
        { lat: 17.4098074953194, lng: 78.51800873740835 },
        { lat: 17.41005418015757, lng: 78.51820698927828 },
        { lat: 17.4101701945074, lng: 78.51827261759152 },
        { lat: 17.41032131162025, lng: 78.51829139077947 },
        { lat: 17.41042771232904, lng: 78.51829943405956 },
        { lat: 17.41056490917023, lng: 78.51828194353637 },
        { lat: 17.4106631652216, lng: 78.51807320282333 },
        { lat: 17.41068025270179, lng: 78.51800838707365 },
        { lat: 17.41134279960134, lng: 78.51816202020673 },
        { lat: 17.41235891067243, lng: 78.51839035165956 },
        { lat: 17.4152864912588, lng: 78.51909361057983 },
        { lat: 17.41684620716631, lng: 78.51947437694464 },
        { lat: 17.41921361675506, lng: 78.52005574268154 },
        { lat: 17.41930784129377, lng: 78.52007707327209 },
        { lat: 17.42067430755996, lng: 78.52038640808031 },
        { lat: 17.42060581226804, lng: 78.52064624413612 },
        { lat: 17.42051257561777, lng: 78.52083545125541 },
        { lat: 17.42044833782952, lng: 78.52095456460052 },
        { lat: 17.42021818852327, lng: 78.52137588490791 },
        { lat: 17.42001706854803, lng: 78.52172960188612 },
        { lat: 17.41978672983462, lng: 78.52213598861246 },
        { lat: 17.41968595338984, lng: 78.52229542363685 },
        { lat: 17.41951962023739, lng: 78.52256403140983 },
        { lat: 17.41948129273402, lng: 78.52265291886366 },
        { lat: 17.41946740194959, lng: 78.52278504314587 },
        { lat: 17.41943039979183, lng: 78.52317263963069 },
        { lat: 17.41940253716441, lng: 78.52338232776542 },
        { lat: 17.41939655197876, lng: 78.52347762734512 },
        { lat: 17.41951077800939, lng: 78.52348666577842 },
        { lat: 17.41967316076605, lng: 78.52347700990968 },
        { lat: 17.41978527528543, lng: 78.5234605606184 },
        { lat: 17.41982349122361, lng: 78.52345880135046 },
        { lat: 17.41982338238447, lng: 78.52364239338189 },
        { lat: 17.41991071132411, lng: 78.52365055083808 },
        { lat: 17.42023232832792, lng: 78.52366612661194 },
        { lat: 17.42035426392803, lng: 78.52367070682804 },
        { lat: 17.42041588276858, lng: 78.52367734248115 },
        { lat: 17.42055696545774, lng: 78.52368415398583 },
        { lat: 17.42068540214107, lng: 78.52368304270486 },
        { lat: 17.42087545772133, lng: 78.52368857176583 },
        { lat: 17.42109292041476, lng: 78.52368812733836 },
        { lat: 17.42104983868138, lng: 78.52397125427726 },
        { lat: 17.42101621408441, lng: 78.52424616307175 },
        { lat: 17.42117186407348, lng: 78.52427144728824 },
        { lat: 17.4214562059778, lng: 78.52431615544505 },
        { lat: 17.42172497644107, lng: 78.52435796218612 },
        { lat: 17.42194202600292, lng: 78.52438822753132 },
        { lat: 17.42226269668723, lng: 78.52442373445228 },
        { lat: 17.42242900582907, lng: 78.52444140737661 },
        { lat: 17.42251626518683, lng: 78.52444396505953 },
        { lat: 17.42272450363138, lng: 78.52436075803533 },
        { lat: 17.42274414654004, lng: 78.5243261369743 },
        { lat: 17.42283867863766, lng: 78.524202384212 },
        { lat: 17.42276921337784, lng: 78.52415104206956 },
        { lat: 17.42293124123974, lng: 78.52392032864051 },
        { lat: 17.42316903813293, lng: 78.52361391133321 },
        { lat: 17.42340038509355, lng: 78.52325007361576 },
        { lat: 17.42407238797657, lng: 78.5221162833288 },
        { lat: 17.42437195093033, lng: 78.52176122918718 },
        { lat: 17.42452825239134, lng: 78.52169295023779 },
        { lat: 17.4246137458893, lng: 78.52176498657182 },
        { lat: 17.42469676320501, lng: 78.52186842274675 },
        { lat: 17.42472997749644, lng: 78.52188739048282 },
        { lat: 17.42479515613255, lng: 78.52205529352045 },
        { lat: 17.42495141197876, lng: 78.5223982210778 },
        { lat: 17.42519008984067, lng: 78.52279679514567 },
        { lat: 17.42546106294783, lng: 78.5233711879901 },
        { lat: 17.42566291671319, lng: 78.52357608366228 },
        { lat: 17.42601262703017, lng: 78.524140457091 },
        { lat: 17.42603927074024, lng: 78.52417392475083 },
        { lat: 17.42605358725211, lng: 78.52417033029897 },
        { lat: 17.42605395731393, lng: 78.52417023686306 },
        { lat: 17.42603907455296, lng: 78.52421096761657 },
        { lat: 17.42592017086752, lng: 78.52445031485 },
        { lat: 17.42568929144778, lng: 78.52471731086325 },
        { lat: 17.42540878701742, lng: 78.52512562936255 },
        { lat: 17.42521312479736, lng: 78.52543820377817 },
        { lat: 17.42507623264015, lng: 78.52576865546362 },
        { lat: 17.42493124022688, lng: 78.52612037745078 },
        { lat: 17.42460911606927, lng: 78.52693005220932 },
        { lat: 17.42437965893356, lng: 78.5275044698653 },
        { lat: 17.42413281008783, lng: 78.52802559805451 },
        { lat: 17.4245459438037, lng: 78.52848307090203 },
        { lat: 17.42506783513734, lng: 78.529038659229 },
        { lat: 17.42553559226729, lng: 78.52956510680862 },
        { lat: 17.42625328447128, lng: 78.53037132838129 },
        { lat: 17.42664305244709, lng: 78.53081418935675 },
        { lat: 17.42677075875628, lng: 78.53091884975305 },
        { lat: 17.42676830183192, lng: 78.53092211574776 },
        { lat: 17.42613057179422, lng: 78.53176977233434 },
        { lat: 17.42557269840591, lng: 78.53287567521615 },
        { lat: 17.42555498161987, lng: 78.53292737387127 },
        { lat: 17.4251337183276, lng: 78.53417007703304 },
        { lat: 17.42480994252059, lng: 78.53542430582856 },
        { lat: 17.42470353755779, lng: 78.5357296491963 },
        { lat: 17.42470835519651, lng: 78.53575095412883 },
        { lat: 17.42470336068818, lng: 78.53575682179688 },
        { lat: 17.42594432777437, lng: 78.5390351310311 },
        { lat: 17.4253740979593, lng: 78.53957029235231 },
        { lat: 17.42530911539627, lng: 78.53962756285966 },
        { lat: 17.42515570337487, lng: 78.53981121566298 },
        { lat: 17.42481333040807, lng: 78.54017508918677 },
        { lat: 17.42423135200541, lng: 78.54082167407613 },
        { lat: 17.42459028071902, lng: 78.5412057921347 },
        { lat: 17.42457786265704, lng: 78.541218779144 },
        { lat: 17.42487566989227, lng: 78.54153050122929 },
        { lat: 17.42499750803458, lng: 78.541662645615 },
        { lat: 17.42521621026782, lng: 78.54188217854175 },
        { lat: 17.42533541593147, lng: 78.54194549874951 },
        { lat: 17.42540786260136, lng: 78.54199720687517 },
        { lat: 17.42559296260891, lng: 78.54213827234416 },
        { lat: 17.4256045801242, lng: 78.54217971599981 },
        { lat: 17.42556042786335, lng: 78.54226260331718 },
        { lat: 17.42547236572101, lng: 78.5424208727764 },
        { lat: 17.42579543067152, lng: 78.54262932526068 },
        { lat: 17.42610815860834, lng: 78.5427919206055 },
        { lat: 17.42640866501662, lng: 78.54291843251754 },
        { lat: 17.42653892490277, lng: 78.54299835770493 },
        { lat: 17.42703397242911, lng: 78.54340355143786 },
        { lat: 17.42770891273515, lng: 78.54399731448538 },
        { lat: 17.42783942403898, lng: 78.54419609785067 },
        { lat: 17.42781528232356, lng: 78.54452089579985 },
        { lat: 17.42778421981989, lng: 78.54470270119462 },
        { lat: 17.42777029784839, lng: 78.54494217840808 },
        { lat: 17.42831892032827, lng: 78.54512945520852 },
        { lat: 17.42834413872631, lng: 78.54516127190585 },
        { lat: 17.42927515938918, lng: 78.54519971991691 },
        { lat: 17.43044380386902, lng: 78.54552995162354 },
        { lat: 17.43129351350287, lng: 78.54582353678262 },
        { lat: 17.4326871023707, lng: 78.54586168034591 },
        { lat: 17.43246548571996, lng: 78.54640477964865 },
        { lat: 17.43239841998964, lng: 78.54655952881507 },
        { lat: 17.4323077019867, lng: 78.54682350142151 },
        { lat: 17.43224803677007, lng: 78.54699846911626 },
        { lat: 17.43249519296083, lng: 78.54709417436368 },
        { lat: 17.432579603827, lng: 78.54710768314627 },
        { lat: 17.43268985490616, lng: 78.54708399068637 },
        { lat: 17.43283935186367, lng: 78.54704508535603 },
        { lat: 17.43296572283049, lng: 78.54705577203177 },
        { lat: 17.43307545064822, lng: 78.54708843775052 },
        { lat: 17.43315617326634, lng: 78.54707603705414 },
        { lat: 17.43325673627078, lng: 78.54701686107543 },
        { lat: 17.43334817213569, lng: 78.54698078214167 },
        { lat: 17.43348902821856, lng: 78.54698978179694 },
        { lat: 17.43361805977185, lng: 78.54700835937832 },
        { lat: 17.43375462831139, lng: 78.54702975690238 },
        { lat: 17.43385949561861, lng: 78.54703593786051 },
        { lat: 17.43413065985307, lng: 78.54704147514767 },
        { lat: 17.43423816325387, lng: 78.54704146232692 },
        { lat: 17.43430427360368, lng: 78.54707167491416 },
        { lat: 17.43437463918662, lng: 78.54712652965793 },
        { lat: 17.43445840850116, lng: 78.54721237896455 },
        { lat: 17.43450551076639, lng: 78.54730223491838 },
        { lat: 17.43450986194095, lng: 78.54744149507304 },
        { lat: 17.43452226070604, lng: 78.54756021488241 },
        { lat: 17.43455176929229, lng: 78.54758719835634 },
        { lat: 17.43461911032234, lng: 78.5476157678278 },
        { lat: 17.43465996895087, lng: 78.54764275391244 },
        { lat: 17.43465921405663, lng: 78.54772768596978 },
        { lat: 17.43458887426234, lng: 78.54804936134097 },
        { lat: 17.4345911586927, lng: 78.5481050399339 },
        { lat: 17.43464185569377, lng: 78.54814790213804 },
        { lat: 17.43556562407925, lng: 78.54872384059053 },
        { lat: 17.43556849129023, lng: 78.54872562961769 },
        { lat: 17.43579901263946, lng: 78.54871712924171 },
        { lat: 17.43600272598015, lng: 78.5487008486798 },
        { lat: 17.43702992935546, lng: 78.54866720390477 },
        { lat: 17.43756975259511, lng: 78.54864505243819 },
        { lat: 17.43823125270746, lng: 78.54880052765957 },
        { lat: 17.43869143117383, lng: 78.5489089025299 },
        { lat: 17.43893600966136, lng: 78.54897534417444 },
        { lat: 17.43889248569361, lng: 78.54903744589087 },
        { lat: 17.43886360300692, lng: 78.54906972059744 },
        { lat: 17.438691796768, lng: 78.54930435263509 },
        { lat: 17.43848893106861, lng: 78.54959785629121 },
        { lat: 17.43847643257936, lng: 78.54966972549217 },
        { lat: 17.43877231751896, lng: 78.54997279862388 },
        { lat: 17.43928291816005, lng: 78.55039171195612 },
        { lat: 17.43946097305693, lng: 78.5505754622685 },
        { lat: 17.43997123033033, lng: 78.55102475825348 },
        { lat: 17.43974875559894, lng: 78.55143404491692 },
        { lat: 17.4397283232759, lng: 78.55150208720319 },
        { lat: 17.43959896933044, lng: 78.552060258607 },
        { lat: 17.43951045555892, lng: 78.55249210535248 },
        { lat: 17.43939438736705, lng: 78.55284818565354 },
        { lat: 17.43928123547053, lng: 78.55313053098044 },
        { lat: 17.43907338263924, lng: 78.55347431776897 },
        { lat: 17.43887708705457, lng: 78.55381385264894 },
        { lat: 17.43862648857729, lng: 78.55421346880513 },
        { lat: 17.43895798412814, lng: 78.55471081118888 },
        { lat: 17.43915296912811, lng: 78.55539297806409 },
        { lat: 17.44027111700436, lng: 78.5561789075795 },
        { lat: 17.44003108403946, lng: 78.5565912271283 },
        { lat: 17.4396186752985, lng: 78.55725537770994 },
        { lat: 17.43991213849113, lng: 78.55733851568935 },
        { lat: 17.44126513945778, lng: 78.55524875835926 },
        { lat: 17.44161510013363, lng: 78.55448967870844 },
        { lat: 17.44201476524916, lng: 78.55278981606658 },
        { lat: 17.44206742555132, lng: 78.55276880190345 },
        { lat: 17.44221026538972, lng: 78.5528336327881 },
        { lat: 17.44319207965864, lng: 78.55363007929422 },
        { lat: 17.44403650499522, lng: 78.55480557900339 },
        { lat: 17.44480751442291, lng: 78.55635347971072 },
        { lat: 17.44550631529573, lng: 78.55828673467812 },
        { lat: 17.44609290705763, lng: 78.55824401760526 },
        { lat: 17.44750975591775, lng: 78.55736262771943 },
        { lat: 17.44915000139454, lng: 78.56032052989188 },
        { lat: 17.44939600493985, lng: 78.56073652478882 },
        { lat: 17.44940916810278, lng: 78.56072652800678 },
        { lat: 17.44973815806745, lng: 78.56051620709887 },
        { lat: 17.45017759541897, lng: 78.560292903415 },
        { lat: 17.45045510131403, lng: 78.56094027109422 },
        { lat: 17.45077848992929, lng: 78.56095658274494 },
        { lat: 17.45113377854422, lng: 78.56098920256309 },
        { lat: 17.4517363717891, lng: 78.56104766219515 },
        { lat: 17.45214918980307, lng: 78.56109445470221 },
        { lat: 17.45250833748181, lng: 78.56114943166548 },
        { lat: 17.45272076401633, lng: 78.56122503570036 },
        { lat: 17.45294408008519, lng: 78.56131169916239 },
        { lat: 17.45315563507968, lng: 78.56141759264972 },
        { lat: 17.45329110016658, lng: 78.56108314132146 },
        { lat: 17.45355993676991, lng: 78.5611791581409 },
        { lat: 17.45372334701082, lng: 78.56125267636932 },
        { lat: 17.45377518464312, lng: 78.56111454378467 },
        { lat: 17.45386179498226, lng: 78.5611534161499 },
        { lat: 17.45466190158882, lng: 78.56137221110737 },
        { lat: 17.45468975058513, lng: 78.56130461365298 },
        { lat: 17.45500011574805, lng: 78.56139609501395 },
        { lat: 17.45532608585319, lng: 78.56147392389742 },
        { lat: 17.45543654866367, lng: 78.56151727207472 },
        { lat: 17.45549689496606, lng: 78.56156626649135 },
        { lat: 17.45559792245028, lng: 78.56161970060104 },
        { lat: 17.45576594608209, lng: 78.56167971241247 },
        { lat: 17.45611874147563, lng: 78.56176498643994 },
        { lat: 17.45646801018964, lng: 78.56187188646152 },
        { lat: 17.4567064160926, lng: 78.56194377290251 },
        { lat: 17.45695085288356, lng: 78.56199878478887 },
        { lat: 17.45706684050264, lng: 78.56202251386233 },
        { lat: 17.45723356681564, lng: 78.56205465666744 },
        { lat: 17.45733154991173, lng: 78.56209368922688 },
        { lat: 17.45751000093535, lng: 78.56214659156971 },
        { lat: 17.4576378705362, lng: 78.5621560906786 },
        { lat: 17.45770994097083, lng: 78.56216929015193 },
        { lat: 17.45816317404724, lng: 78.56229622141049 },
        { lat: 17.45873422184223, lng: 78.56244237775769 },
        { lat: 17.45944145425909, lng: 78.5626246946608 },
        { lat: 17.45993054656563, lng: 78.56275264501572 },
        { lat: 17.46038851508763, lng: 78.56287602974322 },
        { lat: 17.46070269063647, lng: 78.56296646902841 },
        { lat: 17.46074147084726, lng: 78.5630147846412 },
        { lat: 17.46089403647576, lng: 78.56305262898252 },
        { lat: 17.46113476983439, lng: 78.56309798097432 },
        { lat: 17.4613688614433, lng: 78.56312142603299 },
        { lat: 17.46148866887677, lng: 78.56314722268266 },
        { lat: 17.46160639183951, lng: 78.56319794579605 },
        { lat: 17.46165810463412, lng: 78.56312753816039 },
        { lat: 17.46166491143869, lng: 78.5631294540205 },
        { lat: 17.46220726840559, lng: 78.563282081283 },
        { lat: 17.46279451108032, lng: 78.56342366953459 },
        { lat: 17.46286359337847, lng: 78.56345586704202 },
        { lat: 17.4627959413297, lng: 78.56370776136603 },
        { lat: 17.46328046627152, lng: 78.56377502043165 },
        { lat: 17.46370664715319, lng: 78.5638201472971 },
        { lat: 17.464322955935, lng: 78.56389598694727 },
        { lat: 17.46484296322374, lng: 78.56391396906031 },
        { lat: 17.46523491959212, lng: 78.56396478126821 },
        { lat: 17.46539344863979, lng: 78.56398134688445 },
        { lat: 17.46558831447106, lng: 78.56403789356783 },
        { lat: 17.46559169983685, lng: 78.56403855907712 },
        { lat: 17.46561361273348, lng: 78.56407735611772 },
        { lat: 17.46562963697338, lng: 78.56413690419576 },
        { lat: 17.46558955933833, lng: 78.5647669238331 },
        { lat: 17.46563567607617, lng: 78.56477216239486 },
        { lat: 17.46597662388612, lng: 78.56481089039137 },
        { lat: 17.46610511387572, lng: 78.5651106690385 },
        { lat: 17.46625582604936, lng: 78.56522071716788 },
        { lat: 17.4669927884575, lng: 78.56539144829512 },
        { lat: 17.46713519104227, lng: 78.56540601978367 },
        { lat: 17.467384783197, lng: 78.5654589645136 },
        { lat: 17.4682239591412, lng: 78.56559903941309 },
        { lat: 17.46828977152649, lng: 78.56541140701087 },
        { lat: 17.46838797761921, lng: 78.56523454979221 },
        { lat: 17.46849739415015, lng: 78.56509489421482 },
        { lat: 17.469513572946, lng: 78.56576783386964 },
        { lat: 17.46989548033483, lng: 78.56609414677236 },
        { lat: 17.46998464610329, lng: 78.56619148413223 },
        { lat: 17.47034960938696, lng: 78.56653390207492 },
        { lat: 17.47047214312713, lng: 78.56635622189195 },
        { lat: 17.47073061281155, lng: 78.5659180092291 },
        { lat: 17.47092369326453, lng: 78.56559564069939 },
        { lat: 17.47112246489754, lng: 78.56523939720427 },
        { lat: 17.47123810587059, lng: 78.56500682132275 },
        { lat: 17.47125555927709, lng: 78.56501678275464 },
        { lat: 17.47134436951046, lng: 78.56507341064639 },
        { lat: 17.47158541927297, lng: 78.56461799398917 },
        { lat: 17.4716789130002, lng: 78.56468074752462 },
        { lat: 17.47193694585294, lng: 78.56420717455961 },
        { lat: 17.47221866432645, lng: 78.56368721831505 },
        { lat: 17.47258862400802, lng: 78.5630647362426 },
        { lat: 17.47291823914067, lng: 78.56249798712656 },
        { lat: 17.4729760094726, lng: 78.56238769788263 },
        { lat: 17.47306036852911, lng: 78.56242762958644 },
        { lat: 17.47327040303009, lng: 78.56135882234999 },
        { lat: 17.47341595588369, lng: 78.56074330837382 },
        { lat: 17.47349739024701, lng: 78.56036869893606 },
        { lat: 17.47350231785577, lng: 78.56030289318585 },
        { lat: 17.47346639836304, lng: 78.56025805137587 },
        { lat: 17.47336028528202, lng: 78.56017978076301 },
        { lat: 17.47319021456707, lng: 78.56010883711187 },
        { lat: 17.4728904006277, lng: 78.55998135432318 },
        { lat: 17.47261193029994, lng: 78.5598794841785 },
        { lat: 17.47269160398436, lng: 78.55968266526403 },
        { lat: 17.47286083832013, lng: 78.55933527438752 },
        { lat: 17.47318730676997, lng: 78.55865596451676 },
        { lat: 17.47334109274486, lng: 78.55833517373567 },
        { lat: 17.4734788574514, lng: 78.5580509108556 },
        { lat: 17.47358353602723, lng: 78.5578179295938 },
        { lat: 17.47368360464401, lng: 78.55763524872836 },
        { lat: 17.4739470766367, lng: 78.55776122039443 },
        { lat: 17.47418362277629, lng: 78.55725206279232 },
        { lat: 17.47429430745224, lng: 78.55709113359195 },
        { lat: 17.47433681374282, lng: 78.55703368982606 },
        { lat: 17.47474066617246, lng: 78.55660397355858 },
        { lat: 17.47513195529232, lng: 78.55622045090847 },
        { lat: 17.47555749870056, lng: 78.55576879905229 },
        { lat: 17.47716708972885, lng: 78.5544325419735 },
        { lat: 17.47768128678533, lng: 78.5546750703724 },
        { lat: 17.47795765048459, lng: 78.55403261578778 },
        { lat: 17.47818116166786, lng: 78.55350616554838 },
        { lat: 17.47865482205045, lng: 78.553715641444 },
        { lat: 17.47939147873748, lng: 78.55403005029906 },
        { lat: 17.47957695042284, lng: 78.55357369016238 },
        { lat: 17.48056081664972, lng: 78.55400787854502 },
        { lat: 17.48111929902268, lng: 78.55423947588959 },
        { lat: 17.48164211529009, lng: 78.55298201207304 },
        { lat: 17.48209634812553, lng: 78.55178372192965 },
        { lat: 17.48252391476188, lng: 78.55181535272904 },
        { lat: 17.48257591882573, lng: 78.55180242670508 },
        { lat: 17.48309724129683, lng: 78.55073000233195 },
        { lat: 17.48310586515639, lng: 78.55073277070294 },
        { lat: 17.4836157160311, lng: 78.54985615613556 },
        { lat: 17.48362808003575, lng: 78.54983489900698 },
        { lat: 17.48367217557371, lng: 78.54975061994638 },
        { lat: 17.48382772923025, lng: 78.54948585818607 },
        { lat: 17.48387856371137, lng: 78.54940422381755 },
        { lat: 17.4840249283354, lng: 78.54915256765764 },
        { lat: 17.48432154981885, lng: 78.54864255708766 },
        { lat: 17.48557800117347, lng: 78.54646662329174 },
        { lat: 17.48641678095604, lng: 78.54501347829081 },
        { lat: 17.48707953430049, lng: 78.54382043490946 },
        { lat: 17.48742701187966, lng: 78.5432218259964 },
        { lat: 17.48795674813683, lng: 78.54228830520576 },
        { lat: 17.48836427217223, lng: 78.54161790753784 },
        { lat: 17.48846513408025, lng: 78.54165764165553 },
        { lat: 17.48868128940243, lng: 78.54174438838808 },
        { lat: 17.48885244218745, lng: 78.54177362695631 },
        { lat: 17.48902568575246, lng: 78.541814158562 },
        { lat: 17.48922973957355, lng: 78.54181145657995 },
        { lat: 17.4892569086985, lng: 78.54135992259161 },
        { lat: 17.48941822970947, lng: 78.54107136286994 },
        { lat: 17.4894995077177, lng: 78.54097688263158 },
        { lat: 17.48963128785272, lng: 78.54050287325958 },
        { lat: 17.48994252017359, lng: 78.54070246458852 },
        { lat: 17.4900505988898, lng: 78.54074583614737 },
        { lat: 17.49004805434625, lng: 78.54054041770671 },
        { lat: 17.49007249397299, lng: 78.54048779018298 },
        { lat: 17.49011025467316, lng: 78.54035280329929 },
        { lat: 17.49016311125882, lng: 78.53998974503406 },
        { lat: 17.49018856477092, lng: 78.53970493598935 },
        { lat: 17.49024512192137, lng: 78.53937601524655 },
        { lat: 17.49034381031659, lng: 78.53924020709323 },
        { lat: 17.49105456847543, lng: 78.53932029244034 },
        { lat: 17.4912012260293, lng: 78.53825492598179 },
        { lat: 17.49150671478502, lng: 78.53824085683047 },
        { lat: 17.49150656492721, lng: 78.5376506408385 },
        { lat: 17.49169771626486, lng: 78.53764806616296 },
        { lat: 17.491701620371, lng: 78.53719227684137 },
        { lat: 17.49173429967853, lng: 78.53712957630843 },
        { lat: 17.49178066743295, lng: 78.53701439596567 },
        { lat: 17.49180313980852, lng: 78.53689953376244 },
        { lat: 17.491969365542, lng: 78.53700687163806 },
        { lat: 17.49204783522137, lng: 78.5370426546436 },
        { lat: 17.49213761185494, lng: 78.53708429611827 },
        { lat: 17.49229319823784, lng: 78.5371046137612 },
        { lat: 17.49245037277575, lng: 78.53706016085022 },
        { lat: 17.49261853539191, lng: 78.5369383560052 },
        { lat: 17.49274316482837, lng: 78.53677480121333 },
        { lat: 17.49299926102065, lng: 78.53622844540959 },
        { lat: 17.49319220204862, lng: 78.53579251782287 },
        { lat: 17.49318410617414, lng: 78.53571791447231 },
        { lat: 17.49308204692489, lng: 78.5355617236741 },
        { lat: 17.49348230507685, lng: 78.53498858846895 },
      ],
      [
        { lat: 17.52058440721178, lng: 78.54642067826376 },
        { lat: 17.52085259636571, lng: 78.54636725558662 },
        { lat: 17.52165658048161, lng: 78.54600227990163 },
        { lat: 17.51909435827296, lng: 78.54355557591938 },
        { lat: 17.51907313995248, lng: 78.5433921619892 },
        { lat: 17.51910329628864, lng: 78.54324984022139 },
        { lat: 17.51917315256556, lng: 78.54301770853938 },
        { lat: 17.51919039488186, lng: 78.54285735787998 },
        { lat: 17.51927600503686, lng: 78.5425385418529 },
        { lat: 17.51926172693001, lng: 78.54192552254906 },
        { lat: 17.51956333562727, lng: 78.54043195769756 },
        { lat: 17.5177084198405, lng: 78.53994173536199 },
        { lat: 17.51714521128057, lng: 78.53998343787046 },
        { lat: 17.51644213495783, lng: 78.53995378057068 },
        { lat: 17.5162367798456, lng: 78.54010066426841 },
        { lat: 17.51612835507931, lng: 78.54009365873232 },
        { lat: 17.51587170458597, lng: 78.54007647784906 },
        { lat: 17.51548567305083, lng: 78.5400309092414 },
        { lat: 17.51546474001168, lng: 78.54003644509243 },
        { lat: 17.51478635700503, lng: 78.5400617752451 },
        { lat: 17.51424044548323, lng: 78.54007411111894 },
        { lat: 17.51340551200102, lng: 78.54009781532106 },
        { lat: 17.51300441118774, lng: 78.54009375899705 },
        { lat: 17.51300083581044, lng: 78.54009794818062 },
        { lat: 17.5129757961159, lng: 78.54010227123837 },
        { lat: 17.51250964574021, lng: 78.54012913157132 },
        { lat: 17.51184192553124, lng: 78.54016651944174 },
        { lat: 17.51156296366475, lng: 78.54016434619717 },
        { lat: 17.51137257268081, lng: 78.5391258796241 },
        { lat: 17.51134652453451, lng: 78.53876010641078 },
        { lat: 17.51134384103134, lng: 78.53800800559685 },
        { lat: 17.51188758397452, lng: 78.538034654582 },
        { lat: 17.51187328401939, lng: 78.53726772893702 },
        { lat: 17.51188427510847, lng: 78.53719112179726 },
        { lat: 17.51188119068018, lng: 78.53719090923825 },
        { lat: 17.51191052890519, lng: 78.53608964898872 },
        { lat: 17.51195486417736, lng: 78.53542653785797 },
        { lat: 17.51195502734402, lng: 78.53542571292031 },
        { lat: 17.5119534632889, lng: 78.53529985649143 },
        { lat: 17.51205925761625, lng: 78.5347365386422 },
        { lat: 17.51210145354346, lng: 78.53413223552565 },
        { lat: 17.51214515381566, lng: 78.53380287973046 },
        { lat: 17.51292635056003, lng: 78.5313235907455 },
        { lat: 17.51276894889317, lng: 78.53115759927974 },
        { lat: 17.51186324363844, lng: 78.53087097015882 },
        { lat: 17.51174812055845, lng: 78.53074177002043 },
        { lat: 17.51169141371538, lng: 78.53050592438835 },
        { lat: 17.51156861202131, lng: 78.53023984190385 },
        { lat: 17.51134596793087, lng: 78.53011209682413 },
        { lat: 17.51040628372101, lng: 78.52997537069862 },
        { lat: 17.51017197364941, lng: 78.53111799593155 },
        { lat: 17.50987485586116, lng: 78.5309588774891 },
        { lat: 17.50940640957849, lng: 78.53100256976788 },
        { lat: 17.50902740679799, lng: 78.53103259958793 },
        { lat: 17.508753330614, lng: 78.53085262419378 },
        { lat: 17.50800200469886, lng: 78.53048919541082 },
        { lat: 17.50755520244552, lng: 78.53035202754673 },
        { lat: 17.50651831227973, lng: 78.53032557842212 },
        { lat: 17.50545446388448, lng: 78.5302932646598 },
        { lat: 17.50425419535213, lng: 78.5303406245213 },
        { lat: 17.50308356032227, lng: 78.5303689030049 },
        { lat: 17.50247136300167, lng: 78.53038340555906 },
        { lat: 17.50245010736232, lng: 78.5304227923051 },
        { lat: 17.50226959633866, lng: 78.53066581621898 },
        { lat: 17.50226044108406, lng: 78.53069932758348 },
        { lat: 17.50170494605753, lng: 78.53165605138292 },
        { lat: 17.50109031092521, lng: 78.53291582876955 },
        { lat: 17.50070543509083, lng: 78.53343468784794 },
        { lat: 17.50069499595417, lng: 78.53347060608783 },
        { lat: 17.49964454589776, lng: 78.53450849912315 },
        { lat: 17.49953866676873, lng: 78.53487303877262 },
        { lat: 17.49944234967584, lng: 78.5349684783906 },
        { lat: 17.49927187386933, lng: 78.53509629770686 },
        { lat: 17.4990878639769, lng: 78.53517349290806 },
        { lat: 17.49886298364299, lng: 78.53530802267983 },
        { lat: 17.4988581867813, lng: 78.53531508859791 },
        { lat: 17.49872911654106, lng: 78.53538825071462 },
        { lat: 17.49874470648258, lng: 78.53543031693113 },
        { lat: 17.49874346330444, lng: 78.53543014356043 },
        { lat: 17.49884871394492, lng: 78.53570028900688 },
        { lat: 17.49908653272669, lng: 78.53629977579106 },
        { lat: 17.4989775530535, lng: 78.53653036918736 },
        { lat: 17.49893612994975, lng: 78.53663314572022 },
        { lat: 17.49878095542878, lng: 78.5370181624159 },
        { lat: 17.49870632480816, lng: 78.53720512328428 },
        { lat: 17.49896995693695, lng: 78.53730467590803 },
        { lat: 17.49898794557846, lng: 78.53725213226035 },
        { lat: 17.49927425614727, lng: 78.53733046039919 },
        { lat: 17.49914088538403, lng: 78.537791001816 },
        { lat: 17.4993771695186, lng: 78.53788195921146 },
        { lat: 17.49928098519601, lng: 78.53821946939607 },
        { lat: 17.49924478185288, lng: 78.53821055469274 },
        { lat: 17.49924913888401, lng: 78.53846728959799 },
        { lat: 17.49962383738038, lng: 78.5385707210019 },
        { lat: 17.50004001799814, lng: 78.53867668888884 },
        { lat: 17.49992341237616, lng: 78.53914049432382 },
        { lat: 17.49987897492736, lng: 78.53927810146125 },
        { lat: 17.49988927133937, lng: 78.53928142578341 },
        { lat: 17.49984656486831, lng: 78.53941863681294 },
        { lat: 17.49917047460637, lng: 78.53924344489387 },
        { lat: 17.49816117907966, lng: 78.5389855763096 },
        { lat: 17.49781736585754, lng: 78.53881836666429 },
        { lat: 17.49725875653777, lng: 78.53867397161939 },
        { lat: 17.49705117121371, lng: 78.53947121980745 },
        { lat: 17.49697024134271, lng: 78.53949721447948 },
        { lat: 17.49692052788154, lng: 78.5395352408973 },
        { lat: 17.49692044052502, lng: 78.53991379052779 },
        { lat: 17.49686629172909, lng: 78.54036528865551 },
        { lat: 17.49669384489187, lng: 78.5409130164819 },
        { lat: 17.49667112370012, lng: 78.54100795926547 },
        { lat: 17.49653019785324, lng: 78.5412066021355 },
        { lat: 17.49625287682034, lng: 78.54158389847296 },
        { lat: 17.49621131746235, lng: 78.54170150781593 },
        { lat: 17.49637555279039, lng: 78.54184125600075 },
        { lat: 17.4967555118196, lng: 78.54203288868035 },
        { lat: 17.49706841507393, lng: 78.54221297463131 },
        { lat: 17.4972767082911, lng: 78.54243680451546 },
        { lat: 17.49737618457305, lng: 78.54255749911454 },
        { lat: 17.49742816491244, lng: 78.54250948135497 },
        { lat: 17.49745117671504, lng: 78.5424945558047 },
        { lat: 17.49750385162531, lng: 78.54257703725972 },
        { lat: 17.49761437902368, lng: 78.54301138192744 },
        { lat: 17.49772649550329, lng: 78.54338095268443 },
        { lat: 17.49786093137712, lng: 78.54362321093309 },
        { lat: 17.49793635921184, lng: 78.54387699509928 },
        { lat: 17.49791208973174, lng: 78.54387817785218 },
        { lat: 17.49775610362414, lng: 78.54382548454684 },
        { lat: 17.49707973527468, lng: 78.54362786691243 },
        { lat: 17.49682402045563, lng: 78.54420659868163 },
        { lat: 17.49657001561112, lng: 78.54473051559378 },
        { lat: 17.49733142590507, lng: 78.54504155440944 },
        { lat: 17.49717800130353, lng: 78.54539888140945 },
        { lat: 17.49692912496384, lng: 78.54598997099053 },
        { lat: 17.49690682720268, lng: 78.54604207242487 },
        { lat: 17.49692393706152, lng: 78.5460884639386 },
        { lat: 17.49758167444878, lng: 78.54622905967909 },
        { lat: 17.49857007042757, lng: 78.54643993246147 },
        { lat: 17.49908407309854, lng: 78.54655257310054 },
        { lat: 17.49993393098931, lng: 78.54673595990747 },
        { lat: 17.50000407879513, lng: 78.54712749629313 },
        { lat: 17.4983420512038, lng: 78.54788169326588 },
        { lat: 17.49829781789248, lng: 78.5483634473077 },
        { lat: 17.49829260554298, lng: 78.54852191045828 },
        { lat: 17.49827880779208, lng: 78.54903015331291 },
        { lat: 17.49829117455036, lng: 78.54997363039448 },
        { lat: 17.49832523080147, lng: 78.55011886741232 },
        { lat: 17.49846745306575, lng: 78.5503149549862 },
        { lat: 17.49916929278836, lng: 78.55141506066968 },
        { lat: 17.49938990382662, lng: 78.55157274294598 },
        { lat: 17.50004700374408, lng: 78.55195245558163 },
        { lat: 17.50035975309119, lng: 78.55231437053608 },
        { lat: 17.50041375378527, lng: 78.55262371720373 },
        { lat: 17.50063345317376, lng: 78.55299808736848 },
        { lat: 17.50102769194169, lng: 78.55331148777371 },
        { lat: 17.50094222087481, lng: 78.55343425181805 },
        { lat: 17.50140219988461, lng: 78.554108007102 },
        { lat: 17.50240095619582, lng: 78.55545073971213 },
        { lat: 17.50253972968321, lng: 78.55565808751683 },
        { lat: 17.50294048734585, lng: 78.55586882480094 },
        { lat: 17.50447416527885, lng: 78.55669509878733 },
        { lat: 17.50481695650402, lng: 78.55687730742453 },
        { lat: 17.50518126495343, lng: 78.55686620986462 },
        { lat: 17.50518594253756, lng: 78.55685225338728 },
        { lat: 17.5054991045136, lng: 78.55688567344667 },
        { lat: 17.50571193136962, lng: 78.55694509168292 },
        { lat: 17.50612747652357, lng: 78.55697066520791 },
        { lat: 17.50672070967262, lng: 78.55703251870209 },
        { lat: 17.50758431662853, lng: 78.557078703988 },
        { lat: 17.50764096448816, lng: 78.5570784724761 },
        { lat: 17.50785271998252, lng: 78.55709930050412 },
        { lat: 17.50785990183566, lng: 78.55700331618695 },
        { lat: 17.50788027084643, lng: 78.55681375610247 },
        { lat: 17.50790028750471, lng: 78.55669269420166 },
        { lat: 17.50792820648224, lng: 78.55653416398741 },
        { lat: 17.50798949917467, lng: 78.55617469575523 },
        { lat: 17.50802140180652, lng: 78.55604849032517 },
        { lat: 17.50805677666909, lng: 78.55571925521579 },
        { lat: 17.50816595118869, lng: 78.55501149411198 },
        { lat: 17.5084019792219, lng: 78.55356065828259 },
        { lat: 17.50840175313827, lng: 78.55356063589507 },
        { lat: 17.50841296173777, lng: 78.55354302018208 },
        { lat: 17.50850225862648, lng: 78.5529775657631 },
        { lat: 17.50855083825661, lng: 78.55266995232324 },
        { lat: 17.50828402975394, lng: 78.55258386553601 },
        { lat: 17.50823991191925, lng: 78.55179741960228 },
        { lat: 17.50825016193364, lng: 78.55135003329016 },
        { lat: 17.50835831054428, lng: 78.55136053820193 },
        { lat: 17.50846733471398, lng: 78.5513645578113 },
        { lat: 17.5084823727903, lng: 78.55136435618131 },
        { lat: 17.50856969223025, lng: 78.55135504754826 },
        { lat: 17.50871678996501, lng: 78.55126839443294 },
        { lat: 17.50884031369197, lng: 78.55120795912468 },
        { lat: 17.5089436291651, lng: 78.55082700268174 },
        { lat: 17.50897203582413, lng: 78.55065028554834 },
        { lat: 17.50899882662289, lng: 78.5504975000404 },
        { lat: 17.50903588081957, lng: 78.55024694405479 },
        { lat: 17.50915533193856, lng: 78.55004577126702 },
        { lat: 17.50924921839409, lng: 78.54925769733411 },
        { lat: 17.50921110949176, lng: 78.54880391886572 },
        { lat: 17.50931803177529, lng: 78.5487925205555 },
        { lat: 17.50926523672764, lng: 78.54823333622338 },
        { lat: 17.51058667629901, lng: 78.54810799836267 },
        { lat: 17.5106262616382, lng: 78.54821705446808 },
        { lat: 17.51082344785862, lng: 78.54822217388332 },
        { lat: 17.51095630944068, lng: 78.54822038992815 },
        { lat: 17.51411692486957, lng: 78.54813311285979 },
        { lat: 17.5141099963755, lng: 78.54792062635292 },
        { lat: 17.5140825513702, lng: 78.54773045748986 },
        { lat: 17.51473471743031, lng: 78.54771048919169 },
        { lat: 17.51550772725401, lng: 78.54760670225141 },
        { lat: 17.51580051280568, lng: 78.54751310225497 },
        { lat: 17.51588835322983, lng: 78.5477104198225 },
        { lat: 17.51686806199576, lng: 78.5474701036309 },
        { lat: 17.51680672433864, lng: 78.54714812972401 },
        { lat: 17.51660563333404, lng: 78.54610393234938 },
        { lat: 17.51658975486496, lng: 78.54608512156724 },
        { lat: 17.51656308737823, lng: 78.54586131524539 },
        { lat: 17.5174930990317, lng: 78.54569936711796 },
        { lat: 17.51769263283489, lng: 78.54516740064113 },
        { lat: 17.5175962475031, lng: 78.54510331628387 },
        { lat: 17.51767563576932, lng: 78.54475977175053 },
        { lat: 17.51777715714697, lng: 78.54479353088753 },
        { lat: 17.5177790300346, lng: 78.54479145630947 },
        { lat: 17.51868012233712, lng: 78.54513993042453 },
        { lat: 17.51975729387852, lng: 78.54552396512223 },
        { lat: 17.51953920220229, lng: 78.54624610606041 },
        { lat: 17.52058440721178, lng: 78.54642067826376 },
      ],
    ],
  },
  {
    name: "CHARMINAR ZONE",
    color: "#1abc9c",
    polygons: [
      [
        { lat: 17.38681288623838, lng: 78.50968139177075 },
        { lat: 17.38683232114828, lng: 78.50961071276977 },
        { lat: 17.38689460386119, lng: 78.50935702096969 },
        { lat: 17.3868936978027, lng: 78.50920047684563 },
        { lat: 17.38689379811685, lng: 78.50912124156214 },
        { lat: 17.38693912314652, lng: 78.50895480576474 },
        { lat: 17.3869499032821, lng: 78.5089143796536 },
        { lat: 17.3869925968279, lng: 78.50872506148325 },
        { lat: 17.3870195292238, lng: 78.5086167822732 },
        { lat: 17.38701987787719, lng: 78.50846977472987 },
        { lat: 17.38702040338055, lng: 78.50842331656051 },
        { lat: 17.38702237585235, lng: 78.50831421359916 },
        { lat: 17.38694609162106, lng: 78.50827379825874 },
        { lat: 17.38691588000256, lng: 78.50829831905949 },
        { lat: 17.38688400493589, lng: 78.508368726408 },
        { lat: 17.3864581866375, lng: 78.50831808221533 },
        { lat: 17.38643068649115, lng: 78.50829023040383 },
        { lat: 17.38641322636034, lng: 78.50825180858101 },
        { lat: 17.38639340775567, lng: 78.50820606633532 },
        { lat: 17.38637921296731, lng: 78.5081578981108 },
        { lat: 17.38636841004336, lng: 78.50810982694023 },
        { lat: 17.38635539356901, lng: 78.50806546382326 },
        { lat: 17.38634586064799, lng: 78.50802796189936 },
        { lat: 17.38634377893427, lng: 78.50786805161297 },
        { lat: 17.38635159875527, lng: 78.50777386434794 },
        { lat: 17.38634157424257, lng: 78.50769873807712 },
        { lat: 17.38634059470887, lng: 78.50762348552897 },
        { lat: 17.38633750246227, lng: 78.50755958176708 },
        { lat: 17.38632971345898, lng: 78.50748251377445 },
        { lat: 17.3863377788962, lng: 78.50740713870569 },
        { lat: 17.38635703874856, lng: 78.50732323238182 },
        { lat: 17.38637211906641, lng: 78.50726554866813 },
        { lat: 17.38638898364766, lng: 78.50717123885231 },
        { lat: 17.3863816696325, lng: 78.50713061772719 },
        { lat: 17.38639406853064, lng: 78.5070407802064 },
        { lat: 17.38641733841748, lng: 78.50700429946377 },
        { lat: 17.38645412267282, lng: 78.5069635210506 },
        { lat: 17.38648527578056, lng: 78.5069245817626 },
        { lat: 17.38651168430206, lng: 78.50686850732299 },
        { lat: 17.38652928264349, lng: 78.50683063404561 },
        { lat: 17.38653771481751, lng: 78.5067834781516 },
        { lat: 17.38655531316454, lng: 78.50674560674368 },
        { lat: 17.3865695104221, lng: 78.50670704580557 },
        { lat: 17.38658374068697, lng: 78.50667098286706 },
        { lat: 17.38660888457543, lng: 78.50660478306898 },
        { lat: 17.38660487975078, lng: 78.50655765083597 },
        { lat: 17.38661081939647, lng: 78.50649288902324 },
        { lat: 17.38660779469907, lng: 78.50643427659514 },
        { lat: 17.38660153959671, lng: 78.50638805722976 },
        { lat: 17.38659538909375, lng: 78.50634992067341 },
        { lat: 17.38657082366518, lng: 78.5062870454342 },
        { lat: 17.3865416347223, lng: 78.50621629540866 },
        { lat: 17.38656439419382, lng: 78.50614057245652 },
        { lat: 17.38652880137269, lng: 78.50609916258507 },
        { lat: 17.38654150446009, lng: 78.50603269303274 },
        { lat: 17.38658676817798, lng: 78.50594857702528 },
        { lat: 17.38660551898462, lng: 78.5059123060153 },
        { lat: 17.38662543899149, lng: 78.50587910646708 },
        { lat: 17.38663387093161, lng: 78.50583195053538 },
        { lat: 17.38661979307733, lng: 78.50579289424716 },
        { lat: 17.38660575741202, lng: 78.5057570695766 },
        { lat: 17.38659254949095, lng: 78.50569786339322 },
        { lat: 17.38661701765277, lng: 78.5056666566175 },
        { lat: 17.3866584305863, lng: 78.5056340461351 },
        { lat: 17.38670328495964, lng: 78.50560521003084 },
        { lat: 17.38672931492507, lng: 78.50552018254398 },
        { lat: 17.38672808856071, lng: 78.5054261177714 },
        { lat: 17.38671843214245, lng: 78.50537920894443 },
        { lat: 17.38666138290653, lng: 78.50533985673914 },
        { lat: 17.38662664147956, lng: 78.50527697288732 },
        { lat: 17.38661710623952, lng: 78.50523947115195 },
        { lat: 17.38662504778188, lng: 78.50515468895374 },
        { lat: 17.38662794030072, lng: 78.50511643171957 },
        { lat: 17.38663294160556, lng: 78.50506638172523 },
        { lat: 17.3866322530175, lng: 78.50501347019991 },
        { lat: 17.3866223504748, lng: 78.50494774925788 },
        { lat: 17.38661232487934, lng: 78.50487262129943 },
        { lat: 17.38661498589373, lng: 78.5048164302981 },
        { lat: 17.38661773691833, lng: 78.50476729506762 },
        { lat: 17.38660962908794, lng: 78.50466568163819 },
        { lat: 17.38660852535158, lng: 78.50458102213146 },
        { lat: 17.38659898998569, lng: 78.50454352045396 },
        { lat: 17.38658933339327, lng: 78.50449661361525 },
        { lat: 17.38657063173586, lng: 78.50444982758695 },
        { lat: 17.38656097509944, lng: 78.50440291888223 },
        { lat: 17.38655119359005, lng: 78.50434660318889 },
        { lat: 17.38654923199318, lng: 78.50419610207517 },
        { lat: 17.38655754046169, lng: 78.50413953912327 },
        { lat: 17.38656560460397, lng: 78.50406416398849 },
        { lat: 17.38657403612968, lng: 78.50401700992992 },
        { lat: 17.38657047970182, lng: 78.50374422318967 },
        { lat: 17.38656094418503, lng: 78.50370672158493 },
        { lat: 17.38655116431337, lng: 78.50365040781253 },
        { lat: 17.38653246249307, lng: 78.50360362378814 },
        { lat: 17.3865229269282, lng: 78.50356612032081 },
        { lat: 17.38648576938895, lng: 78.50349136257675 },
        { lat: 17.38647149266279, lng: 78.50343702132618 },
        { lat: 17.38645475989846, lng: 78.50336786384393 },
        { lat: 17.38643566298277, lng: 78.50329080288613 },
        { lat: 17.38640808326579, lng: 78.50325692888835 },
        { lat: 17.38637331366117, lng: 78.50319184102398 },
        { lat: 17.3863544886326, lng: 78.50313565010329 },
        { lat: 17.38633578668077, lng: 78.50308886431431 },
        { lat: 17.386307918434, lng: 78.50303279802837 },
        { lat: 17.38628029458184, lng: 78.50299554389608 },
        { lat: 17.38625254758021, lng: 78.50294888090019 },
        { lat: 17.38624276751149, lng: 78.50289256729008 },
        { lat: 17.38625058493779, lng: 78.50279837831116 },
        { lat: 17.38624104928095, lng: 78.50276087872422 },
        { lat: 17.38622222592409, lng: 78.50270468599754 },
        { lat: 17.38620327765924, lng: 78.50263909008154 },
        { lat: 17.38612797867239, lng: 78.50241432508523 },
        { lat: 17.3861103446999, lng: 78.50236267481591 },
        { lat: 17.38609045315712, lng: 78.5023113505772 },
        { lat: 17.38603471440761, lng: 78.5021992147223 },
        { lat: 17.38600709042212, lng: 78.50216196078661 },
        { lat: 17.38599731012235, lng: 78.50210564544165 },
        { lat: 17.38598777429915, lng: 78.50206814219656 },
        { lat: 17.38595123024551, lng: 78.50204041803933 },
        { lat: 17.38591016003938, lng: 78.50201260859659 },
        { lat: 17.38588796488525, lng: 78.50195808169192 },
        { lat: 17.38586461698229, lng: 78.50190180386384 },
        { lat: 17.38586362062714, lng: 78.50182552482671 },
        { lat: 17.38586361511105, lng: 78.50173835436722 },
        { lat: 17.38588301042583, lng: 78.50166503061486 },
        { lat: 17.38589107365452, lng: 78.50158965578234 },
        { lat: 17.38588812818053, lng: 78.50136390352542 },
        { lat: 17.38585915257685, lng: 78.50122317877641 },
        { lat: 17.38586721566082, lng: 78.50114780583867 },
        { lat: 17.38586586589215, lng: 78.50104433483736 },
        { lat: 17.38587429670932, lng: 78.50099718092356 },
        { lat: 17.3858735592713, lng: 78.50094074101742 },
        { lat: 17.38586390187854, lng: 78.5008938346657 },
        { lat: 17.38585411942859, lng: 78.50083751950541 },
        { lat: 17.38583541698285, lng: 78.5007907341456 },
        { lat: 17.38581892613059, lng: 78.50074009773442 },
        { lat: 17.38580239296709, lng: 78.5006862278688 },
        { lat: 17.38578469237634, lng: 78.50062958006919 },
        { lat: 17.38577051057526, lng: 78.5005825884803 },
        { lat: 17.38575520362744, lng: 78.50053605053866 },
        { lat: 17.38574104571775, lng: 78.50049096821127 },
        { lat: 17.38573138820286, lng: 78.50044406004974 },
        { lat: 17.38572185213198, lng: 78.50040656074877 },
        { lat: 17.38570253703081, lng: 78.50031274257503 },
        { lat: 17.38569720887037, lng: 78.500251076649 },
        { lat: 17.38570296806332, lng: 78.50017264779189 },
        { lat: 17.3856818681098, lng: 78.50011545929503 },
        { lat: 17.38567221051096, lng: 78.5000685511802 },
        { lat: 17.3856439128324, lng: 78.49997970713032 },
        { lat: 17.38558985727624, lng: 78.49990988734899 },
        { lat: 17.38557002217011, lng: 78.49986297082023 },
        { lat: 17.38554239780398, lng: 78.49982571738093 },
        { lat: 17.38553274014334, lng: 78.4997788093254 },
        { lat: 17.38554055615221, lng: 78.49968462266779 },
        { lat: 17.3854767480769, lng: 78.49964742261344 },
        { lat: 17.38544691390218, lng: 78.4996140202689 },
        { lat: 17.3854079151508, lng: 78.49957162924503 },
        { lat: 17.38537542599174, lng: 78.49950812952352 },
        { lat: 17.38533863329446, lng: 78.49946159218032 },
        { lat: 17.38526603409769, lng: 78.49944377101465 },
        { lat: 17.38519294356172, lng: 78.49938832029628 },
        { lat: 17.38513806451024, lng: 78.49934203258556 },
        { lat: 17.38507414043088, lng: 78.49929586594767 },
        { lat: 17.38500080333982, lng: 78.49922160529665 },
        { lat: 17.38490033307023, lng: 78.49914771536028 },
        { lat: 17.38486378870241, lng: 78.49911999197421 },
        { lat: 17.38483628569183, lng: 78.4990921438316 },
        { lat: 17.38479974131871, lng: 78.49906442046554 },
        { lat: 17.384747246425, lng: 78.49901126470219 },
        { lat: 17.38471725751381, lng: 78.49898570234096 },
        { lat: 17.38426362406604, lng: 78.49870996367687 },
        { lat: 17.38416092161111, lng: 78.49863338892811 },
        { lat: 17.38413361339839, lng: 78.49862195291418 },
        { lat: 17.38408765588385, lng: 78.49856613399203 },
        { lat: 17.38406003133532, lng: 78.4985288810508 },
        { lat: 17.38403796415851, lng: 78.49848420034077 },
        { lat: 17.38401358055374, lng: 78.4984354366675 },
        { lat: 17.38399487765626, lng: 78.49838865395405 },
        { lat: 17.38395624402884, lng: 78.49820102381976 },
        { lat: 17.38395562920765, lng: 78.49815399146495 },
        { lat: 17.38394597123915, lng: 78.4981070858264 },
        { lat: 17.3839272682474, lng: 78.49806030129231 },
        { lat: 17.38390397837576, lng: 78.49800873095573 },
        { lat: 17.38384402612542, lng: 78.49792032232949 },
        { lat: 17.38379806664097, lng: 78.49786450371256 },
        { lat: 17.38374318730867, lng: 78.49781821491835 },
        { lat: 17.38367926300502, lng: 78.49777205102338 },
        { lat: 17.38362438365806, lng: 78.49772576228474 },
        { lat: 17.38355104612816, lng: 78.49765150284678 },
        { lat: 17.38347795526391, lng: 78.49759605521395 },
        { lat: 17.38343673360937, lng: 78.49755663580362 },
        { lat: 17.38339008716225, lng: 78.49753478458548 },
        { lat: 17.38334069334896, lng: 78.49747563217178 },
        { lat: 17.38330005545931, lng: 78.4973943116462 },
        { lat: 17.3832122296387, lng: 78.49733627270055 },
        { lat: 17.38315747358658, lng: 78.49729939099939 },
        { lat: 17.3830673128321, lng: 78.49723565151973 },
        { lat: 17.38299199198846, lng: 78.49718273478457 },
        { lat: 17.3827648821183, lng: 78.4970225273607 },
        { lat: 17.38267296459708, lng: 78.49691089311095 },
        { lat: 17.38260983926465, lng: 78.49683928733049 },
        { lat: 17.38245258475232, lng: 78.49665989863884 },
        { lat: 17.38226874932141, lng: 78.49643662912733 },
        { lat: 17.38217732328694, lng: 78.49636261681698 },
        { lat: 17.38209981469895, lng: 78.49631531603634 },
        { lat: 17.38206884583646, lng: 78.49628178353699 },
        { lat: 17.38204018424721, lng: 78.49625160224677 },
        { lat: 17.38201231251486, lng: 78.49619553474734 },
        { lat: 17.38201169730884, lng: 78.49614850484264 },
        { lat: 17.38201252176381, lng: 78.49603854074685 },
        { lat: 17.38195373817211, lng: 78.49595320501881 },
        { lat: 17.38194506851001, lng: 78.49589540702861 },
        { lat: 17.38194408478323, lng: 78.4958201588408 },
        { lat: 17.38193393262161, lng: 78.4957356270143 },
        { lat: 17.3819241507307, lng: 78.49567931536278 },
        { lat: 17.38191827579842, lng: 78.4956589756368 },
        { lat: 17.38171840411746, lng: 78.49559964163355 },
        { lat: 17.38167751754532, lng: 78.4955461360053 },
        { lat: 17.38165433613066, lng: 78.49553924796102 },
        { lat: 17.38158766994827, lng: 78.49554280779864 },
        { lat: 17.38155183392309, lng: 78.49548288128084 },
        { lat: 17.38155684036611, lng: 78.49543342338967 },
        { lat: 17.38156378372296, lng: 78.49535909469432 },
        { lat: 17.38158364666473, lng: 78.49532163296067 },
        { lat: 17.38159214254905, lng: 78.49527962078889 },
        { lat: 17.38156462989172, lng: 78.49525089340062 },
        { lat: 17.38152496965565, lng: 78.49524438017295 },
        { lat: 17.38148775492578, lng: 78.49525194528627 },
        { lat: 17.381391674192, lng: 78.49525443812193 },
        { lat: 17.38127267140422, lng: 78.495233282711 },
        { lat: 17.38121552857094, lng: 78.49518688125819 },
        { lat: 17.38118408970942, lng: 78.49511748861168 },
        { lat: 17.3811371326547, lng: 78.49498524619607 },
        { lat: 17.38103169551125, lng: 78.49496390633036 },
        { lat: 17.38103133757398, lng: 78.49493653461593 },
        { lat: 17.3808730463405, lng: 78.49494900234265 },
        { lat: 17.38087012185385, lng: 78.49493914937278 },
        { lat: 17.38085829182801, lng: 78.494677115694 },
        { lat: 17.3807665123196, lng: 78.49448963018024 },
        { lat: 17.38069197600336, lng: 78.49441024605835 },
        { lat: 17.38062107002662, lng: 78.49426260457301 },
        { lat: 17.3805678923697, lng: 78.49400080045045 },
        { lat: 17.38049252962911, lng: 78.49377178467586 },
        { lat: 17.38042428962934, lng: 78.49356869030369 },
        { lat: 17.38041550546989, lng: 78.49341578991083 },
        { lat: 17.38038318282193, lng: 78.49327879093346 },
        { lat: 17.38031604535444, lng: 78.49307362566257 },
        { lat: 17.38024341698614, lng: 78.49279444854862 },
        { lat: 17.38022620951887, lng: 78.49264274302219 },
        { lat: 17.38023529995158, lng: 78.49243339233014 },
        { lat: 17.38026903405391, lng: 78.49233267917577 },
        { lat: 17.38022365054291, lng: 78.49223452077588 },
        { lat: 17.3802627275839, lng: 78.49202378325201 },
        { lat: 17.38039760994901, lng: 78.49178953341927 },
        { lat: 17.38066959847248, lng: 78.49175008429216 },
        { lat: 17.38075265360445, lng: 78.4917027893934 },
        { lat: 17.3808042764774, lng: 78.49167297575696 },
        { lat: 17.38090689738487, lng: 78.49166389587991 },
        { lat: 17.38097644628305, lng: 78.49165774155173 },
        { lat: 17.38086359227559, lng: 78.49151919889947 },
        { lat: 17.38081177200944, lng: 78.49130258639781 },
        { lat: 17.38077562833719, lng: 78.49086844167024 },
        { lat: 17.38073734483181, lng: 78.48977597826581 },
        { lat: 17.38064004982646, lng: 78.48838391061544 },
        { lat: 17.3806335642576, lng: 78.48751330638058 },
        { lat: 17.38063114592648, lng: 78.4871887808672 },
        { lat: 17.38064929674784, lng: 78.48570565761092 },
        { lat: 17.38067305390144, lng: 78.48515564600012 },
        { lat: 17.38064448350291, lng: 78.48483645241527 },
        { lat: 17.38054736670722, lng: 78.48443510174252 },
        { lat: 17.38039421715812, lng: 78.48397060313535 },
        { lat: 17.38014296817408, lng: 78.48351383547677 },
        { lat: 17.37985594863117, lng: 78.48314065200863 },
        { lat: 17.37945185485761, lng: 78.48273071939882 },
        { lat: 17.37941342614193, lng: 78.48260341316279 },
        { lat: 17.37904566684479, lng: 78.48215463627497 },
        { lat: 17.37902578542075, lng: 78.48212926856529 },
        { lat: 17.37904795441647, lng: 78.48208594000309 },
        { lat: 17.37924825337887, lng: 78.48167249186298 },
        { lat: 17.37941095552798, lng: 78.48138051586417 },
        { lat: 17.37882704990214, lng: 78.48127654260591 },
        { lat: 17.3786400082558, lng: 78.48120924539644 },
        { lat: 17.37862197572031, lng: 78.48122433711171 },
        { lat: 17.37853019253846, lng: 78.48120199084208 },
        { lat: 17.37844317508259, lng: 78.48117753257543 },
        { lat: 17.37839223621389, lng: 78.48118123396007 },
        { lat: 17.37835583067782, lng: 78.48116495889337 },
        { lat: 17.37826041705821, lng: 78.48111687418638 },
        { lat: 17.37820949656686, lng: 78.48109754884607 },
        { lat: 17.37816708984086, lng: 78.48108897874417 },
        { lat: 17.3780727620274, lng: 78.48107856251215 },
        { lat: 17.37799101536682, lng: 78.48106883009244 },
        { lat: 17.37758390210818, lng: 78.48084705095056 },
        { lat: 17.37751047879262, lng: 78.48074178631528 },
        { lat: 17.37750894002401, lng: 78.48073794330529 },
        { lat: 17.37724358220773, lng: 78.48061397603747 },
        { lat: 17.37721061867211, lng: 78.48059733800478 },
        { lat: 17.37717882295565, lng: 78.48065936297684 },
        { lat: 17.37714404789782, lng: 78.48072807134908 },
        { lat: 17.37710982524436, lng: 78.4807977560247 },
        { lat: 17.37698160889721, lng: 78.48104873480384 },
        { lat: 17.37687290324104, lng: 78.48127881858143 },
        { lat: 17.37680308233517, lng: 78.48123943831301 },
        { lat: 17.37680262744583, lng: 78.48124032307307 },
        { lat: 17.37638343082022, lng: 78.48100517636196 },
        { lat: 17.37582294362171, lng: 78.48068775103965 },
        { lat: 17.37534464184735, lng: 78.48042931330127 },
        { lat: 17.37513111738329, lng: 78.48033030358418 },
        { lat: 17.3750420266468, lng: 78.48028899232267 },
        { lat: 17.37469179291774, lng: 78.48005304684192 },
        { lat: 17.37438630169707, lng: 78.47978017871615 },
        { lat: 17.3740596492043, lng: 78.47953185739513 },
        { lat: 17.37376390339544, lng: 78.47905425072005 },
        { lat: 17.37355016476182, lng: 78.47870795147175 },
        { lat: 17.3735469970215, lng: 78.47846708116838 },
        { lat: 17.37355420609728, lng: 78.47806967359422 },
        { lat: 17.3736536184815, lng: 78.47771905821972 },
        { lat: 17.37364933884296, lng: 78.47739398010262 },
        { lat: 17.37356302801978, lng: 78.47702182040926 },
        { lat: 17.3733516854712, lng: 78.47677176719515 },
        { lat: 17.37303377719845, lng: 78.47641485608365 },
        { lat: 17.37271636637725, lng: 78.47600987321113 },
        { lat: 17.37256537231592, lng: 78.4759637450425 },
        { lat: 17.37231098866647, lng: 78.47605162544177 },
        { lat: 17.37213100203584, lng: 78.47611870151795 },
        { lat: 17.37211622757654, lng: 78.47610205146432 },
        { lat: 17.3721149123119, lng: 78.47610239211359 },
        { lat: 17.3719250679871, lng: 78.47576782308066 },
        { lat: 17.37181573536002, lng: 78.4753769836588 },
        { lat: 17.37157642445975, lng: 78.47459329927585 },
        { lat: 17.37134062051341, lng: 78.47378726415228 },
        { lat: 17.37131912510705, lng: 78.47371705281257 },
        { lat: 17.37131472815048, lng: 78.47369875762638 },
        { lat: 17.37130667383502, lng: 78.47367122622519 },
        { lat: 17.37120510730009, lng: 78.47324267122724 },
        { lat: 17.37117197734288, lng: 78.47310483088239 },
        { lat: 17.37100600219752, lng: 78.47243106290625 },
        { lat: 17.37106470913381, lng: 78.47267909388039 },
        { lat: 17.37099059710759, lng: 78.47236852905839 },
        { lat: 17.37087928648978, lng: 78.4719166731524 },
        { lat: 17.37081748321448, lng: 78.47168881748216 },
        { lat: 17.37074455091744, lng: 78.47138865250504 },
        { lat: 17.37073091518981, lng: 78.47133020961493 },
        { lat: 17.370692071041, lng: 78.47118107886361 },
        { lat: 17.37051918210747, lng: 78.47042272796001 },
        { lat: 17.37046170987251, lng: 78.47017640589483 },
        { lat: 17.37040143333413, lng: 78.46980049686819 },
        { lat: 17.37026731906213, lng: 78.46913075463637 },
        { lat: 17.37025006220632, lng: 78.46904725416853 },
        { lat: 17.37024574201962, lng: 78.46889136414322 },
        { lat: 17.37021535275113, lng: 78.4687306893761 },
        { lat: 17.37012899748695, lng: 78.46809940908453 },
        { lat: 17.37007061046389, lng: 78.46768853734527 },
        { lat: 17.3700023072553, lng: 78.46728841013284 },
        { lat: 17.36999776350217, lng: 78.466930114039 },
        { lat: 17.37001620366565, lng: 78.46669138737802 },
        { lat: 17.37003693323252, lng: 78.46635142162351 },
        { lat: 17.37004502918344, lng: 78.46624090291215 },
        { lat: 17.37005405828871, lng: 78.46609316792016 },
        { lat: 17.3700336766643, lng: 78.4656885268979 },
        { lat: 17.37002541720196, lng: 78.46556262823418 },
        { lat: 17.37000736923667, lng: 78.46542686413329 },
        { lat: 17.36999040642408, lng: 78.4653754065284 },
        { lat: 17.36993191175617, lng: 78.4652496124094 },
        { lat: 17.36988241493345, lng: 78.46509772722477 },
        { lat: 17.36978764541292, lng: 78.46477156042613 },
        { lat: 17.36971945744662, lng: 78.46452972552034 },
        { lat: 17.36964005872577, lng: 78.46425707878711 },
        { lat: 17.36954385016725, lng: 78.46394977149177 },
        { lat: 17.36948255794378, lng: 78.46371639401804 },
        { lat: 17.36916906353511, lng: 78.46264122602976 },
        { lat: 17.36901158856044, lng: 78.46209798772195 },
        { lat: 17.36900104120688, lng: 78.46206444294046 },
        { lat: 17.36893339722263, lng: 78.4618231531872 },
        { lat: 17.36887520956087, lng: 78.46169843669922 },
        { lat: 17.36880173054947, lng: 78.46161420600664 },
        { lat: 17.36878739130502, lng: 78.46155605290814 },
        { lat: 17.36876925907386, lng: 78.46136987267663 },
        { lat: 17.36873135211119, lng: 78.4612934673879 },
        { lat: 17.36862521211374, lng: 78.46121529571316 },
        { lat: 17.36849907304707, lng: 78.4610677201111 },
        { lat: 17.3684586935246, lng: 78.46089905360947 },
        { lat: 17.36843480182448, lng: 78.4607772284291 },
        { lat: 17.36843214009432, lng: 78.46077168382996 },
        { lat: 17.36840054686297, lng: 78.46069127998375 },
        { lat: 17.36839876698459, lng: 78.46055681737973 },
        { lat: 17.36836158582533, lng: 78.46031069602198 },
        { lat: 17.36833368261604, lng: 78.46016748155142 },
        { lat: 17.36831083723319, lng: 78.46006461704913 },
        { lat: 17.36832082774168, lng: 78.46001087671745 },
        { lat: 17.36830179787605, lng: 78.45983610738243 },
        { lat: 17.3683073042712, lng: 78.45951749461574 },
        { lat: 17.36830580433554, lng: 78.45939956432312 },
        { lat: 17.3683010352257, lng: 78.45932469848456 },
        { lat: 17.36827378469038, lng: 78.45923086034625 },
        { lat: 17.36825134050087, lng: 78.45908558725633 },
        { lat: 17.36819339945734, lng: 78.45898797675191 },
        { lat: 17.36813194329173, lng: 78.45893680789096 },
        { lat: 17.36811766485945, lng: 78.45888320865419 },
        { lat: 17.36812076094169, lng: 78.4587755772651 },
        { lat: 17.36815872235461, lng: 78.45865393582636 },
        { lat: 17.36813492584602, lng: 78.45847935780212 },
        { lat: 17.36812016933953, lng: 78.45838975685761 },
        { lat: 17.3680977394827, lng: 78.45831833935735 },
        { lat: 17.3681047637694, lng: 78.45816582301397 },
        { lat: 17.36807674137957, lng: 78.45801364362191 },
        { lat: 17.36806486042346, lng: 78.45796989010002 },
        { lat: 17.36696885623215, lng: 78.45837046637975 },
        { lat: 17.36692894010755, lng: 78.45825946194886 },
        { lat: 17.36686389689754, lng: 78.45812940447385 },
        { lat: 17.36680704029907, lng: 78.45793456271915 },
        { lat: 17.36681615955828, lng: 78.45785477212863 },
        { lat: 17.36679305497617, lng: 78.45779762609975 },
        { lat: 17.36678927167029, lng: 78.45778826903417 },
        { lat: 17.3666979278736, lng: 78.45772133876619 },
        { lat: 17.36650943530684, lng: 78.45766134281519 },
        { lat: 17.36639558889345, lng: 78.45760280917754 },
        { lat: 17.36624579605486, lng: 78.4575621182735 },
        { lat: 17.36604719162734, lng: 78.45750696581624 },
        { lat: 17.36581828690447, lng: 78.45738374294284 },
        { lat: 17.36573946922252, lng: 78.45732354671422 },
        { lat: 17.36571709421602, lng: 78.45725624628959 },
        { lat: 17.36555413357335, lng: 78.45716047390447 },
        { lat: 17.36547568099312, lng: 78.45712775834374 },
        { lat: 17.36543590482699, lng: 78.45711258431325 },
        { lat: 17.36538944316858, lng: 78.45710485198339 },
        { lat: 17.36525755575724, lng: 78.45705009692229 },
        { lat: 17.36523636733031, lng: 78.45698704287331 },
        { lat: 17.36518124806988, lng: 78.45692328437738 },
        { lat: 17.36519289440962, lng: 78.45686359570368 },
        { lat: 17.36513816835819, lng: 78.45682952194365 },
        { lat: 17.36508495954362, lng: 78.45682452857758 },
        { lat: 17.36506065206552, lng: 78.4567820976828 },
        { lat: 17.36504688731687, lng: 78.45668204660932 },
        { lat: 17.36492946553295, lng: 78.45669499555619 },
        { lat: 17.36491299741325, lng: 78.45664686779133 },
        { lat: 17.36485725093243, lng: 78.45662103890335 },
        { lat: 17.36479243452768, lng: 78.45659342594902 },
        { lat: 17.36472095847387, lng: 78.45640466907388 },
        { lat: 17.36468987971901, lng: 78.45627796349304 },
        { lat: 17.36460094065464, lng: 78.45622187785303 },
        { lat: 17.36445885071266, lng: 78.4561652075285 },
        { lat: 17.36438492690597, lng: 78.4561328701813 },
        { lat: 17.36428900807491, lng: 78.4560620365585 },
        { lat: 17.36420050152934, lng: 78.45603857333403 },
        { lat: 17.3641324259799, lng: 78.4560210007516 },
        { lat: 17.36407558660685, lng: 78.45599815180289 },
        { lat: 17.36402331998888, lng: 78.45597714148778 },
        { lat: 17.36396298038803, lng: 78.45594780793162 },
        { lat: 17.3638518003415, lng: 78.455919810354 },
        { lat: 17.36373961022886, lng: 78.45590093865111 },
        { lat: 17.36368585479049, lng: 78.45594004723074 },
        { lat: 17.3636459018328, lng: 78.45599674788451 },
        { lat: 17.36361504124132, lng: 78.4560569966966 },
        { lat: 17.36358251569014, lng: 78.45607699668456 },
        { lat: 17.36352355117241, lng: 78.45606429442836 },
        { lat: 17.36348625383578, lng: 78.45606554773386 },
        { lat: 17.36344782211215, lng: 78.45606637653118 },
        { lat: 17.36341438101842, lng: 78.45601730978491 },
        { lat: 17.3633094118537, lng: 78.45594615944742 },
        { lat: 17.36326393412458, lng: 78.45592739080473 },
        { lat: 17.36324539060066, lng: 78.45589325534907 },
        { lat: 17.36322664343494, lng: 78.45584383718266 },
        { lat: 17.36316379767672, lng: 78.45570905019581 },
        { lat: 17.36309470547902, lng: 78.45570001585989 },
        { lat: 17.36300887308551, lng: 78.4557076757514 },
        { lat: 17.36293512400079, lng: 78.45568856492122 },
        { lat: 17.3627993316406, lng: 78.45568045730563 },
        { lat: 17.36269093584005, lng: 78.45577705766165 },
        { lat: 17.36257914004872, lng: 78.45578801795982 },
        { lat: 17.36253493020082, lng: 78.45577951940224 },
        { lat: 17.36240602800788, lng: 78.45569415281679 },
        { lat: 17.36230590909103, lng: 78.45564762955756 },
        { lat: 17.36227178207392, lng: 78.45563208363296 },
        { lat: 17.36223073136399, lng: 78.45560605051251 },
        { lat: 17.36216574391338, lng: 78.45556550737773 },
        { lat: 17.36205489933262, lng: 78.45547753946614 },
        { lat: 17.36200776588196, lng: 78.45533400870185 },
        { lat: 17.36195378900186, lng: 78.45527111724813 },
        { lat: 17.36188836981499, lng: 78.45519809733803 },
        { lat: 17.36177920879711, lng: 78.45506660068955 },
        { lat: 17.36168418207598, lng: 78.45497782507522 },
        { lat: 17.3616134854968, lng: 78.45493309773467 },
        { lat: 17.36153111669585, lng: 78.45486090096234 },
        { lat: 17.36147292739312, lng: 78.45473619195283 },
        { lat: 17.36138012248888, lng: 78.45464444589071 },
        { lat: 17.36125805861766, lng: 78.45456310090292 },
        { lat: 17.36113120263702, lng: 78.4545467868023 },
        { lat: 17.36108767662034, lng: 78.45450462165496 },
        { lat: 17.36097661709602, lng: 78.45448573620051 },
        { lat: 17.36090377423808, lng: 78.4544497104361 },
        { lat: 17.36082638470618, lng: 78.45441183825233 },
        { lat: 17.36077223100722, lng: 78.4543357224486 },
        { lat: 17.3607346514164, lng: 78.45431566775407 },
        { lat: 17.36068453906013, lng: 78.45428843887596 },
        { lat: 17.36058041970362, lng: 78.45419611611203 },
        { lat: 17.36050353445384, lng: 78.4541110570133 },
        { lat: 17.36043563596871, lng: 78.45402161140167 },
        { lat: 17.36041821627342, lng: 78.45398702003567 },
        { lat: 17.36036227800449, lng: 78.45394679201846 },
        { lat: 17.36031142561471, lng: 78.45377862400572 },
        { lat: 17.36031316233602, lng: 78.45373906447537 },
        { lat: 17.36031638520421, lng: 78.45364113385486 },
        { lat: 17.36030726784528, lng: 78.45355057623252 },
        { lat: 17.36022191475308, lng: 78.45342389449198 },
        { lat: 17.36018536860109, lng: 78.45331123298014 },
        { lat: 17.36011652535302, lng: 78.45323591144769 },
        { lat: 17.36009254374513, lng: 78.45304767440722 },
        { lat: 17.36004068541927, lng: 78.45297417422708 },
        { lat: 17.36001613690162, lng: 78.45282842065689 },
        { lat: 17.35997068603371, lng: 78.45272646423459 },
        { lat: 17.35993372897699, lng: 78.45258294390982 },
        { lat: 17.35989129678163, lng: 78.45253811779072 },
        { lat: 17.35986261494221, lng: 78.45250691774457 },
        { lat: 17.35972881545119, lng: 78.452478501673 },
        { lat: 17.35972071129082, lng: 78.45237911315265 },
        { lat: 17.35967921600637, lng: 78.45231957867968 },
        { lat: 17.35959741117009, lng: 78.45220475206006 },
        { lat: 17.35956274583841, lng: 78.45206355176184 },
        { lat: 17.35960979333556, lng: 78.45194516994505 },
        { lat: 17.35957084213836, lng: 78.4518218121564 },
        { lat: 17.35951582272255, lng: 78.45176569929718 },
        { lat: 17.35947966537124, lng: 78.45159732871502 },
        { lat: 17.35941908870148, lng: 78.45146324833367 },
        { lat: 17.35943832868782, lng: 78.45137949975602 },
        { lat: 17.35940790885841, lng: 78.45130261429193 },
        { lat: 17.35937886029955, lng: 78.45115869010785 },
        { lat: 17.3593323856967, lng: 78.4510648323772 },
        { lat: 17.35930547449011, lng: 78.45099671670731 },
        { lat: 17.35925708408743, lng: 78.4508438018508 },
        { lat: 17.35920749280688, lng: 78.45068561333933 },
        { lat: 17.35919915192992, lng: 78.45056844449174 },
        { lat: 17.35919354854966, lng: 78.45048709843476 },
        { lat: 17.35917275398098, lng: 78.450198583328 },
        { lat: 17.35915064868955, lng: 78.44989656573667 },
        { lat: 17.35919470200869, lng: 78.44929776777808 },
        { lat: 17.35931421001342, lng: 78.44893146175698 },
        { lat: 17.35939413832167, lng: 78.44864992206269 },
        { lat: 17.35945781461362, lng: 78.4483367136136 },
        { lat: 17.35959929962963, lng: 78.44817777420835 },
        { lat: 17.36016188021635, lng: 78.44779955865204 },
        { lat: 17.36052964319875, lng: 78.44756603421268 },
        { lat: 17.36066444183639, lng: 78.4474994869784 },
        { lat: 17.36085080912468, lng: 78.44731464023278 },
        { lat: 17.36118472918907, lng: 78.44691712023152 },
        { lat: 17.36143397723582, lng: 78.44669935480222 },
        { lat: 17.36184787086536, lng: 78.44627896419946 },
        { lat: 17.36197157664187, lng: 78.44614363755657 },
        { lat: 17.36246221288306, lng: 78.44562752172062 },
        { lat: 17.36293852571374, lng: 78.44522462829943 },
        { lat: 17.36337568351545, lng: 78.44493824358621 },
        { lat: 17.36351864364241, lng: 78.44480543933481 },
        { lat: 17.36370040556752, lng: 78.44461462480672 },
        { lat: 17.36400038829894, lng: 78.44430119727505 },
        { lat: 17.36422196301291, lng: 78.44412834563151 },
        { lat: 17.36440908510192, lng: 78.44391555505207 },
        { lat: 17.36472287651061, lng: 78.44362030495307 },
        { lat: 17.36479990846865, lng: 78.44354632780623 },
        { lat: 17.36489907946382, lng: 78.4435215737349 },
        { lat: 17.36527974705246, lng: 78.44323876367291 },
        { lat: 17.36564510058223, lng: 78.44290986702224 },
        { lat: 17.36599873919879, lng: 78.44272002850592 },
        { lat: 17.36642267127691, lng: 78.44237487808442 },
        { lat: 17.36735478658095, lng: 78.441558757353 },
        { lat: 17.36764727267801, lng: 78.44127717063373 },
        { lat: 17.3678829577259, lng: 78.44106046103427 },
        { lat: 17.36805609506585, lng: 78.44090150707716 },
        { lat: 17.36853973200263, lng: 78.44054008046034 },
        { lat: 17.36896499727691, lng: 78.44021048253767 },
        { lat: 17.36912593521054, lng: 78.44006948126378 },
        { lat: 17.36929442133611, lng: 78.43990103668062 },
        { lat: 17.37005662597905, lng: 78.43914146626236 },
        { lat: 17.37056983392992, lng: 78.43863002630772 },
        { lat: 17.37071265862321, lng: 78.43848751263235 },
        { lat: 17.37075155799251, lng: 78.4384369939597 },
        { lat: 17.37080376833984, lng: 78.43836718168518 },
        { lat: 17.37084262907522, lng: 78.43831372424856 },
        { lat: 17.37089038765061, lng: 78.43824926542902 },
        { lat: 17.3709437143786, lng: 78.43817840760663 },
        { lat: 17.37100591443487, lng: 78.4380946393706 },
        { lat: 17.37113818943145, lng: 78.43800886062394 },
        { lat: 17.37122674360927, lng: 78.43795117984031 },
        { lat: 17.37132092052721, lng: 78.43789121514796 },
        { lat: 17.3713913280495, lng: 78.43782937830444 },
        { lat: 17.3714594433484, lng: 78.43776522283764 },
        { lat: 17.37153012372278, lng: 78.43772381208623 },
        { lat: 17.37162618433097, lng: 78.43763560120499 },
        { lat: 17.37166089990263, lng: 78.43761042174847 },
        { lat: 17.3717288513722, lng: 78.43753406831594 },
        { lat: 17.3717634078693, lng: 78.43749698536864 },
        { lat: 17.37181341691091, lng: 78.43743175917392 },
        { lat: 17.37186437480582, lng: 78.43735285050451 },
        { lat: 17.37192807585173, lng: 78.43729684028385 },
        { lat: 17.37200281812978, lng: 78.43722097902916 },
        { lat: 17.37206092744771, lng: 78.43716960358508 },
        { lat: 17.37211335280423, lng: 78.43711595485986 },
        { lat: 17.37217924429664, lng: 78.43705462236161 },
        { lat: 17.37224714275705, lng: 78.43697430005282 },
        { lat: 17.37230932806144, lng: 78.43688950204098 },
        { lat: 17.37235247996207, lng: 78.43681878679165 },
        { lat: 17.37240432053064, lng: 78.43672134566576 },
        { lat: 17.37244411172819, lng: 78.43665302854785 },
        { lat: 17.37249526790674, lng: 78.43658896257166 },
        { lat: 17.37253525770138, lng: 78.43653548761776 },
        { lat: 17.37258416966442, lng: 78.43647277526108 },
        { lat: 17.37263463372197, lng: 78.43635698096418 },
        { lat: 17.37266524176911, lng: 78.4362783578176 },
        { lat: 17.37272611851645, lng: 78.43626486334041 },
        { lat: 17.37275592584158, lng: 78.43629545889691 },
        { lat: 17.37276410947531, lng: 78.43640014412703 },
        { lat: 17.37277065122506, lng: 78.43646663595611 },
        { lat: 17.37280595791436, lng: 78.43648569039154 },
        { lat: 17.37287091821979, lng: 78.43643936213289 },
        { lat: 17.37296229566399, lng: 78.43633916170282 },
        { lat: 17.37307113132222, lng: 78.43619168202993 },
        { lat: 17.37314073673143, lng: 78.436069886156 },
        { lat: 17.37318940082398, lng: 78.4359886570679 },
        { lat: 17.37322144812802, lng: 78.43593308862296 },
        { lat: 17.37325016303181, lng: 78.43588197690534 },
        { lat: 17.37328337009082, lng: 78.43582859791549 },
        { lat: 17.37328806134452, lng: 78.43575665692298 },
        { lat: 17.37329728238752, lng: 78.43568523976167 },
        { lat: 17.37332011281514, lng: 78.43553220024341 },
        { lat: 17.37333534302736, lng: 78.43540293886763 },
        { lat: 17.37328143570699, lng: 78.43526112166457 },
        { lat: 17.3732806198876, lng: 78.43520013322009 },
        { lat: 17.37327999725233, lng: 78.43506903191232 },
        { lat: 17.37323935322562, lng: 78.43498905417556 },
        { lat: 17.37324053937879, lng: 78.4349086376534 },
        { lat: 17.37323723244046, lng: 78.43483048842702 },
        { lat: 17.37326747880138, lng: 78.43464030781968 },
        { lat: 17.37329696963549, lng: 78.43456272779798 },
        { lat: 17.37333952882085, lng: 78.43444777831047 },
        { lat: 17.37346837200255, lng: 78.43427458833352 },
        { lat: 17.37358986365456, lng: 78.43414353850008 },
        { lat: 17.37366153599652, lng: 78.43409182404767 },
        { lat: 17.37379695441718, lng: 78.43398762416128 },
        { lat: 17.37390653451173, lng: 78.43389583955626 },
        { lat: 17.37394679301197, lng: 78.4338624966538 },
        { lat: 17.37401392698017, lng: 78.43380967045721 },
        { lat: 17.37417123226959, lng: 78.43373558891606 },
        { lat: 17.37421301003255, lng: 78.43364681170912 },
        { lat: 17.37424931897113, lng: 78.4334872656331 },
        { lat: 17.37428344792838, lng: 78.43324940656822 },
        { lat: 17.37423818116429, lng: 78.43282408044215 },
        { lat: 17.37411571632558, lng: 78.43254447075927 },
        { lat: 17.37385720430775, lng: 78.43215315268903 },
        { lat: 17.3736419462571, lng: 78.43169905224072 },
        { lat: 17.37353919948637, lng: 78.43128776316932 },
        { lat: 17.3734632842576, lng: 78.43102264196075 },
        { lat: 17.3733373585093, lng: 78.43073808596232 },
        { lat: 17.37330353400469, lng: 78.43066080771406 },
        { lat: 17.37317198891048, lng: 78.43037882789051 },
        { lat: 17.37309439769767, lng: 78.43024190032833 },
        { lat: 17.37302605004745, lng: 78.4301196879043 },
        { lat: 17.37286219990505, lng: 78.42978951287974 },
        { lat: 17.37274906985348, lng: 78.4296161920157 },
        { lat: 17.3726118589935, lng: 78.4293006208249 },
        { lat: 17.37225319239296, lng: 78.42847732107687 },
        { lat: 17.3719861201291, lng: 78.42786444382085 },
        { lat: 17.37192196950706, lng: 78.42771806891662 },
        { lat: 17.37192048565111, lng: 78.42771120098512 },
        { lat: 17.37137347896889, lng: 78.42518152716232 },
        { lat: 17.37139660873349, lng: 78.42505141651236 },
        { lat: 17.37143168032135, lng: 78.42471609964602 },
        { lat: 17.37139642290031, lng: 78.42453228152786 },
        { lat: 17.37139617810605, lng: 78.4242613975881 },
        { lat: 17.371365238445, lng: 78.4239781590592 },
        { lat: 17.37136120864671, lng: 78.42367808073736 },
        { lat: 17.37139638576244, lng: 78.42343491895559 },
        { lat: 17.37141194201079, lng: 78.4233303430177 },
        { lat: 17.37142130231307, lng: 78.42318543438337 },
        { lat: 17.37141938149952, lng: 78.42304244903481 },
        { lat: 17.37140583415577, lng: 78.42287566861688 },
        { lat: 17.37135223907989, lng: 78.42267358918345 },
        { lat: 17.37138295043942, lng: 78.42243475341797 },
        { lat: 17.37144950587287, lng: 78.42225493974327 },
        { lat: 17.37146955003477, lng: 78.4220637285795 },
        { lat: 17.371433714418, lng: 78.42192122093788 },
        { lat: 17.37144149363116, lng: 78.42165875023568 },
        { lat: 17.37143924980283, lng: 78.42149181083413 },
        { lat: 17.3713892135799, lng: 78.42121810226652 },
        { lat: 17.37128137247934, lng: 78.42084996408006 },
        { lat: 17.37124425181022, lng: 78.42061193742427 },
        { lat: 17.37115950202258, lng: 78.42027933881356 },
        { lat: 17.3711088229508, lng: 78.41995801823526 },
        { lat: 17.37106649213467, lng: 78.41966891610559 },
        { lat: 17.37102118235717, lng: 78.41941057427125 },
        { lat: 17.37097178689324, lng: 78.41918477362807 },
        { lat: 17.37092351984911, lng: 78.41895881059646 },
        { lat: 17.37089770257442, lng: 78.4187206256902 },
        { lat: 17.37082505447685, lng: 78.41844738474518 },
        { lat: 17.37077421239403, lng: 78.4181141624568 },
        { lat: 17.37073708952194, lng: 78.41787613745147 },
        { lat: 17.37070901791375, lng: 78.41755464657943 },
        { lat: 17.37066996665256, lng: 78.41717349013805 },
        { lat: 17.37063052668872, lng: 78.41684745636653 },
        { lat: 17.37061598415093, lng: 78.41669112804789 },
        { lat: 17.37058991304922, lng: 78.41660227920318 },
        { lat: 17.37052701816858, lng: 78.41646574118572 },
        { lat: 17.3704768663509, lng: 78.41618395572362 },
        { lat: 17.37045228649108, lng: 78.41595398273293 },
        { lat: 17.37041054696466, lng: 78.41570926305711 },
        { lat: 17.3703558737936, lng: 78.41542768641283 },
        { lat: 17.37033426093013, lng: 78.415082295623 },
        { lat: 17.37035583900369, lng: 78.41483756326076 },
        { lat: 17.37095650678236, lng: 78.41427099570683 },
        { lat: 17.37125842186748, lng: 78.41427290384763 },
        { lat: 17.37126685952995, lng: 78.41414388325381 },
        { lat: 17.3713182895276, lng: 78.41401689998351 },
        { lat: 17.37133711441091, lng: 78.41381968011525 },
        { lat: 17.37135452974872, lng: 78.41368568204678 },
        { lat: 17.3713599386726, lng: 78.41349982241596 },
        { lat: 17.3713892875109, lng: 78.41332846931006 },
        { lat: 17.3714657129772, lng: 78.41312661407119 },
        { lat: 17.37154065998514, lng: 78.412898911546 },
        { lat: 17.37136034057973, lng: 78.41235557736356 },
        { lat: 17.37133757098792, lng: 78.4120840885723 },
        { lat: 17.37128758286732, lng: 78.41148809882843 },
        { lat: 17.37136394637224, lng: 78.41044390091399 },
        { lat: 17.37137912760253, lng: 78.4101453198172 },
        { lat: 17.37105095974196, lng: 78.4099081154908 },
        { lat: 17.37061461659709, lng: 78.40942898932774 },
        { lat: 17.36999956876125, lng: 78.40898970966875 },
        { lat: 17.36938645533459, lng: 78.40869971361916 },
        { lat: 17.36884259635902, lng: 78.40822210935305 },
        { lat: 17.36812051919583, lng: 78.40782167147803 },
        { lat: 17.36689719850683, lng: 78.40746561704036 },
        { lat: 17.36549517423264, lng: 78.40714940871477 },
        { lat: 17.3641716067707, lng: 78.40735466787801 },
        { lat: 17.36313328581226, lng: 78.40744393288195 },
        { lat: 17.36284900703973, lng: 78.40763456419836 },
        { lat: 17.3616455355844, lng: 78.40880860101933 },
        { lat: 17.36047063651671, lng: 78.40942233561304 },
        { lat: 17.35961246832652, lng: 78.40958370188919 },
        { lat: 17.35874462401551, lng: 78.40899869529906 },
        { lat: 17.35805693468537, lng: 78.40848580997648 },
        { lat: 17.35768548988635, lng: 78.40748325411379 },
        { lat: 17.3575285820867, lng: 78.40644035654888 },
        { lat: 17.35818430156046, lng: 78.40449021841259 },
        { lat: 17.35833444681423, lng: 78.40414597005079 },
        { lat: 17.35761365996312, lng: 78.40172515834654 },
        { lat: 17.35742845120676, lng: 78.4014907259199 },
        { lat: 17.35715552268089, lng: 78.4015419226957 },
        { lat: 17.35713471426769, lng: 78.40092698650763 },
        { lat: 17.35541215613779, lng: 78.40079679835041 },
        { lat: 17.35455011714114, lng: 78.40065965648833 },
        { lat: 17.35439463144496, lng: 78.39972874082444 },
        { lat: 17.35394613140138, lng: 78.39831674813618 },
        { lat: 17.35243950625361, lng: 78.3982260394503 },
        { lat: 17.35082585353018, lng: 78.39817416283255 },
        { lat: 17.35043844239541, lng: 78.39870215984094 },
        { lat: 17.35015999549816, lng: 78.39934058545678 },
        { lat: 17.35002247081046, lng: 78.39979040508926 },
        { lat: 17.34952802643763, lng: 78.40035722754574 },
        { lat: 17.34902533231886, lng: 78.40028966919785 },
        { lat: 17.34855847597292, lng: 78.40022160389569 },
        { lat: 17.34805772267434, lng: 78.40030331031913 },
        { lat: 17.3469467617195, lng: 78.40031897128411 },
        { lat: 17.34629877752597, lng: 78.40010416876088 },
        { lat: 17.34402840415136, lng: 78.39916579367225 },
        { lat: 17.34248302825311, lng: 78.3988516857895 },
        { lat: 17.34004026290957, lng: 78.3984382714639 },
        { lat: 17.33633930385676, lng: 78.3977440381063 },
        { lat: 17.33393140390217, lng: 78.39725550815102 },
        { lat: 17.33260008197146, lng: 78.39686376263175 },
        { lat: 17.33148475546119, lng: 78.39654361508198 },
        { lat: 17.33108034824023, lng: 78.39576560871696 },
        { lat: 17.33081831602853, lng: 78.39491095926631 },
        { lat: 17.33076401750317, lng: 78.39349359156354 },
        { lat: 17.33095765106916, lng: 78.39184880500864 },
        { lat: 17.33104765058575, lng: 78.3905040358799 },
        { lat: 17.33085435161638, lng: 78.38942450902464 },
        { lat: 17.33058888512851, lng: 78.3883086865548 },
        { lat: 17.32993212866075, lng: 78.38742232247937 },
        { lat: 17.32952233125784, lng: 78.38623391446845 },
        { lat: 17.32935558276985, lng: 78.38444497159625 },
        { lat: 17.32903668837331, lng: 78.38198645062133 },
        { lat: 17.32879871863583, lng: 78.38023584901651 },
        { lat: 17.32795703214583, lng: 78.3761800861579 },
        { lat: 17.32780891045418, lng: 78.37445152434577 },
        { lat: 17.32731047930211, lng: 78.3746507074164 },
        { lat: 17.32603837191135, lng: 78.37488990193388 },
        { lat: 17.32533172947116, lng: 78.37497362652147 },
        { lat: 17.32419891338732, lng: 78.37506344331472 },
        { lat: 17.32333403093504, lng: 78.37539966391394 },
        { lat: 17.32270928593389, lng: 78.37527076710052 },
        { lat: 17.32200228349521, lng: 78.37516244517207 },
        { lat: 17.32120619626599, lng: 78.37507155851374 },
        { lat: 17.32031534459615, lng: 78.37499598735316 },
        { lat: 17.31934558460768, lng: 78.37493770627022 },
        { lat: 17.31831843493808, lng: 78.37489964170747 },
        { lat: 17.31725429086423, lng: 78.37488473224525 },
        { lat: 17.31617241161803, lng: 78.37489578776639 },
        { lat: 17.31509431774359, lng: 78.37493588312917 },
        { lat: 17.31403927200791, lng: 78.37500782440921 },
        { lat: 17.31302879851529, lng: 78.3751146846045 },
        { lat: 17.31207988201313, lng: 78.37525842223592 },
        { lat: 17.31190849887808, lng: 78.37529334268234 },
        { lat: 17.30616094859966, lng: 78.38739848242113 },
        { lat: 17.30582288903046, lng: 78.3876490946806 },
        { lat: 17.30539705627644, lng: 78.38851407370107 },
        { lat: 17.30491490198444, lng: 78.38947828820183 },
        { lat: 17.30464114157799, lng: 78.39021856281546 },
        { lat: 17.30429329815827, lng: 78.39066530574445 },
        { lat: 17.30388221747054, lng: 78.39170210903873 },
        { lat: 17.30360745044098, lng: 78.39236878387598 },
        { lat: 17.30337187644145, lng: 78.39317462576112 },
        { lat: 17.30296824166916, lng: 78.39350960849104 },
        { lat: 17.30270734310769, lng: 78.3947839030255 },
        { lat: 17.30203655617309, lng: 78.39568097352942 },
        { lat: 17.29928426500116, lng: 78.39609219396736 },
        { lat: 17.30044194850805, lng: 78.40867328396953 },
        { lat: 17.29974829632365, lng: 78.41048516518411 },
        { lat: 17.29749745612577, lng: 78.41467558744758 },
        { lat: 17.29508876193733, lng: 78.41854820272451 },
        { lat: 17.29389055286672, lng: 78.42096425890969 },
        { lat: 17.29269950256547, lng: 78.42394002679389 },
        { lat: 17.29151661062301, lng: 78.42755546747253 },
        { lat: 17.290720450984, lng: 78.42962172800989 },
        { lat: 17.29071639187008, lng: 78.42963453276654 },
        { lat: 17.29162662408124, lng: 78.43011817508989 },
        { lat: 17.29574672657718, lng: 78.43171757586431 },
        { lat: 17.29929153411386, lng: 78.43291059439447 },
        { lat: 17.30162643017198, lng: 78.4329964080356 },
        { lat: 17.30174692205618, lng: 78.4334681228619 },
        { lat: 17.30176743080619, lng: 78.43500645195152 },
        { lat: 17.30188540999298, lng: 78.4396205222329 },
        { lat: 17.30126069289552, lng: 78.43974750146879 },
        { lat: 17.30058102570837, lng: 78.43999366808121 },
        { lat: 17.3006536303902, lng: 78.44111693753023 },
        { lat: 17.30102256410469, lng: 78.44318302827769 },
        { lat: 17.30082877460874, lng: 78.44578941755594 },
        { lat: 17.30033079544275, lng: 78.44686155643556 },
        { lat: 17.30000900497674, lng: 78.4483454304658 },
        { lat: 17.30030251853123, lng: 78.4489922428717 },
        { lat: 17.30054229537749, lng: 78.44993571404272 },
        { lat: 17.3009429287852, lng: 78.45004843111825 },
        { lat: 17.30157157844189, lng: 78.45021734555424 },
        { lat: 17.30158882287248, lng: 78.45151888904122 },
        { lat: 17.30232816973006, lng: 78.45150863681488 },
        { lat: 17.30312438772329, lng: 78.45143852991421 },
        { lat: 17.30363885445767, lng: 78.45160888647048 },
        { lat: 17.30335788830997, lng: 78.45190869954024 },
        { lat: 17.30364669079351, lng: 78.45220046421645 },
        { lat: 17.30377105571613, lng: 78.4529680665906 },
        { lat: 17.30417604298984, lng: 78.45349507533885 },
        { lat: 17.3039829931602, lng: 78.45362310952545 },
        { lat: 17.3029912830197, lng: 78.45428081643135 },
        { lat: 17.30283310100485, lng: 78.45522982296066 },
        { lat: 17.30255682219599, lng: 78.45588454423023 },
        { lat: 17.30182842561367, lng: 78.45672316054772 },
        { lat: 17.30182598221048, lng: 78.4567239218785 },
        { lat: 17.30231245546165, lng: 78.45768326279337 },
        { lat: 17.30285517067476, lng: 78.4580800497975 },
        { lat: 17.3033735381743, lng: 78.45891252182773 },
        { lat: 17.30403571587087, lng: 78.45930767323276 },
        { lat: 17.30448410170999, lng: 78.45933260976689 },
        { lat: 17.3053498219538, lng: 78.45928961704035 },
        { lat: 17.30585793804239, lng: 78.45931373249086 },
        { lat: 17.30642815329875, lng: 78.45952357282789 },
        { lat: 17.3069064042694, lng: 78.45954809901681 },
        { lat: 17.30747504087173, lng: 78.45963357502681 },
        { lat: 17.30828497105264, lng: 78.45990231781036 },
        { lat: 17.30870348995827, lng: 78.45992766528683 },
        { lat: 17.30885557853672, lng: 78.46014325441325 },
        { lat: 17.30904462750182, lng: 78.46091808690564 },
        { lat: 17.30929261795613, lng: 78.46162991568275 },
        { lat: 17.30965573804061, lng: 78.46199809686475 },
        { lat: 17.31007504503519, lng: 78.4620856309047 },
        { lat: 17.31156638005779, lng: 78.46190966712007 },
        { lat: 17.31258103722178, lng: 78.46183353786175 },
        { lat: 17.31335637330977, lng: 78.46172959505212 },
        { lat: 17.31374463141388, lng: 78.46172426247595 },
        { lat: 17.31413446739997, lng: 78.46184330025707 },
        { lat: 17.31446378138709, lng: 78.46190097344997 },
        { lat: 17.31438048759138, lng: 78.4623996868962 },
        { lat: 17.31445203562735, lng: 78.46333164793757 },
        { lat: 17.31482027240484, lng: 78.46410404717417 },
        { lat: 17.31515824598633, lng: 78.4648457676182 },
        { lat: 17.3156467292362, lng: 78.46567872092757 },
        { lat: 17.31597997728952, lng: 78.46604733160608 },
        { lat: 17.31643033112929, lng: 78.46622774679292 },
        { lat: 17.31674813018028, lng: 78.46631570574127 },
        { lat: 17.31672594416359, lng: 78.46634462332057 },
        { lat: 17.31660755607701, lng: 78.46645406527635 },
        { lat: 17.31658423879866, lng: 78.46644232470251 },
        { lat: 17.31658305356182, lng: 78.46645415676626 },
        { lat: 17.31646547686385, lng: 78.46660504148804 },
        { lat: 17.3161577014223, lng: 78.4668331706897 },
        { lat: 17.31563551600546, lng: 78.46711399481535 },
        { lat: 17.31504008123446, lng: 78.46727142786466 },
        { lat: 17.31376876216993, lng: 78.46760006760981 },
        { lat: 17.31351564872221, lng: 78.46766549702554 },
        { lat: 17.313504328648, lng: 78.46768368868885 },
        { lat: 17.31326420510009, lng: 78.46768697890798 },
        { lat: 17.31253987056385, lng: 78.4678561249932 },
        { lat: 17.31199008164923, lng: 78.46822190307694 },
        { lat: 17.3115368681342, lng: 78.46866596743007 },
        { lat: 17.31106604976747, lng: 78.46922968537903 },
        { lat: 17.31065005729866, lng: 78.46959362453352 },
        { lat: 17.31021293966478, lng: 78.46979863338458 },
        { lat: 17.30973809490406, lng: 78.47004396089875 },
        { lat: 17.30882562835962, lng: 78.47045449410193 },
        { lat: 17.30896947649974, lng: 78.47124861907912 },
        { lat: 17.30929969581625, lng: 78.47166205015506 },
        { lat: 17.30999710657991, lng: 78.47238890062222 },
        { lat: 17.31073575487501, lng: 78.47335402252067 },
        { lat: 17.31139944767913, lng: 78.47443959381921 },
        { lat: 17.31175554949071, lng: 78.47539005502111 },
        { lat: 17.31199620657722, lng: 78.47628238872561 },
        { lat: 17.31240362852546, lng: 78.47675449026065 },
        { lat: 17.31282940982819, lng: 78.47716663691754 },
        { lat: 17.31350343110683, lng: 78.47755549323873 },
        { lat: 17.31402328263924, lng: 78.47784694106417 },
        { lat: 17.31414072577583, lng: 78.47806427079274 },
        { lat: 17.31431867341018, lng: 78.4783986187089 },
        { lat: 17.31425619865139, lng: 78.4787263348417 },
        { lat: 17.31414921339696, lng: 78.4793398101048 },
        { lat: 17.31384584232869, lng: 78.48029928878293 },
        { lat: 17.3135971822789, lng: 78.48104903888014 },
        { lat: 17.3134320952457, lng: 78.48160359455932 },
        { lat: 17.31321191226612, lng: 78.48233802574144 },
        { lat: 17.31283253186548, lng: 78.48295520653734 },
        { lat: 17.31260690773054, lng: 78.48325682320844 },
        { lat: 17.31265287815874, lng: 78.48325819063537 },
        { lat: 17.3125732201441, lng: 78.48347998207134 },
        { lat: 17.31233234012318, lng: 78.48427937441545 },
        { lat: 17.31233765038009, lng: 78.48470223675788 },
        { lat: 17.31265466456501, lng: 78.48520793451254 },
        { lat: 17.31284108680953, lng: 78.48564110875729 },
        { lat: 17.31280699727161, lng: 78.48606878504279 },
        { lat: 17.31280214262437, lng: 78.48641231369096 },
        { lat: 17.31316129549228, lng: 78.48620849093204 },
        { lat: 17.31346684566637, lng: 78.48608808985959 },
        { lat: 17.31357654966394, lng: 78.48621206138154 },
        { lat: 17.31399042616055, lng: 78.48673303303065 },
        { lat: 17.31431078543411, lng: 78.48702018267993 },
        { lat: 17.31449363722022, lng: 78.48716814639116 },
        { lat: 17.31499746267536, lng: 78.48765027834429 },
        { lat: 17.31544628454768, lng: 78.4880767345962 },
        { lat: 17.31585966586349, lng: 78.48856010632494 },
        { lat: 17.31627353950775, lng: 78.48908109167823 },
        { lat: 17.31673214023268, lng: 78.4895638497462 },
        { lat: 17.31722753091028, lng: 78.49009312820324 },
        { lat: 17.31759556389904, lng: 78.49056772377622 },
        { lat: 17.31791776214979, lng: 78.49099592572925 },
        { lat: 17.3180094316611, lng: 78.49108871874364 },
        { lat: 17.31805444815077, lng: 78.49176522438844 },
        { lat: 17.3179008233547, lng: 78.49229676776244 },
        { lat: 17.3178640659843, lng: 78.49242613969828 },
        { lat: 17.31782191258267, lng: 78.49266182806261 },
        { lat: 17.31772806918638, lng: 78.49309571543962 },
        { lat: 17.31763410348396, lng: 78.49352019904805 },
        { lat: 17.31758290372646, lng: 78.49375601161313 },
        { lat: 17.31744629049641, lng: 78.49437857065614 },
        { lat: 17.31737712054588, lng: 78.49454372444296 },
        { lat: 17.3174268963657, lng: 78.49456147413723 },
        { lat: 17.31744986169169, lng: 78.49460481433029 },
        { lat: 17.31776045887951, lng: 78.49412167365391 },
        { lat: 17.31801890887611, lng: 78.49424567537572 },
        { lat: 17.31810830517511, lng: 78.49398944883538 },
        { lat: 17.31819549080292, lng: 78.49401460854129 },
        { lat: 17.31841488681455, lng: 78.4940703908836 },
        { lat: 17.31845212069171, lng: 78.4939902703227 },
        { lat: 17.31829833077879, lng: 78.49392269323585 },
        { lat: 17.31846540184715, lng: 78.49363414287284 },
        { lat: 17.31878425262621, lng: 78.49381855993228 },
        { lat: 17.31875833079157, lng: 78.49401597228419 },
        { lat: 17.31877806750339, lng: 78.49406546484666 },
        { lat: 17.31895754094838, lng: 78.4938938484239 },
        { lat: 17.31904775018084, lng: 78.49412633323904 },
        { lat: 17.31921918302674, lng: 78.49467722971096 },
        { lat: 17.31948906787632, lng: 78.4957154061932 },
        { lat: 17.31958609507982, lng: 78.49630809378161 },
        { lat: 17.31967372512929, lng: 78.49660005716622 },
        { lat: 17.31969020415492, lng: 78.49668038946383 },
        { lat: 17.3183907720748, lng: 78.4967278518575 },
        { lat: 17.31704355166003, lng: 78.4967759597203 },
        { lat: 17.3169862074026, lng: 78.49677673659748 },
        { lat: 17.31728296414684, lng: 78.49604623686147 },
        { lat: 17.3174653511949, lng: 78.49555706942863 },
        { lat: 17.31779744515079, lng: 78.49469028942049 },
        { lat: 17.3177322823594, lng: 78.49473471183099 },
        { lat: 17.31753491724704, lng: 78.49480084838915 },
        { lat: 17.31722742021235, lng: 78.49490173522082 },
        { lat: 17.31716557910444, lng: 78.4950501174227 },
        { lat: 17.3168479507449, lng: 78.49566574168854 },
        { lat: 17.31647483115129, lng: 78.49618807474504 },
        { lat: 17.31555513142901, lng: 78.49641691574465 },
        { lat: 17.31533024965325, lng: 78.49651402564002 },
        { lat: 17.31518519254314, lng: 78.49718371521715 },
        { lat: 17.31509440145279, lng: 78.49785266171493 },
        { lat: 17.31508841760061, lng: 78.49808785443908 },
        { lat: 17.31509466193671, lng: 78.49856739089792 },
        { lat: 17.31499530874876, lng: 78.49927407470166 },
        { lat: 17.3149038983224, lng: 78.49989600750602 },
        { lat: 17.31485587154795, lng: 78.50037628382455 },
        { lat: 17.31484927269082, lng: 78.50056446174457 },
        { lat: 17.31475810653613, lng: 78.5019011253981 },
        { lat: 17.31475774087454, lng: 78.50256884042473 },
        { lat: 17.31461254175241, lng: 78.50322912068718 },
        { lat: 17.31429500784431, lng: 78.50385412860027 },
        { lat: 17.31392247476036, lng: 78.50442345300064 },
        { lat: 17.31365499594274, lng: 78.50449506044134 },
        { lat: 17.31367122587026, lng: 78.50500114083081 },
        { lat: 17.31368954014513, lng: 78.50557228527013 },
        { lat: 17.31366843469513, lng: 78.50579648209074 },
        { lat: 17.31359506311511, lng: 78.50590640610135 },
        { lat: 17.31355113445809, lng: 78.50597221777257 },
        { lat: 17.31328985111456, lng: 78.50610013882776 },
        { lat: 17.31269436898647, lng: 78.50625744736342 },
        { lat: 17.3127188563761, lng: 78.50631340545615 },
        { lat: 17.31272529161296, lng: 78.5062735588035 },
        { lat: 17.31501118533899, lng: 78.5067597598007 },
        { lat: 17.31502209612324, lng: 78.5068141716259 },
        { lat: 17.31641150296663, lng: 78.50602152073287 },
        { lat: 17.3164730610381, lng: 78.50599491750258 },
        { lat: 17.3170743005114, lng: 78.50573507884462 },
        { lat: 17.31742640069598, lng: 78.50566364333788 },
        { lat: 17.31836810829745, lng: 78.50549454054521 },
        { lat: 17.31851642841659, lng: 78.5056261584294 },
        { lat: 17.31863050351855, lng: 78.50592417396213 },
        { lat: 17.31862099568219, lng: 78.5061202303469 },
        { lat: 17.31857797176206, lng: 78.50650333715032 },
        { lat: 17.31854640574118, lng: 78.50669067809444 },
        { lat: 17.31841087881559, lng: 78.50728785205791 },
        { lat: 17.31831995329213, lng: 78.5076227138365 },
        { lat: 17.31805179196731, lng: 78.50803274950798 },
        { lat: 17.31801449684924, lng: 78.50808977495907 },
        { lat: 17.31682043054145, lng: 78.50815563902059 },
        { lat: 17.31663175788125, lng: 78.50835721831267 },
        { lat: 17.31644741519763, lng: 78.50890705200872 },
        { lat: 17.31640402592887, lng: 78.5092372941066 },
        { lat: 17.31697459438548, lng: 78.50958266970368 },
        { lat: 17.31711160075342, lng: 78.50968426301131 },
        { lat: 17.31752176685204, lng: 78.50992321708027 },
        { lat: 17.31794002115215, lng: 78.51008814917935 },
        { lat: 17.31812186593072, lng: 78.51015959755695 },
        { lat: 17.318809483879, lng: 78.51016907945892 },
        { lat: 17.31945175749909, lng: 78.51016977441363 },
        { lat: 17.32073508471873, lng: 78.51007712817778 },
        { lat: 17.32142258014895, lng: 78.51007720669091 },
        { lat: 17.32206241535126, lng: 78.50988983578337 },
        { lat: 17.32238130501358, lng: 78.50936824541515 },
        { lat: 17.32316635440039, lng: 78.50852055761789 },
        { lat: 17.32367639348949, lng: 78.50809041526142 },
        { lat: 17.32427100360114, lng: 78.50790364642152 },
        { lat: 17.32491266529587, lng: 78.50785731320835 },
        { lat: 17.32495788721153, lng: 78.50785670109745 },
        { lat: 17.32559893816133, lng: 78.50776334939127 },
        { lat: 17.32624060144726, lng: 78.50771701469347 },
        { lat: 17.32688165211191, lng: 78.50762366124107 },
        { lat: 17.32757770104726, lng: 78.5075859910752 },
        { lat: 17.32811987519578, lng: 78.50754100478612 },
        { lat: 17.32821936401098, lng: 78.5075396524301 },
        { lat: 17.32890685776397, lng: 78.50753971760702 },
        { lat: 17.32954790796262, lng: 78.5074463627905 },
        { lat: 17.33018956887125, lng: 78.50740002411949 },
        { lat: 17.33055085532467, lng: 78.50735749477445 },
        { lat: 17.33083135221766, lng: 78.50736308713577 },
        { lat: 17.33147301295407, lng: 78.5073167472334 },
        { lat: 17.33211406263375, lng: 78.50722338911523 },
        { lat: 17.33280094677579, lng: 78.50717643143086 },
        { lat: 17.33344260720792, lng: 78.50713008943575 },
        { lat: 17.33408683251264, lng: 78.50728122353057 },
        { lat: 17.3346326685043, lng: 78.5075183452875 },
        { lat: 17.33472311220095, lng: 78.5075171182892 },
        { lat: 17.33528215201972, lng: 78.50737784229705 },
        { lat: 17.33582970569253, lng: 78.50705061513199 },
        { lat: 17.33615701569092, lng: 78.50648183408283 },
        { lat: 17.33615738443065, lng: 78.50581403789336 },
        { lat: 17.33624660685422, lng: 78.5057187689955 },
        { lat: 17.33661314540719, lng: 78.50538459085763 },
        { lat: 17.3371215853032, lng: 78.50552816401148 },
        { lat: 17.33725725054914, lng: 78.50552631706799 },
        { lat: 17.33762220129741, lng: 78.50576589792028 },
        { lat: 17.33780443218845, lng: 78.5058668805196 },
        { lat: 17.3384027040165, lng: 78.50596220460905 },
        { lat: 17.33853910164565, lng: 78.50601678350147 },
        { lat: 17.33909154021491, lng: 78.50606570188613 },
        { lat: 17.33977903258848, lng: 78.50606575592573 },
        { lat: 17.34042130315899, lng: 78.50606642461975 },
        { lat: 17.34087779762773, lng: 78.50569339118674 },
        { lat: 17.34112916745789, lng: 78.50563294899464 },
        { lat: 17.34130506189422, lng: 78.50550739836136 },
        { lat: 17.34159830288916, lng: 78.50527561302967 },
        { lat: 17.34187804732842, lng: 78.50504944714372 },
        { lat: 17.34215042504282, lng: 78.5047785562738 },
        { lat: 17.34213726333618, lng: 78.50474857770261 },
        { lat: 17.34215492090576, lng: 78.50471829232531 },
        { lat: 17.34219442671837, lng: 78.5048042393081 },
        { lat: 17.34232786311382, lng: 78.50497995855049 },
        { lat: 17.34256547805526, lng: 78.50536524548038 },
        { lat: 17.34272666374621, lng: 78.50558175598512 },
        { lat: 17.34279206066425, lng: 78.50566320126171 },
        { lat: 17.34280307461682, lng: 78.5057011634448 },
        { lat: 17.34293022861996, lng: 78.50587696513173 },
        { lat: 17.34319954536823, lng: 78.50633269722759 },
        { lat: 17.34329066593443, lng: 78.50648183195753 },
        { lat: 17.34341368121566, lng: 78.50668316772328 },
        { lat: 17.343596408992, lng: 78.50690661583286 },
        { lat: 17.34359714177864, lng: 78.50691591274453 },
        { lat: 17.34358437452694, lng: 78.5069878406811 },
        { lat: 17.34361899076367, lng: 78.50704584800249 },
        { lat: 17.34377381185929, lng: 78.50721953774098 },
        { lat: 17.34381751138928, lng: 78.50727592709006 },
        { lat: 17.3438861311399, lng: 78.50734554592141 },
        { lat: 17.34403101133483, lng: 78.50750808302566 },
        { lat: 17.34410397363265, lng: 78.50755617252624 },
        { lat: 17.34438710604483, lng: 78.50772608121297 },
        { lat: 17.34472273344556, lng: 78.50781112614284 },
        { lat: 17.34566221516124, lng: 78.5080273607791 },
        { lat: 17.34610322169338, lng: 78.50813088895363 },
        { lat: 17.34682213900241, lng: 78.50829038521114 },
        { lat: 17.34764631324517, lng: 78.5084584125519 },
        { lat: 17.3481709535583, lng: 78.50856603961476 },
        { lat: 17.3486974237902, lng: 78.50859465442551 },
        { lat: 17.34901271344802, lng: 78.50856241902598 },
        { lat: 17.34902343192319, lng: 78.50857198760801 },
        { lat: 17.34903224085496, lng: 78.50889535806608 },
        { lat: 17.34903050096647, lng: 78.50896377127496 },
        { lat: 17.34902060028067, lng: 78.50921487324769 },
        { lat: 17.34900368556499, lng: 78.50939177771839 },
        { lat: 17.34919995454793, lng: 78.50941649903221 },
        { lat: 17.34917735590807, lng: 78.50990452859658 },
        { lat: 17.34956784524396, lng: 78.50998137499502 },
        { lat: 17.34954385429275, lng: 78.51016583838252 },
        { lat: 17.34983137391488, lng: 78.51021953154786 },
        { lat: 17.35000913479812, lng: 78.51027121281913 },
        { lat: 17.35022361302941, lng: 78.51034456220292 },
        { lat: 17.35063038857735, lng: 78.51048461432143 },
        { lat: 17.35059181423209, lng: 78.51064937091621 },
        { lat: 17.35031717398866, lng: 78.51143195012183 },
        { lat: 17.34986743822062, lng: 78.51246594649703 },
        { lat: 17.34976866362948, lng: 78.51267848734203 },
        { lat: 17.34938871181672, lng: 78.51346359911213 },
        { lat: 17.34916982618412, lng: 78.51390845801566 },
        { lat: 17.34938861993698, lng: 78.51401499808907 },
        { lat: 17.34959996760134, lng: 78.5140992427031 },
        { lat: 17.3498113461858, lng: 78.51418597562346 },
        { lat: 17.3499506097614, lng: 78.51423884380033 },
        { lat: 17.35026997431185, lng: 78.5143614470068 },
        { lat: 17.35054853324478, lng: 78.51446967107282 },
        { lat: 17.35079898635983, lng: 78.51457322093023 },
        { lat: 17.35120811674407, lng: 78.51475157973223 },
        { lat: 17.35122873438588, lng: 78.5147680607137 },
        { lat: 17.35124063216623, lng: 78.51477886006757 },
        { lat: 17.35120813945545, lng: 78.51485643925069 },
        { lat: 17.35109883633729, lng: 78.51515953534644 },
        { lat: 17.35109346677354, lng: 78.51517284062038 },
        { lat: 17.35108520681035, lng: 78.5151973298349 },
        { lat: 17.35100253534654, lng: 78.51542657189752 },
        { lat: 17.3509439140245, lng: 78.51551694489328 },
        { lat: 17.35077403446341, lng: 78.51588503168179 },
        { lat: 17.35069247462486, lng: 78.51610174756766 },
        { lat: 17.35077237753008, lng: 78.5161363849906 },
        { lat: 17.35070589951463, lng: 78.51636372662047 },
        { lat: 17.35079489367307, lng: 78.51640980898053 },
        { lat: 17.35072798085643, lng: 78.5166023173265 },
        { lat: 17.35063600422368, lng: 78.51677787097535 },
        { lat: 17.35090715706161, lng: 78.51690560795379 },
        { lat: 17.35079865390195, lng: 78.51717432680822 },
        { lat: 17.35060541652653, lng: 78.51708585218452 },
        { lat: 17.35054201045578, lng: 78.51729125427697 },
        { lat: 17.35036614346212, lng: 78.51721598363422 },
        { lat: 17.35032854830413, lng: 78.51730607272633 },
        { lat: 17.35018312063679, lng: 78.51725726619489 },
        { lat: 17.34996424492508, lng: 78.51718257476648 },
        { lat: 17.34970528424136, lng: 78.5171129018646 },
        { lat: 17.34962968087615, lng: 78.5170606687537 },
        { lat: 17.34874818543986, lng: 78.51679881399484 },
        { lat: 17.34813626663379, lng: 78.51659554077975 },
        { lat: 17.34799323623555, lng: 78.51697694537056 },
        { lat: 17.34762765744098, lng: 78.51689475646819 },
        { lat: 17.34658638711624, lng: 78.51674704904308 },
        { lat: 17.34634518430675, lng: 78.51704889682642 },
        { lat: 17.34618745182424, lng: 78.51733718431569 },
        { lat: 17.34599594718896, lng: 78.51756666334651 },
        { lat: 17.34581699884632, lng: 78.5177582324035 },
        { lat: 17.34560823375277, lng: 78.51805996187507 },
        { lat: 17.34557644376003, lng: 78.51812879443955 },
        { lat: 17.34553468017314, lng: 78.51822555985311 },
        { lat: 17.3452563363572, lng: 78.51818264782646 },
        { lat: 17.34517835676981, lng: 78.51839831767403 },
        { lat: 17.34506729345665, lng: 78.5185957695999 },
        { lat: 17.34497659584846, lng: 78.51874940141876 },
        { lat: 17.34477050321733, lng: 78.51867130221021 },
        { lat: 17.34459315148928, lng: 78.51882298821972 },
        { lat: 17.34444070852407, lng: 78.51898398064287 },
        { lat: 17.34434569016058, lng: 78.51903004960741 },
        { lat: 17.34429376515121, lng: 78.51903590364877 },
        { lat: 17.34423652615414, lng: 78.51903270280738 },
        { lat: 17.34402094111039, lng: 78.51899205657426 },
        { lat: 17.34388951836385, lng: 78.5189704139361 },
        { lat: 17.34380655071953, lng: 78.51895269594607 },
        { lat: 17.34373367397849, lng: 78.51890396943651 },
        { lat: 17.3435551327905, lng: 78.51948976646908 },
        { lat: 17.34345784592054, lng: 78.51982240283951 },
        { lat: 17.3434243000669, lng: 78.52002029593282 },
        { lat: 17.34364616646064, lng: 78.52008574188352 },
        { lat: 17.34354404196655, lng: 78.5205225730424 },
        { lat: 17.34336703916614, lng: 78.5208686070865 },
        { lat: 17.34339493668312, lng: 78.52087375179289 },
        { lat: 17.34353218242883, lng: 78.5209004196044 },
        { lat: 17.34370024993435, lng: 78.52092600644247 },
        { lat: 17.34397112979357, lng: 78.52103832262303 },
        { lat: 17.34395730661267, lng: 78.52109922340824 },
        { lat: 17.3439067920812, lng: 78.52124621714331 },
        { lat: 17.34386815515628, lng: 78.52136816632212 },
        { lat: 17.3438466970717, lng: 78.52148789648811 },
        { lat: 17.34381222890729, lng: 78.52163765953523 },
        { lat: 17.34377139580273, lng: 78.52189102203944 },
        { lat: 17.34370786794839, lng: 78.52221058253176 },
        { lat: 17.34391527714205, lng: 78.52223944731386 },
        { lat: 17.34389623603181, lng: 78.52229534803038 },
        { lat: 17.34375383628292, lng: 78.5226623896267 },
        { lat: 17.34359903798914, lng: 78.5231302850601 },
        { lat: 17.34346473301587, lng: 78.52370938163119 },
        { lat: 17.34332717018663, lng: 78.52433430717335 },
        { lat: 17.34325815656105, lng: 78.52471495318582 },
        { lat: 17.34375921914686, lng: 78.52479805924601 },
        { lat: 17.34373200592211, lng: 78.52491637200059 },
        { lat: 17.34374317849552, lng: 78.52492276779358 },
        { lat: 17.34374144831364, lng: 78.52496812466063 },
        { lat: 17.3435994708484, lng: 78.52565187447352 },
        { lat: 17.34387443350918, lng: 78.52570346934958 },
        { lat: 17.34397992259373, lng: 78.52564677140215 },
        { lat: 17.34410493194406, lng: 78.52573723491255 },
        { lat: 17.34413003423336, lng: 78.52633581610299 },
        { lat: 17.34379382043124, lng: 78.52634032459325 },
        { lat: 17.34366833476089, lng: 78.52614970008075 },
        { lat: 17.34357855728481, lng: 78.52602955284686 },
        { lat: 17.34353465705871, lng: 78.5260647651134 },
        { lat: 17.34349037745557, lng: 78.52613247109299 },
        { lat: 17.3436169800295, lng: 78.52635191067341 },
        { lat: 17.34333578962005, lng: 78.52651232064021 },
        { lat: 17.34335772656816, lng: 78.5265822374932 },
        { lat: 17.34338825582316, lng: 78.5267288400632 },
        { lat: 17.34349447622705, lng: 78.52700859874346 },
        { lat: 17.34354942168669, lng: 78.52710366354506 },
        { lat: 17.34367463477898, lng: 78.52708332226624 },
        { lat: 17.34368811474329, lng: 78.52711051313797 },
        { lat: 17.3437733652603, lng: 78.52708694282663 },
        { lat: 17.34384728668024, lng: 78.52708595187997 },
        { lat: 17.34406734196883, lng: 78.52699086154908 },
        { lat: 17.34410341526298, lng: 78.5270456629304 },
        { lat: 17.3442978385622, lng: 78.5270246268981 },
        { lat: 17.3443263570337, lng: 78.52693551048806 },
        { lat: 17.3445412494472, lng: 78.52692018882456 },
        { lat: 17.34461259744391, lng: 78.52640911825728 },
        { lat: 17.34461203064442, lng: 78.52588035103486 },
        { lat: 17.34470117222777, lng: 78.52584182967406 },
        { lat: 17.3452225690441, lng: 78.52586638175151 },
        { lat: 17.34524371080936, lng: 78.525722336115 },
        { lat: 17.34554444036355, lng: 78.52572856652641 },
        { lat: 17.34567951614248, lng: 78.52572295126657 },
        { lat: 17.34572460974022, lng: 78.52550461298249 },
        { lat: 17.34596944528802, lng: 78.52549510797705 },
        { lat: 17.34641048250755, lng: 78.52540831848195 },
        { lat: 17.34640215480282, lng: 78.52521191252659 },
        { lat: 17.34660902831164, lng: 78.52518413949376 },
        { lat: 17.34660137690838, lng: 78.52507458027075 },
        { lat: 17.34681142133212, lng: 78.52505554300296 },
        { lat: 17.34683629970178, lng: 78.52515376682969 },
        { lat: 17.34701900794018, lng: 78.52514246044585 },
        { lat: 17.34711967162033, lng: 78.52514450766984 },
        { lat: 17.34725522168179, lng: 78.52513613353206 },
        { lat: 17.34724622798009, lng: 78.52499614070753 },
        { lat: 17.34737963475716, lng: 78.52500214993908 },
        { lat: 17.34752443574997, lng: 78.52500020674961 },
        { lat: 17.34762250588024, lng: 78.52499645854843 },
        { lat: 17.34762002773341, lng: 78.5249217592489 },
        { lat: 17.34783995397943, lng: 78.52490889964142 },
        { lat: 17.347838293865, lng: 78.52488657200726 },
        { lat: 17.34787153295213, lng: 78.52488550801105 },
        { lat: 17.34806067562174, lng: 78.52489010228796 },
        { lat: 17.34831195390968, lng: 78.52483887740897 },
        { lat: 17.34849990841582, lng: 78.52479301947304 },
        { lat: 17.34900633660208, lng: 78.52477626984523 },
        { lat: 17.34945529622125, lng: 78.52475033515407 },
        { lat: 17.34954749502043, lng: 78.5247658949783 },
        { lat: 17.34968009853612, lng: 78.52476349245579 },
        { lat: 17.34970388103612, lng: 78.52477046965716 },
        { lat: 17.34977662548654, lng: 78.52479786729701 },
        { lat: 17.3498570398553, lng: 78.52479365132889 },
        { lat: 17.35008184853458, lng: 78.52478485150591 },
        { lat: 17.3501876929919, lng: 78.52477631299017 },
        { lat: 17.35027165110616, lng: 78.5247719102147 },
        { lat: 17.35033949620481, lng: 78.52477820191314 },
        { lat: 17.35058414513497, lng: 78.52482587182074 },
        { lat: 17.35066326138548, lng: 78.52484250737831 },
        { lat: 17.35092281811332, lng: 78.52490163679497 },
        { lat: 17.35128467559335, lng: 78.52493410558752 },
        { lat: 17.35150067865624, lng: 78.52498439683798 },
        { lat: 17.35182370841829, lng: 78.52501738787504 },
        { lat: 17.35201784616836, lng: 78.52501478190084 },
        { lat: 17.3522437885284, lng: 78.52521283531351 },
        { lat: 17.35246996163206, lng: 78.52520860219684 },
        { lat: 17.35298695406666, lng: 78.52518114045525 },
        { lat: 17.35306389416978, lng: 78.52511946942047 },
        { lat: 17.35307086428856, lng: 78.52511202191805 },
        { lat: 17.3543615047353, lng: 78.525124559582 },
        { lat: 17.35435202337968, lng: 78.52522733610212 },
        { lat: 17.35437257760378, lng: 78.52543982648673 },
        { lat: 17.35442863975991, lng: 78.52577991216806 },
        { lat: 17.35445524793052, lng: 78.52605919409098 },
        { lat: 17.35445900447898, lng: 78.52636273899385 },
        { lat: 17.35444995176295, lng: 78.52659677857885 },
        { lat: 17.35443272921042, lng: 78.52664095494384 },
        { lat: 17.35433084431271, lng: 78.52670204922953 },
        { lat: 17.35415633126735, lng: 78.52679397580262 },
        { lat: 17.35406906136849, lng: 78.52687558143145 },
        { lat: 17.35401663245465, lng: 78.52692111876367 },
        { lat: 17.353932445253, lng: 78.52696848723483 },
        { lat: 17.35366192971849, lng: 78.52710669111252 },
        { lat: 17.35321311881138, lng: 78.52733791756714 },
        { lat: 17.35307925195543, lng: 78.52733473570513 },
        { lat: 17.35250042306028, lng: 78.52768092969548 },
        { lat: 17.35216334499518, lng: 78.52786461839396 },
        { lat: 17.35204147805822, lng: 78.52790874310183 },
        { lat: 17.35199394234886, lng: 78.52792015689711 },
        { lat: 17.35158578117607, lng: 78.52797917660358 },
        { lat: 17.35138482974465, lng: 78.52798512397291 },
        { lat: 17.35127769375467, lng: 78.52798135080731 },
        { lat: 17.35113476524966, lng: 78.5279666669376 },
        { lat: 17.35094570502239, lng: 78.52793150585441 },
        { lat: 17.3507712423094, lng: 78.52794196424328 },
        { lat: 17.3507041018311, lng: 78.52796227368607 },
        { lat: 17.35067144154556, lng: 78.52798809404823 },
        { lat: 17.35062667263733, lng: 78.52807827787113 },
        { lat: 17.35059267907635, lng: 78.52813229000989 },
        { lat: 17.3505280028552, lng: 78.52816862177409 },
        { lat: 17.35049714830465, lng: 78.52817911764932 },
        { lat: 17.35041244732472, lng: 78.52818445713915 },
        { lat: 17.35040573211634, lng: 78.52818426124075 },
        { lat: 17.35017998639944, lng: 78.52813353725033 },
        { lat: 17.34996263947171, lng: 78.52806627668203 },
        { lat: 17.34983030201319, lng: 78.52803221737462 },
        { lat: 17.34971224463376, lng: 78.52799348704484 },
        { lat: 17.34968894318132, lng: 78.52798099536139 },
        { lat: 17.34944288282281, lng: 78.52781308441656 },
        { lat: 17.3491608554646, lng: 78.52767698989288 },
        { lat: 17.34897430924743, lng: 78.52768685307863 },
        { lat: 17.34886820084087, lng: 78.52768678208862 },
        { lat: 17.34885026542535, lng: 78.52774375828524 },
        { lat: 17.34884163226804, lng: 78.52785734551988 },
        { lat: 17.34884216341256, lng: 78.52785793373711 },
        { lat: 17.34884017536331, lng: 78.5278709336649 },
        { lat: 17.34893095466526, lng: 78.5279562241091 },
        { lat: 17.34912947954592, lng: 78.52817598621776 },
        { lat: 17.34929231109501, lng: 78.52833281370562 },
        { lat: 17.34950640761769, lng: 78.52849480245166 },
        { lat: 17.3497039392861, lng: 78.5286231393378 },
        { lat: 17.34973999265938, lng: 78.52864894519138 },
        { lat: 17.35016075169082, lng: 78.52885482471748 },
        { lat: 17.35017949573762, lng: 78.52887384643624 },
        { lat: 17.35020273867359, lng: 78.5289060154384 },
        { lat: 17.35020427270576, lng: 78.5289247523939 },
        { lat: 17.35021146020177, lng: 78.52909054590248 },
        { lat: 17.35022323217112, lng: 78.52920852459269 },
        { lat: 17.35022382894725, lng: 78.52922027108211 },
        { lat: 17.3502325083838, lng: 78.52930376607198 },
        { lat: 17.35026760437724, lng: 78.52935903701665 },
        { lat: 17.3503369600689, lng: 78.52940190354974 },
        { lat: 17.3504462608529, lng: 78.52942831020088 },
        { lat: 17.3505160481159, lng: 78.52943870927591 },
        { lat: 17.35056961102193, lng: 78.5294515472191 },
        { lat: 17.35063235048383, lng: 78.5295004747368 },
        { lat: 17.3508654215814, lng: 78.52979596676417 },
        { lat: 17.35112318694491, lng: 78.53015582676258 },
        { lat: 17.35124735984784, lng: 78.53032784842691 },
        { lat: 17.35126256967158, lng: 78.53035303015629 },
        { lat: 17.3512772787806, lng: 78.53044019197942 },
        { lat: 17.35128939544079, lng: 78.53056163741581 },
        { lat: 17.35128941705965, lng: 78.53066920201546 },
        { lat: 17.35139161074763, lng: 78.53067480640878 },
        { lat: 17.35168876089444, lng: 78.53067082688663 },
        { lat: 17.35199423438764, lng: 78.53063687432771 },
        { lat: 17.35204085569105, lng: 78.53054168822878 },
        { lat: 17.3521013206561, lng: 78.53040650070497 },
        { lat: 17.35213125231436, lng: 78.53040163984903 },
        { lat: 17.3521767680428, lng: 78.53038060116369 },
        { lat: 17.35232616237291, lng: 78.53040248933348 },
        { lat: 17.35263517129735, lng: 78.5304998796917 },
        { lat: 17.35329372436641, lng: 78.53072597107199 },
        { lat: 17.35329513355046, lng: 78.53072590987448 },
        { lat: 17.35330818590879, lng: 78.53073042734255 },
        { lat: 17.35355132416483, lng: 78.53071462798852 },
        { lat: 17.35361856005585, lng: 78.53071166675184 },
        { lat: 17.35384245349125, lng: 78.53072857517851 },
        { lat: 17.35421189394255, lng: 78.53076543346172 },
        { lat: 17.35435557740847, lng: 78.5307893895602 },
        { lat: 17.35500125990487, lng: 78.53090218014107 },
        { lat: 17.35512843612319, lng: 78.5309017267207 },
        { lat: 17.35522802488861, lng: 78.53089446180478 },
        { lat: 17.35536790189324, lng: 78.53085215083483 },
        { lat: 17.3554155600862, lng: 78.5309426194639 },
        { lat: 17.35544412476828, lng: 78.53101040981657 },
        { lat: 17.3554519726747, lng: 78.53099210907297 },
        { lat: 17.35549815238365, lng: 78.53087177990118 },
        { lat: 17.35551062398175, lng: 78.53084266405175 },
        { lat: 17.35552909914348, lng: 78.5308152143602 },
        { lat: 17.35556984662673, lng: 78.53076258158235 },
        { lat: 17.35561608910551, lng: 78.53072170149608 },
        { lat: 17.35572097341379, lng: 78.53065499118823 },
        { lat: 17.35582748491585, lng: 78.530603090357 },
        { lat: 17.35589309916536, lng: 78.53056515695309 },
        { lat: 17.35599024499126, lng: 78.53052377820543 },
        { lat: 17.35607123041853, lng: 78.53048431452505 },
        { lat: 17.35616698529865, lng: 78.5304484959831 },
        { lat: 17.35626633240132, lng: 78.53040617904072 },
        { lat: 17.35639059487018, lng: 78.53035449150829 },
        { lat: 17.35639533979595, lng: 78.53035232018206 },
        { lat: 17.35643210839872, lng: 78.5303279039346 },
        { lat: 17.35647575537044, lng: 78.53028867227418 },
        { lat: 17.35658709995686, lng: 78.53015651838255 },
        { lat: 17.35659948463569, lng: 78.53013587494581 },
        { lat: 17.35667322799728, lng: 78.53001295297459 },
        { lat: 17.35682003458699, lng: 78.52970355030169 },
        { lat: 17.35689385405741, lng: 78.52949393334004 },
        { lat: 17.356906443192, lng: 78.5294590735935 },
        { lat: 17.35699471792075, lng: 78.52920534869807 },
        { lat: 17.35704704109848, lng: 78.52905609306488 },
        { lat: 17.35705653626496, lng: 78.52902719735121 },
        { lat: 17.3570900316284, lng: 78.5289785473033 },
        { lat: 17.35713553713687, lng: 78.52878678192864 },
        { lat: 17.3571623477169, lng: 78.52870519234426 },
        { lat: 17.35734031775907, lng: 78.5281677619422 },
        { lat: 17.35740416119123, lng: 78.52796209259137 },
        { lat: 17.35745319792676, lng: 78.52781718626869 },
        { lat: 17.35752002188013, lng: 78.52763731257981 },
        { lat: 17.35757588982932, lng: 78.52751711384174 },
        { lat: 17.35774781542932, lng: 78.52721618395803 },
        { lat: 17.35792318714511, lng: 78.52690400726765 },
        { lat: 17.35807421960203, lng: 78.52665193881852 },
        { lat: 17.3581379016806, lng: 78.5265247413237 },
        { lat: 17.35819129474264, lng: 78.52641890343138 },
        { lat: 17.35828748080471, lng: 78.52621601527677 },
        { lat: 17.3584239804881, lng: 78.5259491532564 },
        { lat: 17.35843026233255, lng: 78.52594177685177 },
        { lat: 17.35844259572544, lng: 78.52591695761001 },
        { lat: 17.35859411355154, lng: 78.52574936707114 },
        { lat: 17.35863765253004, lng: 78.52561840724421 },
        { lat: 17.35874103686178, lng: 78.52530570542329 },
        { lat: 17.35876109540139, lng: 78.52523835789458 },
        { lat: 17.35894000742325, lng: 78.52487188776294 },
        { lat: 17.3589968707513, lng: 78.5247758349247 },
        { lat: 17.35910986946298, lng: 78.52459986180118 },
        { lat: 17.35916264279473, lng: 78.52453319109794 },
        { lat: 17.35920225806812, lng: 78.52447951118742 },
        { lat: 17.35927482050299, lng: 78.5243988735643 },
        { lat: 17.35928465400037, lng: 78.5243670909291 },
        { lat: 17.35931160644807, lng: 78.52435938033825 },
        { lat: 17.35938267061752, lng: 78.52430865541203 },
        { lat: 17.35959648310557, lng: 78.52420624054808 },
        { lat: 17.35984613490746, lng: 78.52410334392408 },
        { lat: 17.36000641665109, lng: 78.52402031399629 },
        { lat: 17.36016639002401, lng: 78.52391240091093 },
        { lat: 17.3602193810434, lng: 78.52384947292859 },
        { lat: 17.36022353088394, lng: 78.52384076027938 },
        { lat: 17.36025916410721, lng: 78.52384215508175 },
        { lat: 17.3602998434998, lng: 78.52378792145451 },
        { lat: 17.36064084075729, lng: 78.52342592690438 },
        { lat: 17.36101253403633, lng: 78.52299003614586 },
        { lat: 17.36141058494833, lng: 78.52244086720445 },
        { lat: 17.36178471470373, lng: 78.52225542160315 },
        { lat: 17.3623421033584, lng: 78.52204497097334 },
        { lat: 17.36263058111227, lng: 78.52194774568216 },
        { lat: 17.36271589944563, lng: 78.52285607134735 },
        { lat: 17.36270046385301, lng: 78.52312131818717 },
        { lat: 17.36267142612316, lng: 78.52330253583631 },
        { lat: 17.36281970484681, lng: 78.52331777210594 },
        { lat: 17.36283098345984, lng: 78.52354681212842 },
        { lat: 17.36311359125016, lng: 78.52351925491168 },
        { lat: 17.36312594786539, lng: 78.523287425019 },
        { lat: 17.36333321057104, lng: 78.52329040845886 },
        { lat: 17.36334279928327, lng: 78.52326156105144 },
        { lat: 17.36358382658546, lng: 78.52333954623982 },
        { lat: 17.36352485500613, lng: 78.52382611441827 },
        { lat: 17.36405327764591, lng: 78.52390865150042 },
        { lat: 17.36411717377199, lng: 78.52353314488492 },
        { lat: 17.36418148627412, lng: 78.52332323711131 },
        { lat: 17.36481612529329, lng: 78.52345881394808 },
        { lat: 17.36473787406349, lng: 78.52374610323284 },
        { lat: 17.36506433995465, lng: 78.52386315001945 },
        { lat: 17.36521870378514, lng: 78.52341640254771 },
        { lat: 17.36525127911969, lng: 78.52336690289724 },
        { lat: 17.36585541265476, lng: 78.52341023501346 },
        { lat: 17.36578013872941, lng: 78.52378875853451 },
        { lat: 17.36562741378642, lng: 78.52445958435555 },
        { lat: 17.36601253565665, lng: 78.52441560804994 },
        { lat: 17.36604661926697, lng: 78.52427329627092 },
        { lat: 17.36652822832395, lng: 78.5242495395425 },
        { lat: 17.36678619632277, lng: 78.5236963591719 },
        { lat: 17.36689240286149, lng: 78.52339698317013 },
        { lat: 17.3670266706673, lng: 78.52342292076239 },
        { lat: 17.3670302948835, lng: 78.52339454611057 },
        { lat: 17.36716516653365, lng: 78.52342249033755 },
        { lat: 17.36716072409583, lng: 78.52306418243616 },
        { lat: 17.36725617648169, lng: 78.52305294369715 },
        { lat: 17.36861808511317, lng: 78.52317223013848 },
        { lat: 17.36857048421347, lng: 78.52462389452381 },
        { lat: 17.36873615319874, lng: 78.5246769246269 },
        { lat: 17.36918251556111, lng: 78.5247756000087 },
        { lat: 17.36969973406811, lng: 78.52485824182664 },
        { lat: 17.37034008921271, lng: 78.5248496360169 },
        { lat: 17.37034261602894, lng: 78.52428217932741 },
        { lat: 17.37005576994657, lng: 78.52432879525533 },
        { lat: 17.36991355470736, lng: 78.52436028147748 },
        { lat: 17.36991304592164, lng: 78.52434757977177 },
        { lat: 17.36991356884413, lng: 78.52434670174046 },
        { lat: 17.3698941479661, lng: 78.52391127267514 },
        { lat: 17.36985107398835, lng: 78.52352112662115 },
        { lat: 17.36997100607552, lng: 78.52355684479429 },
        { lat: 17.37012431746446, lng: 78.52359640617804 },
        { lat: 17.37018179090043, lng: 78.52360889784305 },
        { lat: 17.3706017845372, lng: 78.52375257241923 },
        { lat: 17.37078918849803, lng: 78.52381169185334 },
        { lat: 17.37082660108997, lng: 78.52381950100957 },
        { lat: 17.37087173764416, lng: 78.52382990022856 },
        { lat: 17.37093331145652, lng: 78.52384900109324 },
        { lat: 17.3710211490381, lng: 78.5238838982226 },
        { lat: 17.37112634668415, lng: 78.52390765744336 },
        { lat: 17.37117994955158, lng: 78.5239234802521 },
        { lat: 17.37129429569638, lng: 78.52394751061897 },
        { lat: 17.37140358985268, lng: 78.52396918872904 },
        { lat: 17.37146277282696, lng: 78.52398275243638 },
        { lat: 17.37249191233208, lng: 78.524238575929 },
        { lat: 17.37387839768992, lng: 78.52452208285035 },
        { lat: 17.37428080079265, lng: 78.52459631406792 },
        { lat: 17.37472168313185, lng: 78.52468993571603 },
        { lat: 17.37513376772199, lng: 78.52477399103073 },
        { lat: 17.37539231442142, lng: 78.52481033602523 },
        { lat: 17.3756226820644, lng: 78.52488688082451 },
        { lat: 17.3757777650761, lng: 78.524943531241 },
        { lat: 17.37591474586683, lng: 78.52500515273721 },
        { lat: 17.37605875645523, lng: 78.5250554805628 },
        { lat: 17.37633961085136, lng: 78.52515623463088 },
        { lat: 17.37685816920079, lng: 78.52534712238099 },
        { lat: 17.37712261430456, lng: 78.52545593708739 },
        { lat: 17.37901621488417, lng: 78.52626945320019 },
        { lat: 17.37918993903418, lng: 78.52635436155224 },
        { lat: 17.37942547573267, lng: 78.52644528079585 },
        { lat: 17.37945613931694, lng: 78.52641998646287 },
        { lat: 17.38005319429563, lng: 78.52642131677958 },
        { lat: 17.38050718241686, lng: 78.52652559955786 },
        { lat: 17.3807442689331, lng: 78.52658006011963 },
        { lat: 17.38078810432277, lng: 78.52659012876019 },
        { lat: 17.38083338159049, lng: 78.52624377344816 },
        { lat: 17.38087777544557, lng: 78.52617893502996 },
        { lat: 17.38108406789663, lng: 78.52569237239406 },
        { lat: 17.38115861174537, lng: 78.52551070224933 },
        { lat: 17.38122440167863, lng: 78.52535178962081 },
        { lat: 17.381228947882, lng: 78.5250036351455 },
        { lat: 17.38121771492194, lng: 78.52483444383377 },
        { lat: 17.38109392274153, lng: 78.52460061886285 },
        { lat: 17.38095847790557, lng: 78.52455260227794 },
        { lat: 17.38046546544089, lng: 78.52472714679544 },
        { lat: 17.3802713515333, lng: 78.525106089294 },
        { lat: 17.3801527387441, lng: 78.52520250836959 },
        { lat: 17.38001157815276, lng: 78.52521676567109 },
        { lat: 17.37998592002949, lng: 78.52515248265335 },
        { lat: 17.37994751787947, lng: 78.52515636091259 },
        { lat: 17.37985052494398, lng: 78.52491336284245 },
        { lat: 17.37984799173446, lng: 78.52454252352842 },
        { lat: 17.37977297828912, lng: 78.52430675657502 },
        { lat: 17.37946256607722, lng: 78.5241209811689 },
        { lat: 17.37945676227235, lng: 78.5240954423502 },
        { lat: 17.37939850554032, lng: 78.52406057699197 },
        { lat: 17.37933977848934, lng: 78.5238038343284 },
        { lat: 17.37926420513796, lng: 78.52346852739905 },
        { lat: 17.37927314711323, lng: 78.52337315075614 },
        { lat: 17.37930930284728, lng: 78.5230213391573 },
        { lat: 17.37938453754575, lng: 78.52228151389961 },
        { lat: 17.38001952036181, lng: 78.5204086889747 },
        { lat: 17.38020778459511, lng: 78.5199281030615 },
        { lat: 17.38046722634373, lng: 78.51926838502474 },
        { lat: 17.38054627573616, lng: 78.5190859192 },
        { lat: 17.38028240401854, lng: 78.5189671980237 },
        { lat: 17.38033228440247, lng: 78.51882628774167 },
        { lat: 17.38062417369228, lng: 78.51832260162364 },
        { lat: 17.38088214133022, lng: 78.51822437158597 },
        { lat: 17.38089673442523, lng: 78.51821105824857 },
        { lat: 17.38096576220079, lng: 78.51811604168195 },
        { lat: 17.38116441743784, lng: 78.51798086600581 },
        { lat: 17.38126316554838, lng: 78.5178674018041 },
        { lat: 17.38099496426926, lng: 78.5177074333321 },
        { lat: 17.3810073758608, lng: 78.51768989194271 },
        { lat: 17.38102440751446, lng: 78.51766582119977 },
        { lat: 17.38097513033925, lng: 78.51762599792713 },
        { lat: 17.38102335682383, lng: 78.5175083331076 },
        { lat: 17.38125738557764, lng: 78.51715662384763 },
        { lat: 17.38131174366459, lng: 78.51707577252861 },
        { lat: 17.38137732955762, lng: 78.51698888866989 },
        { lat: 17.38143536632597, lng: 78.51693003485418 },
        { lat: 17.38145610477273, lng: 78.51687257033302 },
        { lat: 17.38150628371758, lng: 78.51681823606361 },
        { lat: 17.38155533928078, lng: 78.5167645020139 },
        { lat: 17.38158198490511, lng: 78.51672651034701 },
        { lat: 17.38160531714049, lng: 78.51669458738101 },
        { lat: 17.38162751877219, lng: 78.51666282828735 },
        { lat: 17.38166305414003, lng: 78.51661280784568 },
        { lat: 17.38169865528285, lng: 78.51656778518121 },
        { lat: 17.38175218946168, lng: 78.51651060983045 },
        { lat: 17.38177664503574, lng: 78.5164782333008 },
        { lat: 17.38182332405367, lng: 78.51641556474767 },
        { lat: 17.38187685817767, lng: 78.51635838931483 },
        { lat: 17.38191266945776, lng: 78.51632968047211 },
        { lat: 17.382046503781, lng: 78.51618674452901 },
        { lat: 17.38210359060152, lng: 78.51614187005855 },
        { lat: 17.38213597150776, lng: 78.51611026503429 },
        { lat: 17.38220759574922, lng: 78.51605284525026 },
        { lat: 17.3822435276188, lng: 78.51603354132051 },
        { lat: 17.38234788093767, lng: 78.51588424320735 },
        { lat: 17.38242759222266, lng: 78.51575291882828 },
        { lat: 17.38247407904184, lng: 78.5156755554948 },
        { lat: 17.38267852563562, lng: 78.51539730041978 },
        { lat: 17.38273193690101, lng: 78.51533071940781 },
        { lat: 17.38276195762056, lng: 78.51529150213295 },
        { lat: 17.38287493793117, lng: 78.51519706501597 },
        { lat: 17.38297320339519, lng: 78.51510150200959 },
        { lat: 17.38308039505122, lng: 78.51499670516134 },
        { lat: 17.38321471649182, lng: 78.51489139319732 },
        { lat: 17.38328621773016, lng: 78.51482456566357 },
        { lat: 17.38333095125703, lng: 78.5147863253308 },
        { lat: 17.38338472807301, lng: 78.5147479628481 },
        { lat: 17.38341148476302, lng: 78.51471849337932 },
        { lat: 17.38344938323175, lng: 78.51467637755412 },
        { lat: 17.38355667702601, lng: 78.51457951618092 },
        { lat: 17.38367404040496, lng: 78.51447443266758 },
        { lat: 17.38380480672261, lng: 78.51435652533662 },
        { lat: 17.38391767300162, lng: 78.51425341372702 },
        { lat: 17.38398011789283, lng: 78.51418582754644 },
        { lat: 17.38406774596476, lng: 78.51414200494233 },
        { lat: 17.38436011440426, lng: 78.51392973148874 },
        { lat: 17.38445758694487, lng: 78.5138601986778 },
        { lat: 17.38453453966619, lng: 78.51377800874357 },
        { lat: 17.38461321581714, lng: 78.51374136369603 },
        { lat: 17.38466040612207, lng: 78.51371808399261 },
        { lat: 17.38471534986794, lng: 78.51368249705189 },
        { lat: 17.38478099244284, lng: 78.51360001951362 },
        { lat: 17.38482560306302, lng: 78.51355237343732 },
        { lat: 17.38485680154506, lng: 78.513516668927 },
        { lat: 17.38493456443892, lng: 78.51340977116112 },
        { lat: 17.38497679108319, lng: 78.5133527466737 },
        { lat: 17.38503069194811, lng: 78.51332379038173 },
        { lat: 17.38511196787229, lng: 78.51331327768503 },
        { lat: 17.38516611214935, lng: 78.51330313352528 },
        { lat: 17.3852304339596, lng: 78.5132929966771 },
        { lat: 17.3853104547849, lng: 78.51327294548173 },
        { lat: 17.3853453159835, lng: 78.51325806500769 },
        { lat: 17.38540004364534, lng: 78.5132058701701 },
        { lat: 17.38545154776728, lng: 78.51316665510402 },
        { lat: 17.38551664328482, lng: 78.5131290191531 },
        { lat: 17.38555245393531, lng: 78.513100309079 },
        { lat: 17.38562375117677, lng: 78.51301789937902 },
        { lat: 17.38567687403921, lng: 78.51292927091446 },
        { lat: 17.38568543036887, lng: 78.51289152236127 },
        { lat: 17.38569852937235, lng: 78.51285532849111 },
        { lat: 17.38572466879632, lng: 78.51277853161457 },
        { lat: 17.38576460099747, lng: 78.51271889443484 },
        { lat: 17.38579115227754, lng: 78.51267369885525 },
        { lat: 17.38585484427815, lng: 78.51261520789376 },
        { lat: 17.38587677592331, lng: 78.51256257561316 },
        { lat: 17.38589872771573, lng: 78.51251156102238 },
        { lat: 17.38592179915685, lng: 78.51245965080473 },
        { lat: 17.38595016122738, lng: 78.5123798831694 },
        { lat: 17.38597680580863, lng: 78.51234188998606 },
        { lat: 17.38601237093546, lng: 78.51229436371027 },
        { lat: 17.38603901547359, lng: 78.5122563686216 },
        { lat: 17.3860564922584, lng: 78.51220909065204 },
        { lat: 17.38606162360795, lng: 78.51216889173989 },
        { lat: 17.38608228165423, lng: 78.5121052517754 },
        { lat: 17.38610306790295, lng: 78.51205160764394 },
        { lat: 17.38612797196533, lng: 78.51196674298919 },
        { lat: 17.38614765134092, lng: 78.51191487852222 },
        { lat: 17.38618131949454, lng: 78.51189530854855 },
        { lat: 17.38623059383861, lng: 78.51177145218172 },
        { lat: 17.38626707883106, lng: 78.51170759808278 },
        { lat: 17.38629337525423, lng: 78.51164285264652 },
        { lat: 17.38631951049699, lng: 78.51156576195807 },
        { lat: 17.38634242779404, lng: 78.51150209129939 },
        { lat: 17.3863664592376, lng: 78.51143708483713 },
        { lat: 17.38638954134146, lng: 78.51138605471493 },
        { lat: 17.38640701970333, lng: 78.51133877657198 },
        { lat: 17.38641434065971, lng: 78.51129310516336 },
        { lat: 17.38643834494846, lng: 78.51113901623008 },
        { lat: 17.38643488193847, lng: 78.51104659758914 },
        { lat: 17.38643188792628, lng: 78.5109903381506 },
        { lat: 17.38642877110536, lng: 78.51092452302794 },
        { lat: 17.38645442029153, lng: 78.51089697897494 },
        { lat: 17.38649110284529, lng: 78.51084840998077 },
        { lat: 17.38650870199211, lng: 78.51081053698418 },
        { lat: 17.38654426854984, lng: 78.51076301404846 },
        { lat: 17.38657971231324, lng: 78.51070608214707 },
        { lat: 17.38659718869293, lng: 78.5106588039348 },
        { lat: 17.38663238691933, lng: 78.51058305974328 },
        { lat: 17.38664986507264, lng: 78.51053578148469 },
        { lat: 17.38667577446363, lng: 78.51044134736036 },
        { lat: 17.38669278898782, lng: 78.51035850052834 },
        { lat: 17.38670340813984, lng: 78.51030558063879 },
        { lat: 17.38670146571679, lng: 78.51024313227003 },
        { lat: 17.38669975417239, lng: 78.51019846725156 },
        { lat: 17.3867081596765, lng: 78.51014925350995 },
        { lat: 17.38673353751168, lng: 78.5101008391851 },
        { lat: 17.38675227997207, lng: 78.5100639797179 },
        { lat: 17.38676963520063, lng: 78.51000729432303 },
        { lat: 17.3867871938957, lng: 78.50996633818573 },
        { lat: 17.38679005246579, lng: 78.50992528562053 },
        { lat: 17.38678940463728, lng: 78.50987546535093 },
        { lat: 17.38678583190345, lng: 78.50977466378963 },
        { lat: 17.38681288623838, lng: 78.50968139177075 },
      ],
    ],
  },
];

export default ZONES_DATA;
